var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs, _rect, _path31, _path32, _path33, _path34, _path35, _polygon, _polygon2, _polygon3, _polygon4, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _defs2, _rect2, _path78, _defs3, _rect3, _path79, _defs4, _rect4, _path80, _defs5, _rect5, _path81, _path82, _defs6, _rect6, _path83, _defs7, _rect7, _path84, _defs8, _rect8, _path85, _defs9, _rect9, _polygon5, _defs10, _rect10, _path86, _defs11, _rect11, _path87, _defs12, _rect12, _path88, _defs13, _rect13, _path89, _defs14, _rect14, _path90, _defs15, _rect15, _path91, _defs16, _rect16, _path92, _defs17, _rect17, _path93, _defs18, _rect18, _path94, _defs19, _rect19, _path95, _defs20, _rect20, _path96, _defs21, _rect21, _path97, _defs22, _rect22, _path98, _defs23, _rect23, _path99, _defs24, _rect24, _path100, _defs25, _rect25, _path101, _defs26, _rect26, _path102, _defs27, _rect27, _path103, _path104, _line, _path105, _path106, _path107, _path108, _defs28, _rect28, _path109, _defs29, _rect29, _path110, _path111, _path112, _defs30, _rect30, _path113, _path114, _path115, _polyline, _path116, _path117, _polyline2, _path118, _defs31, _rect31, _path119, _defs32, _rect32, _path120, _defs33, _rect33, _path121, _defs34, _rect34, _path122, _defs35, _rect35, _path123, _defs36, _rect36, _path124, _defs37, _rect37, _circle, _defs38, _rect38, _path125, _defs39, _rect39, _path126, _defs40, _rect40, _path127, _path128, _defs41, _rect41, _path129, _path130, _path131, _path132, _path133, _polygon6, _polygon7, _path134, _path135, _defs42, _rect42, _path136, _defs43, _rect43, _path137, _defs44, _path138, _path139, _path140, _path141, _defs45, _rect44, _circle2, _defs46, _path142, _path143, _path144, _path145, _defs47, _rect45, _circle3, _defs48, _path146, _path147, _path148, _path149, _defs49, _rect46, _path150, _defs50, _path151, _path152, _path153, _path154, _defs51, _rect47, _path155, _defs52, _path156, _path157, _path158, _path159, _defs53, _rect48, _path160, _defs54, _path161, _path162, _path163, _path164, _defs55, _rect49, _path165, _defs56, _path166, _path167, _path168, _path169, _defs57, _rect50, _path170, _defs58, _path171, _path172, _path173, _path174, _defs59, _rect51, _path175, _defs60, _path176, _path177, _path178, _path179, _defs61, _rect52, _path180, _defs62, _path181, _path182, _path183, _path184, _defs63, _rect53, _path185, _defs64, _path186, _path187, _path188, _path189, _defs65, _rect54, _path190, _defs66, _path191, _path192, _path193, _path194, _defs67, _rect55, _path195, _defs68, _path196, _path197, _path198, _path199, _defs69, _rect56, _path200, _defs70, _path201, _path202, _path203, _path204, _defs71, _rect57, _path205, _defs72, _path206, _path207, _path208, _path209, _defs73, _rect58, _path210, _defs74, _path211, _path212, _path213, _path214, _defs75, _rect59, _path215, _defs76, _path216, _path217, _path218, _path219, _defs77, _rect60, _path220, _defs78, _path221, _path222, _path223, _path224, _defs79, _rect61, _path225, _defs80, _path226, _path227, _path228, _path229, _defs81, _rect62, _path230, _defs82, _path231, _path232, _path233, _path234, _defs83, _rect63, _path235, _defs84, _path236, _path237, _path238, _path239, _defs85, _rect64, _path240, _defs86, _path241, _path242, _path243, _path244, _defs87, _rect65, _path245, _defs88, _rect66, _path246, _defs89, _rect67, _path247, _defs90, _rect68, _path248, _path249, _defs91, _rect69, _path250, _defs92, _rect70, _path251, _defs93, _rect71, _path252, _defs94, _rect72, _polygon8, _defs95, _rect73, _path253, _defs96, _rect74, _path254, _defs97, _rect75, _path255, _defs98, _rect76, _path256, _defs99, _rect77, _path257, _defs100, _rect78, _path258, _defs101, _rect79, _path259, _defs102, _rect80, _path260, _defs103, _rect81, _path261, _defs104, _rect82, _path262, _defs105, _rect83, _path263, _defs106, _rect84, _path264, _defs107, _rect85, _path265, _defs108, _rect86, _path266, _defs109, _rect87, _path267, _defs110, _rect88, _path268, _defs111, _rect89, _path269, _defs112, _rect90, _path270, _path271, _line2, _path272, _path273, _path274, _path275, _defs113, _rect91, _path276, _defs114, _rect92, _path277, _path278, _path279, _defs115, _rect93, _path280, _path281, _path282, _polyline3, _path283, _path284, _polyline4, _path285, _defs116, _rect94, _path286, _defs117, _rect95, _path287, _defs118, _rect96, _path288, _defs119, _rect97, _path289, _defs120, _rect98, _path290, _defs121, _rect99, _path291, _defs122, _rect100, _path292, _defs123, _rect101, _circle4, _defs124, _rect102, _path293, _defs125, _rect103, _path294, _path295, _defs126, _rect104, _path296, _path297, _path298, _defs127, _rect105, _path299, _defs128, _path300, _path301, _path302, _path303, _defs129, _rect106, _path304, _defs130, _path305, _path306, _path307, _path308, _defs131, _rect107, _path309, _defs132, _path310, _path311, _path312, _path313, _defs133, _rect108, _circle5, _defs134, _path314, _path315, _path316, _path317, _defs135, _rect109, _path318, _defs136, _path319, _path320, _path321, _path322, _defs137, _rect110, _path323, _defs138, _path324, _path325, _path326, _path327, _defs139, _rect111, _path328, _defs140, _path329, _path330, _path331, _path332, _defs141, _rect112, _path333, _defs142, _path334, _path335, _path336, _path337, _defs143, _rect113, _path338, _defs144, _path339, _path340, _path341, _path342, _defs145, _rect114, _path343, _defs146, _path344, _path345, _path346, _path347, _defs147, _rect115, _path348, _defs148, _path349, _path350, _path351, _path352, _defs149, _rect116, _path353, _defs150, _path354, _path355, _path356, _path357, _defs151, _rect117, _path358, _defs152, _path359, _path360, _path361, _path362, _defs153, _rect118, _path363, _defs154, _path364, _path365, _path366, _path367, _defs155, _rect119, _path368, _defs156, _path369, _path370, _path371, _path372, _defs157, _rect120, _path373, _defs158, _path374, _path375, _path376, _path377, _defs159, _rect121, _path378, _defs160, _path379, _path380, _path381, _path382, _defs161, _rect122, _path383, _defs162, _path384, _path385, _path386, _path387, _defs163, _rect123, _path388, _defs164, _path389, _path390, _path391, _path392, _defs165, _rect124, _path393, _defs166, _path394, _path395, _path396, _path397, _defs167, _rect125, _path398, _defs168, _path399, _path400, _path401, _path402, _path403, _path404, _polygon9, _polygon10, _path405, _path406, _path407, _path408, _path409, _path410, _defs169, _rect126, _path411, _defs170, _rect127, _path412, _defs171, _rect128, _path413, _defs172, _rect129, _path414, _defs173, _rect130, _path415, _defs174, _rect131, _path416, _defs175, _rect132, _path417, _defs176, _rect133, _polygon11, _defs177, _rect134, _path418, _defs178, _rect135, _polygon12, _defs179, _rect136, _path419, _defs180, _rect137, _polygon13, _defs181, _rect138, _path420, _defs182, _rect139, _path421, _defs183, _rect140, _path422, _defs184, _rect141, _path423, _defs185, _rect142, _path424, _defs186, _rect143, _path425, _defs187, _rect144, _path426, _defs188, _rect145, _polygon14, _defs189, _rect146, _path427, _defs190, _rect147, _polygon15, _defs191, _rect148, _polygon16, _defs192, _rect149, _path428, _defs193, _rect150, _path429, _defs194, _rect151, _path430, _defs195, _rect152, _path431, _defs196, _rect153, _path432, _defs197, _rect154, _path433, _defs198, _rect155, _path434, _defs199, _rect156, _path435, _defs200, _rect157, _path436, _defs201, _rect158, _path437, _path438, _defs202, _rect159, _path439, _defs203, _rect160, _path440, _defs204, _rect161, _path441, _defs205, _rect162, _path442, _defs206, _rect163, _path443, _defs207, _rect164, _path444, _path445, _path446, _defs208, _rect165, _path447, _defs209, _rect166, _path448, _defs210, _rect167, _path449, _defs211, _rect168, _path450, _defs212, _rect169, _path451, _path452, _path453, _defs213, _rect170, _path454, _defs214, _rect171, _path455, _defs215, _rect172, _path456, _defs216, _rect173, _path457, _defs217, _rect174, _path458, _defs218, _rect175, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _defs219, _rect176, _path467, _defs220, _rect177, _path468, _defs221, _rect178, _path469, _defs222, _rect179, _path470, _defs223, _rect180, _path471, _path472, _path473, _defs224, _rect181, _path474, _defs225, _rect182, _path475, _defs226, _rect183, _path476, _defs227, _rect184, _path477, _defs228, _rect185, _path478, _path479, _path480, _defs229, _rect186, _path481, _defs230, _rect187, _path482, _defs231, _rect188, _path483, _defs232, _rect189, _path484, _defs233, _rect190, _path485, _defs234, _rect191, _path486, _path487, _path488, _path489, _defs235, _rect192, _path490, _defs236, _rect193, _path491, _defs237, _rect194, _path492, _defs238, _rect195, _path493, _path494, _path495, _path496, _path497, _path498;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoUnicaragena(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "239px",
    height: "106px",
    viewBox: "0 0 239 106",
    style: {
      enableBackground: "new 0 0 239 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#262324;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#864228;}\n\t.st2{fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#CED0D1;}\n\t.st4{fill:none;stroke:#141D07;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#262324;}\n\t.st6{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st8{clip-path:url(#SVGID_5_);fill:url(#SVGID_6_);}\n\t.st9{clip-path:url(#SVGID_8_);fill:url(#SVGID_9_);}\n\t.st10{clip-path:url(#SVGID_11_);fill:url(#SVGID_12_);}\n\t.st11{clip-path:url(#SVGID_14_);fill:url(#SVGID_15_);}\n\t.st12{clip-path:url(#SVGID_17_);fill:url(#SVGID_18_);}\n\t.st13{clip-path:url(#SVGID_20_);fill:url(#SVGID_21_);}\n\t.st14{clip-path:url(#SVGID_23_);fill:url(#SVGID_24_);}\n\t.st15{clip-path:url(#SVGID_26_);fill:url(#SVGID_27_);}\n\t.st16{clip-path:url(#SVGID_29_);fill:url(#SVGID_30_);}\n\t.st17{clip-path:url(#SVGID_32_);fill:url(#SVGID_33_);}\n\t.st18{clip-path:url(#SVGID_35_);fill:url(#SVGID_36_);}\n\t.st19{clip-path:url(#SVGID_38_);fill:url(#SVGID_39_);}\n\t.st20{clip-path:url(#SVGID_41_);fill:url(#SVGID_42_);}\n\t.st21{clip-path:url(#SVGID_44_);fill:url(#SVGID_45_);}\n\t.st22{clip-path:url(#SVGID_47_);fill:url(#SVGID_48_);}\n\t.st23{clip-path:url(#SVGID_50_);fill:url(#SVGID_51_);}\n\t.st24{clip-path:url(#SVGID_53_);fill:url(#SVGID_54_);}\n\t.st25{clip-path:url(#SVGID_56_);fill:url(#SVGID_57_);}\n\t.st26{clip-path:url(#SVGID_59_);fill:url(#SVGID_60_);}\n\t.st27{clip-path:url(#SVGID_62_);fill:url(#SVGID_63_);}\n\t.st28{clip-path:url(#SVGID_65_);fill:url(#SVGID_66_);}\n\t.st29{clip-path:url(#SVGID_68_);fill:url(#SVGID_69_);}\n\t.st30{clip-path:url(#SVGID_71_);fill:url(#SVGID_72_);}\n\t.st31{clip-path:url(#SVGID_74_);fill:url(#SVGID_75_);}\n\t.st32{clip-path:url(#SVGID_77_);fill:url(#SVGID_78_);}\n\t.st33{clip-path:url(#SVGID_80_);fill:url(#SVGID_81_);}\n\t.st34{clip-path:url(#SVGID_83_);fill:url(#SVGID_84_);}\n\t.st35{clip-path:url(#SVGID_86_);fill:url(#SVGID_87_);}\n\t.st36{clip-path:url(#SVGID_89_);fill:url(#SVGID_90_);}\n\t.st37{clip-path:url(#SVGID_92_);fill:url(#SVGID_93_);}\n\t.st38{clip-path:url(#SVGID_95_);fill:url(#SVGID_96_);}\n\t.st39{clip-path:url(#SVGID_98_);fill:url(#SVGID_99_);}\n\t.st40{clip-path:url(#SVGID_101_);fill:url(#SVGID_102_);}\n\t.st41{clip-path:url(#SVGID_104_);fill:url(#SVGID_105_);}\n\t.st42{clip-path:url(#SVGID_107_);fill:url(#SVGID_108_);}\n\t.st43{clip-path:url(#SVGID_110_);fill:url(#SVGID_111_);}\n\t.st44{clip-path:url(#SVGID_113_);fill:url(#SVGID_114_);}\n\t.st45{clip-path:url(#SVGID_116_);fill:url(#SVGID_117_);}\n\t.st46{clip-path:url(#SVGID_119_);fill:url(#SVGID_120_);}\n\t.st47{clip-path:url(#SVGID_122_);fill:url(#SVGID_123_);}\n\t.st48{clip-path:url(#SVGID_125_);fill:url(#SVGID_126_);}\n\t.st49{clip-path:url(#SVGID_128_);fill:url(#SVGID_129_);}\n\t.st50{opacity:0.41;}\n\t.st51{clip-path:url(#SVGID_131_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st52{clip-path:url(#SVGID_131_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st53{clip-path:url(#SVGID_133_);fill:url(#SVGID_134_);}\n\t.st54{clip-path:url(#SVGID_136_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st55{clip-path:url(#SVGID_136_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st56{clip-path:url(#SVGID_138_);fill:url(#SVGID_139_);}\n\t.st57{clip-path:url(#SVGID_141_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st58{clip-path:url(#SVGID_141_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st59{clip-path:url(#SVGID_143_);fill:url(#SVGID_144_);}\n\t.st60{clip-path:url(#SVGID_146_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st61{clip-path:url(#SVGID_146_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st62{clip-path:url(#SVGID_148_);fill:url(#SVGID_149_);}\n\t.st63{clip-path:url(#SVGID_151_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st64{clip-path:url(#SVGID_151_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st65{clip-path:url(#SVGID_153_);fill:url(#SVGID_154_);}\n\t.st66{clip-path:url(#SVGID_156_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st67{clip-path:url(#SVGID_156_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st68{clip-path:url(#SVGID_158_);fill:url(#SVGID_159_);}\n\t.st69{clip-path:url(#SVGID_161_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st70{clip-path:url(#SVGID_161_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st71{clip-path:url(#SVGID_163_);fill:url(#SVGID_164_);}\n\t.st72{clip-path:url(#SVGID_166_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st73{clip-path:url(#SVGID_166_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st74{clip-path:url(#SVGID_168_);fill:url(#SVGID_169_);}\n\t.st75{clip-path:url(#SVGID_171_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st76{clip-path:url(#SVGID_171_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st77{clip-path:url(#SVGID_173_);fill:url(#SVGID_174_);}\n\t.st78{clip-path:url(#SVGID_176_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st79{clip-path:url(#SVGID_176_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st80{clip-path:url(#SVGID_178_);fill:url(#SVGID_179_);}\n\t.st81{clip-path:url(#SVGID_181_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st82{clip-path:url(#SVGID_181_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st83{clip-path:url(#SVGID_183_);fill:url(#SVGID_184_);}\n\t.st84{clip-path:url(#SVGID_186_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st85{clip-path:url(#SVGID_186_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st86{clip-path:url(#SVGID_188_);fill:url(#SVGID_189_);}\n\t.st87{clip-path:url(#SVGID_191_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st88{clip-path:url(#SVGID_191_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st89{clip-path:url(#SVGID_193_);fill:url(#SVGID_194_);}\n\t.st90{clip-path:url(#SVGID_196_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st91{clip-path:url(#SVGID_196_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st92{clip-path:url(#SVGID_198_);fill:url(#SVGID_199_);}\n\t.st93{clip-path:url(#SVGID_201_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st94{clip-path:url(#SVGID_201_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st95{clip-path:url(#SVGID_203_);fill:url(#SVGID_204_);}\n\t.st96{clip-path:url(#SVGID_206_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st97{clip-path:url(#SVGID_206_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st98{clip-path:url(#SVGID_208_);fill:url(#SVGID_209_);}\n\t.st99{clip-path:url(#SVGID_211_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st100{clip-path:url(#SVGID_211_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st101{clip-path:url(#SVGID_213_);fill:url(#SVGID_214_);}\n\t.st102{clip-path:url(#SVGID_216_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st103{clip-path:url(#SVGID_216_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st104{clip-path:url(#SVGID_218_);fill:url(#SVGID_219_);}\n\t.st105{clip-path:url(#SVGID_221_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st106{clip-path:url(#SVGID_221_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st107{clip-path:url(#SVGID_223_);fill:url(#SVGID_224_);}\n\t.st108{clip-path:url(#SVGID_226_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st109{clip-path:url(#SVGID_226_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st110{clip-path:url(#SVGID_228_);fill:url(#SVGID_229_);}\n\t.st111{clip-path:url(#SVGID_231_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st112{clip-path:url(#SVGID_231_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st113{clip-path:url(#SVGID_233_);fill:url(#SVGID_234_);}\n\t.st114{clip-path:url(#SVGID_236_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st115{clip-path:url(#SVGID_236_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st116{clip-path:url(#SVGID_238_);fill:url(#SVGID_239_);}\n\t.st117{clip-path:url(#SVGID_241_);fill:url(#SVGID_242_);}\n\t.st118{clip-path:url(#SVGID_244_);fill:url(#SVGID_245_);}\n\t.st119{clip-path:url(#SVGID_247_);fill:url(#SVGID_248_);}\n\t.st120{clip-path:url(#SVGID_250_);fill:url(#SVGID_251_);}\n\t.st121{clip-path:url(#SVGID_253_);fill:url(#SVGID_254_);}\n\t.st122{clip-path:url(#SVGID_256_);fill:url(#SVGID_257_);}\n\t.st123{clip-path:url(#SVGID_259_);fill:url(#SVGID_260_);}\n\t.st124{clip-path:url(#SVGID_262_);fill:url(#SVGID_263_);}\n\t.st125{clip-path:url(#SVGID_265_);fill:url(#SVGID_266_);}\n\t.st126{clip-path:url(#SVGID_268_);fill:url(#SVGID_269_);}\n\t.st127{clip-path:url(#SVGID_271_);fill:url(#SVGID_272_);}\n\t.st128{clip-path:url(#SVGID_274_);fill:url(#SVGID_275_);}\n\t.st129{clip-path:url(#SVGID_277_);fill:url(#SVGID_278_);}\n\t.st130{clip-path:url(#SVGID_280_);fill:url(#SVGID_281_);}\n\t.st131{clip-path:url(#SVGID_283_);fill:url(#SVGID_284_);}\n\t.st132{clip-path:url(#SVGID_286_);fill:url(#SVGID_287_);}\n\t.st133{clip-path:url(#SVGID_289_);fill:url(#SVGID_290_);}\n\t.st134{clip-path:url(#SVGID_292_);fill:url(#SVGID_293_);}\n\t.st135{clip-path:url(#SVGID_295_);fill:url(#SVGID_296_);}\n\t.st136{clip-path:url(#SVGID_298_);fill:url(#SVGID_299_);}\n\t.st137{clip-path:url(#SVGID_301_);fill:url(#SVGID_302_);}\n\t.st138{clip-path:url(#SVGID_304_);fill:url(#SVGID_305_);}\n\t.st139{clip-path:url(#SVGID_307_);fill:url(#SVGID_308_);}\n\t.st140{clip-path:url(#SVGID_310_);fill:url(#SVGID_311_);}\n\t.st141{clip-path:url(#SVGID_313_);fill:url(#SVGID_314_);}\n\t.st142{clip-path:url(#SVGID_316_);fill:url(#SVGID_317_);}\n\t.st143{clip-path:url(#SVGID_319_);fill:url(#SVGID_320_);}\n\t.st144{clip-path:url(#SVGID_322_);fill:url(#SVGID_323_);}\n\t.st145{clip-path:url(#SVGID_325_);fill:url(#SVGID_326_);}\n\t.st146{clip-path:url(#SVGID_328_);fill:url(#SVGID_329_);}\n\t.st147{clip-path:url(#SVGID_331_);fill:url(#SVGID_332_);}\n\t.st148{clip-path:url(#SVGID_334_);fill:url(#SVGID_335_);}\n\t.st149{clip-path:url(#SVGID_337_);fill:url(#SVGID_338_);}\n\t.st150{clip-path:url(#SVGID_340_);fill:url(#SVGID_341_);}\n\t.st151{clip-path:url(#SVGID_343_);fill:url(#SVGID_344_);}\n\t.st152{clip-path:url(#SVGID_346_);fill:url(#SVGID_347_);}\n\t.st153{clip-path:url(#SVGID_349_);fill:url(#SVGID_350_);}\n\t.st154{clip-path:url(#SVGID_352_);fill:url(#SVGID_353_);}\n\t.st155{clip-path:url(#SVGID_355_);fill:url(#SVGID_356_);}\n\t.st156{clip-path:url(#SVGID_358_);fill:url(#SVGID_359_);}\n\t.st157{clip-path:url(#SVGID_361_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st158{clip-path:url(#SVGID_361_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st159{clip-path:url(#SVGID_363_);fill:url(#SVGID_364_);}\n\t.st160{clip-path:url(#SVGID_366_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st161{clip-path:url(#SVGID_366_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st162{clip-path:url(#SVGID_368_);fill:url(#SVGID_369_);}\n\t.st163{clip-path:url(#SVGID_371_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st164{clip-path:url(#SVGID_371_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st165{clip-path:url(#SVGID_373_);fill:url(#SVGID_374_);}\n\t.st166{clip-path:url(#SVGID_376_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st167{clip-path:url(#SVGID_376_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st168{clip-path:url(#SVGID_378_);fill:url(#SVGID_379_);}\n\t.st169{clip-path:url(#SVGID_381_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st170{clip-path:url(#SVGID_381_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st171{clip-path:url(#SVGID_383_);fill:url(#SVGID_384_);}\n\t.st172{clip-path:url(#SVGID_386_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st173{clip-path:url(#SVGID_386_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st174{clip-path:url(#SVGID_388_);fill:url(#SVGID_389_);}\n\t.st175{clip-path:url(#SVGID_391_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st176{clip-path:url(#SVGID_391_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st177{clip-path:url(#SVGID_393_);fill:url(#SVGID_394_);}\n\t.st178{clip-path:url(#SVGID_396_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st179{clip-path:url(#SVGID_396_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st180{clip-path:url(#SVGID_398_);fill:url(#SVGID_399_);}\n\t.st181{clip-path:url(#SVGID_401_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st182{clip-path:url(#SVGID_401_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st183{clip-path:url(#SVGID_403_);fill:url(#SVGID_404_);}\n\t.st184{clip-path:url(#SVGID_406_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st185{clip-path:url(#SVGID_406_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st186{clip-path:url(#SVGID_408_);fill:url(#SVGID_409_);}\n\t.st187{clip-path:url(#SVGID_411_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st188{clip-path:url(#SVGID_411_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st189{clip-path:url(#SVGID_413_);fill:url(#SVGID_414_);}\n\t.st190{clip-path:url(#SVGID_416_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st191{clip-path:url(#SVGID_416_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st192{clip-path:url(#SVGID_418_);fill:url(#SVGID_419_);}\n\t.st193{clip-path:url(#SVGID_421_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st194{clip-path:url(#SVGID_421_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st195{clip-path:url(#SVGID_423_);fill:url(#SVGID_424_);}\n\t.st196{clip-path:url(#SVGID_426_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st197{clip-path:url(#SVGID_426_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st198{clip-path:url(#SVGID_428_);fill:url(#SVGID_429_);}\n\t.st199{clip-path:url(#SVGID_431_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st200{clip-path:url(#SVGID_431_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st201{clip-path:url(#SVGID_433_);fill:url(#SVGID_434_);}\n\t.st202{clip-path:url(#SVGID_436_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st203{clip-path:url(#SVGID_436_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st204{clip-path:url(#SVGID_438_);fill:url(#SVGID_439_);}\n\t.st205{clip-path:url(#SVGID_441_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st206{clip-path:url(#SVGID_441_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st207{clip-path:url(#SVGID_443_);fill:url(#SVGID_444_);}\n\t.st208{clip-path:url(#SVGID_446_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st209{clip-path:url(#SVGID_446_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st210{clip-path:url(#SVGID_448_);fill:url(#SVGID_449_);}\n\t.st211{clip-path:url(#SVGID_451_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st212{clip-path:url(#SVGID_451_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st213{clip-path:url(#SVGID_453_);fill:url(#SVGID_454_);}\n\t.st214{clip-path:url(#SVGID_456_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st215{clip-path:url(#SVGID_456_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st216{clip-path:url(#SVGID_458_);fill:url(#SVGID_459_);}\n\t.st217{clip-path:url(#SVGID_461_);fill-rule:evenodd;clip-rule:evenodd;fill:#9BC48A;}\n\t\n\t\t.st218{clip-path:url(#SVGID_461_);fill:none;stroke:#262324;stroke-width:0.1625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\n\t.st219{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st220{clip-path:url(#SVGID_463_);fill:url(#SVGID_464_);}\n\t.st221{clip-path:url(#SVGID_466_);fill:url(#SVGID_467_);}\n\t.st222{clip-path:url(#SVGID_469_);fill:url(#SVGID_470_);}\n\t.st223{clip-path:url(#SVGID_472_);fill:url(#SVGID_473_);}\n\t.st224{clip-path:url(#SVGID_475_);fill:url(#SVGID_476_);}\n\t.st225{clip-path:url(#SVGID_478_);fill:url(#SVGID_479_);}\n\t.st226{clip-path:url(#SVGID_481_);fill:url(#SVGID_482_);}\n\t.st227{clip-path:url(#SVGID_484_);fill:url(#SVGID_485_);}\n\t.st228{clip-path:url(#SVGID_487_);fill:url(#SVGID_488_);}\n\t.st229{clip-path:url(#SVGID_490_);fill:url(#SVGID_491_);}\n\t.st230{clip-path:url(#SVGID_493_);fill:url(#SVGID_494_);}\n\t.st231{clip-path:url(#SVGID_496_);fill:url(#SVGID_497_);}\n\t.st232{clip-path:url(#SVGID_499_);fill:url(#SVGID_500_);}\n\t.st233{clip-path:url(#SVGID_502_);fill:url(#SVGID_503_);}\n\t.st234{clip-path:url(#SVGID_505_);fill:url(#SVGID_506_);}\n\t.st235{clip-path:url(#SVGID_508_);fill:url(#SVGID_509_);}\n\t.st236{clip-path:url(#SVGID_511_);fill:url(#SVGID_512_);}\n\t.st237{clip-path:url(#SVGID_514_);fill:url(#SVGID_515_);}\n\t.st238{clip-path:url(#SVGID_517_);fill:url(#SVGID_518_);}\n\t.st239{clip-path:url(#SVGID_520_);fill:url(#SVGID_521_);}\n\t.st240{clip-path:url(#SVGID_523_);fill:url(#SVGID_524_);}\n\t.st241{clip-path:url(#SVGID_526_);fill:url(#SVGID_527_);}\n\t.st242{clip-path:url(#SVGID_529_);fill:url(#SVGID_530_);}\n\t.st243{clip-path:url(#SVGID_532_);fill:url(#SVGID_533_);}\n\t.st244{clip-path:url(#SVGID_535_);fill:url(#SVGID_536_);}\n\t.st245{clip-path:url(#SVGID_538_);fill:url(#SVGID_539_);}\n\t.st246{clip-path:url(#SVGID_541_);fill:url(#SVGID_542_);}\n\t.st247{clip-path:url(#SVGID_544_);fill:url(#SVGID_545_);}\n\t.st248{clip-path:url(#SVGID_547_);fill:url(#SVGID_548_);}\n\t.st249{clip-path:url(#SVGID_550_);fill:url(#SVGID_551_);}\n\t.st250{clip-path:url(#SVGID_553_);fill:url(#SVGID_554_);}\n\t.st251{clip-path:url(#SVGID_556_);fill:url(#SVGID_557_);}\n\t.st252{clip-path:url(#SVGID_559_);fill:url(#SVGID_560_);}\n\t.st253{clip-path:url(#SVGID_562_);fill:url(#SVGID_563_);}\n\t.st254{clip-path:url(#SVGID_565_);fill:url(#SVGID_566_);}\n\t.st255{clip-path:url(#SVGID_568_);fill:url(#SVGID_569_);}\n\t.st256{clip-path:url(#SVGID_571_);fill:url(#SVGID_572_);}\n\t.st257{clip-path:url(#SVGID_574_);fill:url(#SVGID_575_);}\n\t.st258{clip-path:url(#SVGID_577_);fill:url(#SVGID_578_);}\n\t.st259{fill-rule:evenodd;clip-rule:evenodd;fill:#C78F42;}\n\t.st260{clip-path:url(#SVGID_580_);fill:url(#SVGID_581_);}\n\t.st261{clip-path:url(#SVGID_583_);fill:url(#SVGID_584_);}\n\t.st262{clip-path:url(#SVGID_586_);fill:url(#SVGID_587_);}\n\t.st263{clip-path:url(#SVGID_589_);fill:url(#SVGID_590_);}\n\t.st264{clip-path:url(#SVGID_592_);fill:url(#SVGID_593_);}\n\t.st265{fill-rule:evenodd;clip-rule:evenodd;fill:#D98166;}\n\t.st266{clip-path:url(#SVGID_595_);fill:url(#SVGID_596_);}\n\t.st267{clip-path:url(#SVGID_598_);fill:url(#SVGID_599_);}\n\t.st268{clip-path:url(#SVGID_601_);fill:url(#SVGID_602_);}\n\t.st269{clip-path:url(#SVGID_604_);fill:url(#SVGID_605_);}\n\t.st270{clip-path:url(#SVGID_607_);fill:url(#SVGID_608_);}\n\t.st271{clip-path:url(#SVGID_610_);fill:url(#SVGID_611_);}\n\t.st272{fill:#C59959;}\n\t.st273{clip-path:url(#SVGID_613_);fill:url(#SVGID_614_);}\n\t.st274{clip-path:url(#SVGID_616_);fill:url(#SVGID_617_);}\n\t.st275{clip-path:url(#SVGID_619_);fill:url(#SVGID_620_);}\n\t.st276{clip-path:url(#SVGID_622_);fill:url(#SVGID_623_);}\n\t.st277{clip-path:url(#SVGID_625_);fill:url(#SVGID_626_);}\n\t.st278{clip-path:url(#SVGID_628_);fill:url(#SVGID_629_);}\n\t.st279{clip-path:url(#SVGID_631_);fill:url(#SVGID_632_);}\n\t.st280{clip-path:url(#SVGID_634_);fill:url(#SVGID_635_);}\n\t.st281{clip-path:url(#SVGID_637_);fill:url(#SVGID_638_);}\n\t.st282{clip-path:url(#SVGID_640_);fill:url(#SVGID_641_);}\n\t.st283{clip-path:url(#SVGID_643_);fill:url(#SVGID_644_);}\n\t.st284{clip-path:url(#SVGID_646_);fill:url(#SVGID_647_);}\n\t.st285{clip-path:url(#SVGID_649_);fill:url(#SVGID_650_);}\n\t.st286{clip-path:url(#SVGID_652_);fill:url(#SVGID_653_);}\n\t.st287{clip-path:url(#SVGID_655_);fill:url(#SVGID_656_);}\n\t.st288{clip-path:url(#SVGID_658_);fill:url(#SVGID_659_);}\n\t.st289{clip-path:url(#SVGID_661_);fill:url(#SVGID_662_);}\n\t.st290{clip-path:url(#SVGID_664_);fill:url(#SVGID_665_);}\n\t.st291{clip-path:url(#SVGID_667_);fill:url(#SVGID_668_);}\n\t.st292{clip-path:url(#SVGID_670_);fill:url(#SVGID_671_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.9,75c-0.3-0.4-0.7-0.8-1-1c-0.3-0.2-0.7-0.4-1-0.4c-0.3,0-0.6,0.1-0.8,0.2c-0.2,0.2-0.4,0.4-0.6,0.6 c-0.1,0.3-0.2,0.6-0.3,0.9c-0.1,0.3-0.1,0.7-0.1,1c0,0.4,0,0.7,0.1,1.1c0.1,0.3,0.2,0.7,0.3,0.9c0.1,0.3,0.3,0.5,0.5,0.6 c0.2,0.2,0.5,0.2,0.8,0.2c0.2,0,0.3,0,0.5-0.1c0.2,0,0.3-0.1,0.5-0.2c0.2-0.1,0.3-0.3,0.5-0.4c0.2-0.2,0.4-0.4,0.6-0.7V75z  M139.3,80.8c0,0.1,0,0.1,0,0.2c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.3,0-0.5,0c-0.2,0-0.4,0-0.5,0 c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1-0.1-0.1-0.2v-1c-0.4,0.5-0.9,0.9-1.4,1.1c-0.5,0.3-1,0.4-1.6,0.4 c-0.7,0-1.2-0.1-1.7-0.4c-0.5-0.3-0.8-0.6-1.1-1c-0.3-0.4-0.5-0.9-0.6-1.5c-0.1-0.6-0.2-1.2-0.2-1.8c0-0.8,0.1-1.5,0.2-2.1 c0.2-0.6,0.4-1.1,0.7-1.6c0.3-0.4,0.7-0.8,1.2-1c0.5-0.2,1-0.4,1.6-0.4c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.8,0.5,1.2,0.9V68 c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.4-0.1c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0.1,0.4,0.1 c0.1,0,0.2,0.1,0.2,0.1c0,0.1,0.1,0.1,0.1,0.2V80.8z M235.5,58.2c-0.3-0.4-0.7-0.8-1-1c-0.3-0.2-0.7-0.4-1-0.4 c-0.3,0-0.6,0.1-0.8,0.2c-0.2,0.2-0.4,0.4-0.6,0.6c-0.1,0.3-0.2,0.6-0.3,0.9c-0.1,0.3-0.1,0.7-0.1,1c0,0.4,0,0.7,0.1,1.1 c0.1,0.3,0.2,0.7,0.3,0.9c0.1,0.3,0.3,0.5,0.5,0.6c0.2,0.2,0.5,0.2,0.8,0.2c0.2,0,0.3,0,0.5-0.1c0.2,0,0.3-0.1,0.5-0.2 c0.2-0.1,0.3-0.3,0.5-0.4c0.2-0.2,0.4-0.4,0.6-0.7V58.2z M238,64c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1 c-0.1,0-0.3,0-0.5,0c-0.2,0-0.4,0-0.5,0c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.1-0.1-0.2-0.1c0-0.1-0.1-0.1-0.1-0.2v-1 c-0.4,0.5-0.9,0.9-1.4,1.1c-0.5,0.3-1,0.4-1.6,0.4c-0.7,0-1.2-0.1-1.7-0.4c-0.5-0.3-0.8-0.6-1.1-1c-0.3-0.4-0.5-0.9-0.6-1.5 c-0.1-0.6-0.2-1.2-0.2-1.8c0-0.8,0.1-1.5,0.2-2.1c0.2-0.6,0.4-1.1,0.7-1.6c0.3-0.4,0.7-0.8,1.2-1c0.5-0.2,1-0.4,1.6-0.4 c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.8,0.5,1.2,0.9v-4.7c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.4-0.1 c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0.1,0.4,0.1c0.1,0,0.2,0.1,0.2,0.1c0,0.1,0.1,0.1,0.1,0.2V64z M223.8,60.3h-0.9 c-0.4,0-0.7,0-1,0.1c-0.3,0.1-0.5,0.1-0.7,0.3c-0.2,0.1-0.3,0.3-0.4,0.4c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.4,0.1,0.7,0.3,0.9 c0.2,0.2,0.5,0.3,1,0.3c0.3,0,0.7-0.1,1-0.3c0.3-0.2,0.6-0.4,0.9-0.8V60.3z M226.2,64c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.2,0.1-0.3,0.1 c-0.1,0-0.3,0-0.6,0c-0.3,0-0.5,0-0.6,0c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.1-0.1-0.1-0.2v-0.7c-0.4,0.4-0.8,0.7-1.2,0.9 c-0.5,0.2-1,0.3-1.5,0.3c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.1-0.7-0.3-1-0.5c-0.3-0.2-0.5-0.5-0.7-0.9c-0.2-0.4-0.2-0.8-0.2-1.2 c0-0.5,0.1-1,0.3-1.3c0.2-0.4,0.5-0.7,0.9-0.9c0.4-0.2,0.9-0.4,1.5-0.5c0.6-0.1,1.3-0.2,2-0.2h0.9v-0.5c0-0.3,0-0.5-0.1-0.7 c-0.1-0.2-0.1-0.4-0.3-0.5c-0.1-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.5-0.1-0.8-0.1c-0.4,0-0.8,0-1.1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3 c-0.2,0.1-0.5,0.2-0.6,0.3c-0.2,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3 c0-0.1,0-0.3,0-0.4c0-0.2,0-0.4,0-0.5c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.5-0.3c0.2-0.1,0.5-0.2,0.8-0.3 c0.3-0.1,0.6-0.2,1-0.2c0.4-0.1,0.7-0.1,1.1-0.1c0.7,0,1.3,0.1,1.8,0.2c0.5,0.1,0.9,0.3,1.2,0.6c0.3,0.3,0.5,0.6,0.7,1.1 c0.1,0.4,0.2,1,0.2,1.5V64z M212.9,58.2c-0.3-0.4-0.7-0.8-1-1c-0.3-0.2-0.7-0.4-1-0.4c-0.3,0-0.6,0.1-0.8,0.2 c-0.2,0.2-0.4,0.4-0.6,0.6c-0.1,0.3-0.2,0.6-0.3,0.9c-0.1,0.3-0.1,0.7-0.1,1c0,0.4,0,0.7,0.1,1.1c0.1,0.3,0.2,0.7,0.3,0.9 c0.1,0.3,0.3,0.5,0.5,0.6c0.2,0.2,0.5,0.2,0.8,0.2c0.2,0,0.3,0,0.5-0.1c0.2,0,0.3-0.1,0.5-0.2c0.2-0.1,0.3-0.3,0.5-0.4 c0.2-0.2,0.4-0.4,0.6-0.7V58.2z M215.3,64c0,0.1,0,0.1,0,0.2c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.3,0-0.5,0 c-0.2,0-0.4,0-0.5,0c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.1-0.1-0.2-0.1c0-0.1-0.1-0.1-0.1-0.2v-1c-0.4,0.5-0.9,0.9-1.4,1.1 c-0.5,0.3-1,0.4-1.6,0.4c-0.7,0-1.2-0.1-1.7-0.4c-0.5-0.3-0.8-0.6-1.1-1c-0.3-0.4-0.5-0.9-0.6-1.5c-0.1-0.6-0.2-1.2-0.2-1.8 c0-0.8,0.1-1.5,0.2-2.1c0.2-0.6,0.4-1.1,0.7-1.6c0.3-0.4,0.7-0.8,1.2-1c0.5-0.2,1-0.4,1.6-0.4c0.5,0,0.9,0.1,1.3,0.3 c0.4,0.2,0.8,0.5,1.2,0.9v-4.7c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.4-0.1c0.2,0,0.4,0,0.6,0 c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0.1,0.4,0.1c0.1,0,0.2,0.1,0.2,0.1c0,0.1,0.1,0.1,0.1,0.2V64z M203.8,52.4c0,0.5-0.1,0.8-0.3,1 c-0.2,0.2-0.6,0.3-1.1,0.3c-0.6,0-0.9-0.1-1.1-0.3c-0.2-0.2-0.3-0.5-0.3-1c0-0.5,0.1-0.8,0.3-1c0.2-0.2,0.6-0.3,1.1-0.3 c0.5,0,0.9,0.1,1.1,0.3C203.7,51.6,203.8,51.9,203.8,52.4z M203.6,64c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1 c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.2-0.1c0-0.1-0.1-0.1-0.1-0.2 v-8.7c0-0.1,0-0.1,0.1-0.2c0,0,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.4-0.1c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0,0.4,0.1 c0.1,0,0.2,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.2V64z M198.3,61.5c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.4,0.7-0.8,0.9 c-0.3,0.3-0.7,0.4-1.2,0.6c-0.5,0.1-1,0.2-1.5,0.2c-0.3,0-0.6,0-0.9-0.1c-0.3,0-0.6-0.1-0.8-0.2c-0.2-0.1-0.4-0.2-0.6-0.2 c-0.2-0.1-0.3-0.2-0.3-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.4-0.1-0.6c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0.1-0.3 c0-0.1,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.2,0.7,0.3 c0.3,0.1,0.6,0.1,0.9,0.1c0.2,0,0.4,0,0.6-0.1c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.4 c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.2-0.7-0.3c-0.2-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.5-0.2-0.8-0.4 c-0.2-0.1-0.5-0.3-0.7-0.5c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.6-0.2-1.1c0-0.4,0.1-0.8,0.2-1.1c0.2-0.3,0.4-0.6,0.7-0.9 c0.3-0.2,0.7-0.4,1.1-0.6c0.4-0.1,0.9-0.2,1.5-0.2c0.3,0,0.5,0,0.8,0.1c0.3,0,0.5,0.1,0.7,0.1c0.2,0.1,0.4,0.1,0.5,0.2 c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0.1,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.4c0,0.2,0,0.3,0,0.4 c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.3-0.1-0.5-0.2c-0.2-0.1-0.4-0.1-0.6-0.2 c-0.2-0.1-0.5-0.1-0.8-0.1c-0.2,0-0.4,0-0.6,0.1c-0.2,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1-0.1,0.2-0.1,0.4 c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.3,0.5,0.4c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0.1,0.5,0.2,0.8,0.3c0.3,0.1,0.5,0.2,0.8,0.4 c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.4,0.5,0.5,0.7C198.2,60.8,198.3,61.2,198.3,61.5z M189.8,56.1c0,0.2,0,0.4,0,0.6 c0,0.1,0,0.3-0.1,0.4c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.2,0-0.3-0.1 c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.3,0.1-0.4,0.3c-0.1,0.1-0.3,0.3-0.5,0.5c-0.2,0.2-0.3,0.4-0.5,0.7V64 c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0-0.4-0.1 c-0.1,0-0.2-0.1-0.2-0.1c0-0.1-0.1-0.1-0.1-0.2v-8.7c0-0.1,0-0.1,0-0.2c0,0,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.3-0.1s0.3,0,0.5,0 c0.2,0,0.4,0,0.5,0c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.2v1.1c0.2-0.3,0.4-0.6,0.6-0.8 c0.2-0.2,0.4-0.4,0.6-0.5c0.2-0.1,0.4-0.2,0.5-0.3c0.2,0,0.4-0.1,0.5-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0.1 c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3C189.8,55.7,189.8,55.9,189.8,56.1z M178.8,58.7 c0-0.7-0.1-1.2-0.4-1.6c-0.3-0.4-0.8-0.6-1.4-0.6c-0.3,0-0.6,0.1-0.8,0.2c-0.2,0.1-0.4,0.3-0.6,0.5c-0.2,0.2-0.3,0.4-0.4,0.7 c-0.1,0.3-0.1,0.6-0.1,0.9H178.8z M181.2,59.4c0,0.3-0.1,0.5-0.2,0.7c-0.1,0.1-0.3,0.2-0.5,0.2h-5.3c0,0.4,0,0.7,0.1,1 c0.1,0.3,0.2,0.6,0.4,0.8c0.2,0.2,0.4,0.4,0.7,0.5c0.3,0.1,0.7,0.2,1.1,0.2c0.4,0,0.8,0,1.1-0.1c0.3-0.1,0.6-0.1,0.8-0.2 c0.2-0.1,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1,0.1,0.2c0,0.1,0,0.2,0,0.4 c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1c0,0-0.2,0.1-0.3,0.2c-0.2,0.1-0.4,0.2-0.7,0.2 c-0.3,0.1-0.6,0.1-1,0.2c-0.4,0.1-0.8,0.1-1.2,0.1c-0.8,0-1.5-0.1-2-0.3c-0.6-0.2-1.1-0.5-1.5-0.9c-0.4-0.4-0.7-0.9-0.9-1.5 c-0.2-0.6-0.3-1.3-0.3-2.1c0-0.8,0.1-1.5,0.3-2.1c0.2-0.6,0.5-1.1,0.9-1.6c0.4-0.4,0.9-0.8,1.4-1c0.5-0.2,1.2-0.3,1.9-0.3 c0.7,0,1.4,0.1,1.9,0.3c0.5,0.2,0.9,0.5,1.3,0.9c0.3,0.4,0.6,0.8,0.7,1.4c0.2,0.5,0.2,1.1,0.2,1.7V59.4z M170.8,55.3 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2-0.1,0.2l-2.6,7.9c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.2 c-0.1,0-0.3,0.1-0.5,0.1c-0.2,0-0.5,0-0.9,0c-0.3,0-0.6,0-0.8,0c-0.2,0-0.4,0-0.5-0.1c-0.1,0-0.2-0.1-0.3-0.2 c-0.1-0.1-0.1-0.2-0.1-0.3L162,56c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.2 c0,0,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.4-0.1c0.2,0,0.4,0,0.6,0c0.3,0,0.5,0,0.6,0s0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.2,0.1 c0,0.1,0.1,0.1,0.1,0.2l2,6.4l0.1,0.2l0.1-0.2l2-6.4c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.4-0.1 c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0,0.4,0.1c0.1,0,0.1,0.1,0.2,0.1C170.8,55.2,170.8,55.2,170.8,55.3z M159.5,52.4 c0,0.5-0.1,0.8-0.3,1c-0.2,0.2-0.6,0.3-1.1,0.3c-0.6,0-0.9-0.1-1.1-0.3c-0.2-0.2-0.3-0.5-0.3-1c0-0.5,0.1-0.8,0.3-1 c0.2-0.2,0.6-0.3,1.1-0.3c0.5,0,0.9,0.1,1.1,0.3C159.4,51.6,159.5,51.9,159.5,52.4z M159.4,64c0,0.1,0,0.1-0.1,0.2 c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.2-0.1 c0-0.1-0.1-0.1-0.1-0.2v-8.7c0-0.1,0-0.1,0.1-0.2c0,0,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.4-0.1c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0 c0.2,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.2V64z M153.4,64c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1 c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.2-0.1c0-0.1-0.1-0.1-0.1-0.2 v-5c0-0.4,0-0.8-0.1-1c-0.1-0.2-0.1-0.4-0.3-0.6c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.1-0.6-0.1c-0.3,0-0.6,0.1-0.9,0.3 c-0.3,0.2-0.6,0.6-1,1V64c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0 c-0.2,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.2-0.1c0-0.1-0.1-0.1-0.1-0.2v-8.7c0-0.1,0-0.1,0-0.2c0,0,0.1-0.1,0.2-0.1 c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.3,0,0.5,0c0.2,0,0.4,0,0.5,0c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.2v1 c0.5-0.5,1-0.9,1.5-1.2c0.5-0.3,1-0.4,1.6-0.4c0.6,0,1.1,0.1,1.5,0.3c0.4,0.2,0.7,0.5,1,0.8c0.2,0.3,0.4,0.7,0.5,1.2 c0.1,0.4,0.2,1,0.2,1.6V64z M141.5,59.6c0,0.8-0.1,1.5-0.3,2.1c-0.2,0.6-0.6,1.1-1,1.6c-0.4,0.4-1,0.7-1.6,1 c-0.6,0.2-1.4,0.3-2.2,0.3c-0.8,0-1.5-0.1-2.1-0.3c-0.6-0.2-1.2-0.5-1.6-0.9c-0.4-0.4-0.8-0.9-1-1.5c-0.2-0.6-0.3-1.3-0.3-2.1v-7.7 c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.4-0.1c0.2,0,0.4,0,0.6,0c0.2,0,0.5,0,0.6,0c0.2,0,0.3,0,0.4,0.1 c0.1,0,0.2,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.2v7.5c0,0.5,0.1,0.9,0.2,1.3c0.1,0.4,0.3,0.7,0.5,0.9c0.2,0.2,0.5,0.4,0.8,0.5 c0.3,0.1,0.7,0.2,1.1,0.2c0.4,0,0.8-0.1,1.1-0.2c0.3-0.1,0.6-0.3,0.8-0.5c0.2-0.2,0.4-0.5,0.5-0.9c0.1-0.3,0.2-0.7,0.2-1.2v-7.6 c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.4-0.1c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0,0.4,0.1 c0.1,0,0.2,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.2V59.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.6,77.1h-0.9c-0.4,0-0.7,0-1,0.1c-0.3,0.1-0.5,0.1-0.7,0.3c-0.2,0.1-0.3,0.3-0.4,0.4 c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.4,0.1,0.7,0.3,0.9c0.2,0.2,0.5,0.3,1,0.3c0.3,0,0.7-0.1,1-0.3c0.3-0.2,0.6-0.4,0.9-0.8V77.1z  M238,80.9c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.3,0-0.6,0c-0.3,0-0.5,0-0.6,0c-0.1,0-0.2-0.1-0.3-0.1 C236,81,236,81,236,80.9v-0.7c-0.4,0.4-0.8,0.7-1.2,0.9c-0.5,0.2-1,0.3-1.5,0.3c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.1-0.7-0.3-1-0.5 c-0.3-0.2-0.5-0.5-0.7-0.9c-0.2-0.4-0.2-0.8-0.2-1.2c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.5-0.7,0.9-0.9c0.4-0.2,0.9-0.4,1.5-0.5 c0.6-0.1,1.3-0.2,2-0.2h0.8v-0.5c0-0.3,0-0.5-0.1-0.7c-0.1-0.2-0.1-0.4-0.3-0.5c-0.1-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.5-0.1-0.8-0.1 c-0.4,0-0.8,0-1.1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3c-0.2,0.1-0.5,0.2-0.6,0.3c-0.2,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.1,0-0.2-0.1 c-0.1,0-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.3,0-0.4c0-0.2,0-0.4,0-0.5c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.5-0.3 c0.2-0.1,0.5-0.2,0.8-0.3c0.3-0.1,0.6-0.2,1-0.2c0.4-0.1,0.7-0.1,1.1-0.1c0.7,0,1.3,0.1,1.8,0.2c0.5,0.1,0.9,0.3,1.2,0.6 c0.3,0.3,0.5,0.6,0.7,1.1c0.1,0.4,0.2,1,0.2,1.5V80.9z M228.2,80.8c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.4,0.1 c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.2-0.1c0-0.1-0.1-0.1-0.1-0.2v-5c0-0.4,0-0.8-0.1-1 c-0.1-0.2-0.1-0.4-0.3-0.6c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.1-0.6-0.1c-0.3,0-0.6,0.1-0.9,0.3c-0.3,0.2-0.6,0.6-1,1v5.8 c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0-0.4-0.1 c-0.1,0-0.2-0.1-0.2-0.1c0-0.1-0.1-0.1-0.1-0.2v-8.7c0-0.1,0-0.1,0-0.2c0,0,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.3-0.1 c0.1,0,0.3,0,0.5,0c0.2,0,0.4,0,0.5,0c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1c0,0,0,0.1,0,0.2v1c0.5-0.5,1-0.9,1.5-1.2 c0.5-0.3,1-0.4,1.6-0.4c0.6,0,1.1,0.1,1.5,0.3c0.4,0.2,0.7,0.5,1,0.8c0.2,0.3,0.4,0.7,0.5,1.2c0.1,0.4,0.2,1,0.2,1.6V80.8z  M215.4,75.5c0-0.7-0.1-1.2-0.4-1.6c-0.3-0.4-0.8-0.6-1.4-0.6c-0.3,0-0.6,0.1-0.8,0.2c-0.2,0.1-0.4,0.3-0.6,0.5 c-0.2,0.2-0.3,0.4-0.4,0.7c-0.1,0.3-0.1,0.6-0.1,0.9H215.4z M217.8,76.2c0,0.3-0.1,0.5-0.2,0.7c-0.1,0.1-0.3,0.2-0.5,0.2h-5.3 c0,0.4,0,0.7,0.1,1c0.1,0.3,0.2,0.6,0.4,0.8c0.2,0.2,0.4,0.4,0.7,0.5c0.3,0.1,0.7,0.2,1.1,0.2c0.4,0,0.8,0,1.1-0.1 c0.3-0.1,0.6-0.1,0.8-0.2c0.2-0.1,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1 c0,0.1,0,0.1,0.1,0.2c0,0.1,0,0.2,0,0.4c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1 c0,0-0.2,0.1-0.3,0.2c-0.2,0.1-0.4,0.2-0.7,0.2c-0.3,0.1-0.6,0.1-1,0.2c-0.4,0.1-0.8,0.1-1.2,0.1c-0.8,0-1.5-0.1-2-0.3 c-0.6-0.2-1.1-0.5-1.5-0.9c-0.4-0.4-0.7-0.9-0.9-1.5c-0.2-0.6-0.3-1.3-0.3-2.1c0-0.8,0.1-1.5,0.3-2.1c0.2-0.6,0.5-1.1,0.9-1.6 c0.4-0.4,0.9-0.8,1.4-1c0.5-0.2,1.2-0.3,1.9-0.3c0.7,0,1.4,0.1,1.9,0.3c0.5,0.2,0.9,0.5,1.3,0.9c0.3,0.4,0.6,0.8,0.7,1.4 c0.2,0.5,0.2,1.1,0.2,1.7V76.2z M205.8,81.8c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.6-0.2-1-0.3l-1.7,0c-0.2,0.1-0.3,0.2-0.4,0.4 c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.3,0.2,0.6,0.5,0.7c0.3,0.2,0.8,0.3,1.4,0.3 c0.4,0,0.7,0,0.9-0.1c0.3-0.1,0.5-0.2,0.6-0.3c0.2-0.1,0.3-0.3,0.3-0.4C205.8,82.1,205.8,81.9,205.8,81.8z M205.2,74.8 c0-0.5-0.1-0.8-0.4-1.1c-0.3-0.3-0.6-0.4-1.1-0.4c-0.2,0-0.5,0-0.6,0.1c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0.1-0.2,0.3-0.3,0.5 c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.4,0.1,0.8,0.4,1c0.3,0.3,0.6,0.4,1.1,0.4c0.2,0,0.5,0,0.6-0.1c0.2-0.1,0.3-0.2,0.5-0.3 c0.1-0.1,0.2-0.3,0.3-0.5C205.2,75.2,205.2,75,205.2,74.8z M208.4,72.7c0,0.3,0,0.5-0.1,0.7c-0.1,0.1-0.2,0.2-0.3,0.2h-1 c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.6c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.4,0.7-0.7,1c-0.3,0.3-0.7,0.5-1.1,0.6 c-0.4,0.1-0.9,0.2-1.5,0.2c-0.3,0-0.5,0-0.8-0.1c-0.3-0.1-0.4-0.1-0.6-0.2c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.1,0.4 c0,0.2,0.1,0.3,0.2,0.5c0.2,0.1,0.4,0.2,0.7,0.2l2.1,0.1c0.5,0,0.9,0.1,1.3,0.2c0.4,0.1,0.7,0.3,1,0.5c0.3,0.2,0.5,0.5,0.6,0.8 c0.1,0.3,0.2,0.7,0.2,1c0,0.4-0.1,0.8-0.3,1.2c-0.2,0.4-0.5,0.7-0.8,1c-0.4,0.3-0.9,0.5-1.4,0.7c-0.6,0.2-1.2,0.2-2,0.2 c-0.7,0-1.4-0.1-1.9-0.2c-0.5-0.1-1-0.3-1.3-0.5c-0.3-0.2-0.6-0.5-0.7-0.7c-0.2-0.3-0.2-0.6-0.2-1c0-0.2,0-0.4,0.1-0.6 c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.2-0.3,0.4-0.5c0.2-0.2,0.3-0.3,0.5-0.5c-0.3-0.1-0.5-0.4-0.6-0.6c-0.2-0.3-0.2-0.5-0.2-0.8 c0-0.4,0.1-0.7,0.3-1c0.2-0.3,0.4-0.6,0.7-0.9c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.7-0.2-1.2c0-0.5,0.1-1,0.3-1.4 c0.2-0.4,0.4-0.7,0.7-1c0.3-0.3,0.7-0.5,1.1-0.6c0.4-0.1,0.9-0.2,1.5-0.2c0.3,0,0.5,0,0.8,0c0.2,0,0.5,0.1,0.7,0.1h2.8 c0.1,0,0.2,0.1,0.3,0.2C208.3,72.2,208.4,72.4,208.4,72.7z M195.7,77.1h-0.9c-0.4,0-0.7,0-1,0.1c-0.3,0.1-0.5,0.1-0.7,0.3 c-0.2,0.1-0.3,0.3-0.4,0.4c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.4,0.1,0.7,0.3,0.9c0.2,0.2,0.5,0.3,1,0.3c0.3,0,0.7-0.1,1-0.3 c0.3-0.2,0.6-0.4,0.9-0.8V77.1z M198.1,80.9c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.3,0-0.6,0c-0.3,0-0.5,0-0.6,0 c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.1-0.1-0.1-0.2v-0.7c-0.4,0.4-0.8,0.7-1.2,0.9c-0.5,0.2-1,0.3-1.5,0.3c-0.5,0-0.9-0.1-1.3-0.2 c-0.4-0.1-0.7-0.3-1-0.5c-0.3-0.2-0.5-0.5-0.7-0.9c-0.2-0.4-0.2-0.8-0.2-1.2c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.5-0.7,0.9-0.9 c0.4-0.2,0.9-0.4,1.5-0.5c0.6-0.1,1.3-0.2,2-0.2h0.9v-0.5c0-0.3,0-0.5-0.1-0.7c-0.1-0.2-0.1-0.4-0.3-0.5c-0.1-0.1-0.3-0.2-0.5-0.3 c-0.2-0.1-0.5-0.1-0.8-0.1c-0.4,0-0.8,0-1.1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3c-0.2,0.1-0.5,0.2-0.6,0.3c-0.2,0.1-0.3,0.1-0.4,0.1 c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.3,0-0.4c0-0.2,0-0.4,0-0.5c0-0.1,0.1-0.2,0.2-0.3 c0.1-0.1,0.2-0.2,0.5-0.3c0.2-0.1,0.5-0.2,0.8-0.3c0.3-0.1,0.6-0.2,1-0.2c0.4-0.1,0.7-0.1,1.1-0.1c0.7,0,1.3,0.1,1.8,0.2 c0.5,0.1,0.9,0.3,1.2,0.6c0.3,0.3,0.5,0.6,0.7,1.1c0.1,0.4,0.2,1,0.2,1.5V80.9z M189.1,80c0,0.3,0,0.5-0.1,0.7 c0,0.2-0.1,0.3-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.3,0.1-0.5,0.1c-0.2,0-0.4,0-0.5,0 c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.1-0.7-0.3-0.9-0.6c-0.2-0.3-0.4-0.6-0.5-1c-0.1-0.4-0.2-0.9-0.2-1.4v-4.5h-1c-0.1,0-0.2-0.1-0.3-0.2 c-0.1-0.2-0.1-0.4-0.1-0.8c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2c0,0,0.1,0,0.2,0h1v-1.9 c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.4-0.1c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0,0.4,0.1 c0.1,0,0.2,0.1,0.2,0.1c0,0.1,0.1,0.1,0.1,0.2v1.9h1.9c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3 c0,0.1,0,0.3,0,0.5c0,0.4,0,0.6-0.1,0.8c-0.1,0.2-0.2,0.2-0.3,0.2h-1.9v4.1c0,0.5,0.1,0.8,0.2,1.1c0.1,0.2,0.4,0.4,0.8,0.4 c0.1,0,0.2,0,0.4,0c0.1,0,0.2,0,0.3-0.1c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1 c0,0.1,0,0.2,0.1,0.3C189.1,79.7,189.1,79.8,189.1,80z M182.4,72.9c0,0.2,0,0.4,0,0.6c0,0.1,0,0.3-0.1,0.4c0,0.1-0.1,0.1-0.1,0.2 c0,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0.1 c-0.1,0.1-0.3,0.1-0.4,0.3c-0.1,0.1-0.3,0.3-0.5,0.5c-0.2,0.2-0.3,0.4-0.5,0.7v5.4c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1 c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.2-0.1c0-0.1-0.1-0.1-0.1-0.2 v-8.7c0-0.1,0-0.1,0-0.2c0,0,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.3,0,0.5,0c0.2,0,0.4,0,0.5,0c0.1,0,0.2,0,0.3,0.1 c0.1,0,0.1,0.1,0.2,0.1c0,0,0,0.1,0,0.2v1.1c0.2-0.3,0.4-0.6,0.6-0.8c0.2-0.2,0.4-0.4,0.6-0.5c0.2-0.1,0.4-0.2,0.5-0.3 c0.2,0,0.4-0.1,0.5-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.1 c0,0,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3C182.4,72.5,182.4,72.7,182.4,72.9z M172,77.1H171c-0.4,0-0.7,0-1,0.1c-0.3,0.1-0.5,0.1-0.7,0.3 c-0.2,0.1-0.3,0.3-0.4,0.4c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.4,0.1,0.7,0.3,0.9c0.2,0.2,0.5,0.3,1,0.3c0.3,0,0.7-0.1,1-0.3 c0.3-0.2,0.6-0.4,0.9-0.8V77.1z M174.4,80.9c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.3,0-0.6,0c-0.3,0-0.5,0-0.6,0 c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.1-0.1-0.1-0.2v-0.7c-0.4,0.4-0.8,0.7-1.2,0.9c-0.5,0.2-1,0.3-1.5,0.3c-0.5,0-0.9-0.1-1.3-0.2 c-0.4-0.1-0.7-0.3-1-0.5c-0.3-0.2-0.5-0.5-0.7-0.9c-0.2-0.4-0.2-0.8-0.2-1.2c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.5-0.7,0.9-0.9 c0.4-0.2,0.9-0.4,1.5-0.5c0.6-0.1,1.3-0.2,2-0.2h0.8v-0.5c0-0.3,0-0.5-0.1-0.7c-0.1-0.2-0.1-0.4-0.3-0.5c-0.1-0.1-0.3-0.2-0.5-0.3 c-0.2-0.1-0.5-0.1-0.8-0.1c-0.4,0-0.8,0-1.1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3c-0.2,0.1-0.5,0.2-0.6,0.3c-0.2,0.1-0.3,0.1-0.4,0.1 c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.3,0-0.4c0-0.2,0-0.4,0-0.5c0-0.1,0.1-0.2,0.2-0.3 c0.1-0.1,0.2-0.2,0.5-0.3c0.2-0.1,0.5-0.2,0.8-0.3c0.3-0.1,0.6-0.2,1-0.2c0.4-0.1,0.7-0.1,1.1-0.1c0.7,0,1.3,0.1,1.8,0.2 c0.5,0.1,0.9,0.3,1.2,0.6c0.3,0.3,0.5,0.6,0.7,1.1c0.1,0.4,0.2,1,0.2,1.5V80.9z M165.2,79.3c0,0.2,0,0.3,0,0.4c0,0.1,0,0.2,0,0.3 c0,0.1,0,0.2-0.1,0.2c0,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.6,0.2-1,0.3 c-0.4,0.1-0.8,0.1-1.2,0.1c-0.9,0-1.6-0.1-2.3-0.4c-0.7-0.3-1.3-0.7-1.8-1.2c-0.5-0.5-0.9-1.2-1.1-2c-0.3-0.8-0.4-1.7-0.4-2.8 c0-1.1,0.1-2,0.4-2.9c0.3-0.8,0.7-1.5,1.2-2.1c0.5-0.6,1.1-1,1.8-1.3c0.7-0.3,1.5-0.4,2.4-0.4c0.4,0,0.7,0,1,0.1 c0.3,0.1,0.6,0.1,0.9,0.2c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.4,0.2,0.5,0.3c0.1,0.1,0.2,0.2,0.2,0.2c0,0.1,0.1,0.1,0.1,0.2 c0,0.1,0,0.2,0,0.3c0,0.1,0,0.3,0,0.5c0,0.2,0,0.4,0,0.5c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1 c-0.1,0-0.2-0.1-0.4-0.2c-0.1-0.1-0.3-0.2-0.6-0.4c-0.2-0.1-0.5-0.3-0.8-0.4c-0.3-0.1-0.7-0.2-1.2-0.2c-0.5,0-0.9,0.1-1.3,0.3 c-0.4,0.2-0.7,0.5-1,0.9c-0.3,0.4-0.5,0.8-0.6,1.4c-0.1,0.5-0.2,1.1-0.2,1.8c0,0.7,0.1,1.4,0.2,1.9c0.2,0.5,0.4,1,0.7,1.3 c0.3,0.3,0.6,0.6,1,0.8c0.4,0.2,0.9,0.3,1.4,0.3c0.5,0,0.8-0.1,1.2-0.2c0.3-0.1,0.6-0.2,0.9-0.4c0.2-0.1,0.4-0.2,0.6-0.4 c0.2-0.1,0.3-0.2,0.4-0.2c0.1,0,0.1,0,0.2,0c0,0,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0.1,0.3C165.2,78.8,165.2,79,165.2,79.3z M147.4,75.5 c0-0.7-0.1-1.2-0.4-1.6c-0.3-0.4-0.8-0.6-1.4-0.6c-0.3,0-0.6,0.1-0.8,0.2c-0.2,0.1-0.4,0.3-0.6,0.5c-0.2,0.2-0.3,0.4-0.4,0.7 c-0.1,0.3-0.1,0.6-0.1,0.9H147.4z M149.8,76.2c0,0.3-0.1,0.5-0.2,0.7c-0.1,0.1-0.3,0.2-0.5,0.2h-5.3c0,0.4,0,0.7,0.1,1 c0.1,0.3,0.2,0.6,0.4,0.8c0.2,0.2,0.4,0.4,0.7,0.5c0.3,0.1,0.7,0.2,1.1,0.2c0.4,0,0.8,0,1.1-0.1c0.3-0.1,0.6-0.1,0.8-0.2 c0.2-0.1,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1,0.1,0.2c0,0.1,0,0.2,0,0.4 c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1c0,0-0.2,0.1-0.3,0.2c-0.2,0.1-0.4,0.2-0.7,0.2 c-0.3,0.1-0.6,0.1-1,0.2c-0.4,0.1-0.8,0.1-1.2,0.1c-0.8,0-1.5-0.1-2-0.3c-0.6-0.2-1.1-0.5-1.5-0.9c-0.4-0.4-0.7-0.9-0.9-1.5 c-0.2-0.6-0.3-1.3-0.3-2.1c0-0.8,0.1-1.5,0.3-2.1c0.2-0.6,0.5-1.1,0.9-1.6c0.4-0.4,0.9-0.8,1.4-1c0.5-0.2,1.2-0.3,1.9-0.3 c0.7,0,1.4,0.1,1.9,0.3c0.5,0.2,0.9,0.5,1.3,0.9c0.3,0.4,0.6,0.8,0.7,1.4c0.2,0.5,0.2,1.1,0.2,1.7V76.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.6,94.6c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0h-4.1c-0.1,0-0.1,0-0.1,0 c0,0-0.1,0-0.1-0.1c0,0,0-0.1-0.1-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0.1-0.1 c0,0,0.1-0.1,0.1-0.1l1.4-1.5c0.3-0.3,0.6-0.7,0.8-0.9c0.2-0.3,0.4-0.5,0.5-0.8c0.1-0.2,0.2-0.4,0.2-0.6c0-0.2,0.1-0.4,0.1-0.5 c0-0.2,0-0.3-0.1-0.5c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.4,0-0.6,0.1 c-0.2,0.1-0.3,0.1-0.5,0.2c-0.1,0.1-0.3,0.1-0.3,0.2c-0.1,0.1-0.2,0.1-0.2,0.1c0,0-0.1,0-0.1,0c0,0,0,0-0.1-0.1c0,0,0-0.1,0-0.1 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.2-0.2 c0.1-0.1,0.3-0.1,0.4-0.2c0.2-0.1,0.4-0.1,0.6-0.2c0.2,0,0.4-0.1,0.6-0.1c0.4,0,0.7,0.1,0.9,0.2c0.3,0.1,0.5,0.2,0.7,0.4 c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.1,0.5,0.1,0.7c0,0.2,0,0.5-0.1,0.7c0,0.2-0.1,0.5-0.3,0.8c-0.1,0.3-0.3,0.6-0.6,0.9 c-0.3,0.3-0.6,0.7-1,1.1l-1.2,1.2h3.2c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1C218.6,94.5,218.6,94.5,218.6,94.6  M211.8,93.2c0-0.2,0-0.3-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.4c-0.2-0.1-0.4-0.2-0.7-0.4 c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.1,0.3-0.1,0.5c0,0.4,0.1,0.7,0.4,0.9 c0.3,0.2,0.6,0.3,1.1,0.3c0.5,0,0.9-0.1,1.1-0.3C211.7,93.9,211.8,93.6,211.8,93.2z M211.6,89.4c0-0.2,0-0.3-0.1-0.4 c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.2-0.4-0.2c-0.2,0-0.3-0.1-0.5-0.1c-0.4,0-0.7,0.1-0.9,0.3c-0.2,0.2-0.3,0.4-0.3,0.8 c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.3c0.2,0.1,0.4,0.2,0.6,0.3c0.4-0.2,0.7-0.4,0.9-0.7 C211.5,89.9,211.6,89.6,211.6,89.4z M212.8,93.1c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.2-0.3,0.5-0.5,0.6c-0.2,0.2-0.5,0.3-0.8,0.4 c-0.3,0.1-0.7,0.1-1.1,0.1c-0.4,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.2-0.8-0.4c-0.2-0.2-0.4-0.3-0.5-0.6c-0.1-0.2-0.2-0.5-0.2-0.8 c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.2-0.4,0.3-0.5c0.1-0.2,0.3-0.3,0.5-0.5c0.2-0.1,0.4-0.3,0.7-0.4c-0.2-0.1-0.4-0.2-0.6-0.4 c-0.2-0.1-0.3-0.3-0.4-0.4c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.3,0-0.5,0.1-0.7c0.1-0.2,0.2-0.4,0.4-0.6 c0.2-0.2,0.4-0.3,0.7-0.4c0.3-0.1,0.6-0.1,1-0.1c0.4,0,0.7,0,1,0.1c0.3,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.3,0.3,0.4,0.5 c0.1,0.2,0.1,0.4,0.1,0.7c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.2-0.3,0.3-0.4,0.4c-0.2,0.1-0.4,0.3-0.6,0.4 c0.3,0.1,0.5,0.3,0.7,0.4c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.3,0.3,0.3,0.5C212.8,92.7,212.8,92.9,212.8,93.1z M206.8,94.6 c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0h-3.8c0,0-0.1,0-0.1,0c0,0,0,0-0.1-0.1c0,0,0-0.1,0-0.1 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0h1.5v-5.6l-1.4,0.8c-0.1,0-0.1,0.1-0.2,0.1 c0,0-0.1,0-0.1,0c0,0,0-0.1-0.1-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0.1-0.1l1.7-1.1 c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1 c0,0,0,0,0,0.1v6.5h1.3c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0.1c0,0,0,0.1,0,0.1C206.8,94.5,206.8,94.6,206.8,94.6z M198,94.9 C198,94.9,198,94.9,198,94.9c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.1,0 c0,0-0.1,0-0.1-0.1c0,0,0,0,0-0.1v-3c0-0.3,0-0.5-0.1-0.7c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.1-0.5-0.1 c-0.2,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.5,0.4-0.7,0.7v3.6c0,0,0,0.1,0,0.1c0,0,0,0-0.1,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0,0,0,0-0.1v-5.1c0,0,0-0.1,0-0.1c0,0,0,0,0.1-0.1c0,0,0.1,0,0.1,0 c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0.1v0.7c0.3-0.3,0.6-0.6,0.9-0.7 c0.3-0.1,0.6-0.2,0.9-0.2c0.3,0,0.6,0.1,0.9,0.2c0.2,0.1,0.4,0.3,0.6,0.5c0.1,0.2,0.2,0.4,0.3,0.7c0.1,0.3,0.1,0.6,0.1,0.9V94.9z  M191.2,91.8c0-0.5-0.1-0.9-0.3-1.2c-0.2-0.3-0.6-0.4-1-0.4c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.3,0.2-0.4,0.3 c-0.1,0.1-0.2,0.3-0.3,0.5c-0.1,0.2-0.1,0.4-0.1,0.6H191.2z M192.2,92.1c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-3.4 c0,0.3,0,0.5,0.1,0.8c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.5,0.1,0.8,0.1c0.2,0,0.5,0,0.6-0.1 c0.2,0,0.4-0.1,0.5-0.1c0.1,0,0.3-0.1,0.3-0.1c0.1,0,0.2-0.1,0.2-0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.2c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0-0.1,0.1c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.4,0.1 c-0.2,0-0.4,0.1-0.6,0.1c-0.2,0-0.4,0.1-0.7,0.1c-0.4,0-0.8-0.1-1.1-0.2c-0.3-0.1-0.6-0.3-0.8-0.5c-0.2-0.2-0.4-0.5-0.5-0.9 c-0.1-0.3-0.2-0.8-0.2-1.2c0-0.4,0.1-0.8,0.2-1.2c0.1-0.3,0.3-0.6,0.5-0.9c0.2-0.2,0.5-0.4,0.8-0.6c0.3-0.1,0.6-0.2,1-0.2 c0.4,0,0.7,0.1,1,0.2c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.3,0.1,0.6,0.1,0.9V92.1z M182.5,92.6h-0.8 c-0.3,0-0.5,0-0.7,0.1c-0.2,0-0.3,0.1-0.5,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.3,0.1,0.5,0.3,0.6 c0.2,0.2,0.4,0.2,0.7,0.2c0.2,0,0.5-0.1,0.7-0.2c0.2-0.1,0.4-0.3,0.7-0.6V92.6z M183.4,94.9c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0.1 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1v-0.5c-0.2,0.2-0.5,0.4-0.7,0.6 c-0.3,0.1-0.6,0.2-0.9,0.2c-0.3,0-0.5,0-0.7-0.1c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.3-0.3-0.4-0.5c-0.1-0.2-0.1-0.4-0.1-0.7 c0-0.3,0.1-0.5,0.2-0.8c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.5-0.2,0.8-0.3c0.3-0.1,0.7-0.1,1.1-0.1h0.7v-0.4c0-0.2,0-0.4-0.1-0.5 c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.3,0.1-0.5,0.2 c-0.1,0.1-0.3,0.1-0.3,0.2c-0.1,0.1-0.2,0.1-0.2,0.1c0,0-0.1,0-0.1,0c0,0,0,0-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.2 c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0.1-0.2c0.1,0,0.1-0.1,0.3-0.2c0.1-0.1,0.3-0.1,0.4-0.2c0.2-0.1,0.3-0.1,0.5-0.1 c0.2,0,0.4-0.1,0.6-0.1c0.4,0,0.7,0,0.9,0.1c0.3,0.1,0.5,0.2,0.6,0.4c0.2,0.2,0.3,0.4,0.3,0.6c0.1,0.2,0.1,0.5,0.1,0.8V94.9z  M176.9,91.3c-0.3-0.3-0.5-0.6-0.7-0.7c-0.2-0.2-0.5-0.2-0.7-0.2c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.3-0.4,0.5 c-0.1,0.2-0.2,0.4-0.2,0.6c0,0.2-0.1,0.5-0.1,0.7c0,0.3,0,0.5,0.1,0.8c0,0.2,0.1,0.5,0.2,0.7c0.1,0.2,0.2,0.3,0.4,0.5 c0.2,0.1,0.4,0.2,0.6,0.2c0.1,0,0.2,0,0.4-0.1c0.1,0,0.2-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.3-0.3,0.4-0.5V91.3z  M177.8,94.9C177.8,94.9,177.8,94.9,177.8,94.9c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1v-0.7c-0.3,0.3-0.5,0.5-0.8,0.7c-0.3,0.2-0.6,0.2-1,0.2c-0.4,0-0.7-0.1-1-0.2 c-0.3-0.1-0.5-0.3-0.6-0.6c-0.2-0.2-0.3-0.5-0.4-0.9c-0.1-0.3-0.1-0.7-0.1-1.1c0-0.4,0-0.8,0.1-1.2c0.1-0.4,0.2-0.7,0.4-0.9 c0.2-0.3,0.4-0.4,0.7-0.6c0.3-0.1,0.6-0.2,1-0.2c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.5,0.3,0.7,0.6v-3c0,0,0-0.1,0-0.1c0,0,0,0,0.1-0.1 c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1V94.9z M170.8,92.6H170 c-0.3,0-0.5,0-0.7,0.1c-0.2,0-0.3,0.1-0.5,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.3,0.1,0.5,0.3,0.6 c0.2,0.2,0.4,0.2,0.7,0.2c0.2,0,0.5-0.1,0.7-0.2c0.2-0.1,0.4-0.3,0.7-0.6V92.6z M171.7,94.9c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0.1 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1v-0.5c-0.2,0.2-0.5,0.4-0.7,0.6 c-0.3,0.1-0.6,0.2-0.9,0.2c-0.3,0-0.5,0-0.7-0.1c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.3-0.3-0.4-0.5c-0.1-0.2-0.1-0.4-0.1-0.7 c0-0.3,0.1-0.5,0.2-0.8c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.5-0.2,0.8-0.3c0.3-0.1,0.7-0.1,1.1-0.1h0.7v-0.4c0-0.2,0-0.4-0.1-0.5 c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.3,0.1-0.5,0.2 c-0.1,0.1-0.3,0.1-0.3,0.2c-0.1,0.1-0.2,0.1-0.2,0.1c0,0-0.1,0-0.1,0c0,0,0,0-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.2 c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0.1-0.2c0.1,0,0.1-0.1,0.3-0.2c0.1-0.1,0.3-0.1,0.4-0.2c0.2-0.1,0.3-0.1,0.5-0.1 c0.2,0,0.4-0.1,0.6-0.1c0.4,0,0.7,0,0.9,0.1c0.3,0.1,0.5,0.2,0.6,0.4c0.2,0.2,0.3,0.4,0.3,0.6c0.1,0.2,0.1,0.5,0.1,0.8V94.9z  M165.2,91.3c-0.3-0.3-0.5-0.6-0.7-0.7c-0.2-0.2-0.5-0.2-0.7-0.2c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.3-0.4,0.5 c-0.1,0.2-0.2,0.4-0.2,0.6c0,0.2-0.1,0.5-0.1,0.7c0,0.3,0,0.5,0.1,0.8c0,0.2,0.1,0.5,0.2,0.7c0.1,0.2,0.2,0.3,0.4,0.5 c0.2,0.1,0.4,0.2,0.6,0.2c0.1,0,0.2,0,0.4-0.1c0.1,0,0.2-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.3-0.3,0.4-0.5V91.3z  M166.1,94.9C166.1,94.9,166.1,94.9,166.1,94.9c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1v-0.7c-0.3,0.3-0.5,0.5-0.8,0.7c-0.3,0.2-0.6,0.2-1,0.2c-0.4,0-0.7-0.1-1-0.2 c-0.3-0.1-0.5-0.3-0.6-0.6c-0.2-0.2-0.3-0.5-0.4-0.9c-0.1-0.3-0.1-0.7-0.1-1.1c0-0.4,0-0.8,0.1-1.2c0.1-0.4,0.2-0.7,0.4-0.9 c0.2-0.3,0.4-0.4,0.7-0.6c0.3-0.1,0.6-0.2,1-0.2c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.5,0.3,0.7,0.6v-3c0,0,0-0.1,0-0.1c0,0,0,0,0.1-0.1 c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1V94.9z M160,94.9 C160,94.9,160,94.9,160,94.9c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.1,0 c0,0-0.1,0-0.1-0.1c0,0,0,0,0-0.1v-3c0-0.3,0-0.5-0.1-0.7c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.1-0.5-0.1 c-0.2,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.5,0.4-0.7,0.7v3.6c0,0,0,0.1,0,0.1c0,0,0,0-0.1,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0,0,0,0-0.1v-5.1c0,0,0-0.1,0-0.1c0,0,0,0,0.1-0.1c0,0,0.1,0,0.1,0 c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0.1v0.7c0.3-0.3,0.6-0.6,0.9-0.7 c0.3-0.1,0.6-0.2,0.9-0.2c0.3,0,0.6,0.1,0.9,0.2c0.2,0.1,0.4,0.3,0.6,0.5c0.1,0.2,0.2,0.4,0.3,0.7c0.1,0.3,0.1,0.6,0.1,0.9V94.9z  M153.9,94.9C153.9,94.9,153.9,94.9,153.9,94.9c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0 c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0,0,0,0-0.1v-0.7c-0.3,0.3-0.6,0.6-0.9,0.7c-0.3,0.1-0.6,0.2-0.9,0.2 c-0.3,0-0.6-0.1-0.9-0.2c-0.2-0.1-0.4-0.3-0.6-0.5c-0.1-0.2-0.2-0.4-0.3-0.7c-0.1-0.3-0.1-0.6-0.1-0.9v-3.1c0,0,0-0.1,0-0.1 c0,0,0,0,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0.1v3 c0,0.3,0,0.5,0.1,0.7c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.3,0.1,0.5,0.1c0.2,0,0.5-0.1,0.7-0.3 c0.2-0.2,0.5-0.4,0.7-0.7v-3.6c0,0,0-0.1,0-0.1c0,0,0,0,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0 c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0.1V94.9z M148.1,88.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1 c0,0-0.1,0-0.1,0h-2.7V91h2.6c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2 c0,0.1,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0h-2.6v3.1c0,0,0,0.1,0,0.1c0,0,0,0-0.1,0.1c0,0-0.1,0-0.1,0 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1v-6.8c0-0.1,0-0.3,0.1-0.3 c0.1-0.1,0.2-0.1,0.2-0.1h3.3c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0.1c0,0,0,0.1,0,0.1C148.1,87.9,148.1,88,148.1,88.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224.6,88.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.1c0,0,0,0.1-0.1,0.2l-2.7,6.1 c0,0,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2-0.1 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1l2.8-6.3H220c-0.1,0-0.1,0-0.2-0.1c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1 c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0h4.3c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1C224.6,87.9,224.6,88,224.6,88.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.5,86.2c-7.2,2.9-7.4,2.3-11.8,9.7l-2.8,3.7l-1.7,3.4c-1.5,1.1-2.8,0.5-3.1-0.1l3.2-3.9 c1.1-1.5,2.3-3,3.4-4.5c2-2.7,3.8-5,6.2-7.4c1.1-1.1,2.4-2.6,3.4-3.8c0.1,0.8,0,1.6-0.1,2.4C64.3,85.1,65.5,85.5,66.5,86.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.5,86.2c-7.2,2.9-7.4,2.3-11.8,9.7l-2.8,3.7l-1.7,3.4c-1.5,1.1-2.8,0.5-3.1-0.1l3.2-3.9 c1.1-1.5,2.3-3,3.4-4.5c2-2.7,3.8-5,6.2-7.4c1.1-1.1,2.4-2.6,3.4-3.8c0.1,0.8,0,1.6-0.1,2.4C64.3,85.1,65.5,85.5,66.5,86.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.5,86.2c7.2,2.9,7.4,2.3,11.8,9.6l2.8,3.7l1.7,3.4c1.5,1.1,2.8,0.5,3.1-0.1L63.7,99c-1.1-1.5-2.3-3-3.4-4.5 c-2-2.7-3.8-5-6.2-7.4c-1.1-1.1-2.4-2.6-3.4-3.8c-0.1,0.8,0,1.6,0.1,2.4C49.6,85.1,48.5,85.4,47.5,86.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.5,86.2c7.2,2.9,7.4,2.3,11.8,9.6l2.8,3.7l1.7,3.4c1.5,1.1,2.8,0.5,3.1-0.1L63.7,99c-1.1-1.5-2.3-3-3.4-4.5 c-2-2.7-3.8-5-6.2-7.4c-1.1-1.1-2.4-2.6-3.4-3.8c-0.1,0.8,0,1.6,0.1,2.4C49.6,85.1,48.5,85.4,47.5,86.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.5,88.8c7.4-4.4,17.4-4,25-3c0.8,0.1,1.1,0.5,1.3,0.8L86.6,88c4.6,3.6,8.4,4.1,12.7,1.5 c2.5-1.6,5.5-1.8,7.6-1.7c-0.7,0.8-1.4,1.6-1.5,2.6c0.1,0.9,0.7,1.6,1.2,2.4c-4,0.8-6.4,2.3-7.6,2.8c-5.4,2.1-11.2,0.6-16.4-4 c-0.1-0.1-0.3-0.1-0.4-0.2c0,0,0,0,0,0c0,0,0,0,0,0l-0.2-0.8c0,0,0,0,0,0l0,0l0-0.1c-6.3-0.6-12.1,0.1-18.5,3c0,0.2,0.1,0.5,0.1,0.7 c-0.2,0-0.3,0.1-0.5,0.1l0,0.1l-0.1,0c-4.2,1.1-8.2,1.4-12.4-0.1l0,0l0.1-0.6c-6.8-3.4-12.8-4.1-19.4-3.5l0,0.1l0.4,0.5c0,0,0,0,0,0 l0,0.1c0,0-0.1,0-0.1,0c-0.2,0.3-0.3,0.6-0.6,0.8c-5.2,4.6-11,6-16.4,4c-1.2-0.5-3.3-2.7-7.1-2.8c0.5-0.8,1.1-1.5,1.2-2.4 c-0.2-1-0.8-1.8-1.5-2.6c2.1-0.1,4.6,0.1,7.2,1.7c4.2,2.6,7.9,2.1,12.4-1.2l-0.4-2.2c0.2-0.3,0.5-0.7,1.3-0.8 c8.1-1.3,18-0.8,25.5,3.2c0.1,0,0.2,0,0.3,0l-0.1,1.1c2.4,0.5,4.7,0.5,7.1,0.2l-0.1-1.3C60.3,88.8,60.4,88.8,60.5,88.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.5,88.8c7.4-4.4,17.4-4,25-3c0.8,0.1,1.1,0.5,1.3,0.8L86.6,88c4.6,3.6,8.4,4.1,12.7,1.5 c2.5-1.6,5.5-1.8,7.6-1.7c-0.7,0.8-1.4,1.6-1.5,2.6c0.1,0.9,0.7,1.6,1.2,2.4c-4,0.8-6.4,2.3-7.6,2.8c-5.4,2.1-11.2,0.6-16.4-4 c-0.1-0.1-0.3-0.1-0.4-0.2c0,0,0,0,0,0c0,0,0,0,0,0l-0.2-0.8c0,0,0,0,0,0l0,0l0-0.1c-6.3-0.6-12.1,0.1-18.5,3c0,0.2,0.1,0.5,0.1,0.7 c-0.2,0-0.3,0.1-0.5,0.1l0,0.1l-0.1,0c-4.2,1.1-8.2,1.4-12.4-0.1l0,0l0.1-0.6c-6.8-3.4-12.8-4.1-19.4-3.5l0,0.1l0.4,0.5c0,0,0,0,0,0 l0,0.1c0,0-0.1,0-0.1,0c-0.2,0.3-0.3,0.6-0.6,0.8c-5.2,4.6-11,6-16.4,4c-1.2-0.5-3.3-2.7-7.1-2.8c0.5-0.8,1.1-1.5,1.2-2.4 c-0.2-1-0.8-1.8-1.5-2.6c2.1-0.1,4.6,0.1,7.2,1.7c4.2,2.6,7.9,2.1,12.4-1.2l-0.4-2.2c0.2-0.3,0.5-0.7,1.3-0.8 c8.1-1.3,18-0.8,25.5,3.2c0.1,0,0.2,0,0.3,0l-0.1,1.1c2.4,0.5,4.7,0.5,7.1,0.2l-0.1-1.3C60.3,88.8,60.4,88.8,60.5,88.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.9,91l4.2-0.7l0.5,0.7C29.9,91.2,28.1,91.2,26.9,91z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26.9,91l4.2-0.7l0.5,0.7C29.9,91.2,28.1,91.2,26.9,91z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53.3,88.8c-0.7,0.1-1.3,0.3-1.9,0.5c0.6,0.2,1.2,0.3,1.8,0.5L53.3,88.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M53.3,88.8c-0.7,0.1-1.3,0.3-1.9,0.5c0.6,0.2,1.2,0.3,1.8,0.5L53.3,88.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.2,88.8c0.8,0.1,1.6,0.3,2.5,0.7c-0.8,0.2-1.5,0.4-2.4,0.5L60.2,88.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.2,88.8c0.8,0.1,1.6,0.3,2.5,0.7c-0.8,0.2-1.5,0.4-2.4,0.5L60.2,88.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.8,90.5c1.4,0.1,2.7,0.3,4.1,0.5c-1.3,0-2.5,0.1-3.8,0.4C82.1,91.1,81.9,90.8,81.8,90.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M81.8,90.5c1.4,0.1,2.7,0.3,4.1,0.5c-1.3,0-2.5,0.1-3.8,0.4C82.1,91.1,81.9,90.8,81.8,90.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.2,86.4l0.7,4.6L26.2,86.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26.2,86.4l0.7,4.6L26.2,86.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51.5,89.3l-1,5L51.5,89.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51.5,89.3l-1,5L51.5,89.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.6,89.5l0.9,4.5L62.6,89.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M62.6,89.5l0.9,4.5L62.6,89.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.6,88L86,91L86.6,88z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M86.6,88L86,91L86.6,88z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M97.4,93.4l-0.7,0.1l-0.1,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0,0.1,0.1c0,0,0.1,0,0.2,0l0,0l-0.6,0.1l0,0 c0.1,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.3l0.3-1.6l0,0l0.9,1.3c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0.1,0,0.2,0l0,0L97.5,94l0,0 c0.1,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.2L97.4,93.4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.4,93.4l-0.7,0.1l-0.1,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0,0.1,0.1c0,0,0.1,0,0.2,0l0,0l-0.6,0.1l0,0 c0.1,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.3l0.3-1.6l0,0l0.9,1.3c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0.1,0,0.2,0l0,0L97.5,94l0,0 c0.1,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.2L97.4,93.4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M104.7,91l-0.6,0.2l0,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0,0.1,0.1c0,0,0.1,0,0.2,0l0,0l-0.5,0.2l0,0 c0.1,0,0.1-0.1,0.1-0.1c0-0.1,0-0.2,0-0.3l0.1-1.6l0,0l1.1,1.2c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0,0.1,0,0.2,0l0,0l-0.7,0.3l0,0 c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.2L104.7,91z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.7,91l-0.6,0.2l0,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0,0.1,0.1c0,0,0.1,0,0.2,0l0,0l-0.5,0.2l0,0 c0.1,0,0.1-0.1,0.1-0.1c0-0.1,0-0.2,0-0.3l0.1-1.6l0,0l1.1,1.2c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0,0.1,0,0.2,0l0,0l-0.7,0.3l0,0 c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.2L104.7,91z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M57.9,6.9L57.9,6.9c11.6,6.1,21.1,6.4,31.9,6.7c2.8,18.5,0.1,34.1-6.6,45.5c-5.9,10.1-15.4,17-25.3,24.2 C46.5,77,36.8,67.5,31.3,57.1c-6.9-13.1-7-30.4-5.5-43.9C37.7,13.3,48,11,57.9,6.9 M57.9,5.7c-10.2,4.6-20.6,7-33.4,6.3 c-1.6,14.2-1.8,31.9,5.4,45.7c5.7,10.9,16,21,28,27.7c10.4-7.6,20.4-14.9,26.6-25.5c7-12,9.3-27.9,6.4-47.4 C79.5,12.2,70.2,12.2,57.9,5.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.7088,
    y1: 45.5363,
    x2: 95.6453,
    y2: 45.5363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.7,
    y: 5.7,
    className: "st6",
    width: 71.2,
    height: 79.7
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.9,6.9L57.9,6.9c11.6,6.1,21.1,6.4,31.9,6.7c2.8,18.5,0.1,34.1-6.6,45.5c-5.9,10.1-15.4,17-25.3,24.2 C46.5,77,36.8,67.5,31.3,57.1c-6.9-13.1-7-30.4-5.5-43.9C37.7,13.3,48,11,57.9,6.9z M57.9,5.7c-10.2,4.6-20.6,7-33.4,6.3 c-1.6,14.2-1.8,31.9,5.4,45.7c5.7,10.9,16,21,28,27.7c10.4-7.6,20.4-14.9,26.6-25.5c7-12,9.3-27.9,6.4-47.4 C79.5,12.2,70.2,12.2,57.9,5.7z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M100.1,91.4l0.2,0.7l0.4-0.1c0.1,0,0.2-0.1,0.2-0.1c0-0.1,0-0.1,0-0.2l0,0l0.2,0.6l0,0c0-0.1-0.1-0.1-0.1-0.1 c0,0-0.1,0-0.1,0c0,0-0.1,0-0.2,0l-0.4,0.1l0.2,0.6c0,0.1,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0l0.3-0.1c0.1,0,0.2-0.1,0.2-0.1 c0,0,0.1-0.1,0.1-0.1c0-0.1,0.1-0.2,0.1-0.3l0,0l0,0.5l-1.3,0.5l0,0l0.1,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.2 l-0.4-1.1c0-0.1-0.1-0.2-0.1-0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l1.3-0.5l0.2,0.4l0,0c0-0.1-0.1-0.1-0.1-0.2c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.2,0L100.1,91.4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.1,91.4l0.2,0.7l0.4-0.1c0.1,0,0.2-0.1,0.2-0.1c0-0.1,0-0.1,0-0.2l0,0l0.2,0.6l0,0c0-0.1-0.1-0.1-0.1-0.1 c0,0-0.1,0-0.1,0c0,0-0.1,0-0.2,0l-0.4,0.1l0.2,0.6c0,0.1,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0l0.3-0.1c0.1,0,0.2-0.1,0.2-0.1 c0,0,0.1-0.1,0.1-0.1c0-0.1,0.1-0.2,0.1-0.3l0,0l0,0.5l-1.3,0.5l0,0l0.1,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.2 l-0.4-1.1c0-0.1-0.1-0.2-0.1-0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l1.3-0.5l0.2,0.4l0,0c0-0.1-0.1-0.1-0.1-0.2c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.2,0L100.1,91.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M99.1,91.6l0.2,0.5l0,0C99.2,92,99.1,92,99,91.9c-0.1-0.1-0.3-0.1-0.4,0c-0.2,0.1-0.4,0.2-0.4,0.4 c0,0.2,0,0.4,0,0.6c0.1,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1-0.1,0.1-0.1 l-0.2-0.5c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0-0.1,0c0,0-0.1,0-0.2,0l0,0l0.7-0.2l0,0l0,0c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.2 l0.2,0.5c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.3,0.1-0.6,0.1-0.9-0.1c-0.2-0.1-0.3-0.3-0.4-0.5 c0-0.1-0.1-0.3,0-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.2-0.2,0.4-0.3c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.1,0 c0,0,0,0,0,0C99.1,91.7,99.1,91.7,99.1,91.6L99.1,91.6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.1,91.6l0.2,0.5l0,0C99.2,92,99.1,92,99,91.9c-0.1-0.1-0.3-0.1-0.4,0c-0.2,0.1-0.4,0.2-0.4,0.4 c0,0.2,0,0.4,0,0.6c0.1,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1-0.1,0.1-0.1 l-0.2-0.5c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0-0.1,0c0,0-0.1,0-0.2,0l0,0l0.7-0.2l0,0l0,0c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.2 l0.2,0.5c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.3,0.1-0.6,0.1-0.9-0.1c-0.2-0.1-0.3-0.3-0.4-0.5 c0-0.1-0.1-0.3,0-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.2-0.2,0.4-0.3c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.1,0 c0,0,0,0,0,0C99.1,91.7,99.1,91.7,99.1,91.6L99.1,91.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "97.3,93.4 96.9,92.7 96.7,93.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "97.3,93.4 96.9,92.7 96.7,93.5 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "104.7,90.9 104.1,90.3 104.1,91.1 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "104.7,90.9 104.1,90.3 104.1,91.1 "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M96.2,92.6l0.1,0.4l-0.1,0c0-0.1,0-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.2,0l-0.3,0l0.1,1.4 c0,0.1,0,0.2,0.1,0.2c0,0,0.1,0,0.2,0l0.1,0l0,0l-0.8,0.1l0,0l0.1,0c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1,0-0.2l-0.1-1.4l-0.2,0 c-0.1,0-0.1,0-0.2,0c0,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2l-0.1,0l0-0.4L96.2,92.6z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.2,92.6l0.1,0.4l-0.1,0c0-0.1,0-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.2,0l-0.3,0l0.1,1.4 c0,0.1,0,0.2,0.1,0.2c0,0,0.1,0,0.2,0l0.1,0l0,0l-0.8,0.1l0,0l0.1,0c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1,0-0.2l-0.1-1.4l-0.2,0 c-0.1,0-0.1,0-0.2,0c0,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2l-0.1,0l0-0.4L96.2,92.6z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M94.7,94.6l-0.5,0l-0.6-0.9c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0.5c0,0.1,0,0.2,0,0.2 c0,0,0.1,0.1,0.1,0.1l0.1,0l0,0l-0.8,0l0,0l0.1,0c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1,0-0.2l0-1.2c0-0.1,0-0.2,0-0.2c0,0-0.1-0.1-0.2-0.1 l-0.1,0l0,0l0.7,0c0.2,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3 c-0.1,0.1-0.2,0.1-0.3,0.2l0.4,0.5c0.1,0.1,0.2,0.2,0.2,0.2C94.5,94.5,94.6,94.5,94.7,94.6L94.7,94.6z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.7,94.6l-0.5,0l-0.6-0.9c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0.5c0,0.1,0,0.2,0,0.2 c0,0,0.1,0.1,0.1,0.1l0.1,0l0,0l-0.8,0l0,0l0.1,0c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1,0-0.2l0-1.2c0-0.1,0-0.2,0-0.2c0,0-0.1-0.1-0.2-0.1 l-0.1,0l0,0l0.7,0c0.2,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3 c-0.1,0.1-0.2,0.1-0.3,0.2l0.4,0.5c0.1,0.1,0.2,0.2,0.2,0.2C94.5,94.5,94.6,94.5,94.7,94.6L94.7,94.6z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M92.1,93.8l-0.7-0.1l-0.2,0.3c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0.1,0,0.2,0.1l0,0l-0.6-0.1l0,0 c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.2l0.9-1.3l0,0l0.3,1.6c0,0.1,0.1,0.2,0.1,0.3c0,0,0.1,0.1,0.2,0.1l0,0L92,94.4l0,0 c0.1,0,0.1,0,0.1,0c0,0,0,0,0.1-0.1c0,0,0-0.1,0-0.2L92.1,93.8z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.1,93.8l-0.7-0.1l-0.2,0.3c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0.1,0,0.2,0.1l0,0l-0.6-0.1l0,0 c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.2l0.9-1.3l0,0l0.3,1.6c0,0.1,0.1,0.2,0.1,0.3c0,0,0.1,0.1,0.2,0.1l0,0L92,94.4l0,0 c0.1,0,0.1,0,0.1,0c0,0,0,0,0.1-0.1c0,0,0-0.1,0-0.2L92.1,93.8z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M91.2,92.4L91,93l0,0c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0.1-0.3,0.2 c-0.1,0.1-0.2,0.3-0.2,0.4c-0.1,0.2-0.1,0.3-0.1,0.4c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.2,0.1,0.3,0 c0.1,0,0.2-0.1,0.4-0.2l0,0c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4,0c-0.3-0.1-0.5-0.3-0.5-0.5c-0.1-0.2,0-0.4,0-0.6 c0.1-0.2,0.2-0.3,0.3-0.4c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0.1,0.3,0.2c0,0,0,0,0.1,0.1c0,0,0,0,0.1,0 C91.1,92.5,91.1,92.5,91.2,92.4L91.2,92.4z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.2,92.4L91,93l0,0c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0.1-0.3,0.2 c-0.1,0.1-0.2,0.3-0.2,0.4c-0.1,0.2-0.1,0.3-0.1,0.4c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.2,0.1,0.3,0 c0.1,0,0.2-0.1,0.4-0.2l0,0c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4,0c-0.3-0.1-0.5-0.3-0.5-0.5c-0.1-0.2,0-0.4,0-0.6 c0.1-0.2,0.2-0.3,0.3-0.4c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0.1,0.3,0.2c0,0,0,0,0.1,0.1c0,0,0,0,0.1,0 C91.1,92.5,91.1,92.5,91.2,92.4L91.2,92.4z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M88.1,91.1l-0.3,0.6l0.3,0.2c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.2l0,0l-0.3,0.5l0,0c0-0.1,0-0.1,0-0.2 c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1l-0.3-0.2l-0.3,0.5c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0,0,0.1c0,0,0,0,0.1,0.1l0.3,0.1 c0.1,0,0.2,0.1,0.2,0.1c0,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.3-0.1l0,0L88,93l-1.2-0.7l0,0l0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0 c0,0,0.1-0.1,0.1-0.1l0.6-1c0.1-0.1,0.1-0.2,0.1-0.2c0,0,0-0.1-0.1-0.1l-0.1,0l0,0l1.2,0.7l-0.2,0.4l0,0c0-0.1,0-0.2,0-0.2 c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.2-0.1L88.1,91.1z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.1,91.1l-0.3,0.6l0.3,0.2c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.2l0,0l-0.3,0.5l0,0c0-0.1,0-0.1,0-0.2 c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1l-0.3-0.2l-0.3,0.5c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0,0,0.1c0,0,0,0,0.1,0.1l0.3,0.1 c0.1,0,0.2,0.1,0.2,0.1c0,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.3-0.1l0,0L88,93l-1.2-0.7l0,0l0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0 c0,0,0.1-0.1,0.1-0.1l0.6-1c0.1-0.1,0.1-0.2,0.1-0.2c0,0,0-0.1-0.1-0.1l-0.1,0l0,0l1.2,0.7l-0.2,0.4l0,0c0-0.1,0-0.2,0-0.2 c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.2-0.1L88.1,91.1z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M85.2,91.3L85.2,91.3L85.2,91.3c0.1,0,0.2,0,0.3,0c0,0,0.1-0.1,0.1-0.2l0.6-1c0.1-0.1,0.1-0.2,0.1-0.2 c0-0.1,0-0.1-0.1-0.1l-0.1,0l0,0l0.6,0.4c0.2,0.1,0.4,0.3,0.5,0.4c0.1,0.1,0.1,0.3,0.1,0.4c0,0.2-0.1,0.3-0.2,0.5 c-0.1,0.2-0.3,0.3-0.5,0.4c-0.2,0.1-0.5,0-0.8-0.2L85.2,91.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.2,91.3L85.2,91.3L85.2,91.3c0.1,0,0.2,0,0.3,0c0,0,0.1-0.1,0.1-0.2l0.6-1c0.1-0.1,0.1-0.2,0.1-0.2 c0-0.1,0-0.1-0.1-0.1l-0.1,0l0,0l0.6,0.4c0.2,0.1,0.4,0.3,0.5,0.4c0.1,0.1,0.1,0.3,0.1,0.4c0,0.2-0.1,0.3-0.2,0.5 c-0.1,0.2-0.3,0.3-0.5,0.4c-0.2,0.1-0.5,0-0.8-0.2L85.2,91.3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M26.4,91.9L26.4,91.9l-0.7-0.4l0.1,0.8L26.4,91.9z M26.5,91.9L26.5,91.9l-0.6,0.4l0.1,0.3c0,0.1,0,0.1,0,0.2 c0,0,0,0,0.1,0c0,0,0.1,0,0.2-0.1l0,0l-0.5,0.3l0,0c0.1-0.1,0.1-0.1,0.1-0.1c0-0.1,0-0.2,0-0.3l-0.3-1.6l0,0l1.3,0.9 c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l0,0l-0.6,0.4l0,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1L26.5,91.9 z M24.5,91.8L24.5,91.8l0.3,0.5l0,0c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.2-0.1,0.4 c0,0.1,0,0.3,0.1,0.5c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0,0.4-0.1c0.1,0,0.2-0.1,0.3-0.2 c0.1-0.1,0.1-0.2,0.1-0.4l0,0c0,0.2-0.1,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.1-0.5,0.1-0.8,0c-0.2-0.1-0.3-0.3-0.4-0.5 c-0.1-0.2-0.1-0.3-0.1-0.5c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.2-0.2,0.4-0.3C24,92,24.2,92,24.3,92c0,0,0.1,0,0.1,0c0,0,0,0,0,0 C24.4,91.9,24.4,91.8,24.5,91.8L24.5,91.8z M23.1,94.3L23.1,94.3L23.1,94.3l-0.7,0.2l0,0l0.1,0c0.1,0,0.1-0.1,0.1-0.1 c0,0,0-0.1,0-0.2L22.3,93c0-0.1,0-0.1-0.1-0.2c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0l-0.1,0l0,0l0.7-0.2l0,0l-0.1,0c-0.1,0-0.1,0.1-0.1,0.1 c0,0,0,0.1,0,0.2l0.3,1.1c0,0.1,0,0.1,0.1,0.2c0,0,0,0,0.1,0C23,94.3,23,94.3,23.1,94.3L23.1,94.3z M21.7,94.2L21.7,94.2L21.7,94.2 l0,0.5l-1.4,0.2l0,0l0.1,0c0.1,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.2l-0.2-1.1c0-0.1,0-0.2-0.1-0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l0.8-0.1 l0,0c-0.1,0-0.2,0-0.2,0.1s-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.2l0.2,1.1c0,0.1,0,0.1,0,0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.2,0l0.1,0 c0.1,0,0.2,0,0.3-0.1c0.1,0,0.1-0.1,0.1-0.1C21.6,94.4,21.6,94.3,21.7,94.2z M18.5,94.7L18.5,94.7c0.1,0,0.2,0.1,0.3,0.1 c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.1,0.1-0.3c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.1,0 c0,0-0.1,0-0.1,0L18.5,94.7z M18.6,93.8L18.6,93.8c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1-0.1,0.2-0.1 c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.4-0.1c-0.1,0-0.2,0-0.2,0L18.6,93.8z M19.3,94L19.3,94 c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.3,0-0.5,0L18,94.7l0,0 l0.1,0c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1,0-0.2l0.1-1.2c0-0.1,0-0.2,0-0.2c0,0-0.1-0.1-0.1-0.1l-0.1,0l0,0l0.8,0.1c0.1,0,0.3,0,0.3,0.1 c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.2C19.5,93.9,19.4,93.9,19.3,94z M17.2,92.9L17.2,92.9L17.2,92.9 l0.6,0.1l0,0l-0.1,0c-0.1,0-0.1,0-0.2,0c0,0,0,0.1-0.1,0.2L17.3,94c0,0.2-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.3,0.2 c-0.1,0-0.3,0-0.4,0c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.4l0.2-0.7c0-0.1,0-0.2,0-0.2 c0,0-0.1-0.1-0.1-0.1l-0.1,0l0,0l0.8,0.2l0,0l-0.1,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0.1-0.1,0.2l-0.2,0.8c0,0.1,0,0.1,0,0.2 c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.2-0.1c0.1-0.1,0.1-0.2,0.1-0.4 l0.2-0.7c0-0.1,0-0.2,0-0.2C17.4,93,17.3,92.9,17.2,92.9L17.2,92.9z M14.5,93L14.5,93l0.2-0.7c0.1,0,0.1,0,0.2,0 c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2,0.1-0.3,0c0,0-0.1,0-0.1,0 C14.6,93,14.5,93,14.5,93z M14.5,93L14.5,93c0.1,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0.1c0.2,0.1,0.3,0.1,0.4,0 c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2L14.3,92l0,0l0.1,0 c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.2l-0.4,1.1c0,0.1-0.1,0.2-0.1,0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l0.7,0.2l0,0l-0.1,0 c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.2L14.5,93z M12.9,91.5L12.9,91.5l-0.3,0.6l0.4,0.2c0.1,0,0.2,0.1,0.2,0 c0.1,0,0.1-0.1,0.2-0.2l0,0l-0.2,0.6l0,0c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1l-0.4-0.2l-0.2,0.5 c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0.1,0.1l0.3,0.1c0.1,0,0.2,0.1,0.2,0.1c0,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.3-0.2l0,0 L13,93.4l-1.3-0.5l0,0l0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0-0.1,0.1-0.2l0.5-1.1c0-0.1,0.1-0.2,0.1-0.2c0,0-0.1-0.1-0.1-0.1 l-0.1,0l0,0l1.3,0.5l-0.1,0.4l0,0c0-0.1,0-0.2,0-0.2c0,0,0-0.1-0.1-0.1c0,0-0.1-0.1-0.2-0.1L12.9,91.5z M10.6,91.2L10.6,91.2 C10.6,91.2,10.7,91.2,10.6,91.2C10.7,91.2,10.7,91.2,10.6,91.2c0.2,0.1,0.3,0.1,0.5,0.1c0.1,0,0.2-0.1,0.2-0.2 c0.1-0.1,0.1-0.2,0-0.3c0-0.1-0.1-0.2-0.2-0.2c0,0-0.1,0-0.2-0.1L10.6,91.2z M11.3,92.6l-0.4-0.2l-0.2-1c0,0-0.1,0-0.1,0 c0,0,0,0,0,0c0,0,0,0,0,0l-0.2,0.5c-0.1,0.1-0.1,0.2-0.1,0.2c0,0,0,0.1,0.1,0.1l0.1,0l0,0l-0.7-0.4l0,0l0.1,0c0.1,0,0.1,0,0.2,0 c0,0,0.1-0.1,0.1-0.2l0.5-1c0.1-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.1-0.1-0.1l-0.1,0l0,0l0.6,0.3c0.2,0.1,0.3,0.2,0.4,0.2 c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.3c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2,0-0.4,0l0.1,0.6c0,0.1,0,0.2,0.1,0.3 C11.2,92.4,11.3,92.5,11.3,92.6L11.3,92.6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.4,91.9L26.4,91.9l-0.7-0.4l0.1,0.8L26.4,91.9z M26.5,91.9L26.5,91.9l-0.6,0.4l0.1,0.3c0,0.1,0,0.1,0,0.2 c0,0,0,0,0.1,0c0,0,0.1,0,0.2-0.1l0,0l-0.5,0.3l0,0c0.1-0.1,0.1-0.1,0.1-0.1c0-0.1,0-0.2,0-0.3l-0.3-1.6l0,0l1.3,0.9 c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l0,0l-0.6,0.4l0,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1L26.5,91.9 z M24.5,91.8L24.5,91.8l0.3,0.5l0,0c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.2-0.1,0.4 c0,0.1,0,0.3,0.1,0.5c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0,0.4-0.1c0.1,0,0.2-0.1,0.3-0.2 c0.1-0.1,0.1-0.2,0.1-0.4l0,0c0,0.2-0.1,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.1-0.5,0.1-0.8,0c-0.2-0.1-0.3-0.3-0.4-0.5 c-0.1-0.2-0.1-0.3-0.1-0.5c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.2-0.2,0.4-0.3C24,92,24.2,92,24.3,92c0,0,0.1,0,0.1,0c0,0,0,0,0,0 C24.4,91.9,24.4,91.8,24.5,91.8L24.5,91.8z M23.1,94.3L23.1,94.3L23.1,94.3l-0.7,0.2l0,0l0.1,0c0.1,0,0.1-0.1,0.1-0.1 c0,0,0-0.1,0-0.2L22.3,93c0-0.1,0-0.1-0.1-0.2c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0l-0.1,0l0,0l0.7-0.2l0,0l-0.1,0c-0.1,0-0.1,0.1-0.1,0.1 c0,0,0,0.1,0,0.2l0.3,1.1c0,0.1,0,0.1,0.1,0.2c0,0,0,0,0.1,0C23,94.3,23,94.3,23.1,94.3L23.1,94.3z M21.7,94.2L21.7,94.2L21.7,94.2 l0,0.5l-1.4,0.2l0,0l0.1,0c0.1,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.2l-0.2-1.1c0-0.1,0-0.2-0.1-0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l0.8-0.1 l0,0c-0.1,0-0.2,0-0.2,0.1s-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.2l0.2,1.1c0,0.1,0,0.1,0,0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.2,0l0.1,0 c0.1,0,0.2,0,0.3-0.1c0.1,0,0.1-0.1,0.1-0.1C21.6,94.4,21.6,94.3,21.7,94.2z M18.5,94.7L18.5,94.7c0.1,0,0.2,0.1,0.3,0.1 c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.1,0.1-0.3c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.1,0 c0,0-0.1,0-0.1,0L18.5,94.7z M18.6,93.8L18.6,93.8c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1-0.1,0.2-0.1 c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.4-0.1c-0.1,0-0.2,0-0.2,0L18.6,93.8z M19.3,94L19.3,94 c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.3,0-0.5,0L18,94.7l0,0 l0.1,0c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1,0-0.2l0.1-1.2c0-0.1,0-0.2,0-0.2c0,0-0.1-0.1-0.1-0.1l-0.1,0l0,0l0.8,0.1c0.1,0,0.3,0,0.3,0.1 c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.2C19.5,93.9,19.4,93.9,19.3,94z M17.2,92.9L17.2,92.9L17.2,92.9 l0.6,0.1l0,0l-0.1,0c-0.1,0-0.1,0-0.2,0c0,0,0,0.1-0.1,0.2L17.3,94c0,0.2-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.3,0.2 c-0.1,0-0.3,0-0.4,0c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.4l0.2-0.7c0-0.1,0-0.2,0-0.2 c0,0-0.1-0.1-0.1-0.1l-0.1,0l0,0l0.8,0.2l0,0l-0.1,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0.1-0.1,0.2l-0.2,0.8c0,0.1,0,0.1,0,0.2 c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.2-0.1c0.1-0.1,0.1-0.2,0.1-0.4 l0.2-0.7c0-0.1,0-0.2,0-0.2C17.4,93,17.3,92.9,17.2,92.9L17.2,92.9z M14.5,93L14.5,93l0.2-0.7c0.1,0,0.1,0,0.2,0 c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2,0.1-0.3,0c0,0-0.1,0-0.1,0 C14.6,93,14.5,93,14.5,93z M14.5,93L14.5,93c0.1,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0.1c0.2,0.1,0.3,0.1,0.4,0 c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2L14.3,92l0,0l0.1,0 c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.2l-0.4,1.1c0,0.1-0.1,0.2-0.1,0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l0.7,0.2l0,0l-0.1,0 c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.2L14.5,93z M12.9,91.5L12.9,91.5l-0.3,0.6l0.4,0.2c0.1,0,0.2,0.1,0.2,0 c0.1,0,0.1-0.1,0.2-0.2l0,0l-0.2,0.6l0,0c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1l-0.4-0.2l-0.2,0.5 c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0.1,0.1l0.3,0.1c0.1,0,0.2,0.1,0.2,0.1c0,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.3-0.2l0,0 L13,93.4l-1.3-0.5l0,0l0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0-0.1,0.1-0.2l0.5-1.1c0-0.1,0.1-0.2,0.1-0.2c0,0-0.1-0.1-0.1-0.1 l-0.1,0l0,0l1.3,0.5l-0.1,0.4l0,0c0-0.1,0-0.2,0-0.2c0,0,0-0.1-0.1-0.1c0,0-0.1-0.1-0.2-0.1L12.9,91.5z M10.6,91.2L10.6,91.2 C10.6,91.2,10.7,91.2,10.6,91.2C10.7,91.2,10.7,91.2,10.6,91.2c0.2,0.1,0.3,0.1,0.5,0.1c0.1,0,0.2-0.1,0.2-0.2 c0.1-0.1,0.1-0.2,0-0.3c0-0.1-0.1-0.2-0.2-0.2c0,0-0.1,0-0.2-0.1L10.6,91.2z M11.3,92.6l-0.4-0.2l-0.2-1c0,0-0.1,0-0.1,0 c0,0,0,0,0,0c0,0,0,0,0,0l-0.2,0.5c-0.1,0.1-0.1,0.2-0.1,0.2c0,0,0,0.1,0.1,0.1l0.1,0l0,0l-0.7-0.4l0,0l0.1,0c0.1,0,0.1,0,0.2,0 c0,0,0.1-0.1,0.1-0.2l0.5-1c0.1-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.1-0.1-0.1l-0.1,0l0,0l0.6,0.3c0.2,0.1,0.3,0.2,0.4,0.2 c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.3c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2,0-0.4,0l0.1,0.6c0,0.1,0,0.2,0.1,0.3 C11.2,92.4,11.3,92.5,11.3,92.6L11.3,92.6z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M50.4,90.5L50.4,90.5l0-0.8l-0.5,0.6L50.4,90.5z M50.4,90.6L50.4,90.6l-0.7-0.2l-0.2,0.2 c-0.1,0.1-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0.1l0,0l-0.5-0.2l0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.2l1.1-1.2 l0,0l0.1,1.6c0,0.1,0,0.2,0.1,0.3c0,0,0.1,0.1,0.1,0.1l0,0l-0.7-0.2l0,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.2 L50.4,90.6z M48.4,90.5L48.4,90.5L48.4,90.5l-0.7-0.2l0,0l0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1-0.1,0.1-0.2l0.4-1.1c0-0.1,0-0.1,0-0.2 c0,0,0,0,0-0.1c0,0-0.1-0.1-0.1-0.1l-0.1,0l0,0l0.7,0.2l0,0l-0.1,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0.1-0.1,0.2l-0.4,1.1 c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0.1C48.3,90.4,48.3,90.5,48.4,90.5L48.4,90.5z M45.9,89.7L45.9,89.7c0.1,0,0.2,0.1,0.3,0.1 c0.2,0,0.3,0,0.4,0c0.1,0,0.2-0.1,0.2-0.2c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.1,0 c0,0-0.1,0-0.1,0L45.9,89.7z M46.1,88.9L46.1,88.9c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2-0.1 c0,0,0.1-0.1,0.1-0.2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0-0.2,0L46.1,88.9z M46.7,89.1L46.7,89.1 c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.3,0-0.4-0.1l-0.8-0.2 l0,0l0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1-0.1,0.1-0.2l0.3-1.1c0-0.1,0-0.2,0-0.2c0,0-0.1-0.1-0.1-0.1l-0.1,0l0,0l0.8,0.2 c0.1,0,0.3,0.1,0.3,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0,0.1,0.1,0.2,0,0.3c0,0.1-0.1,0.2-0.1,0.2C46.9,89,46.8,89.1,46.7,89.1z  M43.4,89.3L43.4,89.3L43,87.7l-0.2,1.2c0,0.1,0,0.2,0,0.2c0,0,0.1,0.1,0.1,0.1l0.1,0l0,0l-0.6-0.1l0,0l0.1,0c0.1,0,0.1,0,0.2,0 c0,0,0-0.1,0.1-0.2l0.2-1.2c0-0.1,0-0.1,0-0.2c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.2,0l0,0l0.5,0.1l0.4,1.5l0.8-1.3l0.5,0.1l0,0l-0.1,0 c-0.1,0-0.1,0-0.2,0c0,0,0,0.1-0.1,0.2l-0.2,1.2c0,0.1,0,0.2,0,0.2c0,0,0.1,0.1,0.1,0.1l0.1,0l0,0l-0.8-0.1l0,0l0.1,0 c0.1,0,0.1,0,0.2,0c0,0,0-0.1,0.1-0.2l0.2-1.2L43.4,89.3L43.4,89.3z M41,87.2L41,87.2c-0.2,0-0.3,0-0.4,0.1 c-0.1,0.1-0.2,0.3-0.3,0.6c0,0.3,0,0.5,0.1,0.7c0.1,0.1,0.2,0.2,0.4,0.2c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.3,0.2-0.6 c0-0.3,0-0.5-0.1-0.7C41.3,87.3,41.1,87.2,41,87.2z M41,87.1L41,87.1c0.2,0,0.4,0.1,0.6,0.3c0.1,0.2,0.2,0.4,0.2,0.7 c0,0.3-0.1,0.5-0.3,0.6C41.2,88.9,41,89,40.8,89c-0.2,0-0.4-0.1-0.6-0.3C40,88.4,40,88.2,40,87.9c0-0.3,0.2-0.5,0.4-0.7 C40.6,87.1,40.8,87.1,41,87.1z M39.1,88.3L39.1,88.3L39.1,88.3L39,88.7l-1.4-0.1l0,0l0.1,0c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1,0-0.2 l0.1-1.2c0-0.1,0-0.2,0-0.2c0,0-0.1-0.1-0.1-0.1l-0.1,0l0,0l0.8,0.1l0,0c-0.1,0-0.2,0-0.2,0c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.2 l-0.1,1.1c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0,0.1,0,0.2,0l0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2-0.1C39,88.4,39.1,88.4,39.1,88.3 z M36,86.8L36,86.8c-0.2,0-0.3,0-0.4,0.2c-0.1,0.1-0.2,0.4-0.2,0.6c0,0.3,0,0.5,0.2,0.7c0.1,0.1,0.2,0.2,0.4,0.2 c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.6c0-0.3,0-0.5-0.1-0.7C36.3,86.9,36.2,86.8,36,86.8z M36.1,86.7L36.1,86.7 c0.2,0,0.4,0.1,0.6,0.3c0.2,0.2,0.2,0.4,0.2,0.7c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.3 c-0.2-0.2-0.2-0.4-0.2-0.7c0-0.3,0.1-0.5,0.3-0.7C35.6,86.8,35.8,86.7,36.1,86.7z M34.2,86.7L34.2,86.7l0,0.6h0 c-0.1-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.1-0.4-0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.2-0.2,0.3C33,87.3,33,87.5,33,87.7 c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.1,0.3-0.3l0,0 c-0.1,0.2-0.2,0.3-0.3,0.4s-0.3,0.1-0.4,0.1c-0.3,0-0.5-0.1-0.7-0.3c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.2,0-0.3,0.1-0.5 c0.1-0.1,0.2-0.3,0.3-0.3c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.3,0,0.4,0.1c0,0,0.1,0,0.1,0C34.1,86.8,34.1,86.8,34.2,86.7 C34.1,86.8,34.2,86.8,34.2,86.7L34.2,86.7z M30.3,86.9L30.3,86.9l0,0.7l0.4,0c0.1,0,0.2,0,0.2-0.1c0,0,0.1-0.1,0.1-0.2l0,0l0,0.6 l0,0c0-0.1,0-0.1,0-0.2c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.2,0l-0.4,0l0,0.6c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0l0.3,0 c0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.3l0.1,0l-0.1,0.5l-1.4,0.1l0,0l0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1-0.1 c0,0,0-0.1,0-0.2l0-1.2c0-0.1,0-0.2,0-0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l1.4-0.1l0,0.4l-0.1,0c0-0.1,0-0.2-0.1-0.2 c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.2,0L30.3,86.9z M28.3,88.6L28.3,88.6c0.1,0,0.2,0,0.3,0c0.2,0,0.4-0.1,0.5-0.2 c0.1-0.2,0.2-0.3,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.1-0.3-0.2-0.5-0.2c-0.1,0-0.2,0-0.3,0.1L28.3,88.6z M27.8,88.8L27.8,88.8 L27.8,88.8c0.1-0.1,0.2-0.1,0.2-0.1c0,0,0-0.1,0-0.2l-0.1-1.2c0-0.1,0-0.2,0-0.2c0,0-0.1-0.1-0.2,0l-0.1,0l0,0l0.7,0 c0.3,0,0.5,0,0.6,0.1c0.1,0.1,0.3,0.1,0.4,0.3c0.1,0.1,0.1,0.3,0.2,0.5c0,0.2,0,0.5-0.2,0.6c-0.2,0.2-0.4,0.3-0.8,0.3L27.8,88.8z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.4,90.5L50.4,90.5l0-0.8l-0.5,0.6L50.4,90.5z M50.4,90.6L50.4,90.6l-0.7-0.2l-0.2,0.2 c-0.1,0.1-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0.1l0,0l-0.5-0.2l0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.2l1.1-1.2 l0,0l0.1,1.6c0,0.1,0,0.2,0.1,0.3c0,0,0.1,0.1,0.1,0.1l0,0l-0.7-0.2l0,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.2 L50.4,90.6z M48.4,90.5L48.4,90.5L48.4,90.5l-0.7-0.2l0,0l0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1-0.1,0.1-0.2l0.4-1.1c0-0.1,0-0.1,0-0.2 c0,0,0,0,0-0.1c0,0-0.1-0.1-0.1-0.1l-0.1,0l0,0l0.7,0.2l0,0l-0.1,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0.1-0.1,0.2l-0.4,1.1 c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0.1C48.3,90.4,48.3,90.5,48.4,90.5L48.4,90.5z M45.9,89.7L45.9,89.7c0.1,0,0.2,0.1,0.3,0.1 c0.2,0,0.3,0,0.4,0c0.1,0,0.2-0.1,0.2-0.2c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.1,0 c0,0-0.1,0-0.1,0L45.9,89.7z M46.1,88.9L46.1,88.9c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2-0.1 c0,0,0.1-0.1,0.1-0.2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0-0.2,0L46.1,88.9z M46.7,89.1L46.7,89.1 c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.3,0-0.4-0.1l-0.8-0.2 l0,0l0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1-0.1,0.1-0.2l0.3-1.1c0-0.1,0-0.2,0-0.2c0,0-0.1-0.1-0.1-0.1l-0.1,0l0,0l0.8,0.2 c0.1,0,0.3,0.1,0.3,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0,0.1,0.1,0.2,0,0.3c0,0.1-0.1,0.2-0.1,0.2C46.9,89,46.8,89.1,46.7,89.1z  M43.4,89.3L43.4,89.3L43,87.7l-0.2,1.2c0,0.1,0,0.2,0,0.2c0,0,0.1,0.1,0.1,0.1l0.1,0l0,0l-0.6-0.1l0,0l0.1,0c0.1,0,0.1,0,0.2,0 c0,0,0-0.1,0.1-0.2l0.2-1.2c0-0.1,0-0.1,0-0.2c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.2,0l0,0l0.5,0.1l0.4,1.5l0.8-1.3l0.5,0.1l0,0l-0.1,0 c-0.1,0-0.1,0-0.2,0c0,0,0,0.1-0.1,0.2l-0.2,1.2c0,0.1,0,0.2,0,0.2c0,0,0.1,0.1,0.1,0.1l0.1,0l0,0l-0.8-0.1l0,0l0.1,0 c0.1,0,0.1,0,0.2,0c0,0,0-0.1,0.1-0.2l0.2-1.2L43.4,89.3L43.4,89.3z M41,87.2L41,87.2c-0.2,0-0.3,0-0.4,0.1 c-0.1,0.1-0.2,0.3-0.3,0.6c0,0.3,0,0.5,0.1,0.7c0.1,0.1,0.2,0.2,0.4,0.2c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.3,0.2-0.6 c0-0.3,0-0.5-0.1-0.7C41.3,87.3,41.1,87.2,41,87.2z M41,87.1L41,87.1c0.2,0,0.4,0.1,0.6,0.3c0.1,0.2,0.2,0.4,0.2,0.7 c0,0.3-0.1,0.5-0.3,0.6C41.2,88.9,41,89,40.8,89c-0.2,0-0.4-0.1-0.6-0.3C40,88.4,40,88.2,40,87.9c0-0.3,0.2-0.5,0.4-0.7 C40.6,87.1,40.8,87.1,41,87.1z M39.1,88.3L39.1,88.3L39.1,88.3L39,88.7l-1.4-0.1l0,0l0.1,0c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1,0-0.2 l0.1-1.2c0-0.1,0-0.2,0-0.2c0,0-0.1-0.1-0.1-0.1l-0.1,0l0,0l0.8,0.1l0,0c-0.1,0-0.2,0-0.2,0c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.2 l-0.1,1.1c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0,0.1,0,0.2,0l0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2-0.1C39,88.4,39.1,88.4,39.1,88.3 z M36,86.8L36,86.8c-0.2,0-0.3,0-0.4,0.2c-0.1,0.1-0.2,0.4-0.2,0.6c0,0.3,0,0.5,0.2,0.7c0.1,0.1,0.2,0.2,0.4,0.2 c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.6c0-0.3,0-0.5-0.1-0.7C36.3,86.9,36.2,86.8,36,86.8z M36.1,86.7L36.1,86.7 c0.2,0,0.4,0.1,0.6,0.3c0.2,0.2,0.2,0.4,0.2,0.7c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.3 c-0.2-0.2-0.2-0.4-0.2-0.7c0-0.3,0.1-0.5,0.3-0.7C35.6,86.8,35.8,86.7,36.1,86.7z M34.2,86.7L34.2,86.7l0,0.6h0 c-0.1-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.1-0.4-0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.2-0.2,0.3C33,87.3,33,87.5,33,87.7 c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.1,0.3-0.3l0,0 c-0.1,0.2-0.2,0.3-0.3,0.4s-0.3,0.1-0.4,0.1c-0.3,0-0.5-0.1-0.7-0.3c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.2,0-0.3,0.1-0.5 c0.1-0.1,0.2-0.3,0.3-0.3c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.3,0,0.4,0.1c0,0,0.1,0,0.1,0C34.1,86.8,34.1,86.8,34.2,86.7 C34.1,86.8,34.2,86.8,34.2,86.7L34.2,86.7z M30.3,86.9L30.3,86.9l0,0.7l0.4,0c0.1,0,0.2,0,0.2-0.1c0,0,0.1-0.1,0.1-0.2l0,0l0,0.6 l0,0c0-0.1,0-0.1,0-0.2c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.2,0l-0.4,0l0,0.6c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0l0.3,0 c0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.3l0.1,0l-0.1,0.5l-1.4,0.1l0,0l0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1-0.1 c0,0,0-0.1,0-0.2l0-1.2c0-0.1,0-0.2,0-0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l1.4-0.1l0,0.4l-0.1,0c0-0.1,0-0.2-0.1-0.2 c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.2,0L30.3,86.9z M28.3,88.6L28.3,88.6c0.1,0,0.2,0,0.3,0c0.2,0,0.4-0.1,0.5-0.2 c0.1-0.2,0.2-0.3,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.1-0.3-0.2-0.5-0.2c-0.1,0-0.2,0-0.3,0.1L28.3,88.6z M27.8,88.8L27.8,88.8 L27.8,88.8c0.1-0.1,0.2-0.1,0.2-0.1c0,0,0-0.1,0-0.2l-0.1-1.2c0-0.1,0-0.2,0-0.2c0,0-0.1-0.1-0.2,0l-0.1,0l0,0l0.7,0 c0.3,0,0.5,0,0.6,0.1c0.1,0.1,0.3,0.1,0.4,0.3c0.1,0.1,0.1,0.3,0.2,0.5c0,0.2,0,0.5-0.2,0.6c-0.2,0.2-0.4,0.3-0.8,0.3L27.8,88.8z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M59.1,91.8L59.1,91.8h1.3v0.1l-0.8,2.3h-0.2l0.7-2.1h-0.6c-0.1,0-0.2,0-0.3,0c-0.1,0.1-0.2,0.1-0.2,0.2l0,0 L59.1,91.8z M58.6,93.7L58.6,93.7l-0.2,0.5h-1.4V94c0.4-0.4,0.7-0.7,0.9-0.9c0.2-0.2,0.2-0.4,0.2-0.6c0-0.1,0-0.3-0.1-0.4 C58,92,57.8,92,57.7,92c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.2-0.2,0.3h-0.1c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.4-0.2 c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0,0.1,0,0.2-0.1,0.4c-0.1,0.2-0.2,0.4-0.4,0.6c-0.3,0.3-0.5,0.5-0.5,0.6h0.6 c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1-0.1C58.5,93.8,58.5,93.7,58.6,93.7L58.6,93.7z M56,93L56,93c-0.1,0.1-0.2,0.2-0.2,0.3 c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3 c0-0.1,0-0.2-0.1-0.2C56.4,93.4,56.2,93.2,56,93z M56.2,92.7L56.2,92.7c0.1-0.1,0.2-0.2,0.3-0.3c0-0.1,0.1-0.2,0.1-0.2 c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2 c0,0.1,0.1,0.1,0.1,0.2L56.2,92.7z M55.9,92.9L55.9,92.9c-0.2-0.2-0.3-0.3-0.4-0.4c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.2,0.1-0.3,0.2-0.4 c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.2,0.2,0.4c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.2-0.4,0.3 c0.2,0.2,0.3,0.3,0.4,0.4c0.1,0.1,0.1,0.2,0.1,0.4c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2 c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.1,0-0.2,0.1-0.3C55.6,93.2,55.7,93.1,55.9,92.9z M53.9,92l0.6-0.3h0.1v2c0,0.1,0,0.2,0,0.2 c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.2,0v0.1h-0.9V94c0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.3v-1.3c0-0.2,0-0.3,0-0.3 c0,0,0-0.1,0-0.1c0,0,0,0-0.1,0C54,92,54,92,53.9,92L53.9,92z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.1,91.8L59.1,91.8h1.3v0.1l-0.8,2.3h-0.2l0.7-2.1h-0.6c-0.1,0-0.2,0-0.3,0c-0.1,0.1-0.2,0.1-0.2,0.2l0,0 L59.1,91.8z M58.6,93.7L58.6,93.7l-0.2,0.5h-1.4V94c0.4-0.4,0.7-0.7,0.9-0.9c0.2-0.2,0.2-0.4,0.2-0.6c0-0.1,0-0.3-0.1-0.4 C58,92,57.8,92,57.7,92c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.2-0.2,0.3h-0.1c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.4-0.2 c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0,0.1,0,0.2-0.1,0.4c-0.1,0.2-0.2,0.4-0.4,0.6c-0.3,0.3-0.5,0.5-0.5,0.6h0.6 c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1-0.1C58.5,93.8,58.5,93.7,58.6,93.7L58.6,93.7z M56,93L56,93c-0.1,0.1-0.2,0.2-0.2,0.3 c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3 c0-0.1,0-0.2-0.1-0.2C56.4,93.4,56.2,93.2,56,93z M56.2,92.7L56.2,92.7c0.1-0.1,0.2-0.2,0.3-0.3c0-0.1,0.1-0.2,0.1-0.2 c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2 c0,0.1,0.1,0.1,0.1,0.2L56.2,92.7z M55.9,92.9L55.9,92.9c-0.2-0.2-0.3-0.3-0.4-0.4c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.2,0.1-0.3,0.2-0.4 c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.2,0.2,0.4c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.2-0.4,0.3 c0.2,0.2,0.3,0.3,0.4,0.4c0.1,0.1,0.1,0.2,0.1,0.4c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2 c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.1,0-0.2,0.1-0.3C55.6,93.2,55.7,93.1,55.9,92.9z M53.9,92l0.6-0.3h0.1v2c0,0.1,0,0.2,0,0.2 c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.2,0v0.1h-0.9V94c0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.3v-1.3c0-0.2,0-0.3,0-0.3 c0,0,0-0.1,0-0.1c0,0,0,0-0.1,0C54,92,54,92,53.9,92L53.9,92z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M82.7,89L82.7,89L82.7,89c0.2,0,0.2,0,0.2-0.1c0,0,0-0.1,0.1-0.2l0.2-1.1c0-0.1,0-0.2,0-0.2 c0,0-0.1-0.1-0.1-0.1l-0.1,0l0,0l0.7,0.2c0.3,0.1,0.5,0.1,0.6,0.2c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.2,0.1,0.3,0,0.5 c-0.1,0.2-0.2,0.4-0.4,0.6c-0.2,0.1-0.5,0.2-0.8,0.1L82.7,89z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.7,89L82.7,89L82.7,89c0.2,0,0.2,0,0.2-0.1c0,0,0-0.1,0.1-0.2l0.2-1.1c0-0.1,0-0.2,0-0.2 c0,0-0.1-0.1-0.1-0.1l-0.1,0l0,0l0.7,0.2c0.3,0.1,0.5,0.1,0.6,0.2c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.2,0.1,0.3,0,0.5 c-0.1,0.2-0.2,0.4-0.4,0.6c-0.2,0.1-0.5,0.2-0.8,0.1L82.7,89z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M81.8,88.2l-0.7-0.1l-0.2,0.3c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0.1,0,0.2,0.1l0,0l-0.6-0.1l0,0 c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.2l0.8-1.4l0,0l0.4,1.6c0,0.1,0.1,0.2,0.1,0.2c0,0,0.1,0.1,0.2,0.1l0,0l-0.7-0.1l0,0 c0.1,0,0.1,0,0.1,0c0,0,0,0,0-0.1c0,0,0-0.1,0-0.2L81.8,88.2z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.8,88.2l-0.7-0.1l-0.2,0.3c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0.1,0,0.2,0.1l0,0l-0.6-0.1l0,0 c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.2l0.8-1.4l0,0l0.4,1.6c0,0.1,0.1,0.2,0.1,0.2c0,0,0.1,0.1,0.2,0.1l0,0l-0.7-0.1l0,0 c0.1,0,0.1,0,0.1,0c0,0,0,0,0-0.1c0,0,0-0.1,0-0.2L81.8,88.2z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M78.3,88.5L78.3,88.5L78.3,88.5c0.1,0,0.2-0.1,0.2-0.1c0,0,0-0.1,0-0.2l0.1-1.2c0-0.1,0-0.2,0-0.2 c0,0-0.1-0.1-0.1-0.1l-0.1,0l0,0l0.7,0.1c0.3,0,0.5,0.1,0.6,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.3,0.1,0.5 c0,0.2-0.1,0.5-0.3,0.6c-0.2,0.2-0.4,0.2-0.8,0.2L78.3,88.5z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.3,88.5L78.3,88.5L78.3,88.5c0.1,0,0.2-0.1,0.2-0.1c0,0,0-0.1,0-0.2l0.1-1.2c0-0.1,0-0.2,0-0.2 c0,0-0.1-0.1-0.1-0.1l-0.1,0l0,0l0.7,0.1c0.3,0,0.5,0.1,0.6,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.3,0.1,0.5 c0,0.2-0.1,0.5-0.3,0.6c-0.2,0.2-0.4,0.2-0.8,0.2L78.3,88.5z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M77.9,88.4L77.9,88.4l-0.8,0v0h0.1c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1,0-0.2V87c0-0.1,0-0.1,0-0.2c0,0,0,0-0.1-0.1 c0,0-0.1,0-0.1,0h-0.1v0h0.8v0h-0.1c-0.1,0-0.1,0-0.2,0.1c0,0,0,0.1,0,0.2v1.2c0,0.1,0,0.2,0,0.2c0,0,0,0,0.1,0.1 C77.8,88.4,77.8,88.4,77.9,88.4L77.9,88.4z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.9,88.4L77.9,88.4l-0.8,0v0h0.1c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1,0-0.2V87c0-0.1,0-0.1,0-0.2c0,0,0,0-0.1-0.1 c0,0-0.1,0-0.1,0h-0.1v0h0.8v0h-0.1c-0.1,0-0.1,0-0.2,0.1c0,0,0,0.1,0,0.2v1.2c0,0.1,0,0.2,0,0.2c0,0,0,0,0.1,0.1 C77.8,88.4,77.8,88.4,77.9,88.4L77.9,88.4z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76.5,86.6l0,0.6l0,0c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2-0.1-0.2-0.1 c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0.1,0.1c0.1,0.1,0.2,0.1,0.4,0.3c0.2,0.1,0.3,0.1,0.3,0.2 c0.1,0,0.1,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.2,0 c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c0,0,0,0,0,0.1l0,0l0-0.6l0,0c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.1,0.2,0.2c0.1,0,0.2,0.1,0.3,0.1 c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.3-0.2c-0.2-0.1-0.3-0.1-0.3-0.2 c-0.1,0-0.1-0.1-0.2-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.4-0.2c0.1,0,0.2,0,0.3,0.1c0,0,0.1,0,0.1,0 C76.4,86.7,76.4,86.7,76.5,86.6C76.4,86.7,76.5,86.7,76.5,86.6L76.5,86.6z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.5,86.6l0,0.6l0,0c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2-0.1-0.2-0.1 c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0.1,0.1c0.1,0.1,0.2,0.1,0.4,0.3c0.2,0.1,0.3,0.1,0.3,0.2 c0.1,0,0.1,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.2,0 c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c0,0,0,0,0,0.1l0,0l0-0.6l0,0c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.1,0.2,0.2c0.1,0,0.2,0.1,0.3,0.1 c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.3-0.2c-0.2-0.1-0.3-0.1-0.3-0.2 c-0.1,0-0.1-0.1-0.2-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.4-0.2c0.1,0,0.2,0,0.3,0.1c0,0,0.1,0,0.1,0 C76.4,86.7,76.4,86.7,76.5,86.6C76.4,86.7,76.5,86.7,76.5,86.6L76.5,86.6z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M75.1,88.5l-0.5,0.1l-0.7-0.8c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0l0.1,0.5c0,0.1,0,0.2,0.1,0.2 c0,0,0.1,0,0.2,0l0.1,0l0,0l-0.8,0.1l0,0l0.1,0c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1,0-0.2l-0.1-1.2c0-0.1,0-0.2-0.1-0.2c0,0-0.1,0-0.2,0 l-0.1,0l0,0l0.6-0.1c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3 c-0.1,0.1-0.2,0.2-0.3,0.2l0.4,0.5c0.1,0.1,0.2,0.2,0.2,0.2C74.9,88.5,75,88.5,75.1,88.5L75.1,88.5z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.1,88.5l-0.5,0.1l-0.7-0.8c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0l0.1,0.5c0,0.1,0,0.2,0.1,0.2 c0,0,0.1,0,0.2,0l0.1,0l0,0l-0.8,0.1l0,0l0.1,0c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1,0-0.2l-0.1-1.2c0-0.1,0-0.2-0.1-0.2c0,0-0.1,0-0.2,0 l-0.1,0l0,0l0.6-0.1c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3 c-0.1,0.1-0.2,0.2-0.3,0.2l0.4,0.5c0.1,0.1,0.2,0.2,0.2,0.2C74.9,88.5,75,88.5,75.1,88.5L75.1,88.5z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M71.6,87.3l0.1,0.7l0.4-0.1c0.1,0,0.2,0,0.2-0.1c0,0,0-0.1,0-0.2l0,0l0.1,0.6l0,0c0-0.1-0.1-0.1-0.1-0.2 c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.2,0l-0.4,0.1l0.1,0.6c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0l0.3-0.1c0.1,0,0.2,0,0.2-0.1 c0,0,0.1-0.1,0.1-0.1c0-0.1,0.1-0.2,0.1-0.3l0.1,0l-0.1,0.5l-1.4,0.3l0,0l0.1,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.2 l-0.2-1.1c0-0.1,0-0.2-0.1-0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l1.4-0.3l0.1,0.4l-0.1,0c0-0.1-0.1-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1 c0,0-0.1,0-0.2,0L71.6,87.3z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.6,87.3l0.1,0.7l0.4-0.1c0.1,0,0.2,0,0.2-0.1c0,0,0-0.1,0-0.2l0,0l0.1,0.6l0,0c0-0.1-0.1-0.1-0.1-0.2 c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.2,0l-0.4,0.1l0.1,0.6c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0l0.3-0.1c0.1,0,0.2,0,0.2-0.1 c0,0,0.1-0.1,0.1-0.1c0-0.1,0.1-0.2,0.1-0.3l0.1,0l-0.1,0.5l-1.4,0.3l0,0l0.1,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.2 l-0.2-1.1c0-0.1,0-0.2-0.1-0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l1.4-0.3l0.1,0.4l-0.1,0c0-0.1-0.1-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1 c0,0-0.1,0-0.2,0L71.6,87.3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M70.7,87.4L70.7,87.4c0,0.1-0.1,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2l-0.2,1.6l0,0l-1-1.3 C69.1,88,69.1,88,69.1,88c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0l0,0l0.7-0.2l0,0c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1 c0,0,0,0.1,0.1,0.2l0.7,0.9l0.1-1.1c0-0.1,0-0.2,0-0.2c0,0,0,0-0.1-0.1c0,0-0.1,0-0.1,0c0,0,0,0,0,0l0,0L70.7,87.4z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.7,87.4L70.7,87.4c0,0.1-0.1,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2l-0.2,1.6l0,0l-1-1.3 C69.1,88,69.1,88,69.1,88c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0l0,0l0.7-0.2l0,0c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1 c0,0,0,0.1,0.1,0.2l0.7,0.9l0.1-1.1c0-0.1,0-0.2,0-0.2c0,0,0,0-0.1-0.1c0,0-0.1,0-0.1,0c0,0,0,0,0,0l0,0L70.7,87.4z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M69,89.7L69,89.7L68.3,90l0,0l0.1,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.2L68,88.5c0-0.1-0.1-0.1-0.1-0.2 c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0l-0.1,0l0,0l0.7-0.3l0,0l-0.1,0c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.2l0.4,1.1 c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0.1,0C68.8,89.7,68.9,89.7,69,89.7L69,89.7z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69,89.7L69,89.7L68.3,90l0,0l0.1,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.2L68,88.5c0-0.1-0.1-0.1-0.1-0.2 c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0l-0.1,0l0,0l0.7-0.3l0,0l-0.1,0c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.2l0.4,1.1 c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0.1,0C68.8,89.7,68.9,89.7,69,89.7L69,89.7z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M65.4,89.3l0.4-0.2l1.5,0.8l-0.4-1c0-0.1-0.1-0.2-0.1-0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l0.6-0.2l0,0l-0.1,0 c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.2l0.6,1.4l0,0L66,89.4l0.4,1c0,0.1,0.1,0.2,0.1,0.2c0,0,0.1,0,0.2,0l0.1,0l0,0l-0.6,0.2l0,0 l0.1,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.2l-0.5-1.1c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1,0C65.5,89.3,65.5,89.3,65.4,89.3 L65.4,89.3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.4,89.3l0.4-0.2l1.5,0.8l-0.4-1c0-0.1-0.1-0.2-0.1-0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l0.6-0.2l0,0l-0.1,0 c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.2l0.6,1.4l0,0L66,89.4l0.4,1c0,0.1,0.1,0.2,0.1,0.2c0,0,0.1,0,0.2,0l0.1,0l0,0l-0.6,0.2l0,0 l0.1,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.2l-0.5-1.1c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1,0C65.5,89.3,65.5,89.3,65.4,89.3 L65.4,89.3z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M101.2,91.1l0.4-0.2l1.5,0.8l-0.4-1c0-0.1-0.1-0.2-0.1-0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l0.6-0.2l0,0l-0.1,0 c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.2l0.6,1.4l0,0l-1.7-0.9l0.4,1c0,0.1,0.1,0.2,0.1,0.2c0,0,0.1,0,0.2,0l0.1,0l0,0l-0.6,0.2l0,0 l0.1,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.2l-0.5-1.1c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1,0C101.3,91.1,101.2,91.1,101.2,91.1 L101.2,91.1z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.2,91.1l0.4-0.2l1.5,0.8l-0.4-1c0-0.1-0.1-0.2-0.1-0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l0.6-0.2l0,0l-0.1,0 c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.2l0.6,1.4l0,0l-1.7-0.9l0.4,1c0,0.1,0.1,0.2,0.1,0.2c0,0,0.1,0,0.2,0l0.1,0l0,0l-0.6,0.2l0,0 l0.1,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.2l-0.5-1.1c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1,0C101.3,91.1,101.2,91.1,101.2,91.1 L101.2,91.1z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M64.5,89.8L64.5,89.8l0.5-0.4l0,0l-0.1,0c-0.1,0-0.1,0.1-0.1,0.2c0,0,0,0.1,0.1,0.2l0.4,0.6 c0.1,0.2,0.1,0.3,0.2,0.4c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.2-0.1-0.3-0.1 c-0.1-0.1-0.1-0.2-0.3-0.4l-0.3-0.6c-0.1-0.1-0.1-0.2-0.1-0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l0.7-0.4l0,0l-0.1,0 c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0.1,0.2l0.4,0.7c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0 c0.1,0,0.1,0,0.2-0.1c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.2-0.2-0.4l-0.4-0.6c-0.1-0.1-0.1-0.2-0.1-0.2 C64.7,89.7,64.6,89.7,64.5,89.8L64.5,89.8z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.5,89.8L64.5,89.8l0.5-0.4l0,0l-0.1,0c-0.1,0-0.1,0.1-0.1,0.2c0,0,0,0.1,0.1,0.2l0.4,0.6 c0.1,0.2,0.1,0.3,0.2,0.4c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.2-0.1-0.3-0.1 c-0.1-0.1-0.1-0.2-0.3-0.4l-0.3-0.6c-0.1-0.1-0.1-0.2-0.1-0.2c0,0-0.1,0-0.2,0l-0.1,0l0,0l0.7-0.4l0,0l-0.1,0 c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0.1,0.2l0.4,0.7c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0 c0.1,0,0.1,0,0.2-0.1c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.2-0.2-0.4l-0.4-0.6c-0.1-0.1-0.1-0.2-0.1-0.2 C64.7,89.7,64.6,89.7,64.5,89.8L64.5,89.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M100,65c-1.5,0-3-0.6-4.4-0.1c-1.7,0.8-3.4,1.3-5,1.8c-0.1,0-0.2,0.2-0.3,0.2c-0.6,1.2-1.3,2.1-2.1,2.9 c-0.6,0.3-1.3,0.8-1.9,1.3c-0.5,0.3-1,0.5-1.5,0.8c0.5,0,1.1,0.3,1.5,0.7l1.2-1.1c1.6-0.7,3.4-1.4,5.6-2.1c0.5,0,1,0,1.5,0.2 c0.5-0.6,0.9-1,1.6-1.4C97,67,98.3,65.9,100,65"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.3517,
    y1: 3.8118,
    x2: 86.136,
    y2: 149.9622
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#628864"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 84.7,
    y: 64.4,
    className: "st8",
    width: 15.3,
    height: 8.3
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M100,65c-1.5,0-3-0.6-4.4-0.1c-1.7,0.8-3.4,1.3-5,1.8c-0.1,0-0.2,0.2-0.3,0.2c-0.6,1.2-1.3,2.1-2.1,2.9 c-0.6,0.3-1.3,0.8-1.9,1.3c-0.5,0.3-1,0.5-1.5,0.8c0.5,0,1.1,0.3,1.5,0.7l1.2-1.1c1.6-0.7,3.4-1.4,5.6-2.1c0.5,0,1,0,1.5,0.2 c0.5-0.6,0.9-1,1.6-1.4C97,67,98.3,65.9,100,65z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M89.3,56.6c-0.7,1.4-1.4,2.9-1.5,4.9l-2,3.5c-0.6,0.6-1,1.3-1.6,1.9c-0.1,0.1-0.2,0-0.2,0 c-0.2-0.7,0-1.4,0-2.1c0.4-0.9,1-1.8,1.6-2.7c0-0.9,0.4-1.6,0.8-2.3L89.3,56.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.0712,
    y1: 58.6396,
    x2: 55.3854,
    y2: 83.6136
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 83.8,
    y: 56.6,
    className: "st9",
    width: 5.5,
    height: 10.4
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M89.3,56.6c-0.7,1.4-1.4,2.9-1.5,4.9l-2,3.5c-0.6,0.6-1,1.3-1.6,1.9c-0.1,0.1-0.2,0-0.2,0c-0.2-0.7,0-1.4,0-2.1 c0.4-0.9,1-1.8,1.6-2.7c0-0.9,0.4-1.6,0.8-2.3L89.3,56.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_10_",
    d: "M90.8,58.3c0.2,2.4-0.4,3.9-0.3,5.5c0.1,1.6-1.1,3.1-1.7,5.4L88.1,70c-1.4,0.9-2.8,1.8-4.4,2.3 c0-0.4-0.2-0.7-0.7-0.9c0.6-1.5,1.1-2.9,1.3-4.5l1.6-1.9l2-3.5C90.1,60,90.6,59.1,90.8,58.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.4449,
    y1: 32.3809,
    x2: 84.8943,
    y2: 112.6362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#628864"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 58.3,
    className: "st10",
    width: 8,
    height: 13.9
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.8,58.3c0.2,2.4-0.4,3.9-0.3,5.5c0.1,1.6-1.1,3.1-1.7,5.4L88.1,70c-1.4,0.9-2.8,1.8-4.4,2.3 c0-0.4-0.2-0.7-0.7-0.9c0.6-1.5,1.1-2.9,1.3-4.5l1.6-1.9l2-3.5C90.1,60,90.6,59.1,90.8,58.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M84.3,66.7c-1.2,1.4-0.6,4-0.7,5.6c-0.3,0.1-0.6,0.7-0.9,0.9c-1.3,1-2.5,2.3-2.7,3.7 c-1.5,0.7-3.2,1.6-4.4,2.8c-0.6-0.8-1.8-1.1-2.7-1.1c0.8-2.5,2.5-5.9,5.6-7c1-0.9,1.9-1.8,2.7-2.8C81.9,68.1,83.4,67.2,84.3,66.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.6711,
    y1: 34.3004,
    x2: 76.0077,
    y2: 162.292
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9,
    y: 66.7,
    className: "st11",
    width: 11.4,
    height: 13
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.3,66.7c-1.2,1.4-0.6,4-0.7,5.6c-0.3,0.1-0.6,0.7-0.9,0.9c-1.3,1-2.5,2.3-2.7,3.7c-1.5,0.7-3.2,1.6-4.4,2.8 c-0.6-0.8-1.8-1.1-2.7-1.1c0.8-2.5,2.5-5.9,5.6-7c1-0.9,1.9-1.8,2.7-2.8C81.9,68.1,83.4,67.2,84.3,66.7z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91,58.9c-1,1.6-1.6,3.6-2.5,5.3c-0.6,1.1-0.8,1.8-1.1,3c-0.2,0.9-1.5,2.2-1.5,3.2c-0.5,0.5-1.1,1.4-1.7,1.6"
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_16_",
    d: "M99.3,1.8c-0.2,1.8-0.6,3.5-1.2,4.8c0,1.5,0.3,3,0.7,4.5l3,6.1l1-5.4c0.1-1,0-2-0.3-3.1 c-0.8-1-0.8-2.3-1.4-3.3C100.5,4.4,99.5,3.8,99.3,1.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_17_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_16_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.5076,
    y1: -65.1123,
    x2: 97.2777,
    y2: 49.6476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 98.1,
    y: 1.8,
    className: "st12",
    width: 4.9,
    height: 15.4
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M99.3,1.8c-0.2,1.8-0.6,3.5-1.2,4.8c0,1.5,0.3,3,0.7,4.5l3,6.1l1-5.4c0.1-1,0-2-0.3-3.1c-0.8-1-0.8-2.3-1.4-3.3 C100.5,4.4,99.5,3.8,99.3,1.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M101.3,22.5c-1-1.3-2.1-2.5-3.4-3.4c-0.8-0.8-1.5-1.6-1.8-2.6c-0.6-2.5-1.1-4.2-1.5-5l1,0.3l1.1,0.4 c1,0.2,2.1,0.7,3.1,1c0.8,1.3,1.5,2.6,2.1,4l0.8,1.9c-0.9,1.3-1.2,2.2-1.2,3.6L101.3,22.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.3923,
    y1: -34.1233,
    x2: 97.6692,
    y2: 44.2589
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 94.6,
    y: 11.5,
    className: "st13",
    width: 8.1,
    height: 11.2
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.3,22.5c-1-1.3-2.1-2.5-3.4-3.4c-0.8-0.8-1.5-1.6-1.8-2.6c-0.6-2.5-1.1-4.2-1.5-5l1,0.3l1.1,0.4 c1,0.2,2.1,0.7,3.1,1c0.8,1.3,1.5,2.6,2.1,4l0.8,1.9c-0.9,1.3-1.2,2.2-1.2,3.6L101.3,22.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_22_",
    d: "M102.7,19c0.7-1.1,1.4-2.1,2-3.2l1.1-2.4l0.2-2.2c-0.4-1.4-0.7-3.3-0.6-4.8c-0.6,1.8-1.4,3.5-2.5,4.9 l-1.1,5.9C102,18,102.4,18.5,102.7,19"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_23_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_22_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.2116,
    y1: -31.4148,
    x2: 102.766,
    y2: 27.7931
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 101.8,
    y: 6.4,
    className: "st14",
    width: 4.2,
    height: 12.6
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.7,19c0.7-1.1,1.4-2.1,2-3.2l1.1-2.4l0.2-2.2c-0.4-1.4-0.7-3.3-0.6-4.8c-0.6,1.8-1.4,3.5-2.5,4.9l-1.1,5.9 C102,18,102.4,18.5,102.7,19z"
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_25_",
    points: "105.7,13.8 106.4,17.7 106,20.8 104.8,24.4 103.1,26.3 101.5,22.7 101.7,20.6 102.7,19  104.8,15.9  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.9527,
    y1: 13.7475,
    x2: 102.9518,
    y2: 26.3924
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 13.8,
    className: "st15",
    width: 4.8,
    height: 12.5
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "105.7,13.8 106.4,17.7 106,20.8 104.8,24.4 103.1,26.3 101.5,22.7 101.7,20.6 102.7,19 104.8,15.9 "
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_28_",
    d: "M101.6,34.4l1.5-2.5c0-1.9-0.3-3.7-0.1-5.6c-0.6-1.4-0.9-3.2-2.1-4c-1.1-2-2.8-3-4.4-3.8 c0.4,2.6,0.9,5.2,1.3,7.8c0.7,1.5,0.9,3.2,1.1,5.1C99.8,32.2,100.7,33.2,101.6,34.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_29_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_28_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.1318,
    y1: 18.4264,
    x2: 98.5742,
    y2: 34.5843
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 96.6,
    y: 18.6,
    className: "st16",
    width: 6.6,
    height: 15.9
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.6,34.4l1.5-2.5c0-1.9-0.3-3.7-0.1-5.6c-0.6-1.4-0.9-3.2-2.1-4c-1.1-2-2.8-3-4.4-3.8 c0.4,2.6,0.9,5.2,1.3,7.8c0.7,1.5,0.9,3.2,1.1,5.1C99.8,32.2,100.7,33.2,101.6,34.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_31_",
    d: "M104.6,32.9c0.8-0.6,1.7-0.7,2.4-1.5c0.4-1.6,0.6-3.4,0.9-5.1c0.2-1.1,0.7-2.3,0.9-3.6 c-1.1-1.5-0.7-3.2-0.4-5c-0.7,1.2-1.6,2.3-2.6,3.2c-0.4,1.2-0.7,2.4-1.2,3.6c-0.6,0.7-1.2,1.3-1.7,1.8l0.1,2.8l0.1,2.9 C103.7,32,104.2,32.3,104.6,32.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.1183,
    y1: 17.8771,
    x2: 104.7789,
    y2: 32.6508
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 17.7,
    className: "st17",
    width: 5.9,
    height: 15.2
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.6,32.9c0.8-0.6,1.7-0.7,2.4-1.5c0.4-1.6,0.6-3.4,0.9-5.1c0.2-1.1,0.7-2.3,0.9-3.6c-1.1-1.5-0.7-3.2-0.4-5 c-0.7,1.2-1.6,2.3-2.6,3.2c-0.4,1.2-0.7,2.4-1.2,3.6c-0.6,0.7-1.2,1.3-1.7,1.8l0.1,2.8l0.1,2.9C103.7,32,104.2,32.3,104.6,32.9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_34_",
    d: "M107,31.3l1.2-0.6c0.3-0.8,0.2-1.2,0.7-1.9l0.3-1.3c2-2,1-3.9,2.1-6.9c-1,0.2-2.2,0.9-2.4,2.4l-1.2,4.4 L107,31.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_35_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_34_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.9224,
    y1: 20.976,
    x2: 108.3352,
    y2: 30.9806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 20.6,
    className: "st18",
    width: 4.3,
    height: 10.7
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107,31.3l1.2-0.6c0.3-0.8,0.2-1.2,0.7-1.9l0.3-1.3c2-2,1-3.9,2.1-6.9c-1,0.2-2.2,0.9-2.4,2.4l-1.2,4.4 L107,31.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_37_",
    d: "M95.2,13.2c-0.7-0.1-1.5-0.1-2.1,0.3c-0.5-0.1-0.9-0.1-1.4,0c2.9,1.9,4.5,4.4,5.3,7.4l-0.4-2.3 c0.6,0.3,1.3,0.7,1.9,1.1c-0.8-0.8-1.5-1.5-2.1-2.3C95.9,16,95.5,14.6,95.2,13.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.3741,
    y1: -64.7212,
    x2: 93.4174,
    y2: 75.7349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 91.7,
    y: 13.1,
    className: "st19",
    width: 6.8,
    height: 7.7
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95.2,13.2c-0.7-0.1-1.5-0.1-2.1,0.3c-0.5-0.1-0.9-0.1-1.4,0c2.9,1.9,4.5,4.4,5.3,7.4l-0.4-2.3 c0.6,0.3,1.3,0.7,1.9,1.1c-0.8-0.8-1.5-1.5-2.1-2.3C95.9,16,95.5,14.6,95.2,13.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_40_",
    d: "M96.2,29c0.6,1.3,1.3,2.5,2.8,2.5l2.7,3.1c0.6,1.6,1.1,2.7,1.4,4.6c0.1,0.7,0.6,1.6,0.8,2.4 c0.2,2-0.8,2.2-0.5,3.4c-0.7,0.4-1.9,2-2.3,2.7l0.1-0.9c-0.5-1.4-0.8-2.9-1.5-4.3c-1-0.5-1.1-2.1-1.4-3.3 c-0.2-1.7-0.8-1.5-0.9-2.2c0.3-2.8-0.5-4.4-1-5.9C96.1,30.5,96.3,29.7,96.2,29"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_41_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_40_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.0458,
    y1: -16.5119,
    x2: 98.7426,
    y2: 57.7857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 29,
    className: "st20",
    width: 8,
    height: 18.7
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96.2,29c0.6,1.3,1.3,2.5,2.8,2.5l2.7,3.1c0.6,1.6,1.1,2.7,1.4,4.6c0.1,0.7,0.6,1.6,0.8,2.4 c0.2,2-0.8,2.2-0.5,3.4c-0.7,0.4-1.9,2-2.3,2.7l0.1-0.9c-0.5-1.4-0.8-2.9-1.5-4.3c-1-0.5-1.1-2.1-1.4-3.3c-0.2-1.7-0.8-1.5-0.9-2.2 c0.3-2.8-0.5-4.4-1-5.9C96.1,30.5,96.3,29.7,96.2,29z"
  })), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_43_",
    d: "M110,29.1c-0.1,1-0.4,2-0.4,3c-0.2,0.9-1.1,2.8-1.5,4.6l-2.8,6.1l-1.9,2.2l0-1l0.6-2l-1.2-4.4 c-0.5-2,1.5-3,1.8-4.8c0.8-0.3,1.7-0.8,2.3-1.4c0.4-0.4,0.8-0.4,1.1-0.6C108.8,30.4,109.4,29.8,110,29.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.35,
    y1: 29.574,
    x2: 104.9805,
    y2: 44.5659
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 102.3,
    y: 29.1,
    className: "st21",
    width: 7.7,
    height: 15.9
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110,29.1c-0.1,1-0.4,2-0.4,3c-0.2,0.9-1.1,2.8-1.5,4.6l-2.8,6.1l-1.9,2.2l0-1l0.6-2l-1.2-4.4 c-0.5-2,1.5-3,1.8-4.8c0.8-0.3,1.7-0.8,2.3-1.4c0.4-0.4,0.8-0.4,1.1-0.6C108.8,30.4,109.4,29.8,110,29.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_46_",
    d: "M111.8,33.5c0,2.2,0,3.6-1.4,5.3c-0.4,0.5-0.9,0.8-1.2,1.3c-0.4,1.4-1,2.7-1.6,3.8 c-0.6,0.2-1.2-0.1-1.7,0.6c-0.4,0.6-1.1,1.6-1.4,1.7c-0.4-0.4-0.3-1.2-0.9-1.4l1.7-2l2.8-6.1C110.1,35.6,111.3,34.4,111.8,33.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_47_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_46_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.7181,
    y1: 33.4252,
    x2: 106.6796,
    y2: 46.2583
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 103.6,
    y: 33.5,
    className: "st22",
    width: 8.2,
    height: 12.7
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M111.8,33.5c0,2.2,0,3.6-1.4,5.3c-0.4,0.5-0.9,0.8-1.2,1.3c-0.4,1.4-1,2.7-1.6,3.8c-0.6,0.2-1.2-0.1-1.7,0.6 c-0.4,0.6-1.1,1.6-1.4,1.7c-0.4-0.4-0.3-1.2-0.9-1.4l1.7-2l2.8-6.1C110.1,35.6,111.3,34.4,111.8,33.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_49_",
    d: "M111.2,41.8l-2.3,4.6l-0.7,2.2c-0.5,0.9-1.9,3.1-2.8,5.9c-0.9,0.2-1.8,0.4-2.6,0.9 c-0.3-0.7,0.2-1.7,0.2-2.4c-0.8,0.6-1.9,1.4-2.9,1.6c0.5-2.2,1.2-4.4,2.4-6.5c0.7-0.6,0.9-1.5,2.1-2.1c0.9-0.4,0.7-1.9,2.5-2.1 C109.1,43.7,110.2,42.8,111.2,41.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.5392,
    y1: 6.3218,
    x2: 105.2369,
    y2: 55.7132
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 100.2,
    y: 41.8,
    className: "st23",
    width: 11.1,
    height: 13.7
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M111.2,41.8l-2.3,4.6l-0.7,2.2c-0.5,0.9-1.9,3.1-2.8,5.9c-0.9,0.2-1.8,0.4-2.6,0.9c-0.3-0.7,0.2-1.7,0.2-2.4 c-0.8,0.6-1.9,1.4-2.9,1.6c0.5-2.2,1.2-4.4,2.4-6.5c0.7-0.6,0.9-1.5,2.1-2.1c0.9-0.4,0.7-1.9,2.5-2.1 C109.1,43.7,110.2,42.8,111.2,41.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_52_",
    d: "M96.7,39.9c0.8,1.3,1.8,2.3,2.9,2.6c0.7,0.9,1.1,2.5,1.5,4.1c0.1,1.3-0.2,3,0.2,4.2 c-0.6,1.5-0.9,2.7-1.2,4.2c-0.2,0.1-0.4,0.4-0.5,0.6c-0.1,0.1-0.2,0.2-0.5,0.4c-0.2,0.2-0.3,1-0.8,0.8c-1.3-0.7-4.2-0.1-3.2-2.3 c1-2.1,0.9-1.1,1.1-1.1c0-1.5,0.3-2.9,0.7-4.3v-2.6c-0.1-1.3,0.1-2.5,0.4-3.7C97.3,41.7,96.9,40.8,96.7,39.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_53_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_52_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.3122,
    y1: 19.6402,
    x2: 96.2577,
    y2: 63.7734
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 39.9,
    className: "st24",
    width: 7.2,
    height: 17
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96.7,39.9c0.8,1.3,1.8,2.3,2.9,2.6c0.7,0.9,1.1,2.5,1.5,4.1c0.1,1.3-0.2,3,0.2,4.2c-0.6,1.5-0.9,2.7-1.2,4.2 c-0.2,0.1-0.4,0.4-0.5,0.6c-0.1,0.1-0.2,0.2-0.5,0.4c-0.2,0.2-0.3,1-0.8,0.8c-1.3-0.7-4.2-0.1-3.2-2.3c1-2.1,0.9-1.1,1.1-1.1 c0-1.5,0.3-2.9,0.7-4.3v-2.6c-0.1-1.3,0.1-2.5,0.4-3.7C97.3,41.7,96.9,40.8,96.7,39.9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_55_",
    d: "M108.4,48.6c0.2-0.1,0.4-0.4,0.6-0.5c1-0.3,1.9-1,2.9-1.7c-0.6,0.6-1.2,1.8-1.8,3.5 c-0.3,0.9-0.6,1.2-1.6,2.2c-0.4,0.4-0.8,0.9-1,1.6c-0.1,0.5-0.7,0.9-0.9,1.5c-1.4,1.2-2.9,2-4.3,2.4c0.2-0.7,0.1-1.6,0.5-2.1 c0.9-0.5,1.7-0.8,2.6-0.9C106.3,52.4,107.2,50.4,108.4,48.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_56_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.9927,
    y1: 46.3417,
    x2: 106.2024,
    y2: 57.6402
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 102.3,
    y: 46.5,
    className: "st25",
    width: 9.6,
    height: 11.1
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.4,48.6c0.2-0.1,0.4-0.4,0.6-0.5c1-0.3,1.9-1,2.9-1.7c-0.6,0.6-1.2,1.8-1.8,3.5c-0.3,0.9-0.6,1.2-1.6,2.2 c-0.4,0.4-0.8,0.9-1,1.6c-0.1,0.5-0.7,0.9-0.9,1.5c-1.4,1.2-2.9,2-4.3,2.4c0.2-0.7,0.1-1.6,0.5-2.1c0.9-0.5,1.7-0.8,2.6-0.9 C106.3,52.4,107.2,50.4,108.4,48.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_58_",
    d: "M94.8,41.2c0.6,0.9,1.3,1.7,2.3,2.5l-0.2,5.6l-0.6,4.1c-0.3-0.1-0.8,0.8-1.1,0.3c-0.1-0.2,0.1-2.4-0.1-2.6 c-0.1-0.6,0-1.2,0.4-1.8c-0.1-0.6-0.4-1.3-0.4-1.9c-0.1-0.9,0-1.8,0.2-2.6C95,43.5,94.5,42.2,94.8,41.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_59_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_58_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.9739,
    y1: -52.8398,
    x2: 87.1743,
    y2: 113.4854
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 94.5,
    y: 41.2,
    className: "st26",
    width: 2.6,
    height: 13
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94.8,41.2c0.6,0.9,1.3,1.7,2.3,2.5l-0.2,5.6l-0.6,4.1c-0.3-0.1-0.8,0.8-1.1,0.3c-0.1-0.2,0.1-2.4-0.1-2.6 c-0.1-0.6,0-1.2,0.4-1.8c-0.1-0.6-0.4-1.3-0.4-1.9c-0.1-0.9,0-1.8,0.2-2.6C95,43.5,94.5,42.2,94.8,41.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_61_",
    d: "M94.9,47.7c0,1.3-0.3,2.3,0.1,3.7c0.2,1.3,0.1,2.7-0.1,4c0.3,2.1-0.1,4-0.7,6c-0.1,1.1,0,1.5-0.3,2 c-0.1,0.1-0.3,0.2-0.6,0.1c-0.3,0-0.6-0.2-0.8-0.3c-0.5-0.3-1,0-1.6,0v-4.1c0.1-0.8,0.3-1.8,0.2-2.5c0-0.9-0.3-1.5,0-2.3 c0.2-0.5,0.7-0.6,1.2-2c0.2-0.4,0.2-0.9,0.3-1.2C93.5,49.6,94,49,94.9,47.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_62_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_61_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.2203,
    y1: 33.369,
    x2: 91.1883,
    y2: 75.1703
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 90.9,
    y: 47.7,
    className: "st27",
    width: 4.3,
    height: 15.9
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94.9,47.7c0,1.3-0.3,2.3,0.1,3.7c0.2,1.3,0.1,2.7-0.1,4c0.3,2.1-0.1,4-0.7,6c-0.1,1.1,0,1.5-0.3,2 c-0.1,0.1-0.3,0.2-0.6,0.1c-0.3,0-0.6-0.2-0.8-0.3c-0.5-0.3-1,0-1.6,0v-4.1c0.1-0.8,0.3-1.8,0.2-2.5c0-0.9-0.3-1.5,0-2.3 c0.2-0.5,0.7-0.6,1.2-2c0.2-0.4,0.2-0.9,0.3-1.2C93.5,49.6,94,49,94.9,47.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_64_",
    d: "M94,63.3l0.5-3c1.1-1.3,2.3-2.5,3.8-3.4l2-2.3c0.9-0.3,1.9-0.9,2.8-1.5c-0.2,1.4-0.2,2.7-0.8,4.3 c-0.3,0.5-0.7,1.2-0.9,1.6c-0.3,0.5-0.6,1.1-0.9,1.6c-0.6,0.1-1.3,0.3-1.9,0.7c-1.1,0.9-2,1.9-2.8,3L94,63.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_65_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_64_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.2431,
    y1: 5.3453,
    x2: 97.6329,
    y2: 86.3151
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 53.2,
    className: "st28",
    width: 9,
    height: 11.2
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94,63.3l0.5-3c1.1-1.3,2.3-2.5,3.8-3.4l2-2.3c0.9-0.3,1.9-0.9,2.8-1.5c-0.2,1.4-0.2,2.7-0.8,4.3 c-0.3,0.5-0.7,1.2-0.9,1.6c-0.3,0.5-0.6,1.1-0.9,1.6c-0.6,0.1-1.3,0.3-1.9,0.7c-1.1,0.9-2,1.9-2.8,3L94,63.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_67_",
    d: "M107.8,56.8c-1.4,0.5-2.7,0.6-4,0.2c-0.3,0.1-0.5,0.1-0.7,0.2l-0.8,0.3c-0.5,1.1-1.1,2.1-1.8,3.1 c-2.6,0.9-3.4,1.8-4.7,3.7c0.2,0.2,0.2,0.4,0.1,0.6c1-0.4,2.2-0.2,3.2,0c1.1-1.4,2.8-2,4.5-3C105,59.8,106.1,57.9,107.8,56.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_68_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_67_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.122,
    y1: 14.6045,
    x2: 101.279,
    y2: 78.7169
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7,
    y: 56.8,
    className: "st29",
    width: 12.1,
    height: 8.2
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.8,56.8c-1.4,0.5-2.7,0.6-4,0.2c-0.3,0.1-0.5,0.1-0.7,0.2l-0.8,0.3c-0.5,1.1-1.1,2.1-1.8,3.1 c-2.6,0.9-3.4,1.8-4.7,3.7c0.2,0.2,0.2,0.4,0.1,0.6c1-0.4,2.2-0.2,3.2,0c1.1-1.4,2.8-2,4.5-3C105,59.8,106.1,57.9,107.8,56.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_70_",
    d: "M86.2,72.7c0.8,1.2,0.3,1.7,0,2.8l0.6,0c1,0.2,2.1,0.2,3.1,0l3.7-1.5c1.8-0.2,2.6-0.8,3.5-1.3 c1.7-2.1,2.1-2.4,3.8-3.1l-3.5-0.4c-0.9,0.3-1.8,0.5-2.7,0.4c-0.5-0.1-1-0.2-1.6-0.1c-1.9,0.6-3.8,1.3-5.6,2.2L86.2,72.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_71_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_70_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.0283,
    y1: 68.8704,
    x2: 92.8924,
    y2: 76.0467
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 69.1,
    className: "st30",
    width: 14.6,
    height: 6.7
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M86.2,72.7c0.8,1.2,0.3,1.7,0,2.8l0.6,0c1,0.2,2.1,0.2,3.1,0l3.7-1.5c1.8-0.2,2.6-0.8,3.5-1.3 c1.7-2.1,2.1-2.4,3.8-3.1l-3.5-0.4c-0.9,0.3-1.8,0.5-2.7,0.4c-0.5-0.1-1-0.2-1.6-0.1c-1.9,0.6-3.8,1.3-5.6,2.2L86.2,72.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_73_",
    d: "M97.2,59.9c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3 C95.9,59.3,96.5,59.9,97.2,59.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_74_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_73_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.7652,
    y1: 35.7098,
    x2: 96.885,
    y2: 70.8239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 57.4,
    className: "st31",
    width: 2.6,
    height: 2.6
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.2,59.9c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3C95.9,59.3,96.5,59.9,97.2,59.9 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_76_",
    d: "M94.9,59.6c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4 C93.5,59,94.1,59.6,94.9,59.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_77_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_76_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.4004,
    y1: 38.9214,
    x2: 94.588,
    y2: 71.2522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 56.7,
    className: "st32",
    width: 2.9,
    height: 2.9
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94.9,59.6c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4C93.5,59,94.1,59.6,94.9,59.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_79_",
    d: "M97.1,58.2c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4 C95.8,57.6,96.4,58.2,97.1,58.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_80_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_79_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.705,
    y1: 34.062,
    x2: 96.8249,
    y2: 69.018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 95.8,
    y: 55.5,
    className: "st33",
    width: 2.8,
    height: 2.8
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.1,58.2c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4C95.8,57.6,96.4,58.2,97.1,58.2 z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.8,12.3c-0.6,0.6-0.5,1-0.7,1.8c-0.1,0.6-1.1,1.7-1.1,2.1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 98.9,
    y1: 15.6,
    x2: 100.4,
    y2: 19.4
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M100.4,19.4c0.3,0.9,0.8,2.1,0.8,3.1"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105.8,14.5c-0.5,2.8-0.9,5.5-2.2,8"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.1,18.5c-0.8,3.3-0.7,6.8-2.3,9.5c-0.6,1.1-0.8,3.4-1.7,4.3"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96.9,19c1.1,2,2.2,4.6,3,6.9c0.2,0.6,0,1.7,0.2,2.4c0.9,2,1.5,3.3,1.5,5.5"
  })), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_82_",
    d: "M109.9,29.6c-0.1,0.5-0.2,0.6-0.6,0.8c0,0.8-1.3,1.3-1.3,1.9c-0.1,0-0.3,0.2-0.3,0.2v0.1v0.1 c-0.3,0.3-0.6,1.3-0.6,1.8c-0.5,0.5-0.7,1.5-1.3,2c0,2-1.3,4.2-1.8,5.9v0.2L109.9,29.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_83_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_82_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.6684,
    y1: -134.1305,
    x2: 103.4593,
    y2: 97.4431
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 29.6,
    className: "st34",
    width: 5.8,
    height: 13.2
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M109.9,29.6c-0.1,0.5-0.2,0.6-0.6,0.8c0,0.8-1.3,1.3-1.3,1.9c-0.1,0-0.3,0.2-0.3,0.2v0.1v0.1 c-0.3,0.3-0.6,1.3-0.6,1.8c-0.5,0.5-0.7,1.5-1.3,2c0,2-1.3,4.2-1.8,5.9v0.2L109.9,29.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_85_",
    d: "M96.4,29.6c0.8,3.4,3.3,6.4,4.3,9.7c0,0.1,0.3,0.6,0.3,0.7c0.2,0.7,0.3,1.5,0.5,2.2l0.7,3.4L96.4,29.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_86_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_85_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.3711,
    y1: -166.4375,
    x2: 94.3548,
    y2: 109.8559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 96.4,
    y: 29.6,
    className: "st35",
    width: 5.8,
    height: 15.9
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96.4,29.6c0.8,3.4,3.3,6.4,4.3,9.7c0,0.1,0.3,0.6,0.3,0.7c0.2,0.7,0.3,1.5,0.5,2.2l0.7,3.4L96.4,29.6z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.9,42.5c-1.5,1.9-1.9,2.4-4.4,3.3c0,3.3-2.4,5-3.6,7.6"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97,40.8c1.1,2.7,2.7,5.7,1.9,9c-0.3,1.5-0.6,3.6-1.3,5c0,0.1-0.2,0.5-0.2,0.6"
  })), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_88_",
    d: "M102.8,53.5c-1,2.3-2.5,5-4.5,6.3c-0.4,0.2-0.7,0.9-1.8,1.1c-1.8,0.4-1.2,1.6-1.4,2.1v0.6L102.8,53.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_89_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_88_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.0231,
    y1: -71.0224,
    x2: 97.2234,
    y2: 104.5627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 94.7,
    y: 53.5,
    className: "st36",
    width: 8.1,
    height: 10.1
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.8,53.5c-1,2.3-2.5,5-4.5,6.3c-0.4,0.2-0.7,0.9-1.8,1.1c-1.8,0.4-1.2,1.6-1.4,2.1v0.6L102.8,53.5z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.2,57c-1.9,1.4-4.4,1.1-5.2,3.4c-0.8,2.2-4.1,2.2-5.8,3.3c0,0.3-0.1,0.8-0.1,1.1"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94.7,48.3c-1.3,1.8-0.6,3.9-1.3,5.9c-0.3,0.9-0.9,1.9-0.9,3.1c0.8,0.8,0.3,3.6,0.3,4.8"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "100.3,69.4 97.3,70.6 97.3,70.8 "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.3,70.8c-2.5,1-5.7,0.9-7.8,2.4c0,0.7-2.6,0.8-3.1,0.8"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.8,67.1c-0.2,0.5-0.9,1-0.9,1.6c-1.3,1.3-1.7,3.3-3.4,4.4c0,1.3-2.3,2.3-2.7,3.1c-0.2,0.6-1,1.4-1.4,1.7"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "75.4,77.9 75.4,78 75.4,78.1 "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.4,78.1c-0.1,0.1-0.3,0.3-0.3,0.5"
  })), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_91_",
    d: "M80.9,82.3c-1.4,0.3-5-1.3-8.1-0.8c-2.5,0.9-4.7,2.6-6.6,4.6c1.8-0.3,3.5-0.8,5.3-1.1 c1.3-0.2,2.6-0.4,3.9-0.4C76.6,83.7,79.1,82.9,80.9,82.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_92_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_91_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.9506,
    y1: 80.7179,
    x2: 73.0554,
    y2: 86.3747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 66.2,
    y: 81,
    className: "st37",
    width: 14.7,
    height: 5.1
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M80.9,82.3c-1.4,0.3-5-1.3-8.1-0.8c-2.5,0.9-4.7,2.6-6.6,4.6c1.8-0.3,3.5-0.8,5.3-1.1c1.3-0.2,2.6-0.4,3.9-0.4 C76.6,83.7,79.1,82.9,80.9,82.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_94_",
    d: "M74.2,74.1c-2.5,6.1-1.2,6.1-8,11.4c-1-0.3-1.6-0.7-2.9-0.2c-0.2-1.2-0.3-2.2,0.7-2.9 c0.9-0.7,1.3-1.6,2.2-2.5c1.8-1,3.6-1.9,4.6-3.2C71.7,75.6,72.9,75.2,74.2,74.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_95_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_94_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.5082,
    y1: 73.9183,
    x2: 67.6351,
    y2: 85.7208
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 74.1,
    className: "st38",
    width: 11.2,
    height: 11.4
  }))), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74.2,74.1c-2.5,6.1-1.2,6.1-8,11.4c-1-0.3-1.6-0.7-2.9-0.2c-0.2-1.2-0.3-2.2,0.7-2.9c0.9-0.7,1.3-1.6,2.2-2.5 c1.8-1,3.6-1.9,4.6-3.2C71.7,75.6,72.9,75.2,74.2,74.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_97_",
    d: "M89.6,78.7l-2-1c-1.9-0.3-3.7-0.4-5.7-0.9l-2.7,0.2l-4.3,2.8L74,81.5l1.5-0.1c1.5,0.3,3.3,1.3,4.3,0.5 c1.6-0.5,3.2-0.8,4.7-1.3C86.3,79.9,87.9,79.1,89.6,78.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_98_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_97_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.2626,
    y1: 42.0297,
    x2: 80.9838,
    y2: 151.6068
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 76.9,
    className: "st39",
    width: 15.6,
    height: 5.7
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M89.6,78.7l-2-1c-1.9-0.3-3.7-0.4-5.7-0.9l-2.7,0.2l-4.3,2.8L74,81.5l1.5-0.1c1.5,0.3,3.3,1.3,4.3,0.5 c1.6-0.5,3.2-0.8,4.7-1.3C86.3,79.9,87.9,79.1,89.6,78.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_100_",
    d: "M91,80.2c-3.6,2.4-7.9,2.9-11.5,1.8c1.6-0.6,3-1.2,4.7-1.8l3.3-0.9C88.6,79.6,89.8,80.2,91,80.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_101_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_100_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.5383,
    y1: 33.9917,
    x2: 84.6356,
    y2: 163.3825
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 79.3,
    className: "st40",
    width: 11.5,
    height: 3.7
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91,80.2c-3.6,2.4-7.9,2.9-11.5,1.8c1.6-0.6,3-1.2,4.7-1.8l3.3-0.9C88.6,79.6,89.8,80.2,91,80.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_103_",
    d: "M84.9,77.8c0.9,0,1.7-0.7,1.7-1.7s-0.7-1.7-1.7-1.7s-1.7,0.7-1.7,1.7S84,77.8,84.9,77.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_104_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_103_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.4942,
    y1: 52.111,
    x2: 83.9446,
    y2: 114.027
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 83.2,
    y: 74.5,
    className: "st41",
    width: 3.3,
    height: 3.3
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.9,77.8c0.9,0,1.7-0.7,1.7-1.7s-0.7-1.7-1.7-1.7s-1.7,0.7-1.7,1.7S84,77.8,84.9,77.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_106_",
    d: "M81.8,77.4c1,0,1.7-0.8,1.7-1.7c0-1-0.8-1.7-1.7-1.7s-1.7,0.8-1.7,1.7C80.1,76.6,80.8,77.4,81.8,77.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_107_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_106_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.3245,
    y1: 54.6415,
    x2: 80.7599,
    y2: 116.8432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 73.9,
    className: "st42",
    width: 3.5,
    height: 3.5
  }))), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M81.8,77.4c1,0,1.7-0.8,1.7-1.7c0-1-0.8-1.7-1.7-1.7s-1.7,0.8-1.7,1.7C80.1,76.6,80.8,77.4,81.8,77.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_109_",
    d: "M84.7,75.6c0.9,0,1.7-0.7,1.7-1.7c0-0.9-0.7-1.7-1.7-1.7c-0.9,0-1.7,0.7-1.7,1.7 C83,74.8,83.8,75.6,84.7,75.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_110_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_109_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.208,
    y1: 53.2706,
    x2: 83.8164,
    y2: 108.8829
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 72.2,
    className: "st43",
    width: 3.3,
    height: 3.3
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 84.7,
    cy: 73.9,
    r: 1.7
  })), /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_112_",
    d: "M74.3,81.7c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1C73.3,81.2,73.8,81.7,74.3,81.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_113_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_112_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.769,
    y1: 63.0396,
    x2: 72.9862,
    y2: 133.5459
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 79.7,
    className: "st44",
    width: 2,
    height: 2
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74.3,81.7c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1C73.3,81.2,73.8,81.7,74.3,81.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_115_",
    d: "M72.5,81.5c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1 C71.4,80.9,71.9,81.5,72.5,81.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_116_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_115_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.898,
    y1: 64.2706,
    x2: 71.1453,
    y2: 135.0929
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 71.4,
    y: 79.2,
    className: "st45",
    width: 2.3,
    height: 2.3
  }))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M72.5,81.5c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1C71.4,80.9,71.9,81.5,72.5,81.5 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_118_",
    d: "M74.3,80.3c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1S73.7,80.3,74.3,80.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_119_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_118_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.6969,
    y1: 62.5577,
    x2: 72.9668,
    y2: 131.0707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 73.2,
    y: 78.1,
    className: "st46",
    width: 2.2,
    height: 2.2
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74.3,80.3c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1S73.7,80.3,74.3,80.3z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M89.2,78.7c-2.3,0.2-6.5-1-8.3,0.8c-2,0-3.8,1-5.6,1"
  })), /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_121_",
    d: "M79.8,82.2c-1.8,0-4.8-0.3-6.5,0.2c0,0.6-1.1,1-1.5,1.1c-1.1,0.5-2.4,1.6-3.9,1.6l-0.7,1.1L79.8,82.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_122_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_121_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.007,
    y1: 36.7092,
    x2: 72.5401,
    y2: 194.5041
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 67.3,
    y: 81.9,
    className: "st47",
    width: 12.5,
    height: 4.4
  }))), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M79.8,82.2c-1.8,0-4.8-0.3-6.5,0.2c0,0.6-1.1,1-1.5,1.1c-1.1,0.5-2.4,1.6-3.9,1.6l-0.7,1.1L79.8,82.2z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M73.7,74.6c-0.5,0.5-1.8,1-2,1.4c-0.6,1-2,3.8-2,4.8c-1.6,0-5.2,1.9-5.2,3.8c-0.3,0.2-0.5,0.5-0.6,0.7"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.5,80.1c-2.2,0.9-5,0.7-7.4,0.7"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M93.5,93.6C93.5,93.6,93.5,93.6,93.5,93.6C93.5,93.6,93.5,93.6,93.5,93.6c0.2,0,0.4,0,0.5-0.1 c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2,0L93.5,93.6z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.5,93.6C93.5,93.6,93.5,93.6,93.5,93.6C93.5,93.6,93.5,93.6,93.5,93.6c0.2,0,0.4,0,0.5-0.1 c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2,0L93.5,93.6z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "92.1,93.7 92,92.9 91.5,93.6 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "92.1,93.7 92,92.9 91.5,93.6 "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M85.7,91.5c0.1,0.1,0.2,0.1,0.2,0.2c0.2,0.1,0.4,0.1,0.5,0.1c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.1-0.6 c0-0.2-0.1-0.3-0.3-0.5c-0.1,0-0.2-0.1-0.3-0.1L85.7,91.5z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.7,91.5c0.1,0.1,0.2,0.1,0.2,0.2c0.2,0.1,0.4,0.1,0.5,0.1c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.1-0.6 c0-0.2-0.1-0.3-0.3-0.5c-0.1,0-0.2-0.1-0.3-0.1L85.7,91.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_124_",
    d: "M54.7,87.1c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1S54,87.1,54.7,87.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_125_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_124_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.4988,
    y1: 86.4519,
    x2: 55.8157,
    y2: 85.3762
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 84.8,
    className: "st48",
    width: 2.3,
    height: 2.3
  }))), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M54.7,87.1c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1S54,87.1,54.7,87.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_127_",
    d: "M60.2,86.4c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1 C59.1,85.8,59.6,86.4,60.2,86.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_128_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_127_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.0425,
    y1: 85.7517,
    x2: 61.3518,
    y2: 84.6685
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 59.1,
    y: 84.1,
    className: "st49",
    width: 2.3,
    height: 2.3
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.2,86.4c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1C59.1,85.8,59.6,86.4,60.2,86.4 z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_130_",
    x: 60.2,
    y: 84.5,
    width: 0.6,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_131_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_130_",
    style: {
      overflow: "visible"
    }
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M60.8,84.8c0,0.1-0.1,0.2-0.3,0.2s-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2S60.8,84.6,60.8,84.8z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M60.8,84.8c0,0.1-0.1,0.2-0.3,0.2s-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2S60.8,84.6,60.8,84.8z"
  })))), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M60.7,84.8c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2C60.6,84.6,60.7,84.7,60.7,84.8 z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.7,84.8c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2C60.6,84.6,60.7,84.7,60.7,84.8 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_132_",
    d: "M72.5,81.6c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1 C71.3,81.1,71.8,81.6,72.5,81.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_133_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_132_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.3103,
    y1: 80.9878,
    x2: 73.6196,
    y2: 79.9122
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 79.3,
    className: "st53",
    width: 2.3,
    height: 2.3
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 72.5,
    cy: 80.4,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_135_",
    x: 72.5,
    y: 79.7,
    width: 0.6,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_136_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_135_",
    style: {
      overflow: "visible"
    }
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M73.1,80c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2C72.9,79.7,73.1,79.9,73.1,80z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M73.1,80c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2C72.9,79.7,73.1,79.9,73.1,80z "
  })))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M73,80c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2C72.9,79.8,73,79.9,73,80z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73,80c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2C72.9,79.8,73,79.9,73,80z"
  })), /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_137_",
    d: "M74.4,80.3c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1 C73.3,79.8,73.8,80.3,74.4,80.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_138_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_137_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.2374,
    y1: 79.6745,
    x2: 75.5543,
    y2: 78.5989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 78,
    className: "st56",
    width: 2.3,
    height: 2.3
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 74.4,
    cy: 79.1,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_140_",
    x: 74.4,
    y: 78.4,
    width: 0.6,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_141_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_140_",
    style: {
      overflow: "visible"
    }
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M75,78.7c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2C74.9,78.4,75,78.5,75,78.7z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M75,78.7c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2C74.9,78.4,75,78.5,75,78.7z"
  })))), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M74.9,78.7c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2C74.8,78.5,74.9,78.6,74.9,78.7z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.9,78.7c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2C74.8,78.5,74.9,78.6,74.9,78.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_142_",
    d: "M81.6,77.4c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8C79.8,76.6,80.6,77.4,81.6,77.4 "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_143_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_142_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_144_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.8258,
    y1: 76.4828,
    x2: 83.4215,
    y2: 74.8053
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 79.8,
    y: 73.9,
    className: "st59",
    width: 3.5,
    height: 3.5
  }))), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M81.6,77.4c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8C79.8,76.6,80.6,77.4,81.6,77.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_145_",
    x: 81.6,
    y: 74.6,
    width: 1,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_146_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_145_",
    style: {
      overflow: "visible"
    }
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M82.6,74.9c0,0.2-0.2,0.4-0.5,0.4c-0.3,0-0.5-0.2-0.5-0.4c0-0.2,0.2-0.4,0.5-0.4 C82.4,74.6,82.6,74.7,82.6,74.9z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M82.6,74.9c0,0.2-0.2,0.4-0.5,0.4c-0.3,0-0.5-0.2-0.5-0.4c0-0.2,0.2-0.4,0.5-0.4 C82.4,74.6,82.6,74.7,82.6,74.9z"
  })))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M82.4,74.9c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2C82.3,74.7,82.4,74.8,82.4,74.9 z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.4,74.9c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2C82.3,74.7,82.4,74.8,82.4,74.9 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_147_",
    d: "M85,77.5c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8C83.2,76.7,84,77.5,85,77.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_148_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_147_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_149_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.182,
    y1: 76.5304,
    x2: 86.7625,
    y2: 74.8529
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 83.2,
    y: 73.9,
    className: "st62",
    width: 3.5,
    height: 3.5
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85,77.5c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8C83.2,76.7,84,77.5,85,77.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_150_",
    x: 85,
    y: 74.6,
    width: 1,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_151_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_150_",
    style: {
      overflow: "visible"
    }
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M85.9,75c0,0.2-0.2,0.4-0.5,0.4c-0.3,0-0.5-0.2-0.5-0.4c0-0.2,0.2-0.4,0.5-0.4C85.7,74.6,85.9,74.8,85.9,75z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M85.9,75c0,0.2-0.2,0.4-0.5,0.4c-0.3,0-0.5-0.2-0.5-0.4c0-0.2,0.2-0.4,0.5-0.4C85.7,74.6,85.9,74.8,85.9,75z "
  })))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M85.7,75c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2C85.6,74.7,85.7,74.9,85.7,75z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.7,75c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2C85.6,74.7,85.7,74.9,85.7,75z"
  })), /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_152_",
    d: "M84.8,75.6c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8C83.1,74.8,83.8,75.6,84.8,75.6 "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_153_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_152_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.0303,
    y1: 74.6849,
    x2: 86.6185,
    y2: 73.015
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 83.1,
    y: 72.1,
    className: "st65",
    width: 3.5,
    height: 3.5
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.8,75.6c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8C83.1,74.8,83.8,75.6,84.8,75.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_155_",
    x: 84.8,
    y: 72.8,
    width: 1,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_156_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_155_",
    style: {
      overflow: "visible"
    }
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M85.8,73.1c0,0.2-0.2,0.4-0.5,0.4c-0.3,0-0.5-0.2-0.5-0.4c0-0.2,0.2-0.4,0.5-0.4 C85.6,72.8,85.8,72.9,85.8,73.1z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M85.8,73.1c0,0.2-0.2,0.4-0.5,0.4c-0.3,0-0.5-0.2-0.5-0.4c0-0.2,0.2-0.4,0.5-0.4 C85.6,72.8,85.8,72.9,85.8,73.1z"
  })))), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M85.6,73.1c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2s0.1-0.2,0.3-0.2C85.5,72.9,85.6,73,85.6,73.1z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.6,73.1c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2s0.1-0.2,0.3-0.2C85.5,72.9,85.6,73,85.6,73.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_157_",
    d: "M90.8,66.6c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.8-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7 C89.1,65.8,89.9,66.6,90.8,66.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_158_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_157_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.1227,
    y1: 65.6642,
    x2: 92.5453,
    y2: 64.0695
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 63.2,
    className: "st68",
    width: 3.4,
    height: 3.4
  }))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.8,66.6c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.8-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7C89.1,65.8,89.9,66.6,90.8,66.6 z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_160_",
    x: 90.8,
    y: 63.8,
    width: 0.9,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_161_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_160_",
    style: {
      overflow: "visible"
    }
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M91.7,64.2c0,0.2-0.2,0.4-0.5,0.4c-0.3,0-0.5-0.2-0.5-0.4s0.2-0.4,0.5-0.4C91.5,63.8,91.7,64,91.7,64.2z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M91.7,64.2c0,0.2-0.2,0.4-0.5,0.4c-0.3,0-0.5-0.2-0.5-0.4s0.2-0.4,0.5-0.4C91.5,63.8,91.7,64,91.7,64.2z"
  })))), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M91.6,64.2c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2C91.4,64,91.6,64.1,91.6,64.2z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.6,64.2c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2C91.4,64,91.6,64.1,91.6,64.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_162_",
    d: "M94,66.6c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.8-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7 C92.3,65.8,93.1,66.6,94,66.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_163_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_162_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_164_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.3125,
    y1: 65.7103,
    x2: 95.7352,
    y2: 64.1156
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 63.2,
    className: "st71",
    width: 3.4,
    height: 3.4
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94,66.6c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.8-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7C92.3,65.8,93.1,66.6,94,66.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_165_",
    x: 94,
    y: 63.9,
    width: 0.9,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_166_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_165_",
    style: {
      overflow: "visible"
    }
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M94.9,64.2c0,0.2-0.2,0.4-0.5,0.4S94,64.4,94,64.2c0-0.2,0.2-0.4,0.5-0.4S94.9,64,94.9,64.2z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M94.9,64.2c0,0.2-0.2,0.4-0.5,0.4S94,64.4,94,64.2c0-0.2,0.2-0.4,0.5-0.4S94.9,64,94.9,64.2z"
  })))), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M94.8,64.2c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2C94.6,64,94.8,64.1,94.8,64.2z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.8,64.2c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2C94.6,64,94.8,64.1,94.8,64.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_167_",
    d: "M93.9,64.8c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.8-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7 C92.2,64.1,93,64.8,93.9,64.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_168_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_167_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_169_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.1685,
    y1: 63.9551,
    x2: 95.5986,
    y2: 62.3604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 92.2,
    y: 61.5,
    className: "st74",
    width: 3.4,
    height: 3.4
  }))), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.9,64.8c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.8-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7C92.2,64.1,93,64.8,93.9,64.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_170_",
    x: 93.9,
    y: 62.1,
    width: 0.9,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_171_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_170_",
    style: {
      overflow: "visible"
    }
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M94.8,62.5c0,0.2-0.2,0.4-0.5,0.4c-0.3,0-0.5-0.2-0.5-0.4c0-0.2,0.2-0.4,0.5-0.4 C94.6,62.1,94.8,62.3,94.8,62.5z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M94.8,62.5c0,0.2-0.2,0.4-0.5,0.4c-0.3,0-0.5-0.2-0.5-0.4c0-0.2,0.2-0.4,0.5-0.4 C94.6,62.1,94.8,62.3,94.8,62.5z"
  })))), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M94.6,62.5c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2C94.5,62.3,94.6,62.4,94.6,62.5 z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.6,62.5c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0.1-0.2,0.3-0.2C94.5,62.3,94.6,62.4,94.6,62.5 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_172_",
    d: "M94.7,59.5c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4 C93.3,58.9,93.9,59.5,94.7,59.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_173_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_172_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_174_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.2597,
    y1: 58.7809,
    x2: 96.1031,
    y2: 57.457
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 93.3,
    y: 56.7,
    className: "st77",
    width: 2.8,
    height: 2.8
  }))), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94.7,59.5c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4C93.3,58.9,93.9,59.5,94.7,59.5 z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_175_",
    x: 94.7,
    y: 57.3,
    width: 0.8,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_176_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_175_",
    style: {
      overflow: "visible"
    }
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M95.4,57.6c0,0.2-0.2,0.3-0.4,0.3c-0.2,0-0.4-0.1-0.4-0.3c0-0.2,0.2-0.3,0.4-0.3 C95.3,57.3,95.4,57.4,95.4,57.6z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M95.4,57.6c0,0.2-0.2,0.3-0.4,0.3c-0.2,0-0.4-0.1-0.4-0.3c0-0.2,0.2-0.3,0.4-0.3 C95.3,57.3,95.4,57.4,95.4,57.6z"
  })))), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95.3,57.6c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2C95.2,57.4,95.3,57.5,95.3,57.6 z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.3,57.6c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2C95.2,57.4,95.3,57.5,95.3,57.6 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_177_",
    d: "M97.3,59.6c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4 C95.9,58.9,96.6,59.6,97.3,59.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_178_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_177_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_179_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.9093,
    y1: 58.8148,
    x2: 98.7377,
    y2: 57.4984
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 56.8,
    className: "st80",
    width: 2.8,
    height: 2.8
  }))), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.3,59.6c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4C95.9,58.9,96.6,59.6,97.3,59.6 z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs64 || (_defs64 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_180_",
    x: 97.3,
    y: 57.3,
    width: 0.8,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_181_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_180_",
    style: {
      overflow: "visible"
    }
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M98.1,57.6c0,0.2-0.2,0.3-0.4,0.3c-0.2,0-0.4-0.1-0.4-0.3c0-0.2,0.2-0.3,0.4-0.3 C97.9,57.3,98.1,57.4,98.1,57.6z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M98.1,57.6c0,0.2-0.2,0.3-0.4,0.3c-0.2,0-0.4-0.1-0.4-0.3c0-0.2,0.2-0.3,0.4-0.3 C97.9,57.3,98.1,57.4,98.1,57.6z"
  })))), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M97.9,57.6c0,0.1-0.1,0.2-0.2,0.2s-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2S97.9,57.5,97.9,57.6z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.9,57.6c0,0.1-0.1,0.2-0.2,0.2s-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2S97.9,57.5,97.9,57.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs65 || (_defs65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_182_",
    d: "M97.2,58.1c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4 C95.8,57.5,96.4,58.1,97.2,58.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_183_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_182_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_184_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.7951,
    y1: 57.36,
    x2: 98.6235,
    y2: 56.0436
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 95.8,
    y: 55.3,
    className: "st83",
    width: 2.8,
    height: 2.8
  }))), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.2,58.1c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4C95.8,57.5,96.4,58.1,97.2,58.1 z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs66 || (_defs66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_185_",
    x: 97.2,
    y: 55.8,
    width: 0.8,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_186_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_185_",
    style: {
      overflow: "visible"
    }
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M98,56.1c0,0.2-0.2,0.3-0.4,0.3c-0.2,0-0.4-0.1-0.4-0.3c0-0.2,0.2-0.3,0.4-0.3C97.8,55.8,98,56,98,56.1z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M98,56.1c0,0.2-0.2,0.3-0.4,0.3c-0.2,0-0.4-0.1-0.4-0.3c0-0.2,0.2-0.3,0.4-0.3C97.8,55.8,98,56,98,56.1z"
  })))), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M97.8,56.1c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2C97.7,56,97.8,56,97.8,56.1z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.8,56.1c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2C97.7,56,97.8,56,97.8,56.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs67 || (_defs67 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_187_",
    d: "M102.7,49.2c0.6-0.5,0.7-1.4,0.2-2c-0.5-0.6-1.4-0.7-2-0.2c-0.6,0.5-0.7,1.4-0.2,2 C101.2,49.5,102.1,49.6,102.7,49.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_188_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_187_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_189_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.8579,
    y1: 49.891,
    x2: 102.7459,
    y2: 46.2202
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 100.2,
    y: 46.5,
    className: "st86",
    width: 3.2,
    height: 3.2
  }))), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.7,49.2c0.6-0.5,0.7-1.4,0.2-2c-0.5-0.6-1.4-0.7-2-0.2c-0.6,0.5-0.7,1.4-0.2,2 C101.2,49.5,102.1,49.6,102.7,49.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs68 || (_defs68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_190_",
    x: 101.4,
    y: 47,
    width: 0.7,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_191_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_190_",
    style: {
      overflow: "visible"
    }
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M102.1,47.2c0.1,0.1,0.1,0.3-0.1,0.5c-0.2,0.1-0.4,0.1-0.5,0c-0.1-0.1-0.1-0.3,0.1-0.5 C101.7,47,102,47,102.1,47.2z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M102.1,47.2c0.1,0.1,0.1,0.3-0.1,0.5c-0.2,0.1-0.4,0.1-0.5,0c-0.1-0.1-0.1-0.3,0.1-0.5 C101.7,47,102,47,102.1,47.2z"
  })))), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M101.9,47.2c0.1,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1,0-0.2,0.1-0.3 C101.7,47.2,101.9,47.2,101.9,47.2z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.9,47.2c0.1,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1,0-0.2,0.1-0.3 C101.7,47.2,101.9,47.2,101.9,47.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs69 || (_defs69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_192_",
    d: "M104.8,47.6c0.6-0.5,0.7-1.4,0.2-2c-0.5-0.6-1.4-0.7-2-0.2c-0.6,0.5-0.7,1.4-0.2,2 C103.3,47.9,104.2,48,104.8,47.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_193_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_192_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_194_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.9764,
    y1: 48.2876,
    x2: 104.8645,
    y2: 44.6167
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 102.3,
    y: 44.9,
    className: "st89",
    width: 3.2,
    height: 3.2
  }))), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.8,47.6c0.6-0.5,0.7-1.4,0.2-2c-0.5-0.6-1.4-0.7-2-0.2c-0.6,0.5-0.7,1.4-0.2,2 C103.3,47.9,104.2,48,104.8,47.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs70 || (_defs70 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_195_",
    x: 103.5,
    y: 45.5,
    width: 0.7,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_196_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_195_",
    style: {
      overflow: "visible"
    }
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M104.2,45.6c0.1,0.1,0.1,0.3-0.1,0.5c-0.2,0.1-0.4,0.1-0.5,0c-0.1-0.1-0.1-0.3,0.1-0.5 C103.8,45.4,104.1,45.4,104.2,45.6z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M104.2,45.6c0.1,0.1,0.1,0.3-0.1,0.5c-0.2,0.1-0.4,0.1-0.5,0c-0.1-0.1-0.1-0.3,0.1-0.5 C103.8,45.4,104.1,45.4,104.2,45.6z"
  })))), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M104.1,45.7c0.1,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1,0-0.2,0.1-0.3 C103.9,45.6,104,45.6,104.1,45.7z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.1,45.7c0.1,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1,0-0.2,0.1-0.3 C103.9,45.6,104,45.6,104.1,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs71 || (_defs71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_197_",
    d: "M103.8,46.5c0.6-0.5,0.7-1.4,0.2-2c-0.5-0.6-1.4-0.7-2-0.2c-0.6,0.5-0.7,1.4-0.2,2 C102.3,46.8,103.2,47,103.8,46.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_198_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_197_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_199_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.0013,
    y1: 47.2024,
    x2: 103.8818,
    y2: 43.5315
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 101.4,
    y: 43.8,
    className: "st92",
    width: 3.2,
    height: 3.2
  }))), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.8,46.5c0.6-0.5,0.7-1.4,0.2-2c-0.5-0.6-1.4-0.7-2-0.2c-0.6,0.5-0.7,1.4-0.2,2 C102.3,46.8,103.2,47,103.8,46.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs72 || (_defs72 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_200_",
    x: 102.5,
    y: 44.4,
    width: 0.7,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_201_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_200_",
    style: {
      overflow: "visible"
    }
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M103.2,44.5c0.1,0.1,0.1,0.3-0.1,0.5c-0.2,0.1-0.4,0.1-0.5,0c-0.1-0.1-0.1-0.3,0.1-0.5 C102.9,44.3,103.1,44.4,103.2,44.5z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M103.2,44.5c0.1,0.1,0.1,0.3-0.1,0.5c-0.2,0.1-0.4,0.1-0.5,0c-0.1-0.1-0.1-0.3,0.1-0.5 C102.9,44.3,103.1,44.4,103.2,44.5z"
  })))), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M103.1,44.6c0.1,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1,0-0.2,0.1-0.3 C102.9,44.5,103,44.5,103.1,44.6z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.1,44.6c0.1,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1,0-0.2,0.1-0.3 C102.9,44.5,103,44.5,103.1,44.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs73 || (_defs73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_202_",
    d: "M103.1,36.4c0.5-0.4,0.6-1.2,0.2-1.7c-0.4-0.5-1.2-0.6-1.7-0.2c-0.5,0.4-0.6,1.2-0.2,1.7 C101.8,36.7,102.6,36.8,103.1,36.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_203_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_202_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_204_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.539,
    y1: 37.0264,
    x2: 103.1864,
    y2: 33.8219
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 34,
    className: "st95",
    width: 2.8,
    height: 2.8
  }))), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.1,36.4c0.5-0.4,0.6-1.2,0.2-1.7c-0.4-0.5-1.2-0.6-1.7-0.2c-0.5,0.4-0.6,1.2-0.2,1.7 C101.8,36.7,102.6,36.8,103.1,36.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs74 || (_defs74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_205_",
    x: 102,
    y: 34.5,
    width: 0.6,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_206_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_205_",
    style: {
      overflow: "visible"
    }
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M102.6,34.6c0.1,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.3,0.1-0.4,0c-0.1-0.1,0-0.3,0.1-0.4 C102.3,34.5,102.5,34.5,102.6,34.6z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M102.6,34.6c0.1,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.3,0.1-0.4,0c-0.1-0.1,0-0.3,0.1-0.4 C102.3,34.5,102.5,34.5,102.6,34.6z"
  })))), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M102.5,34.7c0.1,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1,0-0.2,0.1-0.3 C102.3,34.6,102.4,34.6,102.5,34.7z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.5,34.7c0.1,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1,0-0.2,0.1-0.3 C102.3,34.6,102.4,34.6,102.5,34.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs75 || (_defs75 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_207_",
    d: "M105,35c0.5-0.4,0.6-1.2,0.2-1.7c-0.4-0.5-1.2-0.6-1.7-0.2c-0.5,0.4-0.6,1.2-0.2,1.7 C103.7,35.3,104.4,35.4,105,35"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_208_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_207_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_209_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.3994,
    y1: 35.621,
    x2: 105.0392,
    y2: 32.4165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 102.8,
    y: 32.6,
    className: "st98",
    width: 2.8,
    height: 2.8
  }))), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105,35c0.5-0.4,0.6-1.2,0.2-1.7c-0.4-0.5-1.2-0.6-1.7-0.2c-0.5,0.4-0.6,1.2-0.2,1.7 C103.7,35.3,104.4,35.4,105,35z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs76 || (_defs76 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_210_",
    x: 103.9,
    y: 33.1,
    width: 0.6,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_211_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_210_",
    style: {
      overflow: "visible"
    }
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M104.4,33.2c0.1,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.3,0.1-0.4,0c-0.1-0.1,0-0.3,0.1-0.4 C104.2,33.1,104.3,33.1,104.4,33.2z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M104.4,33.2c0.1,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.3,0.1-0.4,0c-0.1-0.1,0-0.3,0.1-0.4 C104.2,33.1,104.3,33.1,104.4,33.2z"
  })))), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M104.3,33.3c0.1,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1,0-0.2,0.1-0.3 C104.2,33.2,104.3,33.2,104.3,33.3z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.3,33.3c0.1,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1,0-0.2,0.1-0.3 C104.2,33.2,104.3,33.2,104.3,33.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs77 || (_defs77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_212_",
    d: "M104.1,34c0.5-0.4,0.6-1.2,0.2-1.7c-0.4-0.5-1.2-0.6-1.7-0.2c-0.5,0.4-0.6,1.2-0.2,1.7 S103.6,34.5,104.1,34"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_213_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_212_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_214_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.5203,
    y1: 34.6739,
    x2: 104.1978,
    y2: 31.4694
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 31.7,
    className: "st101",
    width: 2.8,
    height: 2.8
  }))), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.1,34c0.5-0.4,0.6-1.2,0.2-1.7c-0.4-0.5-1.2-0.6-1.7-0.2c-0.5,0.4-0.6,1.2-0.2,1.7S103.6,34.5,104.1,34z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs78 || (_defs78 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_215_",
    x: 103,
    y: 32.2,
    width: 0.6,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_216_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_215_",
    style: {
      overflow: "visible"
    }
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M103.6,32.3c0.1,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.3,0.1-0.4,0c-0.1-0.1,0-0.3,0.1-0.4 C103.3,32.2,103.5,32.2,103.6,32.3z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M103.6,32.3c0.1,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.3,0.1-0.4,0c-0.1-0.1,0-0.3,0.1-0.4 C103.3,32.2,103.5,32.2,103.6,32.3z"
  })))), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M103.5,32.4c0.1,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1,0-0.2,0.1-0.3 C103.3,32.3,103.4,32.3,103.5,32.4z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.5,32.4c0.1,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1,0-0.2,0.1-0.3 C103.3,32.3,103.4,32.3,103.5,32.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs79 || (_defs79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_217_",
    d: "M104.5,25.5c0.1-0.7-0.4-1.3-1-1.4c-0.7-0.1-1.3,0.4-1.4,1c-0.1,0.7,0.4,1.3,1,1.4 C103.8,26.6,104.4,26.1,104.5,25.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_218_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_217_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_219_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.6648,
    y1: 26.5167,
    x2: 102.9277,
    y2: 24.0494
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 24,
    className: "st104",
    width: 2.6,
    height: 2.6
  }))), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.5,25.5c0.1-0.7-0.4-1.3-1-1.4c-0.7-0.1-1.3,0.4-1.4,1c-0.1,0.7,0.4,1.3,1,1.4 C103.8,26.6,104.4,26.1,104.5,25.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs80 || (_defs80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_220_",
    x: 102.6,
    y: 24.6,
    width: 0.5,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_221_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_220_",
    style: {
      overflow: "visible"
    }
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M102.9,24.6c0.1,0,0.2,0.2,0.2,0.4c0,0.2-0.2,0.3-0.3,0.3c-0.1,0-0.2-0.2-0.2-0.4 C102.6,24.7,102.8,24.5,102.9,24.6z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M102.9,24.6c0.1,0,0.2,0.2,0.2,0.4c0,0.2-0.2,0.3-0.3,0.3c-0.1,0-0.2-0.2-0.2-0.4 C102.6,24.7,102.8,24.5,102.9,24.6z"
  })))), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M102.9,24.7c0.1,0,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1-0.1-0.1-0.2 C102.7,24.7,102.8,24.7,102.9,24.7z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.9,24.7c0.1,0,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1-0.1-0.1-0.2 C102.7,24.7,102.8,24.7,102.9,24.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs81 || (_defs81 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_222_",
    d: "M104.9,23.2c0.1-0.7-0.4-1.3-1-1.4c-0.7-0.1-1.3,0.4-1.4,1c-0.1,0.7,0.4,1.3,1,1.4 C104.2,24.3,104.8,23.8,104.9,23.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_223_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_222_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_224_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.023,
    y1: 24.2037,
    x2: 103.2934,
    y2: 21.7439
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 102.3,
    y: 21.7,
    className: "st107",
    width: 2.6,
    height: 2.6
  }))), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.9,23.2c0.1-0.7-0.4-1.3-1-1.4c-0.7-0.1-1.3,0.4-1.4,1c-0.1,0.7,0.4,1.3,1,1.4 C104.2,24.3,104.8,23.8,104.9,23.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs82 || (_defs82 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_225_",
    x: 103,
    y: 22.3,
    width: 0.5,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_226_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_225_",
    style: {
      overflow: "visible"
    }
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M103.3,22.3c0.1,0,0.2,0.2,0.2,0.4c0,0.2-0.2,0.3-0.3,0.3c-0.1,0-0.2-0.2-0.2-0.4 C103,22.4,103.1,22.2,103.3,22.3z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M103.3,22.3c0.1,0,0.2,0.2,0.2,0.4c0,0.2-0.2,0.3-0.3,0.3c-0.1,0-0.2-0.2-0.2-0.4 C103,22.4,103.1,22.2,103.3,22.3z"
  })))), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M103.3,22.4c0.1,0,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1-0.1-0.1-0.2 C103.1,22.5,103.2,22.4,103.3,22.4z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.3,22.4c0.1,0,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1-0.1-0.1-0.2 C103.1,22.5,103.2,22.4,103.3,22.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs83 || (_defs83 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_227_",
    d: "M103.6,23.1c0.1-0.7-0.4-1.3-1-1.4c-0.7-0.1-1.3,0.4-1.4,1c-0.1,0.7,0.4,1.3,1,1.4 C102.9,24.2,103.5,23.7,103.6,23.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_228_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_227_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_229_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.7651,
    y1: 24.1493,
    x2: 102.0054,
    y2: 21.6443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 101.1,
    y: 21.6,
    className: "st110",
    width: 2.6,
    height: 2.6
  }))), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.6,23.1c0.1-0.7-0.4-1.3-1-1.4c-0.7-0.1-1.3,0.4-1.4,1c-0.1,0.7,0.4,1.3,1,1.4 C102.9,24.2,103.5,23.7,103.6,23.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs84 || (_defs84 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_230_",
    x: 101.7,
    y: 22.2,
    width: 0.5,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_231_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_230_",
    style: {
      overflow: "visible"
    }
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M102,22.2c0.1,0,0.2,0.2,0.2,0.4c0,0.2-0.2,0.3-0.3,0.3c-0.1,0-0.2-0.2-0.2-0.4 C101.7,22.3,101.9,22.2,102,22.2z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M102,22.2c0.1,0,0.2,0.2,0.2,0.4c0,0.2-0.2,0.3-0.3,0.3c-0.1,0-0.2-0.2-0.2-0.4 C101.7,22.3,101.9,22.2,102,22.2z"
  })))), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M102,22.3c0.1,0,0.1,0.1,0.1,0.2s-0.1,0.2-0.2,0.2c-0.1,0-0.1-0.1-0.1-0.2C101.8,22.4,101.9,22.3,102,22.3z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102,22.3c0.1,0,0.1,0.1,0.1,0.2s-0.1,0.2-0.2,0.2c-0.1,0-0.1-0.1-0.1-0.2C101.8,22.4,101.9,22.3,102,22.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs85 || (_defs85 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_232_",
    d: "M103.3,17.1c0.1-0.7-0.4-1.3-1-1.4c-0.7-0.1-1.3,0.4-1.4,1c-0.1,0.7,0.4,1.3,1,1.4 C102.6,18.2,103.2,17.7,103.3,17.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_233_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_232_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_234_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.4561,
    y1: 18.1317,
    x2: 101.7038,
    y2: 15.6267
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 100.8,
    y: 15.6,
    className: "st113",
    width: 2.6,
    height: 2.6
  }))), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.3,17.1c0.1-0.7-0.4-1.3-1-1.4c-0.7-0.1-1.3,0.4-1.4,1c-0.1,0.7,0.4,1.3,1,1.4 C102.6,18.2,103.2,17.7,103.3,17.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs86 || (_defs86 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_235_",
    x: 101.4,
    y: 16.2,
    width: 0.5,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_236_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_235_",
    style: {
      overflow: "visible"
    }
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M101.7,16.2c0.1,0,0.2,0.2,0.2,0.4c0,0.2-0.2,0.3-0.3,0.3c-0.1,0-0.2-0.2-0.2-0.4 C101.4,16.3,101.5,16.1,101.7,16.2z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M101.7,16.2c0.1,0,0.2,0.2,0.2,0.4c0,0.2-0.2,0.3-0.3,0.3c-0.1,0-0.2-0.2-0.2-0.4 C101.4,16.3,101.5,16.1,101.7,16.2z"
  })))), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M101.7,16.3c0.1,0,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1-0.1-0.1-0.2 C101.5,16.4,101.6,16.3,101.7,16.3z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.7,16.3c0.1,0,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1-0.1-0.1-0.2 C101.5,16.4,101.6,16.3,101.7,16.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs87 || (_defs87 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_237_",
    d: "M14.1,64.9c1.5,0,3-0.6,4.4-0.1c1.7,0.8,3.4,1.3,5,1.8c0.1,0,0.2,0.2,0.3,0.2c0.6,1.2,1.3,2.1,2.1,2.9 c0.6,0.3,1.3,0.8,1.9,1.3c0.5,0.3,1,0.5,1.5,0.8c-0.5,0-1.1,0.3-1.5,0.7l-1.2-1.1c-1.6-0.7-3.4-1.4-5.6-2.1c-0.5,0-1,0-1.5,0.2 c-0.5-0.6-0.9-1-1.6-1.4C17.1,66.9,15.9,65.8,14.1,64.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_238_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_237_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_239_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.7654,
    y1: 3.692,
    x2: 27.9736,
    y2: 149.8349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#628864"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 64.3,
    className: "st116",
    width: 15.3,
    height: 8.3
  }))), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M14.1,64.9c1.5,0,3-0.6,4.4-0.1c1.7,0.8,3.4,1.3,5,1.8c0.1,0,0.2,0.2,0.3,0.2c0.6,1.2,1.3,2.1,2.1,2.9 c0.6,0.3,1.3,0.8,1.9,1.3c0.5,0.3,1,0.5,1.5,0.8c-0.5,0-1.1,0.3-1.5,0.7l-1.2-1.1c-1.6-0.7-3.4-1.4-5.6-2.1c-0.5,0-1,0-1.5,0.2 c-0.5-0.6-0.9-1-1.6-1.4C17.1,66.9,15.9,65.8,14.1,64.9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs88 || (_defs88 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_240_",
    d: "M24.8,56.5c0.7,1.4,1.4,2.9,1.5,4.9l2,3.5c0.6,0.6,1,1.3,1.6,1.9c0.1,0.1,0.2,0,0.2,0 c0.2-0.7,0-1.4,0-2.1c-0.4-0.9-1-1.8-1.6-2.7c0-0.9-0.4-1.6-0.8-2.3L24.8,56.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_241_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_240_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_242_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.028,
    y1: 58.5284,
    x2: 58.7062,
    y2: 83.5024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8,
    y: 56.5,
    className: "st117",
    width: 5.5,
    height: 10.4
  }))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M24.8,56.5c0.7,1.4,1.4,2.9,1.5,4.9l2,3.5c0.6,0.6,1,1.3,1.6,1.9c0.1,0.1,0.2,0,0.2,0c0.2-0.7,0-1.4,0-2.1 c-0.4-0.9-1-1.8-1.6-2.7c0-0.9-0.4-1.6-0.8-2.3L24.8,56.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs89 || (_defs89 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_243_",
    d: "M23.3,58.2c-0.2,2.4,0.4,3.9,0.3,5.5c-0.1,1.6,1.1,3.1,1.7,5.4l0.8,0.8c1.4,0.9,2.8,1.8,4.4,2.3 c0-0.4,0.2-0.7,0.7-0.9c-0.6-1.5-1.1-2.9-1.3-4.5l-1.6-1.9l-2-3.5C24,59.9,23.5,59,23.3,58.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_244_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_243_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_245_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.6702,
    y1: 32.2751,
    x2: 29.2207,
    y2: 112.5304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#628864"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1,
    y: 58.2,
    className: "st118",
    width: 8,
    height: 13.9
  }))), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.3,58.2c-0.2,2.4,0.4,3.9,0.3,5.5c-0.1,1.6,1.1,3.1,1.7,5.4l0.8,0.8c1.4,0.9,2.8,1.8,4.4,2.3 c0-0.4,0.2-0.7,0.7-0.9c-0.6-1.5-1.1-2.9-1.3-4.5l-1.6-1.9l-2-3.5C24,59.9,23.5,59,23.3,58.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs90 || (_defs90 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_246_",
    d: "M29.9,66.6c1.2,1.4,0.6,4,0.7,5.6c0.3,0.1,0.6,0.7,0.9,0.9c1.3,1,2.5,2.3,2.7,3.7 c1.5,0.7,3.2,1.6,4.4,2.8c0.6-0.8,1.8-1.1,2.7-1.1c-0.8-2.5-2.5-5.9-5.6-7c-1-0.9-1.9-1.8-2.7-2.8C32.2,68,30.7,67.1,29.9,66.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_247_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_246_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_248_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.4473,
    y1: 34.2179,
    x2: 38.1031,
    y2: 162.1945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9,
    y: 66.6,
    className: "st119",
    width: 11.4,
    height: 13
  }))), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.9,66.6c1.2,1.4,0.6,4,0.7,5.6c0.3,0.1,0.6,0.7,0.9,0.9c1.3,1,2.5,2.3,2.7,3.7c1.5,0.7,3.2,1.6,4.4,2.8 c0.6-0.8,1.8-1.1,2.7-1.1c-0.8-2.5-2.5-5.9-5.6-7c-1-0.9-1.9-1.8-2.7-2.8C32.2,68,30.7,67.1,29.9,66.6z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.1,58.8c1,1.6,1.6,3.6,2.5,5.3c0.6,1.1,0.8,1.8,1.1,3c0.2,0.9,1.5,2.2,1.5,3.2c0.5,0.5,1.1,1.4,1.7,1.6"
  })), /*#__PURE__*/React.createElement("g", null, _defs91 || (_defs91 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_249_",
    d: "M14.8,1.7c0.2,1.8,0.6,3.5,1.2,4.8c0,1.5-0.3,3-0.7,4.5l-3,6.1l-1-5.4c-0.1-1,0-2,0.3-3.1 c0.8-1,0.8-2.3,1.4-3.3C13.7,4.3,14.6,3.7,14.8,1.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_250_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_249_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_251_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.589,
    y1: -65.2249,
    x2: 16.849,
    y2: 49.5652
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2,
    y: 1.7,
    className: "st120",
    width: 4.9,
    height: 15.4
  }))), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M14.8,1.7c0.2,1.8,0.6,3.5,1.2,4.8c0,1.5-0.3,3-0.7,4.5l-3,6.1l-1-5.4c-0.1-1,0-2,0.3-3.1 c0.8-1,0.8-2.3,1.4-3.3C13.7,4.3,14.6,3.7,14.8,1.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs92 || (_defs92 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_252_",
    d: "M12.8,22.4c1-1.3,2.1-2.5,3.4-3.4c0.8-0.8,1.5-1.6,1.8-2.6c0.6-2.5,1.1-4.2,1.5-5l-1,0.3l-1.1,0.4 c-1,0.2-2.1,0.7-3.1,1c-0.8,1.3-1.5,2.6-2.1,4L11.4,19c0.9,1.3,1.2,2.2,1.2,3.6L12.8,22.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_253_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_252_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_254_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.7244,
    y1: -34.229,
    x2: 16.4475,
    y2: 44.1908
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4,
    y: 11.4,
    className: "st121",
    width: 8.1,
    height: 11.2
  }))), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M12.8,22.4c1-1.3,2.1-2.5,3.4-3.4c0.8-0.8,1.5-1.6,1.8-2.6c0.6-2.5,1.1-4.2,1.5-5l-1,0.3l-1.1,0.4 c-1,0.2-2.1,0.7-3.1,1c-0.8,1.3-1.5,2.6-2.1,4L11.4,19c0.9,1.3,1.2,2.2,1.2,3.6L12.8,22.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs93 || (_defs93 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_255_",
    d: "M11.4,18.9c-0.7-1.1-1.4-2.1-2-3.2l-1.1-2.4l-0.2-2.2c0.4-1.4,0.7-3.3,0.6-4.8c0.6,1.8,1.4,3.5,2.5,4.9 l1.1,5.9C12.1,17.9,11.8,18.4,11.4,18.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_256_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_255_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_257_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.8919,
    y1: -31.5209,
    x2: 11.3526,
    y2: 27.687
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 6.3,
    className: "st122",
    width: 4.2,
    height: 12.6
  }))), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M11.4,18.9c-0.7-1.1-1.4-2.1-2-3.2l-1.1-2.4l-0.2-2.2c0.4-1.4,0.7-3.3,0.6-4.8c0.6,1.8,1.4,3.5,2.5,4.9l1.1,5.9 C12.1,17.9,11.8,18.4,11.4,18.9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs94 || (_defs94 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_258_",
    points: "8.4,13.7 7.7,17.6 8.1,20.7 9.3,24.3 11,26.2 12.6,22.6 12.4,20.5 11.5,18.9 9.3,15.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_259_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_258_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_260_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.9673,
    y1: -21.725,
    x2: 10.9918,
    y2: 30.7731
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: 13.7,
    className: "st123",
    width: 4.8,
    height: 12.5
  }))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "8.4,13.7 7.7,17.6 8.1,20.7 9.3,24.3 11,26.2 12.6,22.6 12.4,20.5 11.5,18.9 9.3,15.8 "
  })), /*#__PURE__*/React.createElement("g", null, _defs95 || (_defs95 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_261_",
    d: "M12.5,34.3L11,31.9c0-1.9,0.3-3.7,0.1-5.6c0.6-1.4,0.9-3.2,2.1-4c1.1-2,2.8-3,4.4-3.8 c-0.4,2.6-0.9,5.2-1.3,7.8c-0.7,1.5-0.9,3.2-1.1,5.1C14.3,32.1,13.4,33.1,12.5,34.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_262_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_261_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_263_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.2315,
    y1: -15.7613,
    x2: 15.4214,
    y2: 42.5214
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 18.5,
    className: "st124",
    width: 6.6,
    height: 15.9
  }))), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M12.5,34.3L11,31.9c0-1.9,0.3-3.7,0.1-5.6c0.6-1.4,0.9-3.2,2.1-4c1.1-2,2.8-3,4.4-3.8c-0.4,2.6-0.9,5.2-1.3,7.8 c-0.7,1.5-0.9,3.2-1.1,5.1C14.3,32.1,13.4,33.1,12.5,34.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs96 || (_defs96 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_264_",
    d: "M9.5,32.8c-0.8-0.6-1.7-0.7-2.4-1.5c-0.4-1.6-0.6-3.4-0.9-5.1c-0.2-1.1-0.7-2.3-0.9-3.6 c1.1-1.5,0.7-3.2,0.4-5c0.7,1.2,1.6,2.3,2.6,3.2c0.4,1.2,0.7,2.4,1.2,3.6c0.6,0.7,1.2,1.3,1.7,1.8L11,29l-0.1,2.9 C10.4,31.9,9.9,32.2,9.5,32.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_265_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_264_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_266_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.9978,
    y1: 17.7786,
    x2: 9.3372,
    y2: 32.5524
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 5.2,
    y: 17.6,
    className: "st125",
    width: 5.9,
    height: 15.2
  }))), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.5,32.8c-0.8-0.6-1.7-0.7-2.4-1.5c-0.4-1.6-0.6-3.4-0.9-5.1c-0.2-1.1-0.7-2.3-0.9-3.6c1.1-1.5,0.7-3.2,0.4-5 c0.7,1.2,1.6,2.3,2.6,3.2c0.4,1.2,0.7,2.4,1.2,3.6c0.6,0.7,1.2,1.3,1.7,1.8L11,29l-0.1,2.9C10.4,31.9,9.9,32.2,9.5,32.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs97 || (_defs97 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_267_",
    d: "M7.2,31.2l-1.2-0.6c-0.3-0.8-0.2-1.2-0.7-1.9l-0.3-1.3c-2-2-1-3.9-2.1-6.9c1,0.2,2.2,0.9,2.4,2.4l1.2,4.4 L7.2,31.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_268_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_267_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_269_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.1928,
    y1: 20.8777,
    x2: 5.78,
    y2: 30.8748
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 2.8,
    y: 20.5,
    className: "st126",
    width: 4.3,
    height: 10.7
  }))), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.2,31.2l-1.2-0.6c-0.3-0.8-0.2-1.2-0.7-1.9l-0.3-1.3c-2-2-1-3.9-2.1-6.9c1,0.2,2.2,0.9,2.4,2.4l1.2,4.4 L7.2,31.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs98 || (_defs98 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_270_",
    d: "M18.9,13.1c0.7-0.1,1.5-0.1,2.1,0.3c0.5-0.1,0.9-0.1,1.4-0.1c-2.9,1.9-4.5,4.4-5.3,7.4l0.4-2.3 c-0.6,0.3-1.3,0.7-1.9,1.1c0.8-0.8,1.5-1.5,2.1-2.3C18.2,15.9,18.6,14.5,18.9,13.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_271_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_270_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_272_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.7559,
    y1: -64.8341,
    x2: 20.69,
    y2: 75.7198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6,
    y: 13,
    className: "st127",
    width: 6.8,
    height: 7.7
  }))), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M18.9,13.1c0.7-0.1,1.5-0.1,2.1,0.3c0.5-0.1,0.9-0.1,1.4-0.1c-2.9,1.9-4.5,4.4-5.3,7.4l0.4-2.3 c-0.6,0.3-1.3,0.7-1.9,1.1c0.8-0.8,1.5-1.5,2.1-2.3C18.2,15.9,18.6,14.5,18.9,13.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs99 || (_defs99 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_273_",
    d: "M17.9,28.9c-0.6,1.4-1.3,2.5-2.8,2.5l-2.7,3.1c-0.6,1.6-1.1,2.7-1.4,4.6c-0.1,0.7-0.6,1.6-0.8,2.4 c-0.2,2,0.8,2.2,0.5,3.4c0.7,0.4,1.9,2,2.3,2.7L13,46.7c0.5-1.4,0.8-2.9,1.5-4.3c1-0.5,1.1-2.1,1.4-3.3c0.2-1.7,0.8-1.5,0.9-2.2 c-0.3-2.8,0.5-4.4,1-5.9C18,30.4,17.8,29.6,17.9,28.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_274_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_273_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_275_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.0636,
    y1: -16.6107,
    x2: 15.3743,
    y2: 57.6793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 28.9,
    className: "st128",
    width: 8,
    height: 18.7
  }))), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.9,28.9c-0.6,1.4-1.3,2.5-2.8,2.5l-2.7,3.1c-0.6,1.6-1.1,2.7-1.4,4.6c-0.1,0.7-0.6,1.6-0.8,2.4 c-0.2,2,0.8,2.2,0.5,3.4c0.7,0.4,1.9,2,2.3,2.7L13,46.7c0.5-1.4,0.8-2.9,1.5-4.3c1-0.5,1.1-2.1,1.4-3.3c0.2-1.7,0.8-1.5,0.9-2.2 c-0.3-2.8,0.5-4.4,1-5.9C18,30.4,17.8,29.6,17.9,28.9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs100 || (_defs100 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_276_",
    d: "M4.1,29c0.1,1,0.4,2,0.4,3c0.2,0.9,1.1,2.8,1.5,4.6l2.8,6.1l1.9,2.2l0-1l-0.6-2l1.2-4.4 c0.5-2-1.5-3-1.8-4.8c-0.8-0.3-1.7-0.8-2.3-1.4c-0.4-0.4-0.8-0.4-1.1-0.6C5.3,30.3,4.7,29.7,4.1,29"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_277_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_276_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_278_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.7624,
    y1: 29.4761,
    x2: 9.1395,
    y2: 44.468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 4.1,
    y: 29,
    className: "st129",
    width: 7.7,
    height: 15.9
  }))), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M4.1,29c0.1,1,0.4,2,0.4,3c0.2,0.9,1.1,2.8,1.5,4.6l2.8,6.1l1.9,2.2l0-1l-0.6-2l1.2-4.4c0.5-2-1.5-3-1.8-4.8 c-0.8-0.3-1.7-0.8-2.3-1.4c-0.4-0.4-0.8-0.4-1.1-0.6C5.3,30.3,4.7,29.7,4.1,29z"
  })), /*#__PURE__*/React.createElement("g", null, _defs101 || (_defs101 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_279_",
    d: "M2.3,33.4c0,2.2,0,3.6,1.4,5.3C4.2,39.1,4.7,39.5,5,40c0.4,1.4,1,2.7,1.6,3.8c0.6,0.2,1.2-0.1,1.7,0.6 C8.7,45,9.3,46,9.6,46.1c0.4-0.4,0.3-1.2,0.9-1.4l-1.7-2L6,36.7C4,35.5,2.8,34.3,2.3,33.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_280_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_279_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_281_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.4018,
    y1: 33.3274,
    x2: 7.4328,
    y2: 46.1679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 33.4,
    className: "st130",
    width: 8.2,
    height: 12.7
  }))), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2.3,33.4c0,2.2,0,3.6,1.4,5.3C4.2,39.1,4.7,39.5,5,40c0.4,1.4,1,2.7,1.6,3.8c0.6,0.2,1.2-0.1,1.7,0.6 C8.7,45,9.3,46,9.6,46.1c0.4-0.4,0.3-1.2,0.9-1.4l-1.7-2L6,36.7C4,35.5,2.8,34.3,2.3,33.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs102 || (_defs102 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_282_",
    d: "M2.9,41.7l2.3,4.6l0.7,2.2c0.5,0.9,1.9,3.1,2.8,5.9c0.9,0.2,1.8,0.4,2.6,0.9c0.3-0.7-0.2-1.7-0.2-2.4 c0.8,0.6,1.9,1.4,2.9,1.6c-0.5-2.2-1.2-4.4-2.4-6.5c-0.7-0.6-0.9-1.5-2.1-2.1c-0.9-0.4-0.7-1.9-2.5-2.1C5,43.6,3.9,42.7,2.9,41.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_283_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_282_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_284_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.5763,
    y1: 6.2083,
    x2: 8.8786,
    y2: 55.6071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 2.9,
    y: 41.7,
    className: "st131",
    width: 11.1,
    height: 13.7
  }))), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2.9,41.7l2.3,4.6l0.7,2.2c0.5,0.9,1.9,3.1,2.8,5.9c0.9,0.2,1.8,0.4,2.6,0.9c0.3-0.7-0.2-1.7-0.2-2.4 c0.8,0.6,1.9,1.4,2.9,1.6c-0.5-2.2-1.2-4.4-2.4-6.5c-0.7-0.6-0.9-1.5-2.1-2.1c-0.9-0.4-0.7-1.9-2.5-2.1C5,43.6,3.9,42.7,2.9,41.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs103 || (_defs103 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_285_",
    d: "M17.5,39.8c-0.8,1.3-1.8,2.3-2.9,2.6c-0.7,0.9-1.1,2.5-1.5,4.1c-0.1,1.3,0.2,3-0.2,4.2 c0.6,1.5,0.9,2.7,1.2,4.2c0.2,0.1,0.4,0.4,0.5,0.6c0.1,0.1,0.2,0.2,0.5,0.4c0.2,0.2,0.3,1,0.8,0.8c1.3-0.7,4.2-0.1,3.2-2.3 c-1-2.1-0.9-1.1-1.1-1.1c0-1.5-0.3-2.9-0.7-4.3v-2.6c0.1-1.3-0.1-2.5-0.4-3.7C16.8,41.6,17.2,40.7,17.5,39.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_286_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_285_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_287_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.8022,
    y1: 19.5415,
    x2: 17.8567,
    y2: 63.6522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 39.8,
    className: "st132",
    width: 7.2,
    height: 17
  }))), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.5,39.8c-0.8,1.3-1.8,2.3-2.9,2.6c-0.7,0.9-1.1,2.5-1.5,4.1c-0.1,1.3,0.2,3-0.2,4.2c0.6,1.5,0.9,2.7,1.2,4.2 c0.2,0.1,0.4,0.4,0.5,0.6c0.1,0.1,0.2,0.2,0.5,0.4c0.2,0.2,0.3,1,0.8,0.8c1.3-0.7,4.2-0.1,3.2-2.3c-1-2.1-0.9-1.1-1.1-1.1 c0-1.5-0.3-2.9-0.7-4.3v-2.6c0.1-1.3-0.1-2.5-0.4-3.7C16.8,41.6,17.2,40.7,17.5,39.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs104 || (_defs104 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_288_",
    d: "M5.7,48.5c-0.2-0.1-0.4-0.4-0.6-0.5c-1-0.3-1.9-1-2.9-1.7c0.6,0.6,1.2,1.8,1.8,3.5 c0.3,0.9,0.6,1.2,1.6,2.2c0.4,0.4,0.8,0.9,1,1.6c0.1,0.5,0.7,0.9,0.9,1.5c1.4,1.2,2.9,2,4.3,2.4c-0.2-0.7-0.1-1.6-0.5-2.1 c-0.9-0.5-1.7-0.8-2.6-0.9C7.9,52.3,6.9,50.3,5.7,48.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_289_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_288_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_290_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.1231,
    y1: 46.2433,
    x2: 7.9134,
    y2: 57.5417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 2.2,
    y: 46.4,
    className: "st133",
    width: 9.6,
    height: 11.1
  }))), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.7,48.5c-0.2-0.1-0.4-0.4-0.6-0.5c-1-0.3-1.9-1-2.9-1.7c0.6,0.6,1.2,1.8,1.8,3.5c0.3,0.9,0.6,1.2,1.6,2.2 c0.4,0.4,0.8,0.9,1,1.6c0.1,0.5,0.7,0.9,0.9,1.5c1.4,1.2,2.9,2,4.3,2.4c-0.2-0.7-0.1-1.6-0.5-2.1c-0.9-0.5-1.7-0.8-2.6-0.9 C7.9,52.3,6.9,50.3,5.7,48.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs105 || (_defs105 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_291_",
    d: "M19.3,41.1C18.8,42,18,42.8,17,43.5l0.2,5.6l0.6,4.1c0.3-0.1,0.8,0.8,1.1,0.3c0.1-0.2-0.1-2.4,0.1-2.6 c0.1-0.6,0-1.2-0.4-1.8c0.1-0.6,0.4-1.3,0.4-1.9c0.1-0.9,0-1.8-0.2-2.6C19.1,43.4,19.6,42.1,19.3,41.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_292_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_291_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_293_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.1284,
    y1: -52.9468,
    x2: 26.9505,
    y2: 113.3935
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 41.1,
    className: "st134",
    width: 2.6,
    height: 13
  }))), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M19.3,41.1C18.8,42,18,42.8,17,43.5l0.2,5.6l0.6,4.1c0.3-0.1,0.8,0.8,1.1,0.3c0.1-0.2-0.1-2.4,0.1-2.6 c0.1-0.6,0-1.2-0.4-1.8c0.1-0.6,0.4-1.3,0.4-1.9c0.1-0.9,0-1.8-0.2-2.6C19.1,43.4,19.6,42.1,19.3,41.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs106 || (_defs106 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_294_",
    d: "M19.2,47.6c0,1.3,0.3,2.3-0.1,3.7c-0.2,1.3-0.1,2.7,0.1,4c-0.3,2.1,0.1,4,0.7,6c0.1,1.1,0,1.5,0.3,2 c0.1,0.1,0.3,0.2,0.6,0.1c0.3,0,0.6-0.2,0.8-0.3c0.5-0.3,1,0,1.6,0V59c-0.1-0.8-0.3-1.8-0.2-2.5c0-0.9,0.3-1.5,0-2.3 c-0.2-0.5-0.7-0.6-1.2-2c-0.2-0.4-0.2-0.9-0.3-1.2C20.6,49.5,20.1,48.9,19.2,47.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_295_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_294_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_296_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.8997,
    y1: 33.2848,
    x2: 22.9241,
    y2: 75.0635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9,
    y: 47.6,
    className: "st135",
    width: 4.3,
    height: 15.9
  }))), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M19.2,47.6c0,1.3,0.3,2.3-0.1,3.7c-0.2,1.3-0.1,2.7,0.1,4c-0.3,2.1,0.1,4,0.7,6c0.1,1.1,0,1.5,0.3,2 c0.1,0.1,0.3,0.2,0.6,0.1c0.3,0,0.6-0.2,0.8-0.3c0.5-0.3,1,0,1.6,0V59c-0.1-0.8-0.3-1.8-0.2-2.5c0-0.9,0.3-1.5,0-2.3 c-0.2-0.5-0.7-0.6-1.2-2c-0.2-0.4-0.2-0.9-0.3-1.2C20.6,49.5,20.1,48.9,19.2,47.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs107 || (_defs107 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_297_",
    d: "M20.1,63.2l-0.5-3c-1.1-1.3-2.3-2.5-3.8-3.4l-2-2.3c-0.9-0.3-1.9-0.9-2.8-1.5c0.2,1.4,0.2,2.7,0.8,4.3 c0.3,0.5,0.7,1.2,0.9,1.6c0.3,0.5,0.6,1.1,0.9,1.6c0.6,0.1,1.3,0.3,1.9,0.7c1.1,0.9,2,1.9,2.8,3L20.1,63.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_298_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_297_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_299_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.8729,
    y1: 5.2321,
    x2: 16.4831,
    y2: 86.2396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1,
    y: 53.1,
    className: "st136",
    width: 9,
    height: 11.2
  }))), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20.1,63.2l-0.5-3c-1.1-1.3-2.3-2.5-3.8-3.4l-2-2.3c-0.9-0.3-1.9-0.9-2.8-1.5c0.2,1.4,0.2,2.7,0.8,4.3 c0.3,0.5,0.7,1.2,0.9,1.6c0.3,0.5,0.6,1.1,0.9,1.6c0.6,0.1,1.3,0.3,1.9,0.7c1.1,0.9,2,1.9,2.8,3L20.1,63.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs108 || (_defs108 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_300_",
    d: "M6.3,56.7c1.4,0.5,2.7,0.6,4,0.2c0.3,0.1,0.5,0.1,0.8,0.2l0.8,0.3c0.5,1.1,1.1,2.1,1.8,3.1 c2.6,0.9,3.4,1.8,4.7,3.7c-0.2,0.2-0.2,0.4-0.1,0.6c-1-0.4-2.2-0.2-3.2,0c-1.1-1.4-2.8-2-4.5-3C9.2,59.7,8,57.8,6.3,56.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_301_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_300_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_302_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.6498,
    y1: 56.5115,
    x2: 12.9962,
    y2: 64.9967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 6.3,
    y: 56.7,
    className: "st137",
    width: 12.1,
    height: 8.2
  }))), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.3,56.7c1.4,0.5,2.7,0.6,4,0.2c0.3,0.1,0.5,0.1,0.8,0.2l0.8,0.3c0.5,1.1,1.1,2.1,1.8,3.1 c2.6,0.9,3.4,1.8,4.7,3.7c-0.2,0.2-0.2,0.4-0.1,0.6c-1-0.4-2.2-0.2-3.2,0c-1.1-1.4-2.8-2-4.5-3C9.2,59.7,8,57.8,6.3,56.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs109 || (_defs109 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_303_",
    d: "M28,72.6c-0.8,1.2-0.3,1.7,0,2.8l-0.6,0c-1,0.2-2.1,0.2-3.1,0l-3.7-1.5c-1.8-0.2-2.6-0.8-3.5-1.3 c-1.7-2.1-2.1-2.4-3.8-3.1l3.5-0.4c0.9,0.3,1.8,0.5,2.7,0.4c0.5-0.1,1-0.2,1.6-0.2c1.9,0.6,3.8,1.3,5.6,2.2L28,72.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_304_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_303_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_305_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.0337,
    y1: 26.0491,
    x2: 21.2297,
    y2: 115.0527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3,
    y: 69,
    className: "st138",
    width: 14.6,
    height: 6.7
  }))), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M28,72.6c-0.8,1.2-0.3,1.7,0,2.8l-0.6,0c-1,0.2-2.1,0.2-3.1,0l-3.7-1.5c-1.8-0.2-2.6-0.8-3.5-1.3 c-1.7-2.1-2.1-2.4-3.8-3.1l3.5-0.4c0.9,0.3,1.8,0.5,2.7,0.4c0.5-0.1,1-0.2,1.6-0.2c1.9,0.6,3.8,1.3,5.6,2.2L28,72.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs110 || (_defs110 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_306_",
    d: "M16.9,59.8c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3 C18.2,59.2,17.6,59.8,16.9,59.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_307_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_306_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_308_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.345,
    y1: 35.5967,
    x2: 17.2326,
    y2: 70.6957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6,
    y: 57.3,
    className: "st139",
    width: 2.6,
    height: 2.6
  }))), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16.9,59.8c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3C18.2,59.2,17.6,59.8,16.9,59.8 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs111 || (_defs111 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_309_",
    d: "M19.2,59.5c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4 C20.6,58.9,20,59.5,19.2,59.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_310_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_309_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_311_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.719,
    y1: 38.8013,
    x2: 19.5239,
    y2: 71.1396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8,
    y: 56.6,
    className: "st140",
    width: 2.9,
    height: 2.9
  }))), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M19.2,59.5c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4C20.6,58.9,20,59.5,19.2,59.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs112 || (_defs112 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_312_",
    d: "M17,58.1c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4 C18.4,57.5,17.7,58.1,17,58.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_313_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_312_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_314_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.4107,
    y1: 33.9566,
    x2: 17.2908,
    y2: 68.9202
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6,
    y: 55.4,
    className: "st141",
    width: 2.8,
    height: 2.8
  }))), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17,58.1c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4C18.4,57.5,17.7,58.1,17,58.1z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.3,12.2c0.6,0.6,0.5,1,0.7,1.8c0.1,0.6,1.1,1.7,1.1,2.1"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 15.2,
    y1: 15.5,
    x2: 13.7,
    y2: 19.3
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M13.7,19.3c-0.3,0.9-0.8,2.1-0.8,3.1"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.4,14.4c0.5,2.8,0.9,5.5,2.2,8"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6,18.4c0.8,3.3,0.7,6.8,2.3,9.5c0.6,1.1,0.8,3.4,1.7,4.3"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.2,18.9c-1.1,2-2.2,4.6-3,6.9c-0.2,0.6,0,1.7-0.2,2.4c-0.9,2-1.5,3.3-1.5,5.5"
  })), /*#__PURE__*/React.createElement("g", null, _defs113 || (_defs113 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_315_",
    d: "M4.3,29.5c0.1,0.5,0.2,0.6,0.6,0.8c0,0.8,1.3,1.3,1.3,1.9c0.1,0,0.3,0.2,0.3,0.2v0.1v0.1 C6.8,33,7,33.9,7,34.5c0.5,0.5,0.7,1.5,1.3,2c0,2,1.3,4.2,1.8,5.9v0.2L4.3,29.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_316_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_315_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_317_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.5564,
    y1: -134.2421,
    x2: 10.6603,
    y2: 97.3841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 4.3,
    y: 29.5,
    className: "st142",
    width: 5.8,
    height: 13.2
  }))), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M4.3,29.5c0.1,0.5,0.2,0.6,0.6,0.8c0,0.8,1.3,1.3,1.3,1.9c0.1,0,0.3,0.2,0.3,0.2v0.1v0.1C6.8,33,7,33.9,7,34.5 c0.5,0.5,0.7,1.5,1.3,2c0,2,1.3,4.2,1.8,5.9v0.2L4.3,29.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs114 || (_defs114 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_318_",
    d: "M17.7,29.5c-0.8,3.4-3.3,6.4-4.3,9.7c0,0.1-0.3,0.6-0.3,0.7c-0.2,0.7-0.3,1.5-0.5,2.2l-0.7,3.4L17.7,29.5 z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_319_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_318_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_320_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.7262,
    y1: -166.5729,
    x2: 19.7651,
    y2: 109.7356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9,
    y: 29.5,
    className: "st143",
    width: 5.8,
    height: 15.9
  }))), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.7,29.5c-0.8,3.4-3.3,6.4-4.3,9.7c0,0.1-0.3,0.6-0.3,0.7c-0.2,0.7-0.3,1.5-0.5,2.2l-0.7,3.4L17.7,29.5z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M3.2,42.4c1.5,1.9,1.9,2.4,4.4,3.3c0,3.3,2.4,5,3.6,7.6"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.1,40.7c-1.1,2.7-2.7,5.7-1.9,9c0.3,1.5,0.6,3.6,1.3,5c0,0.1,0.2,0.5,0.2,0.6"
  })), /*#__PURE__*/React.createElement("g", null, _defs115 || (_defs115 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_321_",
    d: "M11.3,53.4c1,2.3,2.5,5,4.5,6.3c0.4,0.2,0.7,0.9,1.8,1.1c1.8,0.4,1.2,1.6,1.4,2.1v0.6L11.3,53.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_322_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_321_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_323_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.1143,
    y1: -71.1424,
    x2: 16.8839,
    y2: 104.4503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: 53.4,
    className: "st144",
    width: 8.1,
    height: 10.1
  }))), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M11.3,53.4c1,2.3,2.5,5,4.5,6.3c0.4,0.2,0.7,0.9,1.8,1.1c1.8,0.4,1.2,1.6,1.4,2.1v0.6L11.3,53.4z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.9,56.9c1.9,1.4,4.4,1.1,5.2,3.4c0.8,2.2,4.1,2.2,5.8,3.3c0,0.3,0.1,0.8,0.1,1.1"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M19.4,48.2c1.3,1.8,0.6,3.9,1.3,5.9c0.3,0.9,0.9,1.9,0.9,3.1c-0.8,0.8-0.3,3.6-0.3,4.8"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "13.8,69.3 16.8,70.5 16.8,70.7 "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16.8,70.7c2.5,1,5.7,0.9,7.8,2.4c0,0.7,2.6,0.8,3.1,0.8"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.3,67c0.2,0.5,0.9,1,0.9,1.6c1.3,1.3,1.7,3.3,3.4,4.4c0,1.3,2.3,2.3,2.7,3.1c0.2,0.6,1,1.4,1.4,1.7"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "38.7,77.8 38.7,77.9 38.7,78 "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.7,78c0.1,0.1,0.3,0.3,0.3,0.5"
  })), /*#__PURE__*/React.createElement("g", null, _defs116 || (_defs116 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_324_",
    d: "M33.3,82.2c1.4,0.3,5-1.3,8.1-0.8C43.8,82.3,46,84,48,86c-1.8-0.3-3.5-0.8-5.3-1.1 c-1.3-0.2-2.6-0.4-3.9-0.4C37.5,83.6,35,82.8,33.3,82.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_325_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_324_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_326_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.1274,
    y1: 36.0249,
    x2: 41.5566,
    y2: 175.7062
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 33.3,
    y: 80.9,
    className: "st145",
    width: 14.7,
    height: 5.1
  }))), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M33.3,82.2c1.4,0.3,5-1.3,8.1-0.8C43.8,82.3,46,84,48,86c-1.8-0.3-3.5-0.8-5.3-1.1c-1.3-0.2-2.6-0.4-3.9-0.4 C37.5,83.6,35,82.8,33.3,82.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs117 || (_defs117 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_327_",
    d: "M39.9,74c2.5,6.1,1.2,6.1,8,11.4c1-0.3,1.6-0.7,2.9-0.2c0.2-1.2,0.3-2.2-0.7-2.9 c-0.9-0.7-1.3-1.6-2.2-2.5c-1.8-1-3.6-1.9-4.6-3.2C42.4,75.5,41.2,75.1,39.9,74"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_328_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_327_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_329_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.6076,
    y1: 73.8199,
    x2: 46.4806,
    y2: 85.6224
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 39.9,
    y: 74,
    className: "st146",
    width: 11.2,
    height: 11.4
  }))), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39.9,74c2.5,6.1,1.2,6.1,8,11.4c1-0.3,1.6-0.7,2.9-0.2c0.2-1.2,0.3-2.2-0.7-2.9c-0.9-0.7-1.3-1.6-2.2-2.5 c-1.8-1-3.6-1.9-4.6-3.2C42.4,75.5,41.2,75.1,39.9,74z"
  })), /*#__PURE__*/React.createElement("g", null, _defs118 || (_defs118 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_330_",
    d: "M24.5,78.6l2-1c1.9-0.3,3.7-0.4,5.7-0.9l2.7,0.2l4.3,2.8l0.9,1.6l-1.5-0.1c-1.5,0.3-3.3,1.3-4.3,0.5 c-1.6-0.5-3.2-0.8-4.7-1.3C27.8,79.8,26.2,79,24.5,78.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_331_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_330_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_332_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.7898,
    y1: 76.4677,
    x2: 32.7978,
    y2: 82.8391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 76.8,
    className: "st147",
    width: 15.6,
    height: 5.7
  }))), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M24.5,78.6l2-1c1.9-0.3,3.7-0.4,5.7-0.9l2.7,0.2l4.3,2.8l0.9,1.6l-1.5-0.1c-1.5,0.3-3.3,1.3-4.3,0.5 c-1.6-0.5-3.2-0.8-4.7-1.3C27.8,79.8,26.2,79,24.5,78.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs119 || (_defs119 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_333_",
    d: "M23.1,80.1c3.6,2.4,7.9,2.9,11.5,1.8c-1.6-0.6-3-1.2-4.7-1.8l-3.3-0.9C25.5,79.5,24.3,80.1,23.1,80.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_334_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_333_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_335_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.5775,
    y1: 33.8411,
    x2: 29.4802,
    y2: 163.2545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1,
    y: 79.2,
    className: "st148",
    width: 11.5,
    height: 3.7
  }))), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.1,80.1c3.6,2.4,7.9,2.9,11.5,1.8c-1.6-0.6-3-1.2-4.7-1.8l-3.3-0.9C25.5,79.5,24.3,80.1,23.1,80.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs120 || (_defs120 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_336_",
    d: "M29.2,77.7c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7c0.9,0,1.7,0.7,1.7,1.7 C30.9,77,30.1,77.7,29.2,77.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_337_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_336_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_338_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.6163,
    y1: 51.9762,
    x2: 30.181,
    y2: 114.0501
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6,
    y: 74.4,
    className: "st149",
    width: 3.3,
    height: 3.3
  }))), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.2,77.7c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7c0.9,0,1.7,0.7,1.7,1.7C30.9,77,30.1,77.7,29.2,77.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs121 || (_defs121 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_339_",
    d: "M32.3,77.3c-1,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7c1,0,1.7,0.8,1.7,1.7C34.1,76.5,33.3,77.3,32.3,77.3 "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_340_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_339_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_341_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.7909,
    y1: 54.5289,
    x2: 33.3556,
    y2: 116.7382
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 30.6,
    y: 73.8,
    className: "st150",
    width: 3.5,
    height: 3.5
  }))), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M32.3,77.3c-1,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7c1,0,1.7,0.8,1.7,1.7C34.1,76.5,33.3,77.3,32.3,77.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs122 || (_defs122 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_342_",
    d: "M29.4,75.5c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7s1.7,0.7,1.7,1.7C31.1,74.7,30.3,75.5,29.4,75.5 "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_343_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_342_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_344_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.9145,
    y1: 53.2099,
    x2: 30.291,
    y2: 108.8071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8,
    y: 72.2,
    className: "st151",
    width: 3.3,
    height: 3.3
  }))), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.4,75.5c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7s1.7,0.7,1.7,1.7C31.1,74.7,30.3,75.5,29.4,75.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs123 || (_defs123 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_345_",
    d: "M39.8,81.6c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1C40.8,81.1,40.4,81.6,39.8,81.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_346_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_345_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_347_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.3541,
    y1: 62.9181,
    x2: 41.1068,
    y2: 133.4395
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 79.6,
    className: "st152",
    width: 2,
    height: 2
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 39.8,
    cy: 80.6,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, _defs124 || (_defs124 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_348_",
    d: "M41.6,81.4c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1C42.8,80.8,42.2,81.4,41.6,81.4 "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_349_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_348_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_350_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.215,
    y1: 64.3017,
    x2: 42.9902,
    y2: 134.9735
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 79.1,
    className: "st153",
    width: 2.3,
    height: 2.3
  }))), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.6,81.4c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1C42.8,80.8,42.2,81.4,41.6,81.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs125 || (_defs125 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_351_",
    d: "M39.8,80.2c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1 C40.9,79.7,40.4,80.2,39.8,80.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_352_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_351_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_353_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.42,
    y1: 62.4072,
    x2: 41.1426,
    y2: 131.0255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7,
    y: 78,
    className: "st154",
    width: 2.2,
    height: 2.2
  }))), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39.8,80.2c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1C40.9,79.7,40.4,80.2,39.8,80.2 z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M25,78.6c2.3,0.2,6.5-1,8.3,0.8c2,0,3.8,1,5.6,1"
  })), /*#__PURE__*/React.createElement("g", null, _defs126 || (_defs126 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_354_",
    d: "M34.3,82.1c1.8,0,4.8-0.3,6.5,0.2c0,0.6,1.1,1,1.5,1.1c1.1,0.5,2.4,1.6,3.9,1.6l0.7,1.1L34.3,82.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_355_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_354_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_356_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.1614,
    y1: 81.5755,
    x2: 40.9362,
    y2: 86.4574
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#ECDA93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#50704C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#374E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#709F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0C383"
    }
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 34.3,
    y: 81.8,
    className: "st155",
    width: 12.5,
    height: 4.4
  }))), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M34.3,82.1c1.8,0,4.8-0.3,6.5,0.2c0,0.6,1.1,1,1.5,1.1c1.1,0.5,2.4,1.6,3.9,1.6l0.7,1.1L34.3,82.1z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M40.4,74.5c0.5,0.5,1.8,1,2,1.4c0.6,1,2,3.8,2,4.8c1.6,0,5.2,1.9,5.2,3.8c0.3,0.2,0.5,0.5,0.6,0.7"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.6,80c2.2,0.9,5,0.7,7.4,0.7"
  })), /*#__PURE__*/React.createElement("g", null, _defs127 || (_defs127 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_357_",
    d: "M41.6,81.5c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1 C42.8,81,42.3,81.5,41.6,81.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_358_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_357_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_359_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.8031,
    y1: 80.8871,
    x2: 40.4937,
    y2: 79.8114
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 79.2,
    className: "st156",
    width: 2.3,
    height: 2.3
  }))), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.6,81.5c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1C42.8,81,42.3,81.5,41.6,81.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs128 || (_defs128 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_360_",
    x: 41,
    y: 79.6,
    width: 0.6,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_361_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_360_",
    style: {
      overflow: "visible"
    }
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M41,79.9c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2C41.2,79.6,41,79.8,41,79.9z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M41,79.9c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2C41.2,79.6,41,79.8,41,79.9z"
  })))), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M41.2,79.9c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2C41.2,79.7,41.2,79.8,41.2,79.9z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.2,79.9c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2C41.2,79.7,41.2,79.8,41.2,79.9z "
  })), /*#__PURE__*/React.createElement("g", null, _defs129 || (_defs129 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_362_",
    d: "M39.7,80.2c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1 C40.9,79.7,40.3,80.2,39.7,80.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_363_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_362_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_364_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.8881,
    y1: 79.58,
    x2: 38.5561,
    y2: 78.4968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6,
    y: 77.9,
    className: "st159",
    width: 2.3,
    height: 2.3
  }))), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39.7,80.2c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1C40.9,79.7,40.3,80.2,39.7,80.2 z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs130 || (_defs130 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_365_",
    x: 39.1,
    y: 78.3,
    width: 0.6,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_366_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_365_",
    style: {
      overflow: "visible"
    }
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M39.1,78.6c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2 C39.2,78.3,39.1,78.4,39.1,78.6z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M39.1,78.6c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2 C39.2,78.3,39.1,78.4,39.1,78.6z"
  })))), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M39.2,78.6c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2C39.3,78.4,39.2,78.5,39.2,78.6z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.2,78.6c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2C39.3,78.4,39.2,78.5,39.2,78.6z "
  })), /*#__PURE__*/React.createElement("g", null, _defs131 || (_defs131 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_367_",
    d: "M32.5,77.3c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8C34.3,76.5,33.5,77.3,32.5,77.3 "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_368_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_367_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_369_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.2849,
    y1: 76.38,
    x2: 30.6968,
    y2: 74.71
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7,
    y: 73.8,
    className: "st162",
    width: 3.5,
    height: 3.5
  }))), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M32.5,77.3c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8C34.3,76.5,33.5,77.3,32.5,77.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs132 || (_defs132 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_370_",
    x: 31.5,
    y: 74.5,
    width: 1,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_371_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_370_",
    style: {
      overflow: "visible"
    }
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M31.5,74.8c0,0.2,0.2,0.4,0.5,0.4c0.3,0,0.5-0.2,0.5-0.4c0-0.2-0.2-0.4-0.5-0.4 C31.8,74.5,31.5,74.6,31.5,74.8z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M31.5,74.8c0,0.2,0.2,0.4,0.5,0.4c0.3,0,0.5-0.2,0.5-0.4c0-0.2-0.2-0.4-0.5-0.4 C31.8,74.5,31.5,74.6,31.5,74.8z"
  })))), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M31.7,74.8c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2C31.9,74.6,31.7,74.7,31.7,74.8z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.7,74.8c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2C31.9,74.6,31.7,74.7,31.7,74.8z "
  })), /*#__PURE__*/React.createElement("g", null, _defs133 || (_defs133 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_372_",
    d: "M29.1,77.4c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8C30.9,76.6,30.1,77.4,29.1,77.4 "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_373_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_372_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_374_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.9377,
    y1: 76.4321,
    x2: 27.3496,
    y2: 74.7547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 27.4,
    y: 73.8,
    className: "st165",
    width: 3.5,
    height: 3.5
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 29.1,
    cy: 75.6,
    r: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs134 || (_defs134 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_375_",
    x: 28.2,
    y: 74.5,
    width: 1,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_376_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_375_",
    style: {
      overflow: "visible"
    }
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M28.2,74.9c0,0.2,0.2,0.4,0.5,0.4c0.3,0,0.5-0.2,0.5-0.4c0-0.2-0.2-0.4-0.5-0.4 C28.4,74.5,28.2,74.7,28.2,74.9z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M28.2,74.9c0,0.2,0.2,0.4,0.5,0.4c0.3,0,0.5-0.2,0.5-0.4c0-0.2-0.2-0.4-0.5-0.4 C28.4,74.5,28.2,74.7,28.2,74.9z"
  })))), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M28.4,74.9c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2C28.5,74.6,28.4,74.8,28.4,74.9z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.4,74.9c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2C28.5,74.6,28.4,74.8,28.4,74.9z "
  })), /*#__PURE__*/React.createElement("g", null, _defs135 || (_defs135 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_377_",
    d: "M29.3,75.5c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8C31.1,74.7,30.3,75.5,29.3,75.5 "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_378_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_377_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_379_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.0883,
    y1: 74.589,
    x2: 27.4926,
    y2: 72.9115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 72,
    className: "st168",
    width: 3.5,
    height: 3.5
  }))), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.3,75.5c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8C31.1,74.7,30.3,75.5,29.3,75.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs136 || (_defs136 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_380_",
    x: 28.3,
    y: 72.7,
    width: 1,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_381_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_380_",
    style: {
      overflow: "visible"
    }
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M28.3,73c0,0.2,0.2,0.4,0.5,0.4c0.3,0,0.5-0.2,0.5-0.4c0-0.2-0.2-0.4-0.5-0.4C28.6,72.7,28.3,72.8,28.3,73z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M28.3,73c0,0.2,0.2,0.4,0.5,0.4c0.3,0,0.5-0.2,0.5-0.4c0-0.2-0.2-0.4-0.5-0.4C28.6,72.7,28.3,72.8,28.3,73z "
  })))), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M28.5,73c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2C28.7,72.8,28.5,72.9,28.5,73z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.5,73c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2C28.7,72.8,28.5,72.9,28.5,73z"
  })), /*#__PURE__*/React.createElement("g", null, _defs137 || (_defs137 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_382_",
    d: "M23.3,66.5c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7 C25,65.7,24.2,66.5,23.3,66.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_383_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_382_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_384_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.9897,
    y1: 65.5655,
    x2: 21.5746,
    y2: 63.9708
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 63.1,
    className: "st171",
    width: 3.4,
    height: 3.4
  }))), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.3,66.5c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7C25,65.7,24.2,66.5,23.3,66.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs138 || (_defs138 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_385_",
    x: 22.4,
    y: 63.7,
    width: 0.9,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_386_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_385_",
    style: {
      overflow: "visible"
    }
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "st172",
    d: "M22.4,64.1c0,0.2,0.2,0.4,0.5,0.4c0.3,0,0.5-0.2,0.5-0.4c0-0.2-0.2-0.4-0.5-0.4 C22.6,63.7,22.4,63.9,22.4,64.1z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "st173",
    d: "M22.4,64.1c0,0.2,0.2,0.4,0.5,0.4c0.3,0,0.5-0.2,0.5-0.4c0-0.2-0.2-0.4-0.5-0.4 C22.6,63.7,22.4,63.9,22.4,64.1z"
  })))), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M22.6,64.1c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2C22.7,63.9,22.6,64,22.6,64.1z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.6,64.1c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2C22.7,63.9,22.6,64,22.6,64.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs139 || (_defs139 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_387_",
    d: "M20.1,66.5c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7 C21.8,65.7,21,66.5,20.1,66.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_388_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_387_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_389_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.8067,
    y1: 65.613,
    x2: 18.384,
    y2: 64.0183
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4,
    y: 63.1,
    className: "st174",
    width: 3.4,
    height: 3.4
  }))), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20.1,66.5c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7C21.8,65.7,21,66.5,20.1,66.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs140 || (_defs140 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_390_",
    x: 19.2,
    y: 63.8,
    width: 0.9,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_391_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_390_",
    style: {
      overflow: "visible"
    }
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M19.2,64.1c0,0.2,0.2,0.4,0.5,0.4c0.3,0,0.5-0.2,0.5-0.4c0-0.2-0.2-0.4-0.5-0.4 C19.4,63.8,19.2,63.9,19.2,64.1z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M19.2,64.1c0,0.2,0.2,0.4,0.5,0.4c0.3,0,0.5-0.2,0.5-0.4c0-0.2-0.2-0.4-0.5-0.4 C19.4,63.8,19.2,63.9,19.2,64.1z"
  })))), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M19.4,64.1c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2C19.5,63.9,19.4,64,19.4,64.1z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.4,64.1c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2C19.5,63.9,19.4,64,19.4,64.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs141 || (_defs141 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_392_",
    d: "M20.2,64.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7 C21.9,64,21.2,64.7,20.2,64.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_393_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_392_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_394_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.9411,
    y1: 63.8549,
    x2: 18.5184,
    y2: 62.2602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 61.4,
    className: "st177",
    width: 3.4,
    height: 3.4
  }))), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20.2,64.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7C21.9,64,21.2,64.7,20.2,64.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs142 || (_defs142 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_395_",
    x: 19.3,
    y: 62,
    width: 0.9,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_396_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_395_",
    style: {
      overflow: "visible"
    }
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M19.3,62.4c0,0.2,0.2,0.4,0.5,0.4c0.3,0,0.5-0.2,0.5-0.4c0-0.2-0.2-0.4-0.5-0.4 C19.5,62,19.3,62.2,19.3,62.4z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M19.3,62.4c0,0.2,0.2,0.4,0.5,0.4c0.3,0,0.5-0.2,0.5-0.4c0-0.2-0.2-0.4-0.5-0.4 C19.5,62,19.3,62.2,19.3,62.4z"
  })))), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M19.5,62.4c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2C19.6,62.2,19.5,62.3,19.5,62.4z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.5,62.4c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.3-0.2C19.6,62.2,19.5,62.3,19.5,62.4z "
  })), /*#__PURE__*/React.createElement("g", null, _defs143 || (_defs143 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_397_",
    d: "M19.4,59.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4 C20.8,58.8,20.2,59.4,19.4,59.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_398_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_397_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_399_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.8513,
    y1: 58.6774,
    x2: 18.0154,
    y2: 57.361
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 56.6,
    className: "st180",
    width: 2.8,
    height: 2.8
  }))), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M19.4,59.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4C20.8,58.8,20.2,59.4,19.4,59.4 z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs144 || (_defs144 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_400_",
    x: 18.7,
    y: 57.2,
    width: 0.8,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_401_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_400_",
    style: {
      overflow: "visible"
    }
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "st181",
    d: "M18.7,57.5c0,0.2,0.2,0.3,0.4,0.3c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.2-0.3-0.4-0.3 C18.9,57.2,18.7,57.3,18.7,57.5z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "st182",
    d: "M18.7,57.5c0,0.2,0.2,0.3,0.4,0.3c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.2-0.3-0.4-0.3 C18.9,57.2,18.7,57.3,18.7,57.5z"
  })))), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M18.8,57.5c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2s-0.1-0.2-0.2-0.2C18.9,57.3,18.8,57.4,18.8,57.5z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.8,57.5c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2s-0.1-0.2-0.2-0.2C18.9,57.3,18.8,57.4,18.8,57.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs145 || (_defs145 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_402_",
    d: "M16.8,59.5c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4 C18.2,58.8,17.6,59.5,16.8,59.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_403_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_402_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_404_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.2106,
    y1: 58.7159,
    x2: 15.3747,
    y2: 57.3995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 15.4,
    y: 56.7,
    className: "st183",
    width: 2.8,
    height: 2.8
  }))), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16.8,59.5c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4C18.2,58.8,17.6,59.5,16.8,59.5 z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs146 || (_defs146 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_405_",
    x: 16,
    y: 57.2,
    width: 0.8,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_406_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_405_",
    style: {
      overflow: "visible"
    }
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "st184",
    d: "M16,57.5c0,0.2,0.2,0.3,0.4,0.3c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.2-0.3-0.4-0.3C16.2,57.2,16,57.3,16,57.5z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "st185",
    d: "M16,57.5c0,0.2,0.2,0.3,0.4,0.3c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.2-0.3-0.4-0.3C16.2,57.2,16,57.3,16,57.5z"
  })))), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M16.2,57.5c0,0.1,0.1,0.2,0.2,0.2s0.2-0.1,0.2-0.2s-0.1-0.2-0.2-0.2S16.2,57.4,16.2,57.5z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.2,57.5c0,0.1,0.1,0.2,0.2,0.2s0.2-0.1,0.2-0.2s-0.1-0.2-0.2-0.2S16.2,57.4,16.2,57.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs147 || (_defs147 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_407_",
    d: "M16.9,58c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4C18.3,57.4,17.7,58,16.9,58 "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_408_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_407_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_409_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.324,
    y1: 57.263,
    x2: 15.4956,
    y2: 55.9466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 55.2,
    className: "st186",
    width: 2.8,
    height: 2.8
  }))), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16.9,58c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4C18.3,57.4,17.7,58,16.9,58z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs148 || (_defs148 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_410_",
    x: 16.2,
    y: 55.7,
    width: 0.8,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_411_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_410_",
    style: {
      overflow: "visible"
    }
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "st187",
    d: "M16.2,56c0,0.2,0.2,0.3,0.4,0.3c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.2-0.3-0.4-0.3C16.3,55.7,16.2,55.9,16.2,56z "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M16.2,56c0,0.2,0.2,0.3,0.4,0.3c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.2-0.3-0.4-0.3C16.3,55.7,16.2,55.9,16.2,56z "
  })))), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M16.3,56c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2C16.4,55.9,16.3,55.9,16.3,56z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.3,56c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2C16.4,55.9,16.3,55.9,16.3,56z"
  })), /*#__PURE__*/React.createElement("g", null, _defs149 || (_defs149 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_412_",
    d: "M11.5,49.1c-0.6-0.5-0.7-1.4-0.2-2c0.5-0.6,1.4-0.7,2-0.2c0.6,0.5,0.7,1.4,0.2,2 C12.9,49.4,12.1,49.5,11.5,49.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_413_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_412_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_414_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.2877,
    y1: 49.8484,
    x2: 11.3545,
    y2: 46.0948
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7,
    y: 46.4,
    className: "st189",
    width: 3.2,
    height: 3.2
  }))), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M11.5,49.1c-0.6-0.5-0.7-1.4-0.2-2c0.5-0.6,1.4-0.7,2-0.2c0.6,0.5,0.7,1.4,0.2,2C12.9,49.4,12.1,49.5,11.5,49.1 z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs150 || (_defs150 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_415_",
    x: 12,
    y: 47,
    width: 0.7,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_416_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_415_",
    style: {
      overflow: "visible"
    }
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M12.1,47.1c-0.1,0.1-0.1,0.3,0.1,0.5c0.2,0.1,0.4,0.1,0.5,0c0.1-0.1,0.1-0.3-0.1-0.5 C12.4,46.9,12.2,46.9,12.1,47.1z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M12.1,47.1c-0.1,0.1-0.1,0.3,0.1,0.5c0.2,0.1,0.4,0.1,0.5,0c0.1-0.1,0.1-0.3-0.1-0.5 C12.4,46.9,12.2,46.9,12.1,47.1z"
  })))), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M12.2,47.1c-0.1,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0c0.1-0.1,0-0.2-0.1-0.3C12.4,47.1,12.2,47.1,12.2,47.1 z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.2,47.1c-0.1,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0c0.1-0.1,0-0.2-0.1-0.3C12.4,47.1,12.2,47.1,12.2,47.1 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs151 || (_defs151 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_417_",
    d: "M9.3,47.5c-0.6-0.5-0.7-1.4-0.2-2c0.5-0.6,1.4-0.7,2-0.2c0.6,0.5,0.7,1.4,0.2,2 C10.8,47.8,10,47.9,9.3,47.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_418_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_417_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_419_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.1695,
    y1: 48.2448,
    x2: 9.2362,
    y2: 44.4912
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 8.6,
    y: 44.8,
    className: "st192",
    width: 3.2,
    height: 3.2
  }))), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.3,47.5c-0.6-0.5-0.7-1.4-0.2-2c0.5-0.6,1.4-0.7,2-0.2c0.6,0.5,0.7,1.4,0.2,2C10.8,47.8,10,47.9,9.3,47.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs152 || (_defs152 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_420_",
    x: 9.9,
    y: 45.4,
    width: 0.7,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_421_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_420_",
    style: {
      overflow: "visible"
    }
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M10,45.5c-0.1,0.1-0.1,0.3,0.1,0.5c0.2,0.1,0.4,0.1,0.5,0c0.1-0.1,0.1-0.3-0.1-0.5 C10.3,45.3,10.1,45.3,10,45.5z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "st194",
    d: "M10,45.5c-0.1,0.1-0.1,0.3,0.1,0.5c0.2,0.1,0.4,0.1,0.5,0c0.1-0.1,0.1-0.3-0.1-0.5 C10.3,45.3,10.1,45.3,10,45.5z"
  })))), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10.1,45.6c-0.1,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0c0.1-0.1,0-0.2-0.1-0.3C10.3,45.5,10.1,45.5,10.1,45.6 z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.1,45.6c-0.1,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0c0.1-0.1,0-0.2-0.1-0.3C10.3,45.5,10.1,45.5,10.1,45.6 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs153 || (_defs153 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_422_",
    d: "M10.3,46.4c-0.6-0.5-0.7-1.4-0.2-2c0.5-0.6,1.4-0.7,2-0.2c0.6,0.5,0.7,1.4,0.2,2 C11.8,46.7,10.9,46.9,10.3,46.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_423_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_422_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_424_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.1334,
    y1: 47.1382,
    x2: 10.2077,
    y2: 43.3846
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 43.7,
    className: "st195",
    width: 3.2,
    height: 3.2
  }))), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.3,46.4c-0.6-0.5-0.7-1.4-0.2-2c0.5-0.6,1.4-0.7,2-0.2c0.6,0.5,0.7,1.4,0.2,2C11.8,46.7,10.9,46.9,10.3,46.4 z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs154 || (_defs154 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_425_",
    x: 10.9,
    y: 44.3,
    width: 0.7,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_426_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_425_",
    style: {
      overflow: "visible"
    }
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "st196",
    d: "M10.9,44.4c-0.1,0.1-0.1,0.3,0.1,0.5c0.2,0.1,0.4,0.1,0.5,0c0.1-0.1,0.1-0.3-0.1-0.5 C11.3,44.2,11,44.3,10.9,44.4z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "st197",
    d: "M10.9,44.4c-0.1,0.1-0.1,0.3,0.1,0.5c0.2,0.1,0.4,0.1,0.5,0c0.1-0.1,0.1-0.3-0.1-0.5 C11.3,44.2,11,44.3,10.9,44.4z"
  })))), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M11,44.5c-0.1,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0c0.1-0.1,0-0.2-0.1-0.3C11.2,44.4,11.1,44.4,11,44.5z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11,44.5c-0.1,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0c0.1-0.1,0-0.2-0.1-0.3C11.2,44.4,11.1,44.4,11,44.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs155 || (_defs155 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_427_",
    d: "M11,36.3c-0.5-0.4-0.6-1.2-0.2-1.7c0.4-0.5,1.2-0.6,1.7-0.2c0.5,0.4,0.6,1.2,0.2,1.7 C12.3,36.6,11.5,36.7,11,36.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_428_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_427_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_429_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.613,
    y1: 36.9693,
    x2: 10.8979,
    y2: 33.6895
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 33.9,
    className: "st198",
    width: 2.8,
    height: 2.8
  }))), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M11,36.3c-0.5-0.4-0.6-1.2-0.2-1.7c0.4-0.5,1.2-0.6,1.7-0.2c0.5,0.4,0.6,1.2,0.2,1.7 C12.3,36.6,11.5,36.7,11,36.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs156 || (_defs156 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_430_",
    x: 11.5,
    y: 34.4,
    width: 0.6,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_431_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_430_",
    style: {
      overflow: "visible"
    }
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M11.5,34.5c-0.1,0.1,0,0.3,0.1,0.4c0.1,0.1,0.3,0.1,0.4,0c0.1-0.1,0-0.3-0.1-0.4 C11.8,34.4,11.6,34.4,11.5,34.5z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "st200",
    d: "M11.5,34.5c-0.1,0.1,0,0.3,0.1,0.4c0.1,0.1,0.3,0.1,0.4,0c0.1-0.1,0-0.3-0.1-0.4 C11.8,34.4,11.6,34.4,11.5,34.5z"
  })))), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M11.6,34.6c-0.1,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0c0.1-0.1,0-0.2-0.1-0.3C11.8,34.5,11.7,34.5,11.6,34.6 z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.6,34.6c-0.1,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0c0.1-0.1,0-0.2-0.1-0.3C11.8,34.5,11.7,34.5,11.6,34.6 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs157 || (_defs157 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_432_",
    d: "M9.1,34.9c-0.5-0.4-0.6-1.2-0.2-1.7c0.4-0.5,1.2-0.6,1.7-0.2c0.5,0.4,0.6,1.2,0.2,1.7 C10.5,35.2,9.7,35.3,9.1,34.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_433_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_432_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_434_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.7492,
    y1: 35.5794,
    x2: 9.0642,
    y2: 32.2997
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 32.5,
    className: "st201",
    width: 2.8,
    height: 2.8
  }))), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.1,34.9c-0.5-0.4-0.6-1.2-0.2-1.7c0.4-0.5,1.2-0.6,1.7-0.2c0.5,0.4,0.6,1.2,0.2,1.7 C10.5,35.2,9.7,35.3,9.1,34.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs158 || (_defs158 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_435_",
    x: 9.6,
    y: 33,
    width: 0.6,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_436_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_435_",
    style: {
      overflow: "visible"
    }
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "st202",
    d: "M9.7,33.1c-0.1,0.1,0,0.3,0.1,0.4c0.1,0.1,0.3,0.1,0.4,0c0.1-0.1,0-0.3-0.1-0.4C10,33,9.8,33,9.7,33.1z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "st203",
    d: "M9.7,33.1c-0.1,0.1,0,0.3,0.1,0.4c0.1,0.1,0.3,0.1,0.4,0c0.1-0.1,0-0.3-0.1-0.4C10,33,9.8,33,9.7,33.1z"
  })))), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M9.8,33.2c-0.1,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0c0.1-0.1,0-0.2-0.1-0.3C10,33.1,9.8,33.1,9.8,33.2z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.8,33.2c-0.1,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0c0.1-0.1,0-0.2-0.1-0.3C10,33.1,9.8,33.1,9.8,33.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs159 || (_defs159 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_437_",
    d: "M10,33.9c-0.5-0.4-0.6-1.2-0.2-1.7c0.4-0.5,1.2-0.6,1.7-0.2c0.5,0.4,0.6,1.2,0.2,1.7 C11.3,34.3,10.5,34.4,10,33.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_438_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_437_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_439_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.601,
    y1: 34.6205,
    x2: 9.916,
    y2: 31.3333
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 9.4,
    y: 31.6,
    className: "st204",
    width: 2.8,
    height: 2.8
  }))), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10,33.9c-0.5-0.4-0.6-1.2-0.2-1.7c0.4-0.5,1.2-0.6,1.7-0.2c0.5,0.4,0.6,1.2,0.2,1.7 C11.3,34.3,10.5,34.4,10,33.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs160 || (_defs160 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_440_",
    x: 10.5,
    y: 32.1,
    width: 0.6,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_441_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_440_",
    style: {
      overflow: "visible"
    }
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "st205",
    d: "M10.5,32.2c-0.1,0.1,0,0.3,0.1,0.4c0.1,0.1,0.3,0.1,0.4,0c0.1-0.1,0-0.3-0.1-0.4 C10.8,32.1,10.6,32.1,10.5,32.2z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "st206",
    d: "M10.5,32.2c-0.1,0.1,0,0.3,0.1,0.4c0.1,0.1,0.3,0.1,0.4,0c0.1-0.1,0-0.3-0.1-0.4 C10.8,32.1,10.6,32.1,10.5,32.2z"
  })))), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10.6,32.3c-0.1,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0c0.1-0.1,0-0.2-0.1-0.3C10.8,32.2,10.7,32.2,10.6,32.3 z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.6,32.3c-0.1,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0c0.1-0.1,0-0.2-0.1-0.3C10.8,32.2,10.7,32.2,10.6,32.3 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs161 || (_defs161 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_442_",
    d: "M9.6,25.4c-0.1-0.7,0.4-1.3,1-1.4c0.7-0.1,1.3,0.4,1.4,1c0.1,0.7-0.4,1.3-1,1.4 C10.3,26.5,9.7,26,9.6,25.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_443_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_442_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_444_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.4261,
    y1: 26.5728,
    x2: 11.2159,
    y2: 23.782
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 23.9,
    className: "st207",
    width: 2.6,
    height: 2.6
  }))), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.6,25.4c-0.1-0.7,0.4-1.3,1-1.4c0.7-0.1,1.3,0.4,1.4,1c0.1,0.7-0.4,1.3-1,1.4C10.3,26.5,9.7,26,9.6,25.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs162 || (_defs162 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_445_",
    x: 11,
    y: 24.5,
    width: 0.5,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_446_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_445_",
    style: {
      overflow: "visible"
    }
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M11.2,24.5c-0.1,0-0.2,0.2-0.2,0.4c0,0.2,0.2,0.3,0.3,0.3c0.1,0,0.2-0.2,0.2-0.4 C11.5,24.6,11.4,24.4,11.2,24.5z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M11.2,24.5c-0.1,0-0.2,0.2-0.2,0.4c0,0.2,0.2,0.3,0.3,0.3c0.1,0,0.2-0.2,0.2-0.4 C11.5,24.6,11.4,24.4,11.2,24.5z"
  })))), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M11.2,24.6c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.1,0.1-0.2C11.4,24.6,11.3,24.6,11.2,24.6 z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.2,24.6c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.1,0.1-0.2C11.4,24.6,11.3,24.6,11.2,24.6 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs163 || (_defs163 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_447_",
    d: "M9.2,23.1c-0.1-0.7,0.4-1.3,1-1.4c0.7-0.1,1.3,0.4,1.4,1c0.1,0.7-0.4,1.3-1,1.4 C10,24.2,9.3,23.7,9.2,23.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_448_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_447_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_449_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.0632,
    y1: 24.2726,
    x2: 10.838,
    y2: 21.527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 21.6,
    className: "st210",
    width: 2.6,
    height: 2.6
  }))), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.2,23.1c-0.1-0.7,0.4-1.3,1-1.4c0.7-0.1,1.3,0.4,1.4,1c0.1,0.7-0.4,1.3-1,1.4C10,24.2,9.3,23.7,9.2,23.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs164 || (_defs164 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_450_",
    x: 10.6,
    y: 22.2,
    width: 0.5,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_451_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_450_",
    style: {
      overflow: "visible"
    }
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M10.8,22.2c-0.1,0-0.2,0.2-0.2,0.4c0,0.2,0.2,0.3,0.3,0.3c0.1,0,0.2-0.2,0.2-0.4 C11.1,22.3,11,22.1,10.8,22.2z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M10.8,22.2c-0.1,0-0.2,0.2-0.2,0.4c0,0.2,0.2,0.3,0.3,0.3c0.1,0,0.2-0.2,0.2-0.4 C11.1,22.3,11,22.1,10.8,22.2z"
  })))), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10.9,22.3c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.1,0.1-0.2C11,22.4,10.9,22.3,10.9,22.3z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.9,22.3c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.1,0.1-0.2C11,22.4,10.9,22.3,10.9,22.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs165 || (_defs165 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_452_",
    d: "M10.5,23c-0.1-0.7,0.4-1.3,1-1.4c0.7-0.1,1.3,0.4,1.4,1c0.1,0.7-0.4,1.3-1,1.4 C11.2,24.1,10.6,23.6,10.5,23"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_453_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_452_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_454_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.3362,
    y1: 24.1678,
    x2: 12.126,
    y2: 21.4222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 21.5,
    className: "st213",
    width: 2.6,
    height: 2.6
  }))), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.5,23c-0.1-0.7,0.4-1.3,1-1.4c0.7-0.1,1.3,0.4,1.4,1c0.1,0.7-0.4,1.3-1,1.4C11.2,24.1,10.6,23.6,10.5,23z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs166 || (_defs166 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_455_",
    x: 11.9,
    y: 22.1,
    width: 0.5,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_456_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_455_",
    style: {
      overflow: "visible"
    }
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "st214",
    d: "M12.1,22.1c-0.1,0-0.2,0.2-0.2,0.4c0,0.2,0.2,0.3,0.3,0.3c0.1,0,0.2-0.2,0.2-0.4 C12.4,22.2,12.3,22.1,12.1,22.1z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "st215",
    d: "M12.1,22.1c-0.1,0-0.2,0.2-0.2,0.4c0,0.2,0.2,0.3,0.3,0.3c0.1,0,0.2-0.2,0.2-0.4 C12.4,22.2,12.3,22.1,12.1,22.1z"
  })))), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M12.1,22.2c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.1,0.1-0.2C12.3,22.3,12.2,22.2,12.1,22.2 z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.1,22.2c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.1,0.1-0.2C12.3,22.3,12.2,22.2,12.1,22.2 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs167 || (_defs167 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_457_",
    d: "M10.8,17c-0.1-0.7,0.4-1.3,1-1.4c0.7-0.1,1.3,0.4,1.4,1c0.1,0.7-0.4,1.3-1,1.4 C11.5,18.1,10.9,17.6,10.8,17"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_458_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_457_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_459_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.646,
    y1: 18.1439,
    x2: 12.4283,
    y2: 15.4058
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#223419"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#709F76"
    }
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7,
    y: 15.5,
    className: "st216",
    width: 2.6,
    height: 2.6
  }))), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.8,17c-0.1-0.7,0.4-1.3,1-1.4c0.7-0.1,1.3,0.4,1.4,1c0.1,0.7-0.4,1.3-1,1.4C11.5,18.1,10.9,17.6,10.8,17z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", null, _defs168 || (_defs168 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_460_",
    x: 12.2,
    y: 16.1,
    width: 0.5,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_461_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_460_",
    style: {
      overflow: "visible"
    }
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "st217",
    d: "M12.4,16.1c-0.1,0-0.2,0.2-0.2,0.4c0,0.2,0.2,0.3,0.3,0.3c0.1,0,0.2-0.2,0.2-0.4 C12.7,16.2,12.6,16,12.4,16.1z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "st218",
    d: "M12.4,16.1c-0.1,0-0.2,0.2-0.2,0.4c0,0.2,0.2,0.3,0.3,0.3c0.1,0,0.2-0.2,0.2-0.4 C12.7,16.2,12.6,16,12.4,16.1z"
  })))), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M12.4,16.2c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.1,0.1-0.2C12.6,16.3,12.5,16.2,12.4,16.2 z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.4,16.2c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.1,0.1-0.2C12.6,16.3,12.5,16.2,12.4,16.2 z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M83.2,88.9c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0.1-0.2,0-0.4-0.1-0.6 c-0.1-0.2-0.3-0.3-0.5-0.3c-0.1,0-0.2,0-0.3,0L83.2,88.9z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.2,88.9c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0.1-0.2,0-0.4-0.1-0.6 c-0.1-0.2-0.3-0.3-0.5-0.3c-0.1,0-0.2,0-0.3,0L83.2,88.9z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "81.7,88.1 81.5,87.3 81.1,88 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "81.7,88.1 81.5,87.3 81.1,88 "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.8,88.4c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.4,0,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.6c0-0.2,0-0.4-0.2-0.6 c-0.1-0.2-0.3-0.2-0.5-0.2c-0.1,0-0.2,0-0.3,0L78.8,88.4z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.8,88.4c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.4,0,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.6c0-0.2,0-0.4-0.2-0.6 c-0.1-0.2-0.3-0.2-0.5-0.2c-0.1,0-0.2,0-0.3,0L78.8,88.4z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M73.7,87.8C73.8,87.8,73.8,87.7,73.7,87.8C73.8,87.7,73.8,87.7,73.7,87.8c0.2,0,0.4-0.1,0.4-0.2 c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.2-0.1-0.3C74.1,87,74,87,73.9,87c-0.1,0-0.1,0-0.2,0L73.7,87.8z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.7,87.8C73.8,87.8,73.8,87.7,73.7,87.8C73.8,87.7,73.8,87.7,73.7,87.8c0.2,0,0.4-0.1,0.4-0.2 c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.2-0.1-0.3C74.1,87,74,87,73.9,87c-0.1,0-0.1,0-0.2,0L73.7,87.8z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "st219",
    d: "M57.9,6.9C48,11,37.6,13.3,25.8,13.2C24.3,26.6,24.4,44,31.3,57c5.5,10.4,15.2,19.9,26.7,26.3 c9.9-7.2,19.5-14.2,25.4-24.2c6.7-11.4,9.4-27,6.6-45.5C79,13.3,69.6,13.1,57.9,6.9z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.9,6.9C48,11,37.6,13.3,25.8,13.2C24.3,26.6,24.4,44,31.3,57c5.5,10.4,15.2,19.9,26.7,26.3 c9.9-7.2,19.5-14.2,25.4-24.2c6.7-11.4,9.4-27,6.6-45.5C79,13.3,69.6,13.1,57.9,6.9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs169 || (_defs169 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_462_",
    d: "M79.5,29.7c1.8-0.7,2.7-4.7,1.6-6.5c-0.6-0.9-0.4-1.3-1.2-1.7c-0.5-0.2-1.3-0.2-2.3-0.1 c0.5-0.3,1.5-0.4,1.3-0.8c-0.3-0.4-0.9-0.4-1.3-0.7c0.4-0.4,1.2,0,1.8,0.1c-0.2-0.5-0.3-1-0.8-1.3c-0.6-0.3-1.1-0.3-1.6,0.1 c-0.6-0.7,0.9-1.2,1.2-1.4c-0.6-0.6-1.5-0.1-2,0.4c0.2-0.4,0-1.1,0.5-1.4c-0.7-0.3-1,0.3-1.5,0.6c-0.7,0.5-0.8-0.6-1.3-0.2 c0,0.1,0.1,0.3,0.1,0.4c0,0.1-0.1,0.4-0.1,0.5c0,0.5,0.2,0.8,0.4,1.2c-0.2-0.6-2.2-0.7-1.9,0.2c0.3,0.6,0.8,0.5,1.3,0.6 c0.3,0.1,0.5,0.4,0.8,0.6C74,20,73.2,20.5,73,20.8c-0.5,0.5-0.3,1.1-0.3,1.8c-0.1-0.5,0.1-0.9,0.5-1.2c0.6-0.4,1,0,1.6,0l-0.1,0.1 c-0.3,0.1-0.6,0.3-0.8,0.6c-0.1,0.2-0.2,0.3-0.2,0.5c-0.3,0.9-0.1,2.2,0.1,3.2C74.3,27.7,77.7,30.3,79.5,29.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_463_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_462_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_464_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.2692,
    y1: 23.9665,
    x2: 81.6566,
    y2: 22.1988
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 71.9,
    y: 16,
    className: "st220",
    width: 10.3,
    height: 14.3
  }))), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.5,29.7c1.8-0.7,2.7-4.7,1.6-6.5c-0.6-0.9-0.4-1.3-1.2-1.7c-0.5-0.2-1.3-0.2-2.3-0.1 c0.5-0.3,1.5-0.4,1.3-0.8c-0.3-0.4-0.9-0.4-1.3-0.7c0.4-0.4,1.2,0,1.8,0.1c-0.2-0.5-0.3-1-0.8-1.3c-0.6-0.3-1.1-0.3-1.6,0.1 c-0.6-0.7,0.9-1.2,1.2-1.4c-0.6-0.6-1.5-0.1-2,0.4c0.2-0.4,0-1.1,0.5-1.4c-0.7-0.3-1,0.3-1.5,0.6c-0.7,0.5-0.8-0.6-1.3-0.2 c0,0.1,0.1,0.3,0.1,0.4c0,0.1-0.1,0.4-0.1,0.5c0,0.5,0.2,0.8,0.4,1.2c-0.2-0.6-2.2-0.7-1.9,0.2c0.3,0.6,0.8,0.5,1.3,0.6 c0.3,0.1,0.5,0.4,0.8,0.6C74,20,73.2,20.5,73,20.8c-0.5,0.5-0.3,1.1-0.3,1.8c-0.1-0.5,0.1-0.9,0.5-1.2c0.6-0.4,1,0,1.6,0l-0.1,0.1 c-0.3,0.1-0.6,0.3-0.8,0.6c-0.1,0.2-0.2,0.3-0.2,0.5c-0.3,0.9-0.1,2.2,0.1,3.2C74.3,27.7,77.7,30.3,79.5,29.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs170 || (_defs170 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_465_",
    d: "M78.6,28.1c-2.4-1.7-2.8-4.1-3.2-6.8c0.1,0.1,0.6-0.3,0.7-0.2c2.6,1.9,2.4,3.6,2.7,6.9L78.6,28.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_466_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_465_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_467_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.7681,
    y1: 24.8081,
    x2: 80.0407,
    y2: 24.0634
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 75.4,
    y: 21,
    className: "st221",
    width: 3.4,
    height: 7.1
  }))), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M79.8,25.5L79.8,25.5l0-0.1C79.8,25.4,79.7,25.4,79.8,25.5c-0.1-0.1-0.1-0.1-0.1-0.1c-0.1-0.1-0.3-0.2-0.5-0.3 l0,0l-0.1,0c-0.1,0-0.3,0.2-0.4,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0,0.1,0,0.1,0c0.2,0,0.4,0.1,0.4,0.2c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.2-0.1,0.3-0.1c0,0,0,0,0,0.1l0.1-0.1c0,0,0,0,0,0C79.4,25.8,79.6,25.6,79.8,25.5 C79.8,25.5,79.8,25.5,79.8,25.5 M79.2,26.4L79.2,26.4C79.2,26.4,79.2,26.3,79.2,26.4c-0.1-0.1-0.4-0.3-0.6-0.4c-0.1,0-0.1,0-0.2,0 l-0.1,0l0,0c0,0,0,0,0,0l0,0l0,0c0,0-0.1,0.1-0.3,0.3C78,26.5,78,26.7,78,26.8c0,0-0.1,0-0.1,0c0,0,0.5,0.1,0.7,0.3c0,0,0,0-0.1,0 c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.3-0.1c0,0,0,0,0,0.1l0.1-0.1c0,0,0,0,0,0C78.8,26.7,79.2,26.4,79.2,26.4z M78.7,25.2L78.7,25.2 C78.7,25.2,78.7,25.2,78.7,25.2C78.7,25.2,78.7,25.2,78.7,25.2C78.7,25.2,78.7,25.2,78.7,25.2C78.7,25.2,78.8,25.2,78.7,25.2 C78.9,25,79,25,79,25l0,0c0,0,0,0,0,0c0-0.2,0.2-0.5,0.3-0.6c0,0,0,0-0.1-0.1c-0.2-0.1-0.4-0.3-0.6-0.3l0,0c0,0-0.2,0.1-0.3,0.3 c-0.1,0.1-0.1,0.3-0.1,0.4c0,0-0.1,0-0.1,0C78.1,24.9,78.6,25,78.7,25.2z M79.9,25.4L79.9,25.4L79.9,25.4l0,0.1 c-0.1,0.1-0.3,0.3-0.3,0.6l0,0.1l-0.1,0c-0.1,0-0.2,0.1-0.2,0.1c0,0,0,0,0,0l0.1,0l-0.1,0.1c-0.1,0.1-0.3,0.3-0.3,0.6l0,0.1l-0.1,0 c-0.1,0-0.2,0.1-0.3,0.1l-0.1,0l0-0.1c0-0.2-0.4-0.2-0.6-0.2l-0.1,0l0-0.1c0-0.2,0-0.4,0.1-0.6c0.3-0.4,0.4-0.4,0.5-0.4l0,0 c0,0,0,0,0,0c0-0.2,0-0.4,0.1-0.5c0,0,0.1-0.1,0.1-0.1l0,0c0-0.2-0.4-0.2-0.6-0.2L78,25l0-0.1c0-0.2,0-0.4,0.1-0.6 c0.3-0.4,0.4-0.4,0.5-0.4l0,0c0.3-0.1,0.6,0.1,0.8,0.3c0,0,0.1,0.1,0.1,0.1l0.1,0l-0.1,0.1c-0.1,0.1-0.3,0.3-0.3,0.5 c0.3,0,0.5,0.2,0.6,0.3C79.8,25.3,79.8,25.4,79.9,25.4z M80.8,23.8L80.8,23.8l0-0.1C80.8,23.7,80.8,23.7,80.8,23.8 c-0.1-0.1-0.1-0.1-0.1-0.1c-0.1-0.1-0.2-0.2-0.5-0.1l0,0h0c0,0-0.1,0.1-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0-0.1,0-0.1,0 c0,0,0.5,0.1,0.6,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0l0.1,0c0,0,0-0.1-0.1-0.1c0-0.1,0.1-0.2,0.1-0.3C80.6,24.1,80.7,23.9,80.8,23.8 C80.8,23.8,80.8,23.8,80.8,23.8z M80.6,24.3L80.6,24.3c-0.1,0.3-0.9-0.4-0.8-0.5c0.3-0.4,0.4-0.4,0.4-0.4c0,0,0,0,0,0l0,0h0 c0.3-0.1,0.5,0.1,0.6,0.2C80.8,23.6,80.7,24.1,80.6,24.3z M77.6,23.7L77.6,23.7c0-0.3,0.3-0.6,0.3-0.6l0-0.1c0,0,0,0,0,0 c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.4-0.1-0.4-0.1c0,0,0,0,0,0l0,0l0,0c0,0-0.1,0.1-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4 c0,0-0.1,0-0.1,0s0.1,0,0.1,0c0.2,0,0.5,0.1,0.6,0.3c0,0,0,0,0,0C77.4,23.8,77.5,23.7,77.6,23.7C77.6,23.7,77.6,23.7,77.6,23.7z  M76.6,23.4L76.6,23.4c0-0.2,0.1-0.4,0.3-0.5l0-0.1c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0c-0.1-0.1-0.5-0.2-0.5-0.2c0,0,0,0,0,0l0,0l0,0 c0,0-0.1,0-0.1,0.1l0,0L76,22.6c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.3-0.1,0.4c0,0,0.1,0,0.1,0c0.2,0,0.4,0.1,0.5,0.2 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0C76.4,23.4,76.5,23.4,76.6,23.4C76.6,23.4,76.6,23.4,76.6,23.4C76.6,23.4,76.6,23.4,76.6,23.4z  M76.4,23.7L76.4,23.7L76.4,23.7C76.4,23.6,76.4,23.6,76.4,23.7L76.4,23.7C76.3,23.7,76.3,23.7,76.4,23.7 C76.3,23.7,76.3,23.7,76.4,23.7l-0.1,0l0,0c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.4-0.2c0,0-0.1,0-0.1,0l-0.1,0v0c0,0,0,0,0,0l0,0l0,0 c0,0-0.1,0-0.1,0.1l0.1,0l-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.4c0,0,0,0.1,0,0.1c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.3,0.1,0.3,0.2 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.2-0.1,0.3-0.1c0,0,0,0,0,0.1l0.1-0.1c0,0,0,0,0,0C76,24,76.2,23.8,76.4,23.7 C76.3,23.7,76.4,23.7,76.4,23.7z M75.7,24.6L75.7,24.6L75.7,24.6L75.7,24.6C75.7,24.6,75.7,24.6,75.7,24.6z M75.6,24.5L75.6,24.5 L75.6,24.5C75.6,24.5,75.6,24.5,75.6,24.5C75.6,24.5,75.6,24.5,75.6,24.5c-0.1-0.1-0.5-0.3-0.6-0.3l-0.1,0c-0.1,0-0.2,0.1-0.3,0.1 l0,0c0,0-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.3-0.1,0.4c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0.1,0.4,0.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0.1,0,0.2-0.1,0.3-0.1c0,0,0,0,0,0c0,0,0,0,0,0l0-0.1c0,0,0,0,0,0C75.3,24.8,75.5,24.6,75.6,24.5C75.6,24.5,75.6,24.5,75.6,24.5z  M75.1,25.5L75.1,25.5L75.1,25.5C75.1,25.4,75.1,25.4,75.1,25.5C75.1,25.4,75.1,25.5,75.1,25.5z M75.3,25.3L75.3,25.3L75.3,25.3 L75.3,25.3c0,0-0.1,0-0.1,0c0,0-0.4,0.4-0.3,0.7c0.2,0,0.5,0.1,0.6,0.3c0,0,0,0-0.1,0l0.1,0c0,0,0,0,0-0.1c0.1,0,0.2-0.1,0.3-0.1 c0,0,0,0,0,0.1l0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0-0.3,0.2-0.5,0.3-0.6c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0-0.1,0.1c0,0,0,0-0.1-0.1 C75.8,25.4,75.6,25.2,75.3,25.3z M76,25.9L76,25.9c-0.1,0.1-0.1,0.3-0.1,0.4c0,0-0.1,0-0.1,0l0.1,0.1c0,0,0,0,0-0.1 c0.2,0,0.5,0.1,0.6,0.3c0,0,0,0-0.1,0l0.1,0c0,0,0,0,0-0.1c0.1,0,0.2-0.1,0.3-0.1c0,0,0,0,0,0.1l0.1-0.1c0,0,0,0,0,0 c0-0.3,0.2-0.5,0.3-0.6c0,0,0,0,0.1,0.1l0-0.1c0,0,0,0-0.1,0.1c0,0,0,0-0.1-0.1c-0.2-0.1-0.4-0.3-0.6-0.3l0,0l0,0 C76.3,25.6,76.2,25.7,76,25.9z M74.8,25.6L74.8,25.6c0-0.1,0.1-0.1,0.1-0.2l0,0c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1,0-0.2,0-0.2,0l0,0 c0,0,0,0,0,0l0,0l0,0c0,0-0.1,0.1-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0-0.1,0-0.1,0l0.1,0.1c0,0,0,0,0-0.1c0.2,0,0.5,0.1,0.6,0.3 c0,0,0.2-0.1,0.3-0.1C74.7,25.9,74.8,25.7,74.8,25.6z M74.7,24.2L74.7,24.2c0.1-0.1,0.2-0.1,0.2-0.1l0,0c0,0,0.1,0,0.1,0 c0,0,0-0.1,0-0.1c0-0.1,0.1-0.3,0.1-0.4c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0,0l0,0l0,0c-0.2-0.1-0.4-0.3-0.6-0.2l0,0l0,0 c0,0-0.1,0.1-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0-0.1,0-0.1,0l0.1,0.1c0,0,0,0,0-0.1C74.3,23.9,74.6,24,74.7,24.2z M74.7,23 L74.7,23C74.7,23,74.7,23,74.7,23c0.2,0,0.5,0,0.6,0.2c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0.2-0.1,0.2-0.1c0,0,0.2-0.5,0.3-0.7 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1-0.1c-0.2-0.1-0.4-0.3-0.6-0.3l0,0l0,0c0,0-0.1,0.1-0.3,0.3 C74.8,22.7,74.7,22.9,74.7,23C74.7,23,74.7,23,74.7,23z M77,22.8L77,22.8L77,22.8C77,22.8,77,22.8,77,22.8z M77,22.7L77,22.7 L77,22.7L77,22.7z M76.4,22.3L76.4,22.3c0.3,0,0.5,0.2,0.6,0.3c0,0,0,0,0,0c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0,0,0.1l0-0.1 c0,0,0.2-0.5,0.3-0.6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.4-0.4-0.7-0.3l0,0h0c0,0-0.1,0.1-0.3,0.3 C76.4,22.1,76.4,22.2,76.4,22.3z M77.5,22.2L77.5,22.2c-0.1,0.1-0.1,0.3-0.1,0.4c0.1,0,0.2,0,0.3,0.1c0.1,0,0.3,0.2,0.3,0.2 c0.1,0,0.2-0.1,0.2,0l0.1-0.1c0,0,0.1-0.5,0.3-0.6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1-0.1c-0.2-0.1-0.4-0.3-0.6-0.3l0,0h0 C77.8,21.9,77.7,22,77.5,22.2z M78.6,22.5L78.6,22.5c-0.1,0.1-0.1,0.3-0.1,0.4c0,0-0.1,0-0.1,0l0.1,0.1c0,0,0,0,0-0.1 c0.2,0,0.5,0.1,0.6,0.3c0,0,0,0-0.1,0l0.1,0c0,0,0,0,0-0.1c0.1,0,0.2-0.1,0.3-0.1c0,0,0,0,0,0.1l0.1-0.1c0,0,0.1-0.5,0.3-0.6 c0,0,0,0,0.1,0.1l0-0.1c0,0,0,0-0.1,0.1c0,0,0,0-0.1-0.1c-0.2-0.1-0.4-0.3-0.6-0.3l0,0l0,0C78.9,22.2,78.7,22.2,78.6,22.5z M78,23.1 L78,23.1L78,23.1C78,23.1,78,23.1,78,23.1L78,23.1C78,23.1,78,23.1,78,23.1z M77.8,23.7L77.8,23.7L77.8,23.7L77.8,23.7 c-0.2,0.1-0.3,0.1-0.4,0.2l-0.1,0l0-0.1c0-0.2-0.4-0.3-0.6-0.3l-0.1,0l0-0.1c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0.1c0,0,0,0,0,0l0.1,0 l-0.1,0.1c-0.1,0.1-0.3,0.3-0.3,0.6l0,0.1l-0.1,0c-0.1,0-0.2,0.1-0.2,0.1l0,0l-0.1,0.1c-0.1,0.1-0.3,0.3-0.3,0.6 c0.3,0,0.4,0.2,0.6,0.3c0,0,0.1,0.1,0.1,0.1c0.1-0.1,0.1-0.1,0.2-0.1c0.3-0.1,0.6,0.1,0.8,0.3c0,0,0.1,0.1,0.1,0.1l0.1,0L77.2,26 c-0.1,0.1-0.3,0.3-0.3,0.6l0,0.1l-0.1,0c-0.1,0-0.2,0.1-0.3,0.1l-0.1,0l0-0.1c0-0.2-0.4-0.2-0.6-0.2l-0.1,0l0-0.1c0,0,0-0.1,0-0.1 c-0.1,0-0.2,0.1-0.3,0.1l-0.1,0l0-0.1c0-0.2-0.4-0.2-0.6-0.2l-0.1,0l0,0c-0.1,0-0.2,0.1-0.2,0.1l-0.1,0l0-0.1c0-0.2-0.4-0.2-0.6-0.2 l-0.1,0l0-0.1c0-0.2,0-0.4,0.1-0.6c0.3-0.4,0.4-0.4,0.5-0.4l0,0c0,0,0,0,0,0c0-0.2,0-0.4,0.1-0.5c0.1-0.1,0.1-0.1,0.2-0.2 c-0.1-0.1-0.3-0.2-0.5-0.2l-0.1,0l0-0.1c0-0.2,0-0.4,0.1-0.6c0.3-0.4,0.4-0.4,0.4-0.4l0,0c0,0,0,0,0,0v0c0-0.2,0-0.4,0.1-0.5 c0.3-0.4,0.4-0.4,0.5-0.4l0,0c0.3-0.1,0.6,0.1,0.8,0.3c0,0,0,0,0.1,0.1c0.1-0.1,0.2-0.1,0.2-0.1l0,0c0,0,0,0,0,0 c0-0.2,0-0.3,0.1-0.4c0.3-0.4,0.4-0.4,0.5-0.4l0,0c0.3-0.1,1,0.3,1,0.3c0.3-0.1,0.6,0.1,0.8,0.3c0,0,0.1,0.1,0.1,0.1l0,0 c0.1-0.1,0.2-0.1,0.2-0.1l0,0c0.3-0.1,0.6,0.1,0.8,0.3c0,0,0.1,0.1,0.1,0.1l0.1,0l-0.1,0.1c-0.1,0.1-0.3,0.3-0.3,0.6l0,0.1l-0.1,0 c-0.1,0-0.2,0.1-0.3,0.1l-0.1,0l0-0.1c0-0.2-0.4-0.2-0.6-0.2l-0.1,0l0-0.1c0,0,0-0.1,0-0.1l0,0c-0.1,0-0.2,0-0.2,0.1l0.1,0l-0.1,0.1 C78,23.2,77.7,23.5,77.8,23.7z M77.8,21.8L77.8,21.8C77.8,21.8,77.8,21.8,77.8,21.8C77.8,21.8,77.8,21.8,77.8,21.8L77.8,21.8z  M76.3,25.5C76.3,25.5,76.3,25.5,76.3,25.5C76.3,25.5,76.3,25.5,76.3,25.5L76.3,25.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs171 || (_defs171 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_468_",
    d: "M36,29.7c-1.8-0.7-2.7-4.7-1.6-6.5c0.6-0.9,0.4-1.3,1.2-1.7c0.5-0.2,1.3-0.2,2.3-0.1 c-0.5-0.3-1.5-0.4-1.3-0.8c0.3-0.4,0.9-0.4,1.3-0.7c-0.4-0.4-1.2,0-1.8,0.1c0.2-0.5,0.3-1,0.8-1.3c0.6-0.3,1.1-0.3,1.6,0.1 c0.6-0.7-0.9-1.2-1.2-1.4c0.6-0.6,1.5-0.1,2,0.4c-0.2-0.4,0-1.1-0.5-1.4c0.7-0.3,1,0.3,1.5,0.6c0.7,0.5,0.8-0.6,1.3-0.2 c0,0.1-0.1,0.3-0.1,0.4c0,0.1,0.1,0.4,0.1,0.5c0,0.5-0.2,0.8-0.4,1.2c0.2-0.6,2.2-0.7,1.9,0.2c-0.3,0.6-0.8,0.5-1.3,0.6 c-0.3,0.1-0.5,0.4-0.8,0.6c0.4-0.2,1.2,0.3,1.4,0.6c0.5,0.5,0.3,1.1,0.3,1.8c0.1-0.5-0.1-0.9-0.5-1.2c-0.6-0.4-1,0-1.6,0l0.1,0.1 c0.3,0.1,0.6,0.3,0.8,0.6c0.1,0.2,0.2,0.3,0.2,0.5c0.3,0.9,0.1,2.2-0.1,3.2C41.2,27.7,37.8,30.3,36,29.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_469_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_468_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_470_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.197,
    y1: 23.967,
    x2: 33.8172,
    y2: 22.1992
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2,
    y: 16,
    className: "st222",
    width: 10.3,
    height: 14.3
  }))), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36,29.7c-1.8-0.7-2.7-4.7-1.6-6.5c0.6-0.9,0.4-1.3,1.2-1.7c0.5-0.2,1.3-0.2,2.3-0.1c-0.5-0.3-1.5-0.4-1.3-0.8 c0.3-0.4,0.9-0.4,1.3-0.7c-0.4-0.4-1.2,0-1.8,0.1c0.2-0.5,0.3-1,0.8-1.3c0.6-0.3,1.1-0.3,1.6,0.1c0.6-0.7-0.9-1.2-1.2-1.4 c0.6-0.6,1.5-0.1,2,0.4c-0.2-0.4,0-1.1-0.5-1.4c0.7-0.3,1,0.3,1.5,0.6c0.7,0.5,0.8-0.6,1.3-0.2c0,0.1-0.1,0.3-0.1,0.4 c0,0.1,0.1,0.4,0.1,0.5c0,0.5-0.2,0.8-0.4,1.2c0.2-0.6,2.2-0.7,1.9,0.2c-0.3,0.6-0.8,0.5-1.3,0.6c-0.3,0.1-0.5,0.4-0.8,0.6 c0.4-0.2,1.2,0.3,1.4,0.6c0.5,0.5,0.3,1.1,0.3,1.8c0.1-0.5-0.1-0.9-0.5-1.2c-0.6-0.4-1,0-1.6,0l0.1,0.1c0.3,0.1,0.6,0.3,0.8,0.6 c0.1,0.2,0.2,0.3,0.2,0.5c0.3,0.9,0.1,2.2-0.1,3.2C41.2,27.7,37.8,30.3,36,29.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs172 || (_defs172 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_471_",
    d: "M36.9,28.1c2.4-1.7,2.8-4.1,3.2-6.8c-0.1,0.1-0.6-0.3-0.7-0.2c-2.6,1.9-2.4,3.6-2.7,6.9L36.9,28.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_472_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_471_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_473_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.6979,
    y1: 24.8082,
    x2: 35.4327,
    y2: 24.0635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 36.6,
    y: 21,
    className: "st223",
    width: 3.4,
    height: 7.1
  }))), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M35.7,25.5L35.7,25.5l0-0.1C35.7,25.4,35.7,25.4,35.7,25.5c0.1-0.1,0.1-0.1,0.1-0.1c0.1-0.1,0.3-0.2,0.5-0.3 l0,0l0.1,0c0.1,0,0.3,0.2,0.4,0.3c0.1,0.1,0.1,0.3,0.1,0.4c0,0-0.1,0-0.1,0c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.3-0.1c0,0,0,0,0,0.1L36,26.1c0,0,0,0,0,0C36,25.8,35.9,25.6,35.7,25.5 C35.7,25.5,35.7,25.5,35.7,25.5 M36.3,26.4L36.3,26.4C36.3,26.4,36.3,26.3,36.3,26.4c0.1-0.1,0.4-0.3,0.6-0.4c0.1,0,0.1,0,0.2,0 l0.1,0l0,0c0,0,0,0,0,0l0,0l0,0c0,0,0.1,0.1,0.3,0.3c0.1,0.1,0.1,0.3,0.1,0.4c0,0,0.1,0,0.1,0c0,0-0.5,0.1-0.7,0.3c0,0,0,0,0.1,0 c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.3-0.1c0,0,0,0,0,0.1L36.6,27c0,0,0,0,0,0C36.6,26.7,36.3,26.4,36.3,26.4z M36.7,25.2L36.7,25.2 C36.7,25.2,36.8,25.2,36.7,25.2C36.8,25.2,36.7,25.2,36.7,25.2C36.7,25.2,36.7,25.2,36.7,25.2C36.7,25.2,36.7,25.2,36.7,25.2 C36.6,25,36.5,25,36.5,25l0,0c0,0,0,0,0,0c0-0.2-0.2-0.5-0.3-0.6c0,0,0,0,0.1-0.1c0.2-0.1,0.4-0.3,0.6-0.3l0,0c0,0,0.2,0.1,0.3,0.3 c0.1,0.1,0.1,0.3,0.1,0.4c0,0,0.1,0,0.1,0C37.4,24.9,36.8,25,36.7,25.2z M35.6,25.4L35.6,25.4L35.6,25.4l0,0.1 c0.1,0.1,0.3,0.3,0.3,0.6l0,0.1l0.1,0c0.1,0,0.2,0.1,0.2,0.1c0,0,0,0,0,0l-0.1,0l0.1,0.1c0.1,0.1,0.3,0.3,0.3,0.6l0,0.1l0.1,0 c0.1,0,0.2,0.1,0.3,0.1l0.1,0l0-0.1c0-0.2,0.4-0.2,0.6-0.2l0.1,0l0-0.1c0-0.2,0-0.4-0.1-0.6c-0.3-0.4-0.4-0.4-0.5-0.4l0,0 c0,0,0,0,0,0c0-0.2,0-0.4-0.1-0.5c0,0-0.1-0.1-0.1-0.1l0,0c0-0.2,0.4-0.2,0.6-0.2l0.1,0l0-0.1c0-0.2,0-0.4-0.1-0.6 C37,24,36.9,24,36.9,24l0,0c-0.3-0.1-0.6,0.1-0.8,0.3c0,0-0.1,0.1-0.1,0.1l-0.1,0l0.1,0.1c0.1,0.1,0.3,0.3,0.3,0.5 c-0.3,0-0.5,0.2-0.6,0.3C35.7,25.3,35.6,25.4,35.6,25.4z M34.6,23.8L34.6,23.8l0-0.1C34.7,23.7,34.7,23.7,34.6,23.8 c0.1-0.1,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.2,0.5-0.1l0,0h0c0,0,0.1,0.1,0.3,0.3c0.1,0.1,0.1,0.3,0.1,0.4c0,0,0.1,0,0.1,0 c0,0-0.5,0.1-0.6,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0l-0.1,0c0,0,0-0.1,0.1-0.1c0-0.1-0.1-0.2-0.1-0.3C34.9,24.1,34.8,23.9,34.6,23.8 C34.7,23.8,34.7,23.8,34.6,23.8z M34.9,24.3L34.9,24.3c0.1,0.3,0.9-0.4,0.8-0.5c-0.3-0.4-0.4-0.4-0.5-0.4c0,0,0,0,0,0l0,0h0 c-0.3-0.1-0.5,0.1-0.6,0.2C34.6,23.6,34.8,24.1,34.9,24.3z M37.8,23.7L37.8,23.7c0-0.3-0.3-0.6-0.3-0.6l0-0.1c0,0,0,0,0,0 c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.4-0.1,0.4-0.1c0,0,0,0,0,0l0,0l0,0c0,0,0.1,0.1,0.3,0.3c0.1,0.1,0.1,0.2,0.1,0.4c0,0,0.1,0,0.1,0 s-0.1,0-0.1,0c-0.2,0-0.5,0.1-0.6,0.3c0,0,0,0,0,0C38,23.8,37.9,23.7,37.8,23.7C37.8,23.7,37.8,23.7,37.8,23.7z M38.9,23.4 L38.9,23.4c0-0.2-0.1-0.4-0.3-0.5l0-0.1c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0c0.1-0.1,0.5-0.2,0.5-0.2c0,0,0,0,0,0l0,0l0,0 c0,0,0.1,0,0.1,0.1l0,0l0.1,0.1c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.3,0.1,0.4c0,0-0.1,0-0.1,0c-0.2,0-0.4,0.1-0.5,0.2 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0C39,23.4,39,23.4,38.9,23.4C38.9,23.4,38.8,23.4,38.9,23.4C38.8,23.4,38.8,23.4,38.9,23.4z  M39.1,23.7L39.1,23.7L39.1,23.7C39.1,23.6,39.1,23.6,39.1,23.7L39.1,23.7C39.1,23.7,39.2,23.7,39.1,23.7 C39.2,23.7,39.2,23.7,39.1,23.7l0.1,0l0,0c0,0,0,0,0,0c0.1-0.1,0.2-0.2,0.4-0.2c0,0,0.1,0,0.1,0l0.1,0l0,0c0,0,0,0,0,0l0,0l0,0 c0,0,0.1,0,0.1,0.1l-0.1,0l0.1,0.1c0.1,0.1,0.2,0.2,0.3,0.4c0,0,0,0.1,0,0.1c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0-0.3,0.1-0.3,0.2 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.3-0.1c0,0,0,0,0,0.1l-0.1-0.1c0,0,0,0,0,0C39.5,24,39.3,23.8,39.1,23.7 C39.1,23.7,39.1,23.7,39.1,23.7z M39.8,24.6L39.8,24.6L39.8,24.6L39.8,24.6C39.8,24.6,39.8,24.6,39.8,24.6z M39.8,24.5L39.8,24.5 L39.8,24.5C39.8,24.5,39.8,24.5,39.8,24.5C39.9,24.5,39.9,24.5,39.8,24.5c0.1-0.1,0.5-0.3,0.6-0.3l0.1,0c0.1,0,0.2,0.1,0.3,0.1l0,0 c0,0,0.1,0.1,0.1,0.2C41,24.6,41,24.8,41,25c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0.1-0.4,0.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c-0.1,0-0.2-0.1-0.3-0.1c0,0,0,0,0,0c0,0,0,0,0,0l0-0.1c0,0,0,0,0,0C40.1,24.8,40,24.6,39.8,24.5C39.8,24.5,39.8,24.5,39.8,24.5z  M40.4,25.5L40.4,25.5L40.4,25.5C40.4,25.4,40.4,25.4,40.4,25.5C40.4,25.4,40.4,25.5,40.4,25.5z M40.2,25.3L40.2,25.3L40.2,25.3 L40.2,25.3c0,0,0.1,0,0.1,0c0,0,0.4,0.4,0.3,0.7c-0.2,0-0.5,0.1-0.6,0.3c0,0,0,0,0.1,0l-0.1,0c0,0,0,0,0-0.1c-0.1,0-0.2-0.1-0.3-0.1 c0,0,0,0,0,0.1l0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0-0.3-0.2-0.5-0.3-0.6c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0.1,0.1c0,0,0,0,0.1-0.1 C39.7,25.4,39.9,25.2,40.2,25.3z M39.5,25.9L39.5,25.9c0.1,0.1,0.1,0.3,0.1,0.4c0,0,0.1,0,0.1,0l-0.1,0.1c0,0,0,0,0-0.1 c-0.2,0-0.5,0.1-0.6,0.3c0,0,0,0,0.1,0l-0.1,0c0,0,0,0,0-0.1c-0.1,0-0.2-0.1-0.3-0.1c0,0,0,0,0,0.1l-0.1-0.1c0,0,0,0,0,0 c0-0.3-0.2-0.5-0.3-0.6c0,0,0,0-0.1,0.1l0-0.1c0,0,0,0,0.1,0.1c0,0,0,0,0.1-0.1c0.2-0.1,0.4-0.3,0.6-0.3l0,0l0,0 C39.2,25.6,39.3,25.7,39.5,25.9z M40.6,25.6L40.6,25.6c0-0.1-0.1-0.1-0.1-0.2l0,0c0.1-0.1,0.2-0.2,0.4-0.2c0.1,0,0.2,0,0.2,0l0,0 c0,0,0,0,0,0l0,0l0,0c0,0,0.1,0.1,0.3,0.3c0.1,0.1,0.1,0.3,0.1,0.4c0,0,0.1,0,0.1,0l-0.1,0.1c0,0,0,0,0-0.1c-0.2,0-0.5,0.1-0.6,0.3 c0,0-0.2-0.1-0.3-0.1C40.7,25.9,40.7,25.7,40.6,25.6z M40.8,24.2L40.8,24.2c-0.1-0.1-0.2-0.1-0.2-0.1l0,0c0,0-0.1,0-0.1,0 c0,0,0-0.1,0-0.1c0-0.1-0.1-0.3-0.1-0.4c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0,0l0,0l0,0c0.2-0.1,0.4-0.3,0.6-0.2l0,0l0,0 c0,0,0.1,0.1,0.3,0.3c0.1,0.1,0.1,0.3,0.1,0.4c0,0,0.1,0,0.1,0L41.3,24c0,0,0,0,0-0.1C41.1,23.9,40.9,24,40.8,24.2z M40.8,23 L40.8,23C40.8,23,40.7,23,40.8,23c-0.2,0-0.5,0-0.6,0.2c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0-0.2-0.1-0.2-0.1c0,0-0.2-0.5-0.3-0.7 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1-0.1c0.2-0.1,0.4-0.3,0.6-0.3l0,0l0,0c0,0,0.1,0.1,0.3,0.3 C40.7,22.7,40.7,22.9,40.8,23C40.8,23,40.8,23,40.8,23z M38.5,22.8L38.5,22.8C38.5,22.8,38.5,22.8,38.5,22.8L38.5,22.8 C38.5,22.8,38.5,22.8,38.5,22.8z M38.5,22.7L38.5,22.7L38.5,22.7L38.5,22.7z M39.1,22.3L39.1,22.3c-0.3,0-0.5,0.2-0.6,0.3 c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0,0,0.1l0-0.1c0,0-0.2-0.5-0.3-0.6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0 c0,0,0.4-0.4,0.7-0.3l0,0h0c0,0,0.1,0.1,0.3,0.3C39.1,22.1,39.1,22.2,39.1,22.3z M38,22.2L38,22.2c0.1,0.1,0.1,0.3,0.1,0.4 c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.3,0.2-0.3,0.2c-0.1,0-0.2-0.1-0.3,0l-0.1-0.1c0,0-0.1-0.5-0.3-0.6c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0.1-0.1c0.2-0.1,0.4-0.3,0.6-0.3l0,0h0C37.7,21.9,37.8,22,38,22.2z M36.9,22.5L36.9,22.5c0.1,0.1,0.1,0.3,0.1,0.4 c0,0,0.1,0,0.1,0L37,23c0,0,0,0,0-0.1c-0.2,0-0.5,0.1-0.6,0.3c0,0,0,0,0.1,0l-0.1,0c0,0,0,0,0-0.1c-0.1,0-0.2-0.1-0.3-0.1 c0,0,0,0,0,0.1l-0.1-0.1c0,0-0.1-0.5-0.3-0.6c0,0,0,0-0.1,0.1l0-0.1c0,0,0,0,0.1,0.1c0,0,0,0,0.1-0.1c0.2-0.1,0.4-0.3,0.6-0.3l0,0 l0,0C36.6,22.2,36.7,22.2,36.9,22.5z M37.5,23.1L37.5,23.1L37.5,23.1C37.5,23.1,37.5,23.1,37.5,23.1L37.5,23.1 C37.5,23.1,37.5,23.1,37.5,23.1z M37.7,23.7L37.7,23.7L37.7,23.7L37.7,23.7c0.2,0.1,0.3,0.1,0.4,0.2l0.1,0l0-0.1 c0-0.2,0.4-0.3,0.6-0.3l0.1,0l0-0.1c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0.1c0,0,0,0,0,0l-0.1,0l0.1,0.1c0.1,0.1,0.3,0.3,0.3,0.6l0,0.1 l0.1,0c0.1,0,0.2,0.1,0.2,0.1l0,0l0.1,0.1c0.1,0.1,0.3,0.3,0.3,0.6c-0.3,0-0.4,0.2-0.6,0.3c0,0-0.1,0.1-0.1,0.1 c-0.1-0.1-0.1-0.1-0.2-0.1c-0.3-0.1-0.6,0.1-0.8,0.3c0,0-0.1,0.1-0.1,0.1l-0.1,0l0.1,0.1c0.1,0.1,0.3,0.3,0.3,0.6l0,0.1l0.1,0 c0.1,0,0.2,0.1,0.3,0.1l0.1,0l0-0.1c0-0.2,0.4-0.2,0.6-0.2l0.1,0l0-0.1c0,0,0-0.1,0-0.1c0.1,0,0.2,0.1,0.3,0.1l0.1,0l0-0.1 c0-0.2,0.4-0.2,0.6-0.2l0.1,0l0,0c0.1,0,0.2,0.1,0.2,0.1l0.1,0l0-0.1c0-0.2,0.4-0.2,0.6-0.2l0.1,0l0-0.1c0-0.2,0-0.4-0.1-0.6 c-0.3-0.4-0.4-0.4-0.5-0.4l0,0c0,0,0,0,0,0c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.1-0.1-0.2-0.2c0.1-0.1,0.3-0.2,0.5-0.2l0.1,0l0-0.1 c0-0.2,0-0.4-0.1-0.6C41.1,23,40.9,23,40.9,23l0,0c0,0,0,0,0,0v0c0-0.2,0-0.4-0.1-0.5c-0.3-0.4-0.4-0.4-0.5-0.4l0,0 c-0.3-0.1-0.6,0.1-0.8,0.3c0,0,0,0-0.1,0.1c-0.1-0.1-0.2-0.1-0.2-0.1l0,0c0,0,0,0,0,0c0-0.2,0-0.3-0.1-0.4c-0.3-0.4-0.4-0.4-0.5-0.4 l0,0c-0.3-0.1-1,0.3-1,0.3c-0.3-0.1-0.6,0.1-0.7,0.3c0,0-0.1,0.1-0.1,0.1l0,0C36.7,22,36.6,22,36.6,22l0,0c-0.3-0.1-0.6,0.1-0.8,0.3 c0,0-0.1,0.1-0.1,0.1l-0.1,0l0.1,0.1c0.1,0.1,0.3,0.3,0.3,0.6l0,0.1l0.1,0c0.1,0,0.2,0.1,0.3,0.1l0.1,0l0-0.1c0-0.2,0.4-0.2,0.6-0.2 l0.1,0l0-0.1c0,0,0-0.1,0-0.1l0,0c0.1,0,0.2,0,0.2,0.1l-0.1,0l0.1,0.1C37.5,23.2,37.7,23.5,37.7,23.7z M37.7,21.8L37.7,21.8 C37.7,21.8,37.7,21.8,37.7,21.8C37.7,21.8,37.7,21.8,37.7,21.8L37.7,21.8z M39.2,25.5C39.2,25.5,39.2,25.5,39.2,25.5 C39.2,25.5,39.2,25.5,39.2,25.5L39.2,25.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs173 || (_defs173 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_474_",
    d: "M54.1,12.1c2.8,0.7,5,0,6.7-2c1.2,1.9,1.5,3.9,0.3,6.1c-2.3-1.9-4.7-2.5-7.2-1.7 C54,13.6,54,12.9,54.1,12.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_475_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_474_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_476_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.8793,
    y1: 13.1081,
    x2: 62.3607,
    y2: 13.1081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9,
    y: 10.1,
    className: "st224",
    width: 8.5,
    height: 6.1
  }))), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.1,12.1c2.8,0.7,5,0,6.7-2c1.2,1.9,1.5,3.9,0.3,6.1c-2.3-1.9-4.7-2.5-7.2-1.7C54,13.6,54,12.9,54.1,12.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs174 || (_defs174 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_477_",
    d: "M56,10.4c0.6-1.1,1.2-1.1,1.8,0v23c-0.6-0.4-1.2-0.3-1.8,0.2V10.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_478_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_477_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_479_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.0329,
    y1: 21.4311,
    x2: 57.8909,
    y2: 21.4311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 9.3,
    className: "st225",
    width: 1.8,
    height: 24.3
  }))), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56,10.4c0.6-1.1,1.2-1.1,1.8,0v23c-0.6-0.4-1.2-0.3-1.8,0.2V10.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs175 || (_defs175 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_480_",
    d: "M59.8,19.4L60,51.6c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4v0L59,19.4v0c0-0.2,0.2-0.4,0.4-0.4 C59.7,19,59.8,19.2,59.8,19.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_481_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_480_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_482_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.0042,
    y1: 35.4933,
    x2: 59.9596,
    y2: 35.4933
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 19,
    className: "st226",
    width: 0.9,
    height: 33
  }))), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.8,19.4L60,51.6c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4v0L59,19.4v0c0-0.2,0.2-0.4,0.4-0.4 C59.7,19,59.8,19.2,59.8,19.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs176 || (_defs176 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_483_",
    points: "59.2,16.5 58,20.1 59.3,19.3 61,19.9  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_484_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_483_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_485_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.9797,
    y1: 18.2789,
    x2: 61.0413,
    y2: 18.2789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 16.5,
    className: "st227",
    width: 3.1,
    height: 3.6
  }))), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "59.2,16.5 58,20.1 59.3,19.3 61,19.9 "
  })), /*#__PURE__*/React.createElement("g", null, _defs177 || (_defs177 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_486_",
    d: "M58,18.8l0.1,29.4c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4v0l-0.1-29.3v0c0-0.2,0.2-0.4,0.4-0.4 C57.8,18.4,58,18.6,58,18.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_487_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_486_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_488_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.229,
    y1: 33.4927,
    x2: 58.0948,
    y2: 33.4927
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 18.4,
    className: "st228",
    width: 0.9,
    height: 30.1
  }))), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58,18.8l0.1,29.4c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4v0l-0.1-29.3v0c0-0.2,0.2-0.4,0.4-0.4 C57.8,18.4,58,18.6,58,18.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs178 || (_defs178 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_489_",
    points: "57.4,16.1 56.3,19.4 57.5,18.7 59.1,19.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_490_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_489_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_491_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.2887,
    y1: 17.7629,
    x2: 59.0945,
    y2: 17.7629
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 56.3,
    y: 16.1,
    className: "st229",
    width: 2.8,
    height: 3.3
  }))), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "57.4,16.1 56.3,19.4 57.5,18.7 59.1,19.3 "
  })), /*#__PURE__*/React.createElement("g", null, _defs179 || (_defs179 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_492_",
    d: "M56,19.7l0.1,31.5c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4v0l-0.1-31.5l0,0c0-0.2,0.2-0.4,0.4-0.4 C55.8,19.3,56,19.5,56,19.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_493_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_492_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_494_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.1829,
    y1: 35.5143,
    x2: 56.1157,
    y2: 35.5143
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 55.2,
    y: 19.3,
    className: "st230",
    width: 0.9,
    height: 32.4
  }))), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56,19.7l0.1,31.5c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4v0l-0.1-31.5l0,0c0-0.2,0.2-0.4,0.4-0.4 C55.8,19.3,56,19.5,56,19.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs180 || (_defs180 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_495_",
    points: "55.4,16.9 54.2,20.4 55.5,19.6 57.2,20.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_496_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_495_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_497_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.1697,
    y1: 18.6193,
    x2: 57.1786,
    y2: 18.6193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 54.2,
    y: 16.9,
    className: "st231",
    width: 3,
    height: 3.5
  }))), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "55.4,16.9 54.2,20.4 55.5,19.6 57.2,20.3 "
  })), /*#__PURE__*/React.createElement("g", null, _defs181 || (_defs181 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_498_",
    d: "M54.6,23.2c1.7-0.6,3.4-0.6,5.1,0v43.3c-1.3,0.9-2.6,1.2-5.1,0V23.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_499_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_498_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_500_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.618,
    y1: 45.1007,
    x2: 59.7331,
    y2: 45.1007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 54.6,
    y: 22.5,
    className: "st232",
    width: 5.1,
    height: 45.1
  }))), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.6,23.2c1.7-0.6,3.4-0.6,5.1,0v43.3c-1.3,0.9-2.6,1.2-5.1,0V23.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs182 || (_defs182 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_501_",
    d: "M55.4,23.2l0.1,43.5L55.4,23.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_502_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_501_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_503_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.3559,
    y1: 44.9232,
    x2: 55.4236,
    y2: 44.9232
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 55.4,
    y: 23.2,
    className: "st233",
    width: 0.1,
    height: 43.5
  }))), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.4,23.2l0.1,43.5L55.4,23.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs183 || (_defs183 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_504_",
    d: "M59,23.2l0.2,43.5L59,23.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_505_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_504_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_506_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.9666,
    y1: 44.9044,
    x2: 59.1246,
    y2: 44.9044
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 23.2,
    className: "st234",
    width: 0.2,
    height: 43.5
  }))), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59,23.2l0.2,43.5L59,23.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs184 || (_defs184 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_507_",
    d: "M56,23l0.1,43.9L56,23z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_508_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_507_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_509_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.0329,
    y1: 44.9503,
    x2: 56.1683,
    y2: 44.9503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 23,
    className: "st235",
    width: 0.1,
    height: 43.9
  }))), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56,23l0.1,43.9L56,23z"
  })), /*#__PURE__*/React.createElement("g", null, _defs185 || (_defs185 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_510_",
    d: "M58.1,23L58.2,67L58.1,23z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_511_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_510_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_512_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.1392,
    y1: 44.9789,
    x2: 58.2445,
    y2: 44.9789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 58.1,
    y: 23,
    className: "st236",
    width: 0.1,
    height: 43.9
  }))), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.1,23L58.2,67L58.1,23z"
  })), /*#__PURE__*/React.createElement("g", null, _defs186 || (_defs186 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_513_",
    d: "M45.1,37.2l20.6,28.5c0.1,0.2,0.1,0.5-0.1,0.6c-0.2,0.1-0.5,0.1-0.6-0.1l0,0L44.4,37.7l0,0 c-0.1-0.2-0.1-0.5,0.1-0.6C44.7,36.9,44.9,37,45.1,37.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_514_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_513_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_515_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.1628,
    y1: 51.6662,
    x2: 65.8495,
    y2: 51.6662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 44.2,
    y: 36.9,
    className: "st237",
    width: 21.6,
    height: 29.5
  }))), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.1,37.2l20.6,28.5c0.1,0.2,0.1,0.5-0.1,0.6c-0.2,0.1-0.5,0.1-0.6-0.1l0,0L44.4,37.7l0,0 c-0.1-0.2-0.1-0.5,0.1-0.6C44.7,36.9,44.9,37,45.1,37.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs187 || (_defs187 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_516_",
    d: "M47.3,31.3l22.1,29.5c0.2,0.2,0.1,0.5-0.1,0.7c-0.2,0.2-0.5,0.1-0.7-0.1l0,0L46.5,31.9l0,0 c-0.2-0.2-0.1-0.5,0.1-0.7C46.8,31.1,47.1,31.1,47.3,31.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_517_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_516_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_518_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.269,
    y1: 46.3468,
    x2: 69.6257,
    y2: 46.3468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 46.3,
    y: 31.1,
    className: "st238",
    width: 23.2,
    height: 30.6
  }))), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.3,31.3l22.1,29.5c0.2,0.2,0.1,0.5-0.1,0.7c-0.2,0.2-0.5,0.1-0.7-0.1l0,0L46.5,31.9l0,0 c-0.2-0.2-0.1-0.5,0.1-0.7C46.8,31.1,47.1,31.1,47.3,31.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs188 || (_defs188 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_519_",
    points: "44.7,28.8 45.9,32.7 46.6,31.2 48.5,30.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_520_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_519_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_521_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.7134,
    y1: 30.7554,
    x2: 48.5422,
    y2: 30.7554
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7,
    y: 28.8,
    className: "st239",
    width: 3.8,
    height: 3.9
  }))), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "44.7,28.8 45.9,32.7 46.6,31.2 48.5,30.7 "
  })), /*#__PURE__*/React.createElement("g", null, _defs189 || (_defs189 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_522_",
    d: "M49.8,25.4l21.9,30.7c0.2,0.2,0.1,0.5-0.1,0.7c-0.2,0.2-0.5,0.1-0.7-0.1l0,0L49.1,26l0,0 c-0.2-0.2-0.1-0.5,0.1-0.7C49.4,25.2,49.7,25.2,49.8,25.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_523_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_522_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_524_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.8341,
    y1: 41.0756,
    x2: 71.9877,
    y2: 41.0756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9,
    y: 25.2,
    className: "st240",
    width: 23,
    height: 31.8
  }))), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.8,25.4l21.9,30.7c0.2,0.2,0.1,0.5-0.1,0.7c-0.2,0.2-0.5,0.1-0.7-0.1l0,0L49.1,26l0,0 c-0.2-0.2-0.1-0.5,0.1-0.7C49.4,25.2,49.7,25.2,49.8,25.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs190 || (_defs190 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_525_",
    points: "47.2,23.1 48.5,27.3 49.3,25.7 51.3,25.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_526_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_525_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_527_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.2198,
    y1: 25.2047,
    x2: 51.3496,
    y2: 25.2047
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 47.2,
    y: 23.1,
    className: "st241",
    width: 4.1,
    height: 4.2
  }))), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "47.2,23.1 48.5,27.3 49.3,25.7 51.3,25.1 "
  })), /*#__PURE__*/React.createElement("g", null, _defs191 || (_defs191 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_528_",
    points: "42.5,35 43.6,38.9 44.4,37.4 46.3,36.9  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_529_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_528_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_530_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.4718,
    y1: 36.9191,
    x2: 46.2999,
    y2: 36.9191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 35,
    className: "st242",
    width: 3.8,
    height: 3.9
  }))), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "42.5,35 43.6,38.9 44.4,37.4 46.3,36.9 "
  })), /*#__PURE__*/React.createElement("g", null, _defs192 || (_defs192 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_531_",
    d: "M59.5,38.7c0.1-0.1,0.1-0.3,0.2-0.5c1.6-3.4,2.9-3.7,6.7-4.7c1.2-0.3,4.5-2.9,4.3-4.1 c0-0.2,0-0.4-0.1-0.4c-2.1-2.6-3.6,1.5-1,0.8c-0.9,0.9-2,1.6-2.7,1.9c-4.9,2.1-6.1-1.1-8.4,4.9c0,0.1-0.1,0.1-0.1,0.1 c-0.4-0.1-0.7,0.2-0.6,0.7c-0.7-0.4-1.2,0.2-1.2,0.7c-0.3-0.3-1.1-0.2-1,0.5l-0.3-0.1c-3.1,0.3-4,0.9-4.6,1.9 c-0.7,1.1-1.2,2.4-2.5,4.9c-0.3,0.4-0.8,0.9-1.4,1.3c-0.5,0.2-1,0.4-1.4,0.5c1.3-2.3-3.1-2.1-1.2,0.6c0.1,0.1,0.2,0.2,0.4,0.3 c1.6,0.6,4.2-1.1,5.1-3.1c2-3.4,1.8-3.5,6-3.7c0.2,0,0.6-0.4,0.6-0.6c0.8,0.1,0.9,0.2,1.2-0.5c0.5,0.3,1-0.2,1-0.7 C58.8,39.4,59.5,39.6,59.5,38.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_532_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_531_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_533_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.2724,
    y1: 37.5243,
    x2: 70.8947,
    y2: 37.5243
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 26.4,
    className: "st243",
    width: 28.6,
    height: 22.3
  }))), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.5,38.7c0.1-0.1,0.1-0.3,0.2-0.5c1.6-3.4,2.9-3.7,6.7-4.7c1.2-0.3,4.5-2.9,4.3-4.1c0-0.2,0-0.4-0.1-0.4 c-2.1-2.6-3.6,1.5-1,0.8c-0.9,0.9-2,1.6-2.7,1.9c-4.9,2.1-6.1-1.1-8.4,4.9c0,0.1-0.1,0.1-0.1,0.1c-0.4-0.1-0.7,0.2-0.6,0.7 c-0.7-0.4-1.2,0.2-1.2,0.7c-0.3-0.3-1.1-0.2-1,0.5l-0.3-0.1c-3.1,0.3-4,0.9-4.6,1.9c-0.7,1.1-1.2,2.4-2.5,4.9 c-0.3,0.4-0.8,0.9-1.4,1.3c-0.5,0.2-1,0.4-1.4,0.5c1.3-2.3-3.1-2.1-1.2,0.6c0.1,0.1,0.2,0.2,0.4,0.3c1.6,0.6,4.2-1.1,5.1-3.1 c2-3.4,1.8-3.5,6-3.7c0.2,0,0.6-0.4,0.6-0.6c0.8,0.1,0.9,0.2,1.2-0.5c0.5,0.3,1-0.2,1-0.7C58.8,39.4,59.5,39.6,59.5,38.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs193 || (_defs193 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_534_",
    d: "M59.9,47c0.1-0.1-0.1-0.2,0-0.3c0.4-0.3,0.9-0.7,1.1-1.2c1.4-3.2,2.3-3.8,4.8-4.3 c3.1-0.5,4.9-2.3,4.7-3.4c0-0.2,0-0.3-0.1-0.4c-2.1-2.4-3.4,1.6-0.9,0.9c-0.8,0.9-2.1,1.2-3,1.3c-3.1,1.1-5.2-0.9-7.8,5.1 c0,0.1-0.1,0.2-0.1,0.1c-0.5-0.3-1-0.1-0.7,0.7c-0.7-0.4-1.2,0.2-1.1,0.7c-0.8-0.3-1.5,0.1-1.3,0.9l-0.3-0.1 c-2.5,0-3.3,0.3-4.2,1.2c-0.9,0.9-1.3,1.5-2.3,5c-0.9,1.4-0.5,1.1-1,1.5c-0.4,0.3-0.6,0.6-1,0.8c1.2-2.3-3.1-1.8-1.1,0.7 c0.1,0.1,0.2,0.2,0.4,0.2c1.6,0.5,3.5-1.6,4.4-3.5c1.8-3.3,2.1-2.8,5.9-3.6c0.2,0,0.6-0.4,0.6-0.6c0.8,0.1,0.9,0.2,1.1-0.6 c0.5,0.2,1-0.2,0.9-0.7C59,47.3,59.7,47.7,59.9,47"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_535_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_534_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_536_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.5595,
    y1: 45.994,
    x2: 70.7307,
    y2: 45.994
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6,
    y: 35.1,
    className: "st244",
    width: 27.2,
    height: 21.8
  }))), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.9,47c0.1-0.1-0.1-0.2,0-0.3c0.4-0.3,0.9-0.7,1.1-1.2c1.4-3.2,2.3-3.8,4.8-4.3c3.1-0.5,4.9-2.3,4.7-3.4 c0-0.2,0-0.3-0.1-0.4c-2.1-2.4-3.4,1.6-0.9,0.9c-0.8,0.9-2.1,1.2-3,1.3c-3.1,1.1-5.2-0.9-7.8,5.1c0,0.1-0.1,0.2-0.1,0.1 c-0.5-0.3-1-0.1-0.7,0.7c-0.7-0.4-1.2,0.2-1.1,0.7c-0.8-0.3-1.5,0.1-1.3,0.9l-0.3-0.1c-2.5,0-3.3,0.3-4.2,1.2 c-0.9,0.9-1.3,1.5-2.3,5c-0.9,1.4-0.5,1.1-1,1.5c-0.4,0.3-0.6,0.6-1,0.8c1.2-2.3-3.1-1.8-1.1,0.7c0.1,0.1,0.2,0.2,0.4,0.2 c1.6,0.5,3.5-1.6,4.4-3.5c1.8-3.3,2.1-2.8,5.9-3.6c0.2,0,0.6-0.4,0.6-0.6c0.8,0.1,0.9,0.2,1.1-0.6c0.5,0.2,1-0.2,0.9-0.7 C59,47.3,59.7,47.7,59.9,47z"
  })), /*#__PURE__*/React.createElement("g", null, _defs194 || (_defs194 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_537_",
    d: "M56.1,37.9c0.4-0.1,0.9,0.5,1.1,1.3c0.1,0.3,0.2,0.6,0.3,0.8c0,0.4-0.1,0.6-0.5,0.7 c-0.6,0.1-0.8-0.4-1.1-1.3C55.6,38.6,55.7,38,56.1,37.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_538_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_537_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_539_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.4462,
    y1: 39.321,
    x2: 57.5825,
    y2: 39.321
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 55.6,
    y: 37.8,
    className: "st245",
    width: 1.9,
    height: 3
  }))), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.1,37.9c0.4-0.1,0.9,0.5,1.1,1.3c0.1,0.3,0.2,0.6,0.3,0.8c0,0.4-0.1,0.6-0.5,0.7c-0.6,0.1-0.8-0.4-1.1-1.3 C55.6,38.6,55.7,38,56.1,37.9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs195 || (_defs195 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_540_",
    d: "M57.1,37.4c0.5-0.1,0.9,0.2,1.2,0.9c0.3,0.7,0.5,1.6,0,1.8c-0.2,0.1-0.4,0-0.6,0 c-0.3-0.1-0.2-0.4-0.6-1.1C56.6,38.3,56.5,37.4,57.1,37.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_541_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_540_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_542_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.3489,
    y1: 38.7305,
    x2: 59.0719,
    y2: 38.7305
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 37.3,
    className: "st246",
    width: 2.3,
    height: 2.8
  }))), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.1,37.4c0.5-0.1,0.9,0.2,1.2,0.9c0.3,0.7,0.5,1.6,0,1.8c-0.2,0.1-0.4,0-0.6,0c-0.3-0.1-0.2-0.4-0.6-1.1 C56.6,38.3,56.5,37.4,57.1,37.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs196 || (_defs196 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_543_",
    d: "M58.2,36.8c0.5-0.1,0.9,0.2,1.2,0.9c0.3,0.7,0.5,1.6,0,1.7c-0.2,0.1-0.4,0-0.6,0 c-0.3-0.1-0.2-0.4-0.6-1.1C57.7,37.6,57.7,36.8,58.2,36.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_544_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_543_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_545_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.4546,
    y1: 38.099,
    x2: 60.1175,
    y2: 38.099
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 57.7,
    y: 36.7,
    className: "st247",
    width: 2.2,
    height: 2.8
  }))), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.2,36.8c0.5-0.1,0.9,0.2,1.2,0.9c0.3,0.7,0.5,1.6,0,1.7c-0.2,0.1-0.4,0-0.6,0c-0.3-0.1-0.2-0.4-0.6-1.1 C57.7,37.6,57.7,36.8,58.2,36.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs197 || (_defs197 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_546_",
    d: "M55.9,46.2c0.4-0.4,1.1,0.3,1.4,1.1c0.1,0.3,0.3,0.6,0.4,0.8c0.1,0.4-0.1,0.6-0.5,0.8 c-0.6,0.2-0.9-0.3-1.3-1.1C55.4,46.9,55.4,46.5,55.9,46.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_547_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_546_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_548_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.2431,
    y1: 47.4458,
    x2: 57.7631,
    y2: 47.4458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 55.4,
    y: 45.8,
    className: "st248",
    width: 2.3,
    height: 3.2
  }))), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.9,46.2c0.4-0.4,1.1,0.3,1.4,1.1c0.1,0.3,0.3,0.6,0.4,0.8c0.1,0.4-0.1,0.6-0.5,0.8c-0.6,0.2-0.9-0.3-1.3-1.1 C55.4,46.9,55.4,46.5,55.9,46.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs198 || (_defs198 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_549_",
    d: "M56.9,45.6c0.6-0.2,1,0,1.4,0.8c0.4,0.8,0.8,1.5,0.2,1.8c-0.2,0.1-0.4,0.1-0.6,0.1 c-0.4,0-0.3-0.5-0.8-1.1C56.5,46.5,56.3,45.8,56.9,45.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_550_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_549_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_551_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.2812,
    y1: 46.8075,
    x2: 59.0343,
    y2: 46.8075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 56.3,
    y: 45.3,
    className: "st249",
    width: 2.8,
    height: 3
  }))), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.9,45.6c0.6-0.2,1,0,1.4,0.8c0.4,0.8,0.8,1.5,0.2,1.8c-0.2,0.1-0.4,0.1-0.6,0.1c-0.4,0-0.3-0.5-0.8-1.1 C56.5,46.5,56.3,45.8,56.9,45.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs199 || (_defs199 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_552_",
    d: "M58,44.9c0.5-0.1,1,0.1,1.4,0.8c0.4,0.7,0.7,1.5,0.2,1.7c-0.2,0.1-0.4,0.1-0.6,0c-0.4,0-0.2-0.4-0.8-1 C57.6,45.8,57.6,45,58,44.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_553_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_552_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_554_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.417,
    y1: 46.1155,
    x2: 60.4184,
    y2: 46.1155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 57.6,
    y: 44.7,
    className: "st250",
    width: 2.6,
    height: 2.7
  }))), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58,44.9c0.5-0.1,1,0.1,1.4,0.8c0.4,0.7,0.7,1.5,0.2,1.7c-0.2,0.1-0.4,0.1-0.6,0c-0.4,0-0.2-0.4-0.8-1 C57.6,45.8,57.6,45,58,44.9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs200 || (_defs200 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_555_",
    d: "M49,69.9c0.4,0,1,0.1,1.4,0.1c0.9,0.1,1.7,0,2.6,0.1c0.2,0,0.6,0,1.1,0.1c0.9,0.1,1.8,0.6,2.7,1.1 c-0.1-0.1-1,0-1.5,0.3c-0.1,0.1-0.7,0.6-1,0.8c-0.1,0.1-0.2,0.1-0.2,0.1C52.3,72.9,49.4,71.6,49,69.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_556_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_555_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_557_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.9537,
    y1: 71.3806,
    x2: 56.6957,
    y2: 71.3806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4A351"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 69.9,
    className: "st251",
    width: 7.7,
    height: 3
  }))), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49,69.9c0.4,0,1,0.1,1.4,0.1c0.9,0.1,1.7,0,2.6,0.1c0.2,0,0.6,0,1.1,0.1c0.9,0.1,1.8,0.6,2.7,1.1 c-0.1-0.1-1,0-1.5,0.3c-0.1,0.1-0.7,0.6-1,0.8c-0.1,0.1-0.2,0.1-0.2,0.1C52.3,72.9,49.4,71.6,49,69.9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs201 || (_defs201 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_558_",
    d: "M72.9,25.4c0,0.1,0,0.2,0,0.3c-0.2,1-1.1,2.7-0.5,3.9c0.6,1.2,2,1.5,3,1.6c0.1-0.1,0.4-0.6,0.2-0.6 c0.6-0.8,1.7-2,2.1-2.1c0.9-1.5-1.8-2.8-3.7-3.2C73.6,25.1,73.1,25.4,72.9,25.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_559_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_558_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_560_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.7816,
    y1: 28.1568,
    x2: 78.5065,
    y2: 28.1568
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 71.8,
    y: 25.1,
    className: "st252",
    width: 6.7,
    height: 6.1
  }))), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.9,25.4c0,0.1,0,0.2,0,0.3c-0.2,1-1.1,2.7-0.5,3.9c0.6,1.2,2,1.5,3,1.6c0.1-0.1,0.4-0.6,0.2-0.6 c0.6-0.8,1.7-2,2.1-2.1c0.9-1.5-1.8-2.8-3.7-3.2C73.6,25.1,73.1,25.4,72.9,25.4z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.9,28.4c-0.6,0-0.7,0.2-0.9,0.8c-0.1,0.2-0.2,0.5-0.4,0.6c-0.2,0.1-0.4,0.1-0.6,0.2"
  })), /*#__PURE__*/React.createElement("g", null, _defs202 || (_defs202 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_561_",
    d: "M57.7,21c2.5,0,3.3,0.8,3.2,1.5c0,0.3,0.1,0.5-0.1,0.8c-0.1,0.2-0.3,0.4-0.6,0.3 c-0.6-0.1-1.5-0.3-2.5-0.4c-1.3-0.2-2.4,0.5-3.2,0.6c-0.6,0.1-1.4-1-0.7-1.8C54.6,21.2,55.2,21,57.7,21"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_562_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_561_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_563_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.5953,
    y1: 22.4778,
    x2: 61.103,
    y2: 22.4778
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 53.1,
    y: 21,
    className: "st253",
    width: 7.9,
    height: 2.9
  }))), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.7,21c2.5,0,3.3,0.8,3.2,1.5c0,0.3,0.1,0.5-0.1,0.8c-0.1,0.2-0.3,0.4-0.6,0.3c-0.6-0.1-1.5-0.3-2.5-0.4 c-1.3-0.2-2.4,0.5-3.2,0.6c-0.6,0.1-1.4-1-0.7-1.8C54.6,21.2,55.2,21,57.7,21z"
  })), /*#__PURE__*/React.createElement("g", null, _defs203 || (_defs203 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_564_",
    d: "M59.8,55.5c0-0.1,0,0,0.1-0.1c2-3.2,2.2-3.5,4.2-4.5c2.3-1.3,4-1.1,3.8-2.6c0-0.1,0-0.3-0.1-0.3 c-0.5-0.7-1-0.7-1.3-0.4c-0.4,0.4-0.3,1.3,0.5,1.1c-3.4,1.9-5.8,0.6-8,5.2c0,0,0,0.1-0.1,0.1c-0.3-0.2-0.6-0.1-0.5,0.5 c-0.5-0.3-0.8,0.1-0.7,0.5c-0.1-0.1-0.2-0.1-0.4-0.1c-0.4,0-0.8,0.3-0.8,0.7l-0.3,0c-1.9,0.2-2.3,0.3-2.8,1.1 c-0.6,0.8-1,1.3-2.1,3.6c-0.7,1.1-0.4,0.8-0.8,1.1c-0.3,0.2-0.4,0.5-0.7,0.6c0.6-1.3-2-0.8-1,0.5c0.1,0.1,0.3,0.2,0.4,0.3 c1.2,0.5,2.7-1.3,3.4-2.8c1.6-2.2,1.7-1.9,4.5-2.7c0.1,0,0.4-0.3,0.4-0.4c0.4,0.2,0.7,0.2,0.9-0.3c0.4,0.2,0.8-0.1,0.8-0.5 C59.2,55.9,59.6,56.2,59.8,55.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_565_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_564_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_566_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.0137,
    y1: 55.1452,
    x2: 68.2491,
    y2: 55.1452
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 47.8,
    y: 47.2,
    className: "st254",
    width: 20.2,
    height: 15.9
  }))), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.8,55.5c0-0.1,0,0,0.1-0.1c2-3.2,2.2-3.5,4.2-4.5c2.3-1.3,4-1.1,3.8-2.6c0-0.1,0-0.3-0.1-0.3 c-0.5-0.7-1-0.7-1.3-0.4c-0.4,0.4-0.3,1.3,0.5,1.1c-3.4,1.9-5.8,0.6-8,5.2c0,0,0,0.1-0.1,0.1c-0.3-0.2-0.6-0.1-0.5,0.5 c-0.5-0.3-0.8,0.1-0.7,0.5c-0.1-0.1-0.2-0.1-0.4-0.1c-0.4,0-0.8,0.3-0.8,0.7l-0.3,0c-1.9,0.2-2.3,0.3-2.8,1.1 c-0.6,0.8-1,1.3-2.1,3.6c-0.7,1.1-0.4,0.8-0.8,1.1c-0.3,0.2-0.4,0.5-0.7,0.6c0.6-1.3-2-0.8-1,0.5c0.1,0.1,0.3,0.2,0.4,0.3 c1.2,0.5,2.7-1.3,3.4-2.8c1.6-2.2,1.7-1.9,4.5-2.7c0.1,0,0.4-0.3,0.4-0.4c0.4,0.2,0.7,0.2,0.9-0.3c0.4,0.2,0.8-0.1,0.8-0.5 C59.2,55.9,59.6,56.2,59.8,55.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs204 || (_defs204 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_567_",
    d: "M56.7,54.7c0.3-0.3,0.9,0.2,1.1,0.9c0.1,0.2,0.3,0.5,0.3,0.6c0.1,0.3-0.1,0.5-0.4,0.6 c-0.5,0.2-0.8-0.3-1.1-0.9C56.3,55.3,56.4,55,56.7,54.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_568_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_567_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_569_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.221,
    y1: 55.7271,
    x2: 58.2971,
    y2: 55.7271
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 56.3,
    y: 54.4,
    className: "st255",
    width: 1.9,
    height: 2.7
  }))), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.7,54.7c0.3-0.3,0.9,0.2,1.1,0.9c0.1,0.2,0.3,0.5,0.3,0.6c0.1,0.3-0.1,0.5-0.4,0.6c-0.5,0.2-0.8-0.3-1.1-0.9 C56.3,55.3,56.4,55,56.7,54.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs205 || (_defs205 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_570_",
    d: "M57.6,54.2c0.5-0.2,0.8,0,1.1,0.7c0.3,0.6,0.6,1.3,0.2,1.5c-0.2,0.1-0.3,0.1-0.5,0.1 c-0.3,0-0.2-0.4-0.7-0.9C57.3,54.9,57.1,54.4,57.6,54.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_571_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_570_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_572_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.8453,
    y1: 55.2032,
    x2: 59.6361,
    y2: 55.2032
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1,
    y: 54,
    className: "st256",
    width: 2.3,
    height: 2.4
  }))), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.6,54.2c0.5-0.2,0.8,0,1.1,0.7c0.3,0.6,0.6,1.3,0.2,1.5c-0.2,0.1-0.3,0.1-0.5,0.1c-0.3,0-0.2-0.4-0.7-0.9 C57.3,54.9,57.1,54.4,57.6,54.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs206 || (_defs206 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_573_",
    d: "M58.5,53.6c0.4-0.1,0.8,0.1,1.1,0.7c0.3,0.6,0.6,1.2,0.2,1.4c-0.2,0.1-0.3,0.1-0.5,0 c-0.3,0-0.2-0.3-0.6-0.8C58.2,54.4,58.1,53.7,58.5,53.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_574_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_573_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_575_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.1392,
    y1: 54.6345,
    x2: 60.2379,
    y2: 54.6345
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 58.1,
    y: 53.5,
    className: "st257",
    width: 2.1,
    height: 2.3
  }))), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.5,53.6c0.4-0.1,0.8,0.1,1.1,0.7c0.3,0.6,0.6,1.2,0.2,1.4c-0.2,0.1-0.3,0.1-0.5,0c-0.3,0-0.2-0.3-0.6-0.8 C58.2,54.4,58.1,53.7,58.5,53.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs207 || (_defs207 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_576_",
    d: "M60.8,72.6c-0.1-0.2-1.8-1.4-2.4-1.3c-0.7,0.1-0.9,0.1-1.6,0.2c-0.2,0-0.5,0.1-0.9,0.2 c-0.5,0.2-1,0.4-1.5,0.7c-0.3,0.1-0.5,0.2-0.8,0.3c0.1,0,0.8,0,1.3,0.3c0.1,0.1,0.3,0.3,0.6,0.5c0.1,0.1,0.3,0,0.3,0 c0.6-0.1,1.2,0.1,2,0C59,73.4,60.2,73.1,60.8,72.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_577_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_576_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_578_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.6709,
    y1: 72.3762,
    x2: 60.8698,
    y2: 72.3762
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ECCD94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D09E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#795B2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 53.7,
    y: 71.2,
    className: "st258",
    width: 7.2,
    height: 2.4
  }))), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.8,72.6c-0.1-0.2-1.8-1.4-2.4-1.3c-0.7,0.1-0.9,0.1-1.6,0.2c-0.2,0-0.5,0.1-0.9,0.2c-0.5,0.2-1,0.4-1.5,0.7 c-0.3,0.1-0.5,0.2-0.8,0.3c0.1,0,0.8,0,1.3,0.3c0.1,0.1,0.3,0.3,0.6,0.5c0.1,0.1,0.3,0,0.3,0c0.6-0.1,1.2,0.1,2,0 C59,73.4,60.2,73.1,60.8,72.6z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "st259",
    d: "M54,72.7c-0.3,0.1-0.5,0.2-0.7,0.3c-1.3,0.6-4.3,5.3-1.3,5.5c0.2-0.1,1.1-0.1,1-1c0.1-0.8-0.9-0.9-0.8-1.3 c0.3-0.8,0.7-0.6,1.7-1.2c0.5-0.3,1.1-1.2,1.7-1.3v0c0,0-0.1,0-0.1,0C55.3,73.3,55.1,73,55,73C54.7,72.7,54.2,72.7,54,72.7z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54,72.7c-0.3,0.1-0.5,0.2-0.7,0.3c-1.3,0.6-4.3,5.3-1.3,5.5c0.2-0.1,1.1-0.1,1-1c0.1-0.8-0.9-0.9-0.8-1.3 c0.3-0.8,0.7-0.6,1.7-1.2c0.5-0.3,1.1-1.2,1.7-1.3v0c0,0-0.1,0-0.1,0C55.3,73.3,55.1,73,55,73C54.7,72.7,54.2,72.7,54,72.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs208 || (_defs208 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_579_",
    d: "M85.1,39.8c-0.8,0.8-2.3,1.2-3.3,1.7c-1.4,0.7-2.9,1.1-4.3,1.8c-0.3,0.2-3.2,1.3-3.5,2 c-1.9,2.1-2.3,5.4-1,6.4c0,0,0.2-0.2,0.2-0.2c1.1-0.8,4.8-2.1,6.8-2.8c1.1-0.4,2.2-0.6,3.2-1.3C85.3,45.7,86.1,42.1,85.1,39.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_580_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_579_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_581_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.6469,
    y1: 45.742,
    x2: 86.0807,
    y2: 45.742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#B48338"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D7B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#795B2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 71.6,
    y: 39.8,
    className: "st260",
    width: 14.4,
    height: 11.8
  }))), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.1,39.8c-0.8,0.8-2.3,1.2-3.3,1.7c-1.4,0.7-2.9,1.1-4.3,1.8c-0.3,0.2-3.2,1.3-3.5,2c-1.9,2.1-2.3,5.4-1,6.4 c0,0,0.2-0.2,0.2-0.2c1.1-0.8,4.8-2.1,6.8-2.8c1.1-0.4,2.2-0.6,3.2-1.3C85.3,45.7,86.1,42.1,85.1,39.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs209 || (_defs209 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_582_",
    d: "M86.2,31.8c-0.9,0.9-2.3,1.6-3.5,2.2c-1.6,0.8-3.3,1.5-4.8,2.3c-0.4,0.2-3.7,2.4-4.1,3.1 c-1.3,2.8-1.5,3.5-0.2,6.2c0.4-0.6,1.3-1.2,2.3-1.7c0.1-0.1,0.3-0.2,0.5-0.2c1.5-0.7,3.3-1.3,4.4-1.8c0.6-0.3,1.5-0.7,2.2-1 c0.6-0.2,0.9-0.4,1.5-0.7C87.5,38.5,88,34.1,86.2,31.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_583_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_582_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_584_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.1603,
    y1: 42.4589,
    x2: 88.2204,
    y2: 34.9968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 72.3,
    y: 31.8,
    className: "st261",
    width: 15.7,
    height: 13.9
  }))), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.2,31.8c-0.9,0.9-2.3,1.6-3.5,2.2c-1.6,0.8-3.3,1.5-4.8,2.3c-0.4,0.2-3.7,2.4-4.1,3.1 c-1.3,2.8-1.5,3.5-0.2,6.2c0.4-0.6,1.3-1.2,2.3-1.7c0.1-0.1,0.3-0.2,0.5-0.2c1.5-0.7,3.3-1.3,4.4-1.8c0.6-0.3,1.5-0.7,2.2-1 c0.6-0.2,0.9-0.4,1.5-0.7C87.5,38.5,88,34.1,86.2,31.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs210 || (_defs210 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_585_",
    d: "M86,25.5c-1.7,0.2-2.9,0.6-4,1c-4.3,1.8-7.1,2-8.5,5.9c-1.2,1.6-1.2,4,0.2,7.2c0.4-0.6,1.3-1.4,2.3-2.1 c0.1-0.1,0.3-0.2,0.5-0.3c1.4-0.7,2.9-1.9,4.1-2.3c0.6-0.3,1.5-0.7,2.2-1c0.6-0.2,0.9-0.4,1.5-0.7c0.7-0.4,1.4-0.8,1.9-1.4 C88,29.7,87.9,26.9,86,25.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_586_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_585_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_587_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.2815,
    y1: 36.187,
    x2: 88.0407,
    y2: 28.8678
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 72.3,
    y: 25.5,
    className: "st262",
    width: 15.7,
    height: 14.1
  }))), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86,25.5c-1.7,0.2-2.9,0.6-4,1c-4.3,1.8-7.1,2-8.5,5.9c-1.2,1.6-1.2,4,0.2,7.2c0.4-0.6,1.3-1.4,2.3-2.1 c0.1-0.1,0.3-0.2,0.5-0.3c1.4-0.7,2.9-1.9,4.1-2.3c0.6-0.3,1.5-0.7,2.2-1c0.6-0.2,0.9-0.4,1.5-0.7c0.7-0.4,1.4-0.8,1.9-1.4 C88,29.7,87.9,26.9,86,25.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs211 || (_defs211 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_588_",
    d: "M71.6,65c-0.7,0.6-2.3,0.6-4,0.7c-2.7,0.2-5.3,2.2-6.3,4.5c0.6,0.1-0.5,0.4,2.2,0c0.8-0.1,1.7,0,3.9-0.7 C69.7,68.9,71.1,67.6,71.6,65"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_589_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_588_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_590_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.8487,
    y1: 67.8489,
    x2: 71.6229,
    y2: 67.8489
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ECCD94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D09E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#795B2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 60.8,
    y: 65,
    className: "st263",
    width: 10.8,
    height: 5.6
  }))), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.6,65c-0.7,0.6-2.3,0.6-4,0.7c-2.7,0.2-5.3,2.2-6.3,4.5c0.6,0.1-0.5,0.4,2.2,0c0.8-0.1,1.7,0,3.9-0.7 C69.7,68.9,71.1,67.6,71.6,65z"
  })), /*#__PURE__*/React.createElement("g", null, _defs212 || (_defs212 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_591_",
    d: "M71.1,30.6c-0.1,0.2-0.5,0.7-0.5,1c-0.3,0.1-0.9,0.5-1.1,0.7c0.4,0,0.6-0.2,1-0.2c0,0.2,0.1,0.4,0.1,0.5 c-0.4,0.2-0.2,0.6-0.1,1c0.2,0,0.4-0.1,0.5-0.2c0.2,0,0.4,0,0.5,0.1c-0.2,0.5-0.2,0.8-0.2,1.3c0.1-0.1,0.3-0.3,0.3-0.5 c0.2,0,1.2-0.4,1.3-0.6c0.4-0.7,0.3-1.7,0.6-2.4c-0.5-0.2-1.2-0.2-1.7-0.7C71.6,30.7,71.4,30.6,71.1,30.6L71.1,30.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_592_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_591_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_593_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.5836,
    y1: 32.6942,
    x2: 73.4884,
    y2: 32.6942
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 69.6,
    y: 30.6,
    className: "st264",
    width: 3.9,
    height: 4.3
  }))), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.1,30.6c-0.1,0.2-0.5,0.7-0.5,1c-0.3,0.1-0.9,0.5-1.1,0.7c0.4,0,0.6-0.2,1-0.2c0,0.2,0.1,0.4,0.1,0.5 c-0.4,0.2-0.2,0.6-0.1,1c0.2,0,0.4-0.1,0.5-0.2c0.2,0,0.4,0,0.5,0.1c-0.2,0.5-0.2,0.8-0.2,1.3c0.1-0.1,0.3-0.3,0.3-0.5 c0.2,0,1.2-0.4,1.3-0.6c0.4-0.7,0.3-1.7,0.6-2.4c-0.5-0.2-1.2-0.2-1.7-0.7C71.6,30.7,71.4,30.6,71.1,30.6L71.1,30.6z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "st265",
    d: "M82.4,20.8c-0.6-0.5-1.2-0.6-1.9-0.2l-0.7,0.7c0.1,0.3-0.9,1.2-1.1,1.7c-0.5,1-0.6,4-0.6,5.1 c0.4,0,1.7-0.7,3.1-1.2c1.7-0.6,3.5-1.2,3.5-1.2l-0.4-0.1c0-0.7-0.2-1.5-0.3-2.1h-0.1v-0.6C83.1,22,82.7,21.8,82.4,20.8z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.4,20.8c-0.6-0.5-1.2-0.6-1.9-0.2l-0.7,0.7c0.1,0.3-0.9,1.2-1.1,1.7c-0.5,1-0.6,4-0.6,5.1 c0.4,0,1.7-0.7,3.1-1.2c1.7-0.6,3.5-1.2,3.5-1.2l-0.4-0.1c0-0.7-0.2-1.5-0.3-2.1h-0.1v-0.6C83.1,22,82.7,21.8,82.4,20.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs213 || (_defs213 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_594_",
    d: "M83.6,17.5c-0.2,0-0.4-0.2-0.7,0.1c-0.2,0.1-0.2,0.7-0.3,1c-0.1,0.5-0.4,1.1-0.5,1.7 c-0.1,0.4-0.5,1-0.6,1.4c-0.1,0.5,0,1.2,0,1.7c0,1-0.2,2.3,0.3,3.2l2.8-0.9c0,0,0.8-2.6,0.5-4.2c-0.2-1.6-0.7-1.6-0.9-2.1 c-0.2-0.3-0.3-0.7-0.7-1L83.6,17.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_595_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_594_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_596_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.1122,
    y1: 21.9972,
    x2: 85.5353,
    y2: 21.9972
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3,
    y: 17.4,
    className: "st266",
    width: 4,
    height: 9.3
  }))), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.6,17.5c-0.2,0-0.4-0.2-0.7,0.1c-0.2,0.1-0.2,0.7-0.3,1c-0.1,0.5-0.4,1.1-0.5,1.7c-0.1,0.4-0.5,1-0.6,1.4 c-0.1,0.5,0,1.2,0,1.7c0,1-0.2,2.3,0.3,3.2l2.8-0.9c0,0,0.8-2.6,0.5-4.2c-0.2-1.6-0.7-1.6-0.9-2.1c-0.2-0.3-0.3-0.7-0.7-1L83.6,17.5 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs214 || (_defs214 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_597_",
    d: "M79.7,19.9c1.2,0,2.5,0.5,2.3,1.9c-0.2,1.4-1,2-2.2,2c-1.2,0-2.1-0.7-2.2-2 C77.4,20.5,78.4,19.9,79.7,19.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_598_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_597_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_599_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.415,
    y1: 21.8362,
    x2: 82.2075,
    y2: 21.8362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 77.4,
    y: 19.9,
    className: "st267",
    width: 4.8,
    height: 4
  }))), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.7,19.9c1.2,0,2.5,0.5,2.3,1.9c-0.2,1.4-1,2-2.2,2c-1.2,0-2.1-0.7-2.2-2C77.4,20.5,78.4,19.9,79.7,19.9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs215 || (_defs215 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_600_",
    d: "M74,24.2c0,0.1-0.3,0.1-0.4,0.2c-0.2,1-0.7,2.8-0.1,4c0.6,1.3,1.6,1.3,2.6,1.4c0.1-0.1,0.2-0.3,0.4-0.3 c0.1-0.4,1.9-1.4,2.4-1.7c0.9-1.5-1.9-3.2-3.8-3.7C74.7,24.1,74.3,24.2,74,24.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_601_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_600_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_602_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.9077,
    y1: 26.9453,
    x2: 79.698,
    y2: 26.9453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9,
    y: 24.1,
    className: "st268",
    width: 6.8,
    height: 5.8
  }))), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74,24.2c0,0.1-0.3,0.1-0.4,0.2c-0.2,1-0.7,2.8-0.1,4c0.6,1.3,1.6,1.3,2.6,1.4c0.1-0.1,0.2-0.3,0.4-0.3 c0.1-0.4,1.9-1.4,2.4-1.7c0.9-1.5-1.9-3.2-3.8-3.7C74.7,24.1,74.3,24.2,74,24.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs216 || (_defs216 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_603_",
    d: "M73.5,24.7c-0.2,0-0.3-0.1-0.4-0.2h-1.1c-0.6,0.9-0.8,1.7-0.8,2.8c0.1-0.1,0.5-0.1,0.5-0.2 c0.1,0,0.1-0.1,0.1-0.1c0-0.3,0.6-0.5,0.6-0.8l0.1,0c0-0.1,0-0.3,0.1-0.3v-0.1c0,0,0.2-0.2,0.2-0.2c0.2,0,0.5,0,0.6-0.1V24.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_604_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_603_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_605_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.2957,
    y1: 25.8474,
    x2: 73.5313,
    y2: 25.8474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 24.5,
    className: "st269",
    width: 2.2,
    height: 2.8
  }))), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.5,24.7c-0.2,0-0.3-0.1-0.4-0.2h-1.1c-0.6,0.9-0.8,1.7-0.8,2.8c0.1-0.1,0.5-0.1,0.5-0.2 c0.1,0,0.1-0.1,0.1-0.1c0-0.3,0.6-0.5,0.6-0.8l0.1,0c0-0.1,0-0.3,0.1-0.3v-0.1c0,0,0.2-0.2,0.2-0.2c0.2,0,0.5,0,0.6-0.1V24.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs217 || (_defs217 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_606_",
    d: "M81.6,20.4c1.4,0.2,2.7,3.1,2.2,4.6c-0.3,0.7-0.1,1-0.6,1.4c-0.5,0.4-2,0.4-3.2,0.7c-1.7,0.4-2.1-1.5-2-3 C78.1,22.7,80.2,20.2,81.6,20.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_607_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_606_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_608_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.825,
    y1: 23.9071,
    x2: 84.7906,
    y2: 23.9071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 77.9,
    y: 20.2,
    className: "st270",
    width: 6.4,
    height: 7.4
  }))), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.6,20.4c1.4,0.2,2.7,3.1,2.2,4.6c-0.3,0.7-0.1,1-0.6,1.4c-0.5,0.4-2,0.4-3.2,0.7c-1.7,0.4-2.1-1.5-2-3 C78.1,22.7,80.2,20.2,81.6,20.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs218 || (_defs218 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_609_",
    d: "M81.2,21.7c-1.5,1.6-1.4,3.4-1.3,5.5c0.1-0.1,0.5,0.1,0.6,0c1.6-1.8,1.2-3,0.9-5.5L81.2,21.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_610_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_609_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_611_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.698,
    y1: 24.5269,
    x2: 82.0901,
    y2: 24.5269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 79.7,
    y: 21.7,
    className: "st271",
    width: 2.4,
    height: 5.6
  }))), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.2,21.7c-1.5,1.6-1.4,3.4-1.3,5.5c0.1-0.1,0.5,0.1,0.6,0c1.6-1.8,1.2-3,0.9-5.5L81.2,21.7z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "st272",
    d: "M78.3,27.9c-0.8,0.7,0.4,1.1,0.7,1.6c-0.3,0.2-0.7,0-1,0.1c-0.4,0.2-0.1,0.5-0.1,0.8c-0.1,0.4-0.3,0-0.6,0.1 C76.9,30.6,77,31,77,31.2c-1-0.6-0.8,0.9-1.3,1.3c0-0.2,0-0.5-0.1-0.7c-0.4,0.6-1.2,0.4-1.6-0.2c0.4,0,0.7-0.1,1-0.4 c-0.7,0.3-1.6-0.6-1.4-1.3c0.5,0.1,1,0.3,1.5,0.2c-0.5-0.2-0.7-1-0.2-1.3c0.3,0.6,0.5,0.6,1.1,0.4c-0.6-0.2,0-1,0.4-1 c-0.1,0.3,0.2,0.8,0.5,0.4c-0.3-0.3,0.1-0.6,0.4-0.7C77.7,27.7,78,28.1,78.3,27.9z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.3,27.9c-0.8,0.7,0.4,1.1,0.7,1.6c-0.3,0.2-0.7,0-1,0.1c-0.4,0.2-0.1,0.5-0.1,0.8c-0.1,0.4-0.3,0-0.6,0.1 C76.9,30.6,77,31,77,31.2c-1-0.6-0.8,0.9-1.3,1.3c0-0.2,0-0.5-0.1-0.7c-0.4,0.6-1.2,0.4-1.6-0.2c0.4,0,0.7-0.1,1-0.4 c-0.7,0.3-1.6-0.6-1.4-1.3c0.5,0.1,1,0.3,1.5,0.2c-0.5-0.2-0.7-1-0.2-1.3c0.3,0.6,0.5,0.6,1.1,0.4c-0.6-0.2,0-1,0.4-1 c-0.1,0.3,0.2,0.8,0.5,0.4c-0.3-0.3,0.1-0.6,0.4-0.7C77.7,27.7,78,28.1,78.3,27.9z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "st272",
    d: "M84.2,26.7c0.5,0.3,0.1,0.3,0,0.6c-0.1,0.6,0.1,1.3-0.5,1.8c0.2-0.6,0-1-0.6-1.2c-0.1,0.6-0.6,1.2-1.2,1.6 c-0.3-0.5-0.6-1-0.4-1.5c-0.6,0.3-1,1-1.6,1.2c-0.1-0.4,0.2-0.7,0.2-1c-0.6,0.2-1.1,0.6-1.7,0.7c0.2-1.1,0.6-1.8,1.9-2.1 c1-0.2,2-0.6,3-0.7L84.2,26.7z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.2,26.7c0.5,0.3,0.1,0.3,0,0.6c-0.1,0.6,0.1,1.3-0.5,1.8c0.2-0.6,0-1-0.6-1.2c-0.1,0.6-0.6,1.2-1.2,1.6 c-0.3-0.5-0.6-1-0.4-1.5c-0.6,0.3-1,1-1.6,1.2c-0.1-0.4,0.2-0.7,0.2-1c-0.6,0.2-1.1,0.6-1.7,0.7c0.2-1.1,0.6-1.8,1.9-2.1 c1-0.2,2-0.6,3-0.7L84.2,26.7z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.3,26.2c0.4-0.3,0.4-0.9,0.5-1.4c0.1-0.5,0-1.1,0-1.7"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.3,25.4c-0.3,0.4-0.3,3,0.4,2.8"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.7,20.3c0.3,0.6,0.5,1.1,0.5,1.8c0,0.4,0,0.9,0,1.3c0,0.4,0.1,0.9,0,1.3c-0.1,0.3-0.4,0.6-0.5,0.9"
  })), /*#__PURE__*/React.createElement("g", null, _defs219 || (_defs219 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_612_",
    d: "M83.4,47.2c-0.7,0.6-2.3,1-3.2,1.3c-1.4,0.5-2.9,1.1-4.4,1.6c-0.8,0.3-2.2,0.8-2.5,1.2 c-1.8,1.7-2.3,3.6-1.4,5.4c1.1-1.3,4.1-0.7,6.5-1.2c0.8-0.2,1.6-0.5,2.2-0.9C82.8,53.3,84.3,49.5,83.4,47.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_613_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_612_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_614_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.0512,
    y1: 51.9659,
    x2: 84.334,
    y2: 51.9659
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B48338"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D7B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#795B2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 71.1,
    y: 47.2,
    className: "st273",
    width: 13.3,
    height: 9.4
  }))), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.4,47.2c-0.7,0.6-2.3,1-3.2,1.3c-1.4,0.5-2.9,1.1-4.4,1.6c-0.8,0.3-2.2,0.8-2.5,1.2 c-1.8,1.7-2.3,3.6-1.4,5.4c1.1-1.3,4.1-0.7,6.5-1.2c0.8-0.2,1.6-0.5,2.2-0.9C82.8,53.3,84.3,49.5,83.4,47.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs220 || (_defs220 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_615_",
    d: "M77.2,60.8c-0.7,0.6-2.3,0.5-4,0.7c-2,0.2-2.7-0.7-3.9,0.4c-2.2,1.9-2.7,1.8-3,4.5 c1.1-0.3,0.1-0.1,2.8-0.5c0.8-0.1,1.8,0.2,4-0.5C75.3,64.7,78.1,63,77.2,60.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_616_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_615_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_617_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.2745,
    y1: 63.5619,
    x2: 78.1454,
    y2: 63.5619
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ECCD94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D09E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#795B2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 66.3,
    y: 60.8,
    className: "st274",
    width: 11.9,
    height: 5.6
  }))), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.2,60.8c-0.7,0.6-2.3,0.5-4,0.7c-2,0.2-2.7-0.7-3.9,0.4c-2.2,1.9-2.7,1.8-3,4.5c1.1-0.3,0.1-0.1,2.8-0.5 c0.8-0.1,1.8,0.2,4-0.5C75.3,64.7,78.1,63,77.2,60.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs221 || (_defs221 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_618_",
    d: "M80.7,54.7c-0.7,0.6-1.9,0.9-3.5,1.1c-2,0.2-3.4-0.1-4.8,0.7C69.7,58,69,59,69.7,61.8 c1.1-0.3,0.8,0.4,3.6,0c0.8-0.1,2.5-0.4,3.1-0.8C78.8,59.7,81.6,56.9,80.7,54.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_619_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_618_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_620_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.0405,
    y1: 58.4039,
    x2: 81.6365,
    y2: 58.4039
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ECCD94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D09E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#795B2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 54.7,
    className: "st275",
    width: 12.6,
    height: 7.5
  }))), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.7,54.7c-0.7,0.6-1.9,0.9-3.5,1.1c-2,0.2-3.4-0.1-4.8,0.7C69.7,58,69,59,69.7,61.8c1.1-0.3,0.8,0.4,3.6,0 c0.8-0.1,2.5-0.4,3.1-0.8C78.8,59.7,81.6,56.9,80.7,54.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs222 || (_defs222 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_621_",
    d: "M65.9,70c-0.4,0-1,0.1-1.4,0.1c-0.9,0.1-1.7,0-2.6,0.1c-0.2,0-0.6,0-1.1,0.1c-0.9,0.1-1.8,0.6-2.6,1.1 c0.1-0.1,1,0,1.5,0.3c0.1,0.1,0.7,0.5,1,0.8c0.1,0.1,0.2,0.1,0.2,0.1C62.6,73,65.5,71.7,65.9,70"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_622_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_621_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_623_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.167,
    y1: 71.469,
    x2: 65.8992,
    y2: 71.469
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ECCD94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D09E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#795B2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2,
    y: 70,
    className: "st276",
    width: 7.7,
    height: 3
  }))), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.9,70c-0.4,0-1,0.1-1.4,0.1c-0.9,0.1-1.7,0-2.6,0.1c-0.2,0-0.6,0-1.1,0.1c-0.9,0.1-1.8,0.6-2.6,1.1 c0.1-0.1,1,0,1.5,0.3c0.1,0.1,0.7,0.5,1,0.8c0.1,0.1,0.2,0.1,0.2,0.1C62.6,73,65.5,71.7,65.9,70z"
  })), /*#__PURE__*/React.createElement("g", null, _defs223 || (_defs223 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_624_",
    d: "M53.8,72.6c0.1-0.2,1.8-1.4,2.4-1.3c0.7,0.1,0.9,0.1,1.6,0.2c0.2,0,0.5,0.1,0.9,0.2 c0.5,0.2,1,0.4,1.5,0.7c0.3,0.1,0.5,0.2,0.8,0.3c-0.1,0-0.8,0-1.3,0.3c-0.1,0.1-0.3,0.3-0.6,0.5c-0.1,0.1-0.3,0-0.3,0 c-0.6-0.1-1.2,0.1-2,0C55.6,73.4,54.5,73.1,53.8,72.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_625_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_624_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_626_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.9758,
    y1: 72.3762,
    x2: 53.8116,
    y2: 72.3762
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ECCD94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D09E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#795B2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8,
    y: 71.2,
    className: "st277",
    width: 7.2,
    height: 2.4
  }))), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.8,72.6c0.1-0.2,1.8-1.4,2.4-1.3c0.7,0.1,0.9,0.1,1.6,0.2c0.2,0,0.5,0.1,0.9,0.2c0.5,0.2,1,0.4,1.5,0.7 c0.3,0.1,0.5,0.2,0.8,0.3c-0.1,0-0.8,0-1.3,0.3c-0.1,0.1-0.3,0.3-0.6,0.5c-0.1,0.1-0.3,0-0.3,0c-0.6-0.1-1.2,0.1-2,0 C55.6,73.4,54.5,73.1,53.8,72.6z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "st259",
    d: "M60.7,72.7c0.3,0.1,0.5,0.2,0.7,0.3c1.3,0.6,4.3,5.3,1.3,5.5c-0.2-0.1-1.1-0.1-1-1c-0.1-0.8,0.9-0.9,0.8-1.3 c-0.3-0.8-0.7-0.6-1.7-1.2c-0.5-0.3-1.1-1.2-1.7-1.3v0c0,0,0.1,0,0.1,0c0.3-0.2,0.5-0.5,0.6-0.6C60,72.7,60.4,72.7,60.7,72.7z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.7,72.7c0.3,0.1,0.5,0.2,0.7,0.3c1.3,0.6,4.3,5.3,1.3,5.5c-0.2-0.1-1.1-0.1-1-1c-0.1-0.8,0.9-0.9,0.8-1.3 c-0.3-0.8-0.7-0.6-1.7-1.2c-0.5-0.3-1.1-1.2-1.7-1.3v0c0,0,0.1,0,0.1,0c0.3-0.2,0.5-0.5,0.6-0.6C60,72.7,60.4,72.7,60.7,72.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs224 || (_defs224 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_627_",
    d: "M29.6,39.8c0.8,0.8,2.3,1.2,3.3,1.7c1.4,0.7,2.9,1.1,4.3,1.8c0.3,0.2,3.2,1.3,3.5,2 c1.9,2.1,2.3,5.4,1,6.4c0,0-0.2-0.2-0.2-0.2c-1.1-0.8-4.8-2.1-6.8-2.8c-1.1-0.4-2.2-0.6-3.2-1.3C29.4,45.7,28.6,42.1,29.6,39.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_628_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_627_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_629_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.0096,
    y1: 45.742,
    x2: 28.5758,
    y2: 45.742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#B48338"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D7B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#795B2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 39.8,
    className: "st278",
    width: 14.4,
    height: 11.8
  }))), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.6,39.8c0.8,0.8,2.3,1.2,3.3,1.7c1.4,0.7,2.9,1.1,4.3,1.8c0.3,0.2,3.2,1.3,3.5,2c1.9,2.1,2.3,5.4,1,6.4 c0,0-0.2-0.2-0.2-0.2c-1.1-0.8-4.8-2.1-6.8-2.8c-1.1-0.4-2.2-0.6-3.2-1.3C29.4,45.7,28.6,42.1,29.6,39.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs225 || (_defs225 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_630_",
    d: "M28.5,31.8c0.9,0.9,2.3,1.6,3.5,2.2c1.6,0.8,3.3,1.5,4.8,2.3c0.4,0.2,3.7,2.4,4.1,3.1 c1.3,2.8,1.5,3.5,0.2,6.2c-0.4-0.6-1.3-1.2-2.3-1.7c-0.1-0.1-0.3-0.2-0.5-0.2c-1.5-0.7-3.3-1.3-4.4-1.8c-0.6-0.3-1.5-0.7-2.2-1 c-0.6-0.2-0.9-0.4-1.5-0.7C27.1,38.5,26.6,34.1,28.5,31.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_631_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_630_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_632_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.4999,
    y1: 42.4606,
    x2: 26.4398,
    y2: 34.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 26.6,
    y: 31.8,
    className: "st279",
    width: 15.7,
    height: 13.9
  }))), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.5,31.8c0.9,0.9,2.3,1.6,3.5,2.2c1.6,0.8,3.3,1.5,4.8,2.3c0.4,0.2,3.7,2.4,4.1,3.1c1.3,2.8,1.5,3.5,0.2,6.2 c-0.4-0.6-1.3-1.2-2.3-1.7c-0.1-0.1-0.3-0.2-0.5-0.2c-1.5-0.7-3.3-1.3-4.4-1.8c-0.6-0.3-1.5-0.7-2.2-1c-0.6-0.2-0.9-0.4-1.5-0.7 C27.1,38.5,26.6,34.1,28.5,31.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs226 || (_defs226 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_633_",
    d: "M28.7,25.5c1.7,0.2,2.9,0.6,4,1c4.3,1.8,7.1,2,8.5,5.9c1.2,1.6,1.2,4-0.2,7.2c-0.4-0.6-1.3-1.4-2.3-2.1 c-0.1-0.1-0.3-0.2-0.5-0.3c-1.4-0.7-2.9-1.9-4.1-2.3c-0.6-0.3-1.5-0.7-2.2-1c-0.6-0.2-0.9-0.4-1.5-0.7c-0.7-0.4-1.4-0.8-1.9-1.4 C26.6,29.7,26.7,26.9,28.7,25.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_634_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_633_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_635_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.3794,
    y1: 36.1872,
    x2: 26.6127,
    y2: 28.8681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9983C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#B28241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 26.6,
    y: 25.5,
    className: "st280",
    width: 15.7,
    height: 14.1
  }))), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.7,25.5c1.7,0.2,2.9,0.6,4,1c4.3,1.8,7.1,2,8.5,5.9c1.2,1.6,1.2,4-0.2,7.2c-0.4-0.6-1.3-1.4-2.3-2.1 c-0.1-0.1-0.3-0.2-0.5-0.3c-1.4-0.7-2.9-1.9-4.1-2.3c-0.6-0.3-1.5-0.7-2.2-1c-0.6-0.2-0.9-0.4-1.5-0.7c-0.7-0.4-1.4-0.8-1.9-1.4 C26.6,29.7,26.7,26.9,28.7,25.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs227 || (_defs227 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_636_",
    d: "M43,65c0.7,0.6,2.3,0.6,4,0.7c2.7,0.2,5.3,2.2,6.3,4.5c-0.6,0.1,0.5,0.4-2.2,0c-0.8-0.1-1.7,0-3.9-0.7 C44.9,68.9,43.6,67.6,43,65"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_637_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_636_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_638_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.378,
    y1: 67.8489,
    x2: 43.0119,
    y2: 67.8489
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ECCD94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D09E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#795B2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 65,
    className: "st281",
    width: 10.8,
    height: 5.6
  }))), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43,65c0.7,0.6,2.3,0.6,4,0.7c2.7,0.2,5.3,2.2,6.3,4.5c-0.6,0.1,0.5,0.4-2.2,0c-0.8-0.1-1.7,0-3.9-0.7 C44.9,68.9,43.6,67.6,43,65z"
  })), /*#__PURE__*/React.createElement("g", null, _defs228 || (_defs228 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_639_",
    d: "M43.5,30.6c0.1,0.2,0.5,0.7,0.5,1c0.3,0.1,0.9,0.5,1.1,0.7c-0.4,0-0.6-0.2-1-0.2c0,0.2-0.1,0.4-0.1,0.5 c0.4,0.2,0.2,0.6,0.1,1c-0.2,0-0.4-0.1-0.5-0.2c-0.2,0-0.4,0-0.5,0.1c0.2,0.5,0.2,0.8,0.2,1.3c-0.1-0.1-0.3-0.3-0.3-0.5 c-0.2,0-1.2-0.4-1.3-0.6c-0.4-0.7-0.3-1.7-0.6-2.4c0.5-0.2,1.2-0.2,1.7-0.7C43.1,30.7,43.3,30.6,43.5,30.6L43.5,30.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_640_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_639_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_641_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.073,
    y1: 32.6942,
    x2: 41.1681,
    y2: 32.6942
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 41.2,
    y: 30.6,
    className: "st282",
    width: 3.9,
    height: 4.3
  }))), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.5,30.6c0.1,0.2,0.5,0.7,0.5,1c0.3,0.1,0.9,0.5,1.1,0.7c-0.4,0-0.6-0.2-1-0.2c0,0.2-0.1,0.4-0.1,0.5 c0.4,0.2,0.2,0.6,0.1,1c-0.2,0-0.4-0.1-0.5-0.2c-0.2,0-0.4,0-0.5,0.1c0.2,0.5,0.2,0.8,0.2,1.3c-0.1-0.1-0.3-0.3-0.3-0.5 c-0.2,0-1.2-0.4-1.3-0.6c-0.4-0.7-0.3-1.7-0.6-2.4c0.5-0.2,1.2-0.2,1.7-0.7C43.1,30.7,43.3,30.6,43.5,30.6L43.5,30.6z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "st265",
    d: "M32.3,20.8c0.6-0.5,1.2-0.6,1.9-0.2l0.7,0.7c-0.1,0.3,0.9,1.2,1.1,1.7c0.5,1,0.6,4,0.6,5.1 c-0.4,0-1.7-0.7-3.1-1.2c-1.7-0.6-3.5-1.2-3.5-1.2l0.4-0.1c0-0.7,0.2-1.5,0.3-2.1h0.1v-0.6C31.6,22,31.9,21.8,32.3,20.8z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.3,20.8c0.6-0.5,1.2-0.6,1.9-0.2l0.7,0.7c-0.1,0.3,0.9,1.2,1.1,1.7c0.5,1,0.6,4,0.6,5.1 c-0.4,0-1.7-0.7-3.1-1.2c-1.7-0.6-3.5-1.2-3.5-1.2l0.4-0.1c0-0.7,0.2-1.5,0.3-2.1h0.1v-0.6C31.6,22,31.9,21.8,32.3,20.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs229 || (_defs229 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_642_",
    d: "M31.1,17.5c0.2,0,0.4-0.2,0.7,0.1c0.2,0.1,0.2,0.7,0.3,1c0.1,0.5,0.4,1.1,0.5,1.7c0.1,0.4,0.5,1,0.6,1.4 c0.1,0.5,0,1.2,0,1.7c0,1,0.2,2.3-0.3,3.2l-2.8-0.9c0,0-0.8-2.6-0.5-4.2c0.2-1.6,0.7-1.6,0.9-2.1c0.2-0.3,0.3-0.7,0.7-1L31.1,17.5 z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_643_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_642_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_644_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.5263,
    y1: 21.9972,
    x2: 29.1032,
    y2: 21.9972
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 29.3,
    y: 17.4,
    className: "st283",
    width: 4,
    height: 9.3
  }))), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.1,17.5c0.2,0,0.4-0.2,0.7,0.1c0.2,0.1,0.2,0.7,0.3,1c0.1,0.5,0.4,1.1,0.5,1.7c0.1,0.4,0.5,1,0.6,1.4 c0.1,0.5,0,1.2,0,1.7c0,1,0.2,2.3-0.3,3.2l-2.8-0.9c0,0-0.8-2.6-0.5-4.2c0.2-1.6,0.7-1.6,0.9-2.1c0.2-0.3,0.3-0.7,0.7-1L31.1,17.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs230 || (_defs230 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_645_",
    d: "M35,19.9c-1.2,0-2.5,0.5-2.3,1.9c0.2,1.4,1,2,2.2,2c1.2,0,2.1-0.7,2.2-2C37.2,20.5,36.2,19.9,35,19.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_646_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_645_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_647_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.2415,
    y1: 21.8362,
    x2: 32.4491,
    y2: 21.8362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 32.4,
    y: 19.9,
    className: "st284",
    width: 4.8,
    height: 4
  }))), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35,19.9c-1.2,0-2.5,0.5-2.3,1.9c0.2,1.4,1,2,2.2,2c1.2,0,2.1-0.7,2.2-2C37.2,20.5,36.2,19.9,35,19.9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs231 || (_defs231 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_648_",
    d: "M40.7,24.2c0,0.1,0.3,0.1,0.4,0.2c0.2,1,0.7,2.8,0.1,4c-0.6,1.3-1.6,1.3-2.6,1.4 c-0.1-0.1-0.2-0.3-0.4-0.3c-0.1-0.4-1.9-1.4-2.4-1.7c-0.9-1.5,1.9-3.2,3.8-3.7C40,24.1,40.4,24.2,40.7,24.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_649_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_648_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_650_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.7489,
    y1: 26.9453,
    x2: 34.9577,
    y2: 26.9453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 24.1,
    className: "st285",
    width: 6.8,
    height: 5.8
  }))), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.7,24.2c0,0.1,0.3,0.1,0.4,0.2c0.2,1,0.7,2.8,0.1,4c-0.6,1.3-1.6,1.3-2.6,1.4c-0.1-0.1-0.2-0.3-0.4-0.3 c-0.1-0.4-1.9-1.4-2.4-1.7c-0.9-1.5,1.9-3.2,3.8-3.7C40,24.1,40.4,24.2,40.7,24.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs232 || (_defs232 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_651_",
    d: "M41.1,24.7c0.2,0,0.3-0.1,0.4-0.2h1.1c0.6,0.9,0.8,1.7,0.8,2.8c-0.1-0.1-0.5-0.1-0.5-0.2 c-0.1,0-0.1-0.1-0.1-0.1c0-0.3-0.6-0.5-0.6-0.8l-0.1,0c0-0.1,0-0.3-0.1-0.3v-0.1c0,0-0.2-0.2-0.2-0.2c-0.2,0-0.5,0-0.6-0.1V24.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_652_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_651_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_653_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.3729,
    y1: 25.8474,
    x2: 41.1087,
    y2: 25.8474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 41.1,
    y: 24.5,
    className: "st286",
    width: 2.2,
    height: 2.8
  }))), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.1,24.7c0.2,0,0.3-0.1,0.4-0.2h1.1c0.6,0.9,0.8,1.7,0.8,2.8c-0.1-0.1-0.5-0.1-0.5-0.2 c-0.1,0-0.1-0.1-0.1-0.1c0-0.3-0.6-0.5-0.6-0.8l-0.1,0c0-0.1,0-0.3-0.1-0.3v-0.1c0,0-0.2-0.2-0.2-0.2c-0.2,0-0.5,0-0.6-0.1V24.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs233 || (_defs233 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_654_",
    d: "M33.1,20.4c-1.4,0.2-2.7,3.1-2.2,4.6c0.3,0.7,0.1,1,0.6,1.4c0.5,0.4,2,0.4,3.2,0.7c1.7,0.4,2.1-1.5,2-3 C36.6,22.7,34.5,20.2,33.1,20.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_655_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_654_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_656_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.806,
    y1: 23.9071,
    x2: 29.8403,
    y2: 23.9071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 30.3,
    y: 20.2,
    className: "st287",
    width: 6.4,
    height: 7.4
  }))), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.1,20.4c-1.4,0.2-2.7,3.1-2.2,4.6c0.3,0.7,0.1,1,0.6,1.4c0.5,0.4,2,0.4,3.2,0.7c1.7,0.4,2.1-1.5,2-3 C36.6,22.7,34.5,20.2,33.1,20.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs234 || (_defs234 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_657_",
    d: "M33.5,21.7c1.5,1.6,1.4,3.4,1.3,5.5c-0.1-0.1-0.5,0.1-0.6,0c-1.6-1.8-1.2-3-0.9-5.5L33.5,21.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_658_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_657_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_659_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.9555,
    y1: 24.5269,
    x2: 32.5634,
    y2: 24.5269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A75930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#E9D0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#CB8044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#5F2517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#DA8C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6,
    y: 21.7,
    className: "st288",
    width: 2.4,
    height: 5.6
  }))), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.5,21.7c1.5,1.6,1.4,3.4,1.3,5.5c-0.1-0.1-0.5,0.1-0.6,0c-1.6-1.8-1.2-3-0.9-5.5L33.5,21.7z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.4,26.2c-0.4-0.3-0.4-0.9-0.5-1.4c-0.1-0.5,0-1.1,0-1.7"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.4,25.4c0.3,0.4,0.3,3-0.4,2.8"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31,20.3c-0.3,0.6-0.5,1.1-0.5,1.8c0,0.4,0,0.9,0,1.3c0,0.4-0.1,0.9,0,1.3c0.1,0.3,0.4,0.6,0.5,0.9"
  })), /*#__PURE__*/React.createElement("g", null, _defs235 || (_defs235 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_660_",
    d: "M31.3,47.2c0.7,0.6,2.3,1,3.2,1.3c1.4,0.5,2.9,1.1,4.4,1.6c0.8,0.3,2.2,0.8,2.5,1.2 c1.8,1.7,2.3,3.6,1.4,5.4c-1.1-1.3-4.1-0.7-6.5-1.2c-0.8-0.2-1.6-0.5-2.2-0.9C31.9,53.3,30.3,49.5,31.3,47.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_661_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_660_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_662_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.1176,
    y1: 51.9659,
    x2: 29.547,
    y2: 51.9659
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B48338"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D7B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#795B2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 30.3,
    y: 47.2,
    className: "st289",
    width: 13.3,
    height: 9.4
  }))), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.3,47.2c0.7,0.6,2.3,1,3.2,1.3c1.4,0.5,2.9,1.1,4.4,1.6c0.8,0.3,2.2,0.8,2.5,1.2c1.8,1.7,2.3,3.6,1.4,5.4 c-1.1-1.3-4.1-0.7-6.5-1.2c-0.8-0.2-1.6-0.5-2.2-0.9C31.9,53.3,30.3,49.5,31.3,47.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs236 || (_defs236 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_663_",
    d: "M37.5,60.8c0.7,0.6,2.3,0.5,4,0.7c2,0.2,2.7-0.7,3.9,0.4c2.2,1.9,2.7,1.8,3,4.5c-1.1-0.3-0.1-0.1-2.8-0.5 c-0.8-0.1-1.8,0.2-4-0.5C39.4,64.7,36.5,63,37.5,60.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_664_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_663_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_665_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.3828,
    y1: 63.5619,
    x2: 36.5111,
    y2: 63.5619
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ECCD94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D09E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#795B2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 60.8,
    className: "st290",
    width: 11.9,
    height: 5.6
  }))), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.5,60.8c0.7,0.6,2.3,0.5,4,0.7c2,0.2,2.7-0.7,3.9,0.4c2.2,1.9,2.7,1.8,3,4.5c-1.1-0.3-0.1-0.1-2.8-0.5 c-0.8-0.1-1.8,0.2-4-0.5C39.4,64.7,36.5,63,37.5,60.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs237 || (_defs237 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_666_",
    d: "M34,54.7c0.7,0.6,1.9,0.9,3.5,1.1c2,0.2,3.4-0.1,4.8,0.7C45,58,45.6,59,45,61.8c-1.1-0.3-0.8,0.4-3.6,0 c-0.8-0.1-2.5-0.4-3.1-0.8C35.8,59.7,33,56.9,34,54.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_667_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_666_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_668_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.6161,
    y1: 58.4039,
    x2: 33.02,
    y2: 58.4039
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ECCD94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D09E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#795B2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 54.7,
    className: "st291",
    width: 12.6,
    height: 7.5
  }))), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34,54.7c0.7,0.6,1.9,0.9,3.5,1.1c2,0.2,3.4-0.1,4.8,0.7C45,58,45.6,59,45,61.8c-1.1-0.3-0.8,0.4-3.6,0 c-0.8-0.1-2.5-0.4-3.1-0.8C35.8,59.7,33,56.9,34,54.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs238 || (_defs238 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_669_",
    d: "M48.8,70c0.4,0,1,0.1,1.4,0.1c0.9,0.1,1.7,0,2.6,0.1c0.2,0,0.6,0,1.1,0.1c0.9,0.1,1.8,0.6,2.6,1.1 c-0.1-0.1-1,0-1.5,0.3c-0.1,0.1-0.7,0.5-1,0.8c-0.1,0.1-0.2,0.1-0.2,0.1C52,73,49.2,71.7,48.8,70"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_670_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_669_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_671_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.4895,
    y1: 71.469,
    x2: 48.7491,
    y2: 71.469
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C99249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ECCD94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D09E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#795B2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#674F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#E2BD7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0CD9D"
    }
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8,
    y: 70,
    className: "st292",
    width: 7.7,
    height: 3
  }))), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.8,70c0.4,0,1,0.1,1.4,0.1c0.9,0.1,1.7,0,2.6,0.1c0.2,0,0.6,0,1.1,0.1c0.9,0.1,1.8,0.6,2.6,1.1 c-0.1-0.1-1,0-1.5,0.3c-0.1,0.1-0.7,0.5-1,0.8c-0.1,0.1-0.2,0.1-0.2,0.1C52,73,49.2,71.7,48.8,70z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37,21.4c0.1,0,0.3,0.2,0.3,0.3c0.1,0.1,0.1,0.3,0.1,0.5c-0.2,0-0.5,0-0.5,0.2c-0.1,0-0.2-0.1-0.3-0.1 c0-0.2-0.2-0.4-0.3-0.6C36.4,21.6,36.6,21.3,37,21.4"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "st272",
    d: "M35.4,27.7c0.8,0.8-0.4,1.1-0.7,1.6c0.3,0.2,0.7,0,1,0.2c0.4,0.3,0.1,0.5,0.1,0.8c0.1,0.4,0.3,0,0.6,0.1 c0.4,0.1,0.3,0.5,0.3,0.8c1-0.6,0.8,0.9,1.3,1.4c0-0.2,0-0.5,0.1-0.7c0.4,0.7,1.2,0.4,1.6-0.2c-0.4,0-0.7-0.1-1-0.4 c0.7,0.3,1.6-0.6,1.4-1.3c-0.5,0.1-1,0.3-1.5,0.2c0.5-0.3,0.7-1,0.2-1.4c-0.3,0.6-0.5,0.6-1.1,0.5c0.6-0.3,0-1.1-0.4-1 c0.1,0.4-0.2,0.9-0.5,0.4c0.3-0.3-0.1-0.7-0.4-0.8C36,27.4,35.7,27.9,35.4,27.7z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.4,27.7c0.8,0.8-0.4,1.1-0.7,1.6c0.3,0.2,0.7,0,1,0.2c0.4,0.3,0.1,0.5,0.1,0.8c0.1,0.4,0.3,0,0.6,0.1 c0.4,0.1,0.3,0.5,0.3,0.8c1-0.6,0.8,0.9,1.3,1.4c0-0.2,0-0.5,0.1-0.7c0.4,0.7,1.2,0.4,1.6-0.2c-0.4,0-0.7-0.1-1-0.4 c0.7,0.3,1.6-0.6,1.4-1.3c-0.5,0.1-1,0.3-1.5,0.2c0.5-0.3,0.7-1,0.2-1.4c-0.3,0.6-0.5,0.6-1.1,0.5c0.6-0.3,0-1.1-0.4-1 c0.1,0.4-0.2,0.9-0.5,0.4c0.3-0.3-0.1-0.7-0.4-0.8C36,27.4,35.7,27.9,35.4,27.7z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "st272",
    d: "M29.4,26.2c-0.5,0.3-0.1,0.3,0,0.6c0.1,0.6-0.1,1.4,0.5,1.9c-0.2-0.6,0-1,0.6-1.2c0.1,0.6,0.6,1.3,1.2,1.7 c0.3-0.5,0.6-1,0.4-1.6c0.6,0.3,1,1.1,1.6,1.2c0.1-0.4-0.2-0.7-0.2-1.1c0.6,0.2,1.1,0.6,1.7,0.7c-0.2-1.1-0.6-1.9-1.9-2.2 c-1-0.3-2-0.6-3-0.8L29.4,26.2z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.4,26.2c-0.5,0.3-0.1,0.3,0,0.6c0.1,0.6-0.1,1.4,0.5,1.9c-0.2-0.6,0-1,0.6-1.2c0.1,0.6,0.6,1.3,1.2,1.7 c0.3-0.5,0.6-1,0.4-1.6c0.6,0.3,1,1.1,1.6,1.2c0.1-0.4-0.2-0.7-0.2-1.1c0.6,0.2,1.1,0.6,1.7,0.7c-0.2-1.1-0.6-1.9-1.9-2.2 c-1-0.3-2-0.6-3-0.8L29.4,26.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUnicaragena);
export default __webpack_public_path__ + "static/media/logo-unicaragena.a9b9abb972959a8b2ef213f8381db953.svg";
export { ForwardRef as ReactComponent };